require("./index.css");
var $feLGi$history = require("history");
var $feLGi$react = require("react");
var $feLGi$classnames = require("classnames");
var $feLGi$proptypes = require("prop-types");
var $feLGi$reactbootstrap = require("react-bootstrap");
var $feLGi$reactrouterdom = require("react-router-dom");
var $feLGi$highcharts = require("highcharts");
var $feLGi$highchartshighchartsmore = require("highcharts/highcharts-more");
var $feLGi$highchartsmodulessolidgauge = require("highcharts/modules/solid-gauge");
var $feLGi$highchartsreactofficial = require("highcharts-react-official");
var $feLGi$swiperreact = require("swiper/react");
var $feLGi$reactimgix = require("react-imgix");
var $feLGi$swiper = require("swiper");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.scss");
var $feLGi$bugsnagjs = require("@bugsnag/js");
var $feLGi$bugsnagpluginreact = require("@bugsnag/plugin-react");
var $feLGi$momenttimezone = require("moment-timezone");
var $feLGi$reactshimmereffects = require("react-shimmer-effects");
var $feLGi$jspdf = require("jspdf");
var $feLGi$html2canvas = require("html2canvas");
var $feLGi$reacthelmet = require("react-helmet");
var $feLGi$reactselect = require("react-select");
var $feLGi$reactbootstrapCol = require("react-bootstrap/Col");
var $feLGi$reactbootstrapNav = require("react-bootstrap/Nav");
var $feLGi$reactbootstrapRow = require("react-bootstrap/Row");
var $feLGi$formik = require("formik");
var $feLGi$yup = require("yup");
var $feLGi$reactcountryflag = require("react-country-flag");
var $feLGi$worldcountries = require("world-countries");
var $feLGi$axios = require("axios");
var $feLGi$numbertowords = require("number-to-words");
var $feLGi$stripereactstripejs = require("@stripe/react-stripe-js");
var $feLGi$stripestripejs = require("@stripe/stripe-js");
var $feLGi$loadablecomponent = require("@loadable/component");
var $feLGi$lazysizes = require("lazysizes");
var $feLGi$lazysizespluginsparentfitlsparentfit = require("lazysizes/plugins/parent-fit/ls.parent-fit");
var $feLGi$lazysizespluginsattrchangelsattrchange = require("lazysizes/plugins/attrchange/ls.attrchange");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "history", () => $d64b76c7d7ee0683$export$55abd4691b317664);
$parcel$export(module.exports, "showJourneyMediaDescription", () => $48146d44b0fa9b23$export$2e2bcd8739ae039);
$parcel$export(module.exports, "plans", () => $625df15f91b44219$export$2e2bcd8739ae039);
$parcel$export(module.exports, "manageGroup", () => $b5f12f83c4275d44$export$ec8a5eeacff9f002);
$parcel$export(module.exports, "programIds", () => $b5f12f83c4275d44$export$effd300369b6ebd2);
$parcel$export(module.exports, "programs", () => $b5f12f83c4275d44$export$7f4c6ae6cd2bdde3);
$parcel$export(module.exports, "showInUrls", () => $b5f12f83c4275d44$export$3103d3761b63f14d);
$parcel$export(module.exports, "mediaCategoriesConstants", () => $b5f12f83c4275d44$export$f1fd5412d5e57eca);
$parcel$export(module.exports, "internalMediaTypes", () => $b5f12f83c4275d44$export$16f8adc1f5353264);
$parcel$export(module.exports, "mediaContent", () => $b5f12f83c4275d44$export$c24fb550983679aa);
$parcel$export(module.exports, "simple360", () => $b5f12f83c4275d44$export$7846f3dca8bd5e36);
$parcel$export(module.exports, "simple360Url", () => $b5f12f83c4275d44$export$258b8fda08817d66);
$parcel$export(module.exports, "sows", () => $b5f12f83c4275d44$export$517c6d5dba4c50ae);
$parcel$export(module.exports, "sowStatus", () => $b5f12f83c4275d44$export$821a12f7ff141b92);
$parcel$export(module.exports, "sowStatusLabel", () => $b5f12f83c4275d44$export$40bae20db5989375);
$parcel$export(module.exports, "paymentStatus", () => $b5f12f83c4275d44$export$a18da5e670f0b062);
$parcel$export(module.exports, "paymentStatusLabel", () => $b5f12f83c4275d44$export$28dd478a8c6c6590);
$parcel$export(module.exports, "paymentType", () => $b5f12f83c4275d44$export$cf6c01cadfc8fe18);
$parcel$export(module.exports, "coachingPlanStatus", () => $b5f12f83c4275d44$export$2d54bae301ecd176);
$parcel$export(module.exports, "coachRecommends", () => $b5f12f83c4275d44$export$777f84cc921315f3);
$parcel$export(module.exports, "coachRecommendsUrl", () => $b5f12f83c4275d44$export$bd747daeacd12df3);
$parcel$export(module.exports, "leaderAssessments", () => $b5f12f83c4275d44$export$e3c9dc9ffebfa801);
$parcel$export(module.exports, "leaderAssessmentsUrl", () => $b5f12f83c4275d44$export$d106f1f368cdf806);
$parcel$export(module.exports, "mediaCategoriesIds", () => $b5f12f83c4275d44$export$53fd046cd6eac48);
$parcel$export(module.exports, "surveyType", () => $b5f12f83c4275d44$export$2048b4b7dcce9e34);
$parcel$export(module.exports, "getAssessmentCompareRoutePrefix", () => $b5f12f83c4275d44$export$802fe12baad01513);
$parcel$export(module.exports, "useErrorService", () => $abbf3dedc3048db2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useUserService", () => $ca001929343b7efa$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAuth", () => $c37381977905147d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useNotificationService", () => $102ddb9add0f5b8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useResolutionService", () => $6e18117e8ec75a85$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useWindowSize", () => $b51351853dc8ae14$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AuthContext", () => $045e98f186682651$export$a0fd8390cfe8ae69);
$parcel$export(module.exports, "IntentionContext", () => $045e98f186682651$export$38c578650d02ce71);
$parcel$export(module.exports, "SelfReflectionContext", () => $045e98f186682651$export$766af349f7dda290);
$parcel$export(module.exports, "TeamContext", () => $045e98f186682651$export$fb536717633b0757);
$parcel$export(module.exports, "ModelContext", () => $045e98f186682651$export$caf6d77d41020cdf);
$parcel$export(module.exports, "nameRegex", () => $62ffb3622b928f7d$export$bb982375c1b0798f);
$parcel$export(module.exports, "getNextPaymentDate", () => $50f91df4720112ee$export$bffff7662ad2cb68);
$parcel$export(module.exports, "getDownloadTimestamp", () => $89420a3db7aa95f0$export$9520d446222eef3c);
$parcel$export(module.exports, "getDownloadedAtFileSuffix", () => $89420a3db7aa95f0$export$a05b62b0b8453404);
$parcel$export(module.exports, "sanitizeDownloadFileSegment", () => $89420a3db7aa95f0$export$5d0ccbd57c6f4340);
$parcel$export(module.exports, "sanitizeAggregateDownloadFileName", () => $89420a3db7aa95f0$export$df30674c511b335d);
$parcel$export(module.exports, "getAggregatePdfFileName", () => $89420a3db7aa95f0$export$ba9fdf0369491da);
$parcel$export(module.exports, "buildEntityFileNamePrefix", () => $89420a3db7aa95f0$export$1a142a86e2eeb509);
$parcel$export(module.exports, "getAggregatedAssessmentFileLabel", () => $89420a3db7aa95f0$export$5c8a4f5d2eeaad);
$parcel$export(module.exports, "getGroupAssessmentFileLabel", () => $89420a3db7aa95f0$export$6dce16fec17ac59e);
$parcel$export(module.exports, "getQuarterAssessmentFileLabel", () => $89420a3db7aa95f0$export$2dbc9cb8c61c8b45);
$parcel$export(module.exports, "formatQuarterFileLabel", () => $89420a3db7aa95f0$export$ee41ca24a5c12249);
$parcel$export(module.exports, "buildAggregatedCombinedSummaryFileBase", () => $89420a3db7aa95f0$export$1f1007e3e43483a1);
$parcel$export(module.exports, "buildGroupCombinedSummaryFileBase", () => $89420a3db7aa95f0$export$4d86f60c02acee6);
$parcel$export(module.exports, "buildQuarterAssessmentFileBase", () => $89420a3db7aa95f0$export$1ecd35faaf992528);
$parcel$export(module.exports, "buildAggregatedAssessmentUsersFileBase", () => $89420a3db7aa95f0$export$c9562625c3822691);
$parcel$export(module.exports, "downloadAssessmentPdf", () => $1ca4df0143566e72$export$6eb62a57cb117d2c);
$parcel$export(module.exports, "downloadComparisonAssessmentPdf", () => $1ca4df0143566e72$export$4d3866480a5f3c6c);
$parcel$export(module.exports, "downloadTravelChecklistPdf", () => $77f25c8eec95e4e8$export$24fda5aee259610b);
$parcel$export(module.exports, "buildTravelChecklistPdfHtml", () => $77f25c8eec95e4e8$export$b1e495304ea49a69);
$parcel$export(module.exports, "downloadQuestItineraryPdf", () => $7b38bc0be6891ec0$export$a7f322dc2750e2ee);
$parcel$export(module.exports, "buildQuestItineraryPdfHtml", () => $7b38bc0be6891ec0$export$b76e62620358c591);
$parcel$export(module.exports, "splitChecklistSections", () => $b6f2fdec6c694a56$export$d12d06391209fdd8);
$parcel$export(module.exports, "Imgix", () => $a78d72d5d16583e5$export$2e2bcd8739ae039);

var $2cc048a7b2c045c0$exports = {};

$parcel$export($2cc048a7b2c045c0$exports, "Button", () => $ba6b6ef9345ffc3c$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ABTooltip", () => $33b04ac1332410ed$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "NotificationProvider", () => $0a01bfcecb6af40f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "NotificationContext", () => $0a01bfcecb6af40f$export$a6e93d8cb5d50678);
$parcel$export($2cc048a7b2c045c0$exports, "Notification", () => $85e1b49c3de8f11c$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "NotificationContainerProvider", () => $f6b18d3fe22096f3$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ABSpinner", () => $a41d748d78d3a02e$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "FeatherLoader", () => $0999456108fdf02f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PolygonChart", () => $189bb98b3f895790$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "LeaderSelect", () => $e28d628c3e837aec$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "WisdomAssessmentResult", () => $686360e717aae731$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "GrowthPlanBtn", () => $c940715c92ec6515$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "OverviewWisdomSurveyResults", () => $1e72e0479dbb5016$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "WisdomSummaryResult", () => $d1af843886830771$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "CategoryModal", () => $f5e2cc126c098556$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "WisdomComparisonReport", () => $8c0346575f5896b8$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AssessmentLoader", () => $2725f3cac93899b8$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AssessmentComparisionLoader", () => $f036bbe39d78cd8f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProsperityAssessmentResult", () => $ac8f3c011e3f7c05$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "GrowthPlanBtnForPA", () => $3eaaa660ae7be38e$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "OverviewProsperitySurveyResults", () => $fd10b8c815b7dbfa$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProsperitySummaryResult", () => $e1d5251c383ee501$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProsperityComparisonReport", () => $1b858d3f322ddeab$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "SurveyComparisonReport", () => $80d9961445c5e23a$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProsperityAssessmentLoader", () => $82c8f12444b0cafe$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProsperityAssessmentComparisionLoader", () => $f036bbe39d78cd8f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AwarenessSummaryResult", () => $e0385fcb19273fcc$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AwarenessCategoryComparisonOverview", () => $1847fab3bb0b54b4$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "CompareResultsPageHeader", () => $8cd010ee20c8a311$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AssessmentPreviousResults", () => $fdab543446e764ca$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProfileButton", () => $47128abee7b91e19$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ProfileDropdown", () => $8c6c6c33107b39ee$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "Logout", () => $a5cf6b9480d432d8$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "BackwardIcon", () => $a41af764d0830af5$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PreviousIcon", () => $421a794e95cab7fd$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PauseIcon", () => $e39ad7008e61b323$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "NextIcon", () => $8259f5e91aaf63c4$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ForwardIcon", () => $aa447dcb2c314f21$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PlayIcon", () => $4ab75bde7505621f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "JournalIcon", () => $281c2e3099f752e6$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "VolumeIcon", () => $d49ea8814e522437$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "VolumeMuteIcon", () => $f02f206622e4e8ba$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "LeftArrowIcon", () => $a70a9e1418ed64a5$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "RightArrowIcon", () => $633876fd9be55329$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "CloseIcon", () => $000a07b0d337ce91$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "InfoIcon", () => $8d04a2f4ff06a04c$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PaymentSuccessIcon", () => $ff4839f57a77df06$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "GoBackIcon", () => $b6ee68546aeff868$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "DropdownCaretDownIcon", () => $e56d2de78eb5c0ce$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "DropdownCaretUpIcon", () => $b5104a1b3db51ba6$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "RightClickIcon", () => $a7419c8e33d1fcac$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "FeatherIcon", () => $dd6d3315f56a98c1$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AbroadIconForSM", () => $6f6337ce4cf8e86f$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "SignupHeaderIcon", () => $70b6fafed4b968ca$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "CrossIcon", () => $b240f4d8050e5472$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "LeftAngleIcon", () => $4236b320e4df4712$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ReturnLeftIcon", () => $42a1c68119c41042$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "Feedback", () => $a342f5c2d7c66d88$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ModalProvider", () => $046f139f7bee52e1$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ErrorView", () => $e841dd9ba70a7ecf$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "BottomAccordion", () => $1967c4823d3fb15b$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "ArrowWrapper", () => $b0c4be3d31d7f430$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "SidebarDropdown", () => $aa29f57a76350ed7$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PrintableArea", () => $5ea950ea68d4b864$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "DownloadPdfIcon", () => $dc3e8dc1c67b3a4b$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AssessmentPdfDownload", () => $2804ed17bfb2a01c$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AssessmentComparisonPdfDownload", () => $09226703b1b735cd$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PdfPreviewModal", () => $8227729a699e1ad8$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "Loader", () => $1d50b8027efcc9eb$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "QuestionRenderer", () => $a1f984fe84e53642$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "EnrollmentFormPreviewModal", () => $0f486ef2fcf0337b$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "SubscriptionTable", () => $6fd600a01db077f7$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "PaymentHistoryTable", () => $a3c868540a2e7f9d$export$2e2bcd8739ae039);
$parcel$export($2cc048a7b2c045c0$exports, "AddCreditCard", () => $6cb41c74f36dfb61$export$2e2bcd8739ae039);
var $9e1a431b1deb4138$exports = {};

$parcel$export($9e1a431b1deb4138$exports, "ABCard", () => $c38dfa7ca6f56853$export$2e2bcd8739ae039);




const $c38dfa7ca6f56853$var$ABCard = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ children: children , className: className , onHoverShadow: onHoverShadow , shadowClass: shadowClass , border: border , shadow: shadow , ...reset }, ref)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Card), {
        ref: ref,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("rounded-lg border-0 border-radius-10", {
            shadow: shadow,
            "hover:shadow transition": onHoverShadow
        }, shadowClass, className),
        ...reset
    }, children);
});
$c38dfa7ca6f56853$var$ABCard.propTypes = {
    shadow: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    onHoverShadow: (0, ($parcel$interopDefault($feLGi$proptypes))).bool
};
$c38dfa7ca6f56853$var$ABCard.defaultProps = {
    shadow: true,
    onHoverShadow: false
};
var $c38dfa7ca6f56853$export$2e2bcd8739ae039 = {
    ...(0, $feLGi$reactbootstrap.Card),
    ...$c38dfa7ca6f56853$var$ABCard
};




var $8c246ff365b80da1$exports = {};

$parcel$export($8c246ff365b80da1$exports, "ABNav", () => $433ae475c3d1bd9e$export$2e2bcd8739ae039);
$parcel$export($8c246ff365b80da1$exports, "SaffronNav", () => $422f60e0da9e9a0a$export$2e2bcd8739ae039);
$parcel$export($8c246ff365b80da1$exports, "NavTabs", () => $5ee4fd7e4673b4d2$export$2e2bcd8739ae039);


const $433ae475c3d1bd9e$var$ABNav = ({ children: children  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Nav), {
        variant: "tabs",
        defaultActiveKey: "/home",
        className: "custom-tabs border-0 justify-content-center"
    }, children);
};
var $433ae475c3d1bd9e$export$2e2bcd8739ae039 = {
    ...(0, $feLGi$reactbootstrap.Nav),
    ...$433ae475c3d1bd9e$var$ABNav
};





const $422f60e0da9e9a0a$var$SaffronNav = ({ children: children , className: className , ...props })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Nav), {
        variant: "tabs",
        defaultActiveKey: "/home",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("saffron-tabs border-0 font-18 justify-content-center", className),
        ...props
    }, children);
};
var $422f60e0da9e9a0a$export$2e2bcd8739ae039 = {
    ...(0, $feLGi$reactbootstrap.Nav),
    ...$422f60e0da9e9a0a$var$SaffronNav
};


/* eslint-disable prettier/prettier */ 



const $5ee4fd7e4673b4d2$var$NavTabs = ({ pages: pages , tabWrapperClasses: tabWrapperClasses = "header-tabs" , linkClickedHandler: linkClickedHandler = ()=>{} , pathname: pathname , hash: hash , NavLink: NavLink  })=>{
    const handleClick = (e, page)=>{
        if (page === null || page === void 0 ? void 0 : page.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        linkClickedHandler(page === null || page === void 0 ? void 0 : page.name);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $422f60e0da9e9a0a$export$2e2bcd8739ae039), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex", tabWrapperClasses)
    }, pages.map((page, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (page === null || page === void 0 ? void 0 : page.isDiscardTab) ? null : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $422f60e0da9e9a0a$export$2e2bcd8739ae039).Item, {
            key: page === null || page === void 0 ? void 0 : page.path,
            className: "position-relative"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $422f60e0da9e9a0a$export$2e2bcd8739ae039).Link, {
            as: NavLink,
            to: (page === null || page === void 0 ? void 0 : page.disabled) ? "#" : (page === null || page === void 0 ? void 0 : page.hashURL) ? `${page === null || page === void 0 ? void 0 : page.path}${page === null || page === void 0 ? void 0 : page.hashURL}` : page === null || page === void 0 ? void 0 : page.path,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))({
                "mr-0": (pages === null || pages === void 0 ? void 0 : pages.length) === index + 1,
                disabled: page === null || page === void 0 ? void 0 : page.disabled
            }, page === null || page === void 0 ? void 0 : page.classNames),
            isActive: (match)=>{
                if (page === null || page === void 0 ? void 0 : page.disabled) return false;
                if ((page === null || page === void 0 ? void 0 : page.hashURL) && `${page === null || page === void 0 ? void 0 : page.path}${page === null || page === void 0 ? void 0 : page.hashURL}` === `${pathname}${hash}`) return true;
                if ((page === null || page === void 0 ? void 0 : page.defaultUrl) && (page === null || page === void 0 ? void 0 : page.defaultUrl) === pathname) return true;
                if ((page === null || page === void 0 ? void 0 : page.discardDefaultMatch) && pathname !== (page === null || page === void 0 ? void 0 : page.path)) return false;
                if (match && !(page === null || page === void 0 ? void 0 : page.hashURL)) return true;
                return false;
            },
            onClick: (e)=>handleClick(e, page),
            style: (page === null || page === void 0 ? void 0 : page.disabled) ? {
                pointerEvents: "none",
                opacity: 0.5
            } : {}
        }, page === null || page === void 0 ? void 0 : page.name)));
    }));
};
$5ee4fd7e4673b4d2$var$NavTabs.propsTypes = {
    pages: (0, ($parcel$interopDefault($feLGi$proptypes))).arrayOf((0, ($parcel$interopDefault($feLGi$proptypes))).shape({
        name: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
        path: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
        defaultUrl: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
        hashURL: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
        noUseDefaultMatch: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
        classNames: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
        disabled: (0, ($parcel$interopDefault($feLGi$proptypes))).bool
    })).isRequired,
    linkClickedHandler: (0, ($parcel$interopDefault($feLGi$proptypes))).func
};
var $5ee4fd7e4673b4d2$export$2e2bcd8739ae039 = $5ee4fd7e4673b4d2$var$NavTabs;







const $ba6b6ef9345ffc3c$var$Button = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ children: children , isLoading: isLoading , className: className , ...rest }, ref)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Button), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("font-montserrat border-radius-5", className),
        ref: ref,
        ...rest
    }, isLoading && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Spinner), {
        as: "span",
        animation: "border",
        size: "sm",
        role: "Loading",
        "aria-hidden": "true",
        className: "btn-spinner"
    }), !isLoading && children));
});
var $ba6b6ef9345ffc3c$export$2e2bcd8739ae039 = $ba6b6ef9345ffc3c$var$Button;







let $33b04ac1332410ed$var$ABtooltips = null;
const $33b04ac1332410ed$var$ABTooltip = ({ children: children , controllId: controllId , contentText: contentText , className: className , overlayProps: overlayProps , buttonLabel: buttonLabel , customPlacement: customPlacement , placement: placement , showOnlyOnce: showOnlyOnce , showFeather: showFeather , contentTextClass: contentTextClass , wrapperClasses: wrapperClasses = ""  })=>{
    const tooltipRef = (0, $feLGi$react.useRef)(null);
    const [renderTooltip, setRenderTooltip] = (0, $feLGi$react.useState)(false);
    const [show, setShow] = (0, $feLGi$react.useState)(false);
    const [target, setTarget] = (0, $feLGi$react.useState)(null);
    const getTooltipData = ()=>{
        try {
            if (!window.localStorage) return $33b04ac1332410ed$var$ABtooltips;
            else return JSON.parse(localStorage.getItem("ABtooltips"));
        } catch (e) {
        // Error
        }
    };
    (0, $feLGi$react.useEffect)(()=>{
        try {
            const tooltipData = getTooltipData();
            if (tooltipData) {
                if (!tooltipData.includes(controllId)) setRenderTooltip(true);
            } else {
                if (!window.localStorage) $33b04ac1332410ed$var$ABtooltips = [];
                else localStorage.setItem("ABtooltips", JSON.stringify([]));
                setRenderTooltip(true);
            }
        } catch (err) {
        // error
        }
    }, [
        controllId
    ]);
    const showTooltip = (event)=>{
        setShow(true);
        setTarget(event.target);
    };
    const hideTooltip = ()=>{
        if (showOnlyOnce) {
            const tooltipData = getTooltipData();
            if (!window.localStorage) $33b04ac1332410ed$var$ABtooltips = [
                ...tooltipData,
                controllId
            ];
            else localStorage.setItem("ABtooltips", JSON.stringify([
                ...tooltipData,
                controllId
            ]));
            setRenderTooltip(false);
        }
        setShow(false);
    };
    if (!renderTooltip) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        ref: tooltipRef,
        className: wrapperClasses
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", {
            invisible: show,
            "tooltip-icon-container": !children
        }, className),
        onClick: showTooltip
    }, !children && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Image), {
        className: "tooltip-icon",
        src: `${process.env.PUBLIC_URL}/assets/images/abroad-feather-gold@2x.png`
    }), children), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Overlay), {
        rootClose: true,
        arrowProps: {
            style: {
                display: "none"
            }
        },
        popperConfig: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: ({ placement: placement , reference: reference , popper: popper  })=>{
                            if (placement === "auto") return [
                                -10,
                                0
                            ];
                            if (placement === "auto-end") return [
                                -popper.width / 2.3,
                                0
                            ];
                            if (customPlacement && placement === "bottom-end") return [
                                -20,
                                -40
                            ];
                            return [];
                        }
                    }
                }
            ]
        },
        show: show,
        target: target,
        placement: placement || "auto",
        container: tooltipRef.current,
        onHide: hideTooltip,
        ...overlayProps
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Popover), {
        className: "tooltip-box"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Popover).Content, {
        className: "px-3 pt-2 pb-3 clearfix"
    }, showFeather && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Image), {
        className: "popover-icon",
        src: `${process.env.PUBLIC_URL}/assets/images/abroad-feather-gold@2x.png`
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("font-open-sans font-weight-light font-italic", contentTextClass)
    }, contentText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: hideTooltip,
        variant: "black",
        size: "xs",
        className: "d-none d-lg-block float-right text-capitalize"
    }, buttonLabel), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: hideTooltip,
        variant: "black",
        className: "d-block d-lg-none float-right text-capitalize"
    }, buttonLabel)))));
};
$33b04ac1332410ed$var$ABTooltip.propTypes = {
    customPlacement: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    buttonLabel: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    contentText: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    controllId: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    overlayProps: (0, ($parcel$interopDefault($feLGi$proptypes))).instanceOf((0, $feLGi$reactbootstrap.Overlay)),
    showOnlyOnce: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    showFeather: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    wrapperClasses: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
$33b04ac1332410ed$var$ABTooltip.defaultProps = {
    buttonLabel: "Close",
    customPlacement: false,
    showOnlyOnce: true,
    showFeather: true
};
var $33b04ac1332410ed$export$2e2bcd8739ae039 = $33b04ac1332410ed$var$ABTooltip;



const $0a01bfcecb6af40f$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext({
    showNotification: ()=>{},
    clearMessage: ()=>{}
});
const $0a01bfcecb6af40f$var$NotificationProvider = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).memo(({ children: children , setNotification: setNotification  })=>{
    const showNotification = (newMessage, newType)=>{
        setNotification({
            message: newMessage,
            type: newType
        });
    };
    const clearMessage = ()=>{
        setNotification({
            message: null,
            type: null
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($0a01bfcecb6af40f$export$a6e93d8cb5d50678.Provider, {
        value: {
            showNotification: showNotification,
            clearMessage: clearMessage
        }
    }, children);
});
var $0a01bfcecb6af40f$export$2e2bcd8739ae039 = $0a01bfcecb6af40f$var$NotificationProvider;








const $f6b18d3fe22096f3$export$5652a72e6427544 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext({
    notification: null,
    setNotification: ()=>{}
});
const $f6b18d3fe22096f3$var$NotificationContainerProvider = ({ children: children  })=>{
    const [notification, setNotification] = (0, $feLGi$react.useState)(null);
    const childrenWithProps = (0, ($parcel$interopDefault($feLGi$react))).Children.map(children, (child)=>{
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).isValidElement(child)) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).cloneElement(child, {
            setNotification: setNotification
        });
        return child;
    });
    const clearMessage = ()=>{
        setNotification({
            message: null,
            type: null
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, childrenWithProps, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($f6b18d3fe22096f3$export$5652a72e6427544.Provider, {
        value: {
            notification: notification,
            clearMessage: clearMessage
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $85e1b49c3de8f11c$export$2e2bcd8739ae039), null)));
};
var $f6b18d3fe22096f3$export$2e2bcd8739ae039 = $f6b18d3fe22096f3$var$NotificationContainerProvider;




const $000a07b0d337ce91$var$CloseIcon = ({ className: className = "" , discardMargin: discardMargin = false , color: color , fontSize: fontSize , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-close icon-cross cursor-pointer", {
            "font-16": !fontSize
        }, {
            "ml-2": !discardMargin
        }, className),
        style: {
            ...color && {
                color: color
            },
            ...fontSize && {
                fontSize: fontSize
            }
        },
        ...rest
    });
};
var $000a07b0d337ce91$export$2e2bcd8739ae039 = $000a07b0d337ce91$var$CloseIcon;


const $85e1b49c3de8f11c$var$Notification = ()=>{
    const [alerts, setAlerts] = (0, $feLGi$react.useState)([]);
    const { clearMessage: clearMessage  } = (0, $feLGi$react.useContext)((0, $0a01bfcecb6af40f$export$a6e93d8cb5d50678));
    const { notification: notification  } = (0, $feLGi$react.useContext)((0, $f6b18d3fe22096f3$export$5652a72e6427544));
    const generate = (0, $feLGi$react.useCallback)(()=>{
        if (notification === null || notification === void 0 ? void 0 : notification.message) setAlerts((alerts)=>{
            if (alerts.find((alerts)=>{
                return (alerts === null || alerts === void 0 ? void 0 : alerts.message) === (notification === null || notification === void 0 ? void 0 : notification.message);
            })) return alerts;
            return [
                ...alerts,
                {
                    id: new Date().getTime(),
                    type: (notification === null || notification === void 0 ? void 0 : notification.type) || "danger",
                    message: notification === null || notification === void 0 ? void 0 : notification.message
                }
            ];
        });
    }, [
        notification
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        clearMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        alerts
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        generate();
    }, [
        notification,
        generate
    ]);
    const onDismissed = (0, $feLGi$react.useCallback)((alert)=>{
        setAlerts((alerts)=>{
            const idx = alerts.indexOf(alert);
            if (idx < 0) return alerts;
            return [
                ...alerts.slice(0, idx),
                ...alerts.slice(idx + 1)
            ];
        });
    }, []);
    if (alerts.length === 0) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "notification-container"
    }, alerts.map((alert)=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Toast), {
            show: true,
            key: alert.id,
            delay: alert.type === "danger" ? 5000 : 3000,
            autohide: true,
            onClose: ()=>onDismissed(alert),
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("border-radius-5 bg-opacity-75 overflow-hidden", {
                "bg-red-800": alert.type === "danger" || alert.type === "error",
                "bg-green-100": alert.type === "success",
                "bg-warning-toast": alert.type === "warning",
                "bg-info-toast": alert.type === "info"
            })
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Toast).Body, {
            className: "text-white justify-content-between d-flex align-items-center"
        }, alert.message, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $000a07b0d337ce91$export$2e2bcd8739ae039), {
            className: "text-white font-12 cursor-pointer ml-2 ms-2",
            onClick: ()=>onDismissed(alert)
        })));
    })));
};
var $85e1b49c3de8f11c$export$2e2bcd8739ae039 = $85e1b49c3de8f11c$var$Notification;








const $a41d748d78d3a02e$var$ABSpinner = ({ colorClass: colorClass  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "mt-4 px-lg-5"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "h-40 d-flex justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Spinner), {
        animation: "border",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(colorClass),
        role: "status"
    })));
};
$a41d748d78d3a02e$var$ABSpinner.defaultProps = {
    colorClass: "text-saffron-700"
};
var $a41d748d78d3a02e$export$2e2bcd8739ae039 = $a41d748d78d3a02e$var$ABSpinner;




const $0999456108fdf02f$var$FeatherLoader = (props)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Image), {
        src: `${process.env.PUBLIC_URL}/assets/images/logo.png`,
        ...props
    }));
};
$0999456108fdf02f$var$FeatherLoader.defaultProps = {
    width: 20
};
var $0999456108fdf02f$export$2e2bcd8739ae039 = $0999456108fdf02f$var$FeatherLoader;








const $045e98f186682651$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext({
    auth: false,
    setAuth: ()=>{},
    user: null,
    setUser: ()=>{},
    journeyMetdata: null
});
const $045e98f186682651$export$38c578650d02ce71 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext();
const $045e98f186682651$export$766af349f7dda290 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext();
const $045e98f186682651$export$caf6d77d41020cdf = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext({
    show: false,
    onHide: ()=>{},
    onShow: ()=>{},
    setModalData: ()=>{},
    data: null
});
const $045e98f186682651$export$fb536717633b0757 = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createContext();


const $211762d35a7f4198$var$LearnMore = ({ category: category , i18n: i18n , onLearnMoreClick: onLearnMoreClick  })=>{
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
    /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        onClick: ()=>{
            onShow();
            setModalData(category);
            onLearnMoreClick(category._id);
        },
        "data-toggle": "modal",
        className: "btn-overall-score cursor-pointer"
    }, "LEARN MORE"));
};
var $211762d35a7f4198$export$2e2bcd8739ae039 = $211762d35a7f4198$var$LearnMore;







(0, ($parcel$interopDefault($feLGi$highchartshighchartsmore)))((0, ($parcel$interopDefault($feLGi$highcharts))));
(0, ($parcel$interopDefault($feLGi$highchartsmodulessolidgauge)))((0, ($parcel$interopDefault($feLGi$highcharts))));
const $63a2d890b0d016d6$var$GaugeChart = ({ className: className , gaugeOption: gaugeOption , backgroundColor: backgroundColor , color: color , percentage: percentage , labelProps: labelProps , size: size  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$highchartsreactofficial))), {
        containerProps: {
            className: className
        },
        highcharts: (0, ($parcel$interopDefault($feLGi$highcharts))),
        options: (0, ($parcel$interopDefault($feLGi$highcharts))).merge({
            chart: {
                type: "solidgauge",
                backgroundColor: "transparent"
            },
            caption: {
                text: null
            },
            title: null,
            pane: {
                center: [
                    "50%",
                    "50%"
                ],
                size: size,
                startAngle: 0,
                endAngle: 360,
                background: {
                    backgroundColor: backgroundColor,
                    borderWidth: 0,
                    innerRadius: "90%",
                    outerRadius: "100%",
                    shape: "arc"
                }
            },
            tooltip: {
                enabled: false
            },
            // the value axis
            yAxis: {
                zIndex: 4,
                stops: [
                    [
                        0,
                        color
                    ],
                    [
                        1,
                        color
                    ] // White
                ],
                background: {
                    backgroundColor: backgroundColor,
                    innerRadius: "90%",
                    outerRadius: "100%",
                    shape: "arc"
                },
                tickInterval: 0,
                lineWidth: 0,
                minorTickWidth: 0,
                tickWidth: 0,
                title: {
                    text: ""
                },
                labels: {
                    enabled: false
                },
                min: 0,
                max: 100
            },
            plotOptions: {
                solidgauge: {
                    innerRadius: "90%",
                    dataLabels: {
                        y: 0,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            series: [
                {
                    name: "",
                    data: [
                        percentage || 0
                    ],
                    dataLabels: {
                        format: `<span class="${labelProps === null || labelProps === void 0 ? void 0 : labelProps.scoreClassName}">${Number.isInteger(percentage) ? percentage : "N/A"}</span>
              <span class="${labelProps === null || labelProps === void 0 ? void 0 : labelProps.percentageClassName}">${Number.isInteger(percentage) ? "%" : ""}</span>`,
                        align: "center",
                        verticalAlign: "middle"
                    },
                    tooltip: {
                        enabled: false
                    }
                }
            ]
        }, gaugeOption)
    });
};
$63a2d890b0d016d6$var$GaugeChart.defaultProps = {
    color: "#000000",
    className: "gaugeSmaller",
    backgroundColor: "transparent",
    size: "100%"
};
var $63a2d890b0d016d6$export$2e2bcd8739ae039 = $63a2d890b0d016d6$var$GaugeChart;






const $f5e2cc126c098556$var$CategoryModal = ()=>{
    const { show: show , onHide: onHide , data: data  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal), {
        show: show,
        size: "lg",
        onHide: onHide,
        "aria-labelledby": "Insight",
        centered: true,
        className: "assessment-category-modal"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal).Header, {
        className: "border-0 pb-0 px-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "text-uppercase s4"
    }, data === null || data === void 0 ? void 0 : data.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal).Body, {
        className: "pb-3 pt-2 px-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: data === null || data === void 0 ? void 0 : data.description
        },
        className: "s7"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-right mt-3 space-x-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: "secondary-light",
        size: "sm",
        onClick: onHide,
        className: "px-3 secondary-popup-button"
    }, "Close"))));
};
var $f5e2cc126c098556$export$2e2bcd8739ae039 = $f5e2cc126c098556$var$CategoryModal;








const $4ab75bde7505621f$var$PlayIcon = ({ className: className , isLoading: isLoading , ...rest })=>{
    const [goldColorVisible, setGoldColorVisible] = (0, $feLGi$react.useState)(false);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 96.445 96.445",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        onMouseOver: (e)=>{
            setGoldColorVisible(true);
        },
        onMouseEnter: (e)=>{
            setGoldColorVisible(true);
        },
        onMouseLeave: (e)=>{
            setGoldColorVisible(false);
        },
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("defs", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("linearGradient", {
        id: "playGradAnimation"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "y2",
        values: "0;0;1;1;0",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "x2",
        values: "0;1;1;0;0",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "y1",
        values: "1;1;0;0;1",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "x1",
        values: "1;0;0;1;1",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.2",
        style: {
            stopColor: "rgb(255,255,255)",
            stopOpacity: 1
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.3",
        style: {
            stopColor: "rgb(191,144,0)",
            stopOpacity: 1
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.5",
        style: {
            stopColor: "rgb(191,144,0)",
            stopOpacity: 1
        }
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        stroke: "none",
        d: "M48.223,0A48.223,48.223,0,1,1,0,48.223,48.223,48.223,0,0,1,48.223,0Z"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fill: isLoading ? "url('#playGradAnimation')" : goldColorVisible ? "#efc030" : "#fff",
        d: "M 48.22265625 2.999992370605469 C 42.11631774902344 2.999992370605469 36.1942253112793 4.195259094238281 30.62088775634766 6.552581787109375 C 25.23616027832031 8.830131530761719 20.39955139160156 12.09127044677734 16.24540710449219 16.24540710449219 C 12.09127044677734 20.39955139160156 8.830131530761719 25.23616027832031 6.552581787109375 30.62088775634766 C 4.195259094238281 36.1942253112793 2.999992370605469 42.11631774902344 2.999992370605469 48.22265625 C 2.999992370605469 54.32899475097656 4.195259094238281 60.2510871887207 6.552581787109375 65.82442474365234 C 8.830131530761719 71.20915222167969 12.09127044677734 76.04576110839844 16.24540710449219 80.19990539550781 C 20.39955139160156 84.35404205322266 25.23616027832031 87.61518096923828 30.62088775634766 89.89273071289063 C 36.1942253112793 92.25005340576172 42.11631774902344 93.44532012939453 48.22265625 93.44532012939453 C 54.32899475097656 93.44532012939453 60.2510871887207 92.25005340576172 65.82442474365234 89.89273071289063 C 71.20915222167969 87.61518096923828 76.04576110839844 84.35404205322266 80.19990539550781 80.19990539550781 C 84.35404205322266 76.04576110839844 87.61518096923828 71.20915222167969 89.89273071289063 65.82442474365234 C 92.25005340576172 60.2510871887207 93.44532012939453 54.32899475097656 93.44532012939453 48.22265625 C 93.44532012939453 42.11631774902344 92.25005340576172 36.1942253112793 89.89273071289063 30.62088775634766 C 87.61518096923828 25.23616027832031 84.35404205322266 20.39955139160156 80.19990539550781 16.24540710449219 C 76.04576110839844 12.09127044677734 71.20915222167969 8.830131530761719 65.82442474365234 6.552581787109375 C 60.2510871887207 4.195259094238281 54.32899475097656 2.999992370605469 48.22265625 2.999992370605469 M 48.22265625 -7.62939453125e-06 C 74.85528564453125 -7.62939453125e-06 96.44532012939453 21.59002685546875 96.44532012939453 48.22265625 C 96.44532012939453 74.85528564453125 74.85528564453125 96.44532012939453 48.22265625 96.44532012939453 C 21.59002685546875 96.44532012939453 -7.62939453125e-06 74.85528564453125 -7.62939453125e-06 48.22265625 C -7.62939453125e-06 21.59002685546875 21.59002685546875 -7.62939453125e-06 48.22265625 -7.62939453125e-06 Z"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        fill: goldColorVisible ? "#efc030" : "#fff",
        transform: "translate(72.64 28.954) rotate(90)"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        stroke: "none",
        d: "M 35.0960693359375 35.79190826416016 L 5.054467678070068 35.79190826416016 C 4.341457843780518 35.79190826416016 3.698507785797119 35.42584991455078 3.334587812423706 34.81270980834961 C 2.970667839050293 34.19956970214844 2.957297801971436 33.4598388671875 3.298807859420776 32.83395004272461 L 18.31961822509766 5.305349349975586 C 18.6756477355957 4.652859210968018 19.33195686340332 4.263309478759766 20.07526779174805 4.263309478759766 C 20.81857872009277 4.263309478759766 21.47488784790039 4.652859210968018 21.8309268951416 5.305349349975586 L 36.85171890258789 32.83395004272461 C 37.1932373046875 33.4598503112793 37.17985916137695 34.19956970214844 36.81593704223633 34.81270980834961 C 36.45201873779297 35.42585754394531 35.80907821655273 35.79190826416016 35.0960693359375 35.79190826416016 Z"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fill: goldColorVisible ? "#efc030" : "#fff",
        d: "M 20.07526779174805 5.263309478759766 C 19.89680862426758 5.263309478759766 19.45402717590332 5.314079284667969 19.19743728637695 5.784328460693359 L 4.176639556884766 33.31292724609375 C 3.930507659912109 33.76400756835938 4.107158660888672 34.15509796142578 4.194538116455078 34.30231094360352 C 4.281906127929688 34.44952011108398 4.540596008300781 34.79190063476563 5.054466247558594 34.79190063476563 L 35.09607696533203 34.79190063476563 C 35.60980987548828 34.79190063476563 35.8685188293457 34.44945907592773 35.95590972900391 34.30223846435547 C 36.04328918457031 34.15501022338867 36.21996688842773 33.76390075683594 35.97389984130859 33.31292724609375 L 20.95309829711914 5.784339904785156 C 20.69650840759277 5.314079284667969 20.25372695922852 5.263309478759766 20.07526779174805 5.263309478759766 M 20.07526397705078 3.263309478759766 C 21.10771369934082 3.263309478759766 22.14016342163086 3.784328460693359 22.70874786376953 4.826370239257813 L 37.72954940795898 32.3549690246582 C 38.82028961181641 34.35397720336914 37.37321090698242 36.79190063476563 35.0960807800293 36.79190063476563 C 35.09594345092773 36.79190063476563 35.09620666503906 36.79190063476563 35.0960693359375 36.79190063476563 L 5.054466247558594 36.79190063476563 C 2.777099609375 36.79190826416016 1.330177307128906 34.35409927368164 2.420986175537109 32.3549690246582 L 17.44178771972656 4.826370239257813 C 18.01036834716797 3.784328460693359 19.04281616210938 3.263309478759766 20.07526397705078 3.263309478759766 Z"
    })));
};
var $4ab75bde7505621f$export$2e2bcd8739ae039 = $4ab75bde7505621f$var$PlayIcon;













const $a70a9e1418ed64a5$var$LeftArrowIcon = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ className: className , style: style , bgColor: bgColor , bgOpacity: bgOpacity , removeSwiperClass: removeSwiperClass , ...rest }, ref)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        ref: ref,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "swiper-button-prev": !removeSwiperClass
        }, className),
        width: "16",
        height: "23",
        viewBox: "0 0 16 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M14 1.58594L2 11.2922",
        stroke: "black",
        strokeWidth: "3",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M14 20.9992L2 11.293",
        stroke: "black",
        strokeWidth: "3",
        strokeLinecap: "round"
    }));
});
$a70a9e1418ed64a5$var$LeftArrowIcon.propTypes = {
    removeSwiperClass: (0, ($parcel$interopDefault($feLGi$proptypes))).bool
};
$a70a9e1418ed64a5$var$LeftArrowIcon.defaultProps = {
    removeSwiperClass: false
};
var $a70a9e1418ed64a5$export$2e2bcd8739ae039 = $a70a9e1418ed64a5$var$LeftArrowIcon;





const $633876fd9be55329$var$RightArrowIcon = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ className: className , bgColor: bgColor , style: style , bgOpacity: bgOpacity , removeSwiperClass: removeSwiperClass , ...rest }, ref)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        ref: ref,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "swiper-button-next": !removeSwiperClass
        }, className),
        width: "16",
        height: "23",
        viewBox: "0 0 16 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M2 21L14 11.2937",
        stroke: "black",
        strokeWidth: "3",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M2 1.5867L14 11.293",
        stroke: "black",
        strokeWidth: "3",
        strokeLinecap: "round"
    }));
});
$633876fd9be55329$var$RightArrowIcon.propTypes = {
    removeSwiperClass: (0, ($parcel$interopDefault($feLGi$proptypes))).bool
};
$633876fd9be55329$var$RightArrowIcon.defaultProps = {
    removeSwiperClass: false
};
var $633876fd9be55329$export$2e2bcd8739ae039 = $633876fd9be55329$var$RightArrowIcon;




(0, ($parcel$interopDefault($feLGi$swiper))).use([
    (0, $feLGi$swiper.Navigation),
    (0, $feLGi$swiper.EffectFade)
]);
const $48066f01c1cada83$var$ABSwiperSlider = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ children: children , breakpoints: breakpoints , containerClassName: containerClassName , effect: effect , arrowProps: { hide: hide , ...resetArrowProps } , ...rest }, ref)=>{
    const prevRef = (0, $feLGi$react.useRef)(null);
    const nextRef = (0, $feLGi$react.useRef)(null);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: containerClassName
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$swiperreact.Swiper), {
        ref: ref,
        breakpoints: breakpoints,
        onInit: (swiper)=>{
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
        // swiper.navigation.init()
        // swiper.navigation.update()
        },
        navigation: {
            nextEl: nextRef.current ? nextRef.current : undefined,
            prevEl: prevRef.current ? prevRef.current : undefined
        },
        style: {
            position: "unset"
        },
        ...rest
    }, !hide && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a70a9e1418ed64a5$export$2e2bcd8739ae039), {
        ref: prevRef,
        ...resetArrowProps
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $633876fd9be55329$export$2e2bcd8739ae039), {
        ref: nextRef,
        ...resetArrowProps
    })), children));
});
$48066f01c1cada83$var$ABSwiperSlider.propTypes = {
    containerClassName: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
$48066f01c1cada83$var$ABSwiperSlider.defaultProps = {
    breakpoints: {
        320: {
            slidesPerView: "auto",
            spaceBetween: 20
        },
        576: {
            slidesPerView: "auto",
            spaceBetween: 25
        },
        992: {
            slidesPerView: "auto",
            spaceBetween: 25
        }
    },
    arrowProps: {
        hide: false
    }
};
var $48066f01c1cada83$export$2e2bcd8739ae039 = $48066f01c1cada83$var$ABSwiperSlider;



const $6e18117e8ec75a85$var$useResolutionService = ()=>{
    const [isLGScreen, setIsLGScreen] = (0, $feLGi$react.useState)(window.innerWidth > 1080);
    const [isSMScreen, setIsSMScreen] = (0, $feLGi$react.useState)(window.innerWidth > 576 && window.innerWidth < 768);
    const [isMDScreen, setIsMDScreen] = (0, $feLGi$react.useState)(window.innerWidth > 768 && window.innerWidth < 1080);
    const [isXSScreen, setIsXSScreen] = (0, $feLGi$react.useState)(window.innerWidth < 576);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $feLGi$react.useEffect)(()=>{
        const windowSize = ()=>{
            if (window.innerWidth > 1080) {
                setIsLGScreen(true);
                setIsSMScreen(false);
                setIsMDScreen(false);
                setIsXSScreen(false);
            } else if (window.innerWidth > 576 && window.innerWidth < 768) {
                setIsLGScreen(false);
                setIsSMScreen(true);
                setIsMDScreen(false);
                setIsXSScreen(false);
            } else if (window.innerWidth > 768 && window.innerWidth < 1080) {
                setIsLGScreen(false);
                setIsSMScreen(false);
                setIsMDScreen(true);
                setIsXSScreen(false);
            } else {
                setIsXSScreen(true);
                setIsLGScreen(false);
                setIsSMScreen(false);
                setIsMDScreen(false);
            }
        };
        window.addEventListener("resize", windowSize);
        return ()=>window.removeEventListener("resize", windowSize);
    });
    return {
        isLGScreen: isLGScreen,
        isSMScreen: isSMScreen,
        isMDScreen: isMDScreen,
        isXSScreen: isXSScreen
    };
};
var $6e18117e8ec75a85$export$2e2bcd8739ae039 = $6e18117e8ec75a85$var$useResolutionService;


const $6cc7c1c352fdaa37$var$RecommendedAudio = ({ NavLink: NavLink , recommendedData: recommendedData , isRecommendedLoading: isRecommendedLoading , limit: limit , setRecommendPage: setRecommendPage , recommendedSwiperRef: recommendedSwiperRef , playRecommendedAudio: playRecommendedAudio = ()=>{}  })=>{
    const [recentIndex, setRecentIndex] = (0, $feLGi$react.useState)(0);
    const { isMDScreen: isMDScreen , isLGScreen: isLGScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    if (recommendedData.length === 0) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, !isRecommendedLoading && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $48066f01c1cada83$export$2e2bcd8739ae039), {
        onSlideNextTransitionEnd: (e)=>{
            const index = e.activeIndex;
            if (index > recentIndex && index > 0 && (index + 3) % limit === 0) {
                setRecentIndex(()=>index);
                setRecommendPage((prev)=>prev + 1);
            }
        },
        arrowProps: {
            hide: isLGScreen && recommendedData.length < 3 || isMDScreen && recommendedData.length < 2,
            bgColor: "#646464",
            bgOpacity: 1
        },
        onSwiper: (swiper)=>recommendedSwiperRef.current = swiper,
        containerClassName: "card-swiper"
    }, recommendedData === null || recommendedData === void 0 ? void 0 : recommendedData.map((media)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$swiperreact.SwiperSlide), {
            key: media._id
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(NavLink, {
            to: `/media/category/${media.subCategoryId._id}/${media._id}`,
            onClick: ()=>playRecommendedAudio(media.subCategoryId._id, media._id)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "position-relative border-radius-10 overflow-hidden"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
            className: "border-radius-10 img-cover",
            imgixParams: {
                fit: "crop",
                crop: "edges",
                w: 400,
                h: 400,
                ar: "1:1"
            },
            src: `${process.env.REACT_APP_IMG_SOURCE}/${media.imageFilename}`,
            width: "100%",
            alt: "image"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "position-absolute inset-0 d-flex justify-content-center align-items-center px-5 border-radius-10 hover:bg-black-100 hover:bg-opacity-75 breakthrough-media-card"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4ab75bde7505621f$export$2e2bcd8739ae039), {
            className: "play-icon"
        })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "d-block font-open-sans font-lg-14 font-12 font-semibold media-card-title letter-spacing-minus-02 text-truncate"
        }, media.title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "font-open-sans font-semibold font-lg-12 font-10 media-card-minutes"
        }, Math.round(media.duration / 60), " minutes")))))));
};
var $6cc7c1c352fdaa37$export$2e2bcd8739ae039 = $6cc7c1c352fdaa37$var$RecommendedAudio;






const $046f139f7bee52e1$var$ModalProvider = ({ children: children  })=>{
    const [show, setShow] = (0, $feLGi$react.useState)(false);
    const [data, setData] = (0, $feLGi$react.useState)(null);
    const onHide = ()=>{
        setShow(false);
    };
    const onShow = ()=>{
        setShow(true);
    };
    const setModalData = (data)=>{
        setData(data);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $045e98f186682651$export$caf6d77d41020cdf).Provider, {
        value: {
            show: show,
            data: data,
            onShow: onShow,
            onHide: onHide,
            setModalData: setModalData
        }
    }, children);
};
var $046f139f7bee52e1$export$2e2bcd8739ae039 = $046f139f7bee52e1$var$ModalProvider;







const $16cd004ed61f6568$export$e9e149b4285ca4b1 = (0, ($parcel$interopDefault($feLGi$bugsnagjs))).start({
    apiKey: process.env.REACT_APP_BUGSNAG,
    plugins: [
        new (0, ($parcel$interopDefault($feLGi$bugsnagpluginreact)))()
    ],
    enabledBreadcrumbTypes: [
        "error",
        "log",
        "navigation",
        "request"
    ],
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: [
        "production"
    ]
});
const $16cd004ed61f6568$var$ErrorBoundary = (0, ($parcel$interopDefault($feLGi$bugsnagjs))).getPlugin("react").createErrorBoundary((0, ($parcel$interopDefault($feLGi$react))));
var $16cd004ed61f6568$export$2e2bcd8739ae039 = $16cd004ed61f6568$var$ErrorBoundary;


const $abbf3dedc3048db2$var$useErrorService = ()=>{
    const Notification = (0, $feLGi$react.useContext)((0, $0a01bfcecb6af40f$export$a6e93d8cb5d50678));
    const showError = (error)=>{
        var _error_constructor;
        if ((error === null || error === void 0 ? void 0 : (_error_constructor = error.constructor) === null || _error_constructor === void 0 ? void 0 : _error_constructor.name) === "Error") {
            if (error.message === "Request aborted") return;
            if (error.message === "Network Error") Notification && Notification.showNotification("Network Error, Please try again later");
            else {
                (0, $16cd004ed61f6568$export$e9e149b4285ca4b1).leaveBreadcrumb("Error State", error, "error");
                (0, $16cd004ed61f6568$export$e9e149b4285ca4b1).notify("ErrorService");
                Notification && Notification.showNotification("Something went wrong, please try again later.");
            }
        } else switch(error === null || error === void 0 ? void 0 : error.code){
            case "payment_fail":
            case "card_declined":
            case "expired_card":
            case "incorrect_cvc":
            case "processing_error":
            case "incorrect_number":
            case "token_expired":
            case "not_found":
            case "signup_error":
            case "email_exists":
            case "internal_server_error":
            case "user_not_found":
            case "unauthorize":
            case "upgrade_plan":
            case "forbidden":
            case "previous_media_not_completed":
            case "media_not_completed":
            case "previous_module_not_completed":
            case "validation_error":
            case "code_already_exists":
            case "need_at_least_one_survey":
            case "resource_not_found":
            case "company_cycle_not_started_yet":
            case "not_in_current_billing_cycle":
            case "session_limit_exceeded":
            case "cycle_start_date_cannot_change":
            case "payment_must_be_within_cycle":
            case "cycle_start_date_not_set":
            case "only_six_months_date_range_allowed":
            case "participant_level_required_to_assign_team":
            case "different_team_participant_level":
            case "conflict":
            case "session_duration_not_set":
            case "max_media_limit_exceeded":
            case "session_date_must_be_within_cycle":
            case "need_at_least_three_survey":
            case "sow_team_custom_rate_needed":
            case "not_taken_survey":
            case "transition_cannot_do_leader":
            case "user_not_eligible":
            case "user_plan_not_expire":
            case "leader_req_cant_update":
            case "coaching_plan_limit_exceeded":
            case "cant_update_plan_as_user_in_group":
            case "register_with_org_provided_email":
            case "org_not_invite_only":
            case "network_not_invite_only":
            case "cant_set_no_plan_in_org":
            case "cant_set_no_plan_in_network":
            case "csv_max_limit":
            case "video_already_exists":
            case "register_with_invite_link":
            case "invalid_quest_resource_order":
                if (Notification) Notification.showNotification(error.message);
                break;
            case "document_not_found":
            case "participant_level_must_be_set":
                if (Notification) Notification.showNotification(error.message);
                break;
            case "user_not_part_of_team":
                if (Notification) Notification.showNotification(error.message);
                break;
            case "session_notes_character_limit_exceeded":
                if (Notification) Notification.showNotification(error.message);
                break;
            case "two_factor_not_verified":
            case "payment_required":
            case "quest_payment_required":
            case "plan_expired":
            case "account_not_verify":
                Notification && Notification.showNotification(error.message);
                break;
            // case 'quest_not_ready_to_publish':
            //   // Handled by CreateQuest publish flow (dedicated notification + overview refresh).
            //   break
            default:
                (0, $16cd004ed61f6568$export$e9e149b4285ca4b1).leaveBreadcrumb("Error State", error, "error");
                (0, $16cd004ed61f6568$export$e9e149b4285ca4b1).notify("ErrorService default");
                if (Notification) Notification.showNotification("Something went wrong!");
                break;
        }
    };
    return {
        showError: showError
    };
};
var $abbf3dedc3048db2$export$2e2bcd8739ae039 = $abbf3dedc3048db2$var$useErrorService;


const $37e9eb5c1b76d025$var$SurveyResult = ({ isLoading: isLoading , survey: survey , clientId: clientId , onClick: onClick , i18n: i18n , navigateToSurveyCategory: navigateToSurveyCategory = ()=>{} , onLearnMoreClick: onLearnMoreClick = ()=>{} , headerText: headerText , subHeaderText: subHeaderText = "" , subHeaderDescription: subHeaderDescription = "" , showBreakthroughProgramInfo: showBreakthroughProgramInfo = true , onGoBack: onGoBack = ()=>{} , showGoBackButton: showGoBackButton = true , API: API , NavLink: NavLink , playRecommendedAudio: playRecommendedAudio = ()=>{}  })=>{
    var _survey_results, _survey_results_self_awareness, _survey_categories, _survey_results1, _survey_results_team_cohesion, _survey_categories1, _survey_results2, _survey_results_vision__impact, _survey_categories2, _survey_results3, _survey_results_self_awareness1, _survey_categories3, _survey_results4, _survey_results_self_awareness2, _survey_results5, _survey_results_team_cohesion1, _survey_categories4, _survey_results6, _survey_results_team_cohesion2, _survey_results7, _survey_results_vision__impact1, _survey_categories5, _survey_results8, _survey_results_vision__impact2, _survey_users;
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const recommendedSwiperRef = (0, $feLGi$react.useRef)(null);
    const [recommendedData, setRecommendedData] = (0, $feLGi$react.useState)([]);
    const [isRecommendedLoading, setIsRecommendedLoading] = (0, $feLGi$react.useState)(false);
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    const [recommendPage, setRecommendPage] = (0, $feLGi$react.useState)(1);
    const limit = 6;
    (0, $feLGi$react.useEffect)(()=>{
        const getRecommendedData = async ()=>{
            try {
                if (recommendPage === 1) setIsRecommendedLoading(true);
                const { data: data  } = await API.mediaLibrary.getRecommendedMedias({
                    page: recommendPage,
                    limit: limit
                });
                if (Array.isArray(data)) setRecommendedData([
                    ...recommendedData,
                    ...data
                ]);
                else throw data;
                setIsRecommendedLoading(false);
            } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === "ValidationError" || (e === null || e === void 0 ? void 0 : e.code) === "resource_not_found" || (e === null || e === void 0 ? void 0 : e.code) === "not_found") history.replace("/404");
                else {
                    setIsRecommendedLoading(false);
                    Error.showError(e);
                }
            }
        };
        if (showBreakthroughProgramInfo) getRecommendedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recommendPage
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        if (!isRecommendedLoading && recommendedData.length > 0) setTimeout(()=>{
            if (recommendedSwiperRef && recommendedSwiperRef.current) recommendedSwiperRef.current.update();
        });
    }, [
        isRecommendedLoading,
        recommendedData
    ]);
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a41d748d78d3a02e$export$2e2bcd8739ae039), null);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $046f139f7bee52e1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("pt-4 mb-2-5", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo
        }),
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center align-items-center"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn mr-lg-4 mr-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h2", {
        className: "font-montserrat font-bold font-32 text-dark-900 line-height-39 letter-spacing-minus-02 mb-0"
    }, headerText))), subHeaderText && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h4", {
        className: "font-montserrat font-semibold text-grey-600 mt-3"
    }, subHeaderText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "font-montserrat text-grey-600 d-flex justify-content-center mt-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "w-100 w-lg-7/12"
    }, subHeaderDescription))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pb-4 category-chart-section",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 3,
        xl: 3
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "position-relative text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "well text-center bg-blue-100 category-score-card"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#ffffff",
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_self_awareness = _survey_results.self_awareness) === null || _survey_results_self_awareness === void 0 ? void 0 : _survey_results_self_awareness.percent,
        labelProps: {
            scoreClassName: "category-score",
            percentageClassName: "seperate-percentage"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "category-title-label"
    }, "Self Awareness"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $33b04ac1332410ed$export$2e2bcd8739ae039), {
        placement: "auto-end",
        controllId: "xs-awareness-tooltip",
        contentText: "Now that you have completed your assessment you can quickly see what areas could benefit from growth and development.",
        className: "d-flex d-lg-none xs-awareness-tooltip-icon"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        i18n: i18n,
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.self_awareness) || (survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "self_awareness";
        })),
        onLearnMoreClick: onLearnMoreClick
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative well text-center bg-green-100 category-score-card"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $33b04ac1332410ed$export$2e2bcd8739ae039), {
        controllId: "assessment-tooltip",
        contentText: "Now that you have completed your assessment you can quickly see what areas could benefit from growth and development.",
        className: "d-none d-lg-flex team-cohesion-tooltip-icon"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#ffffff",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_team_cohesion = _survey_results1.team_cohesion) === null || _survey_results_team_cohesion === void 0 ? void 0 : _survey_results_team_cohesion.percent,
        labelProps: {
            scoreClassName: "category-score",
            percentageClassName: "seperate-percentage"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "category-title-label"
    }, "Team Cohesion")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.team_cohesion) || (survey === null || survey === void 0 ? void 0 : (_survey_categories1 = survey.categories) === null || _survey_categories1 === void 0 ? void 0 : _survey_categories1.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "team_cohesion";
        })),
        onLearnMoreClick: onLearnMoreClick,
        i18n: i18n
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "well text-center bg-red-500 category-score-card"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#ffffff",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_vision__impact = _survey_results2.vision__impact) === null || _survey_results_vision__impact === void 0 ? void 0 : _survey_results_vision__impact.percent,
        labelProps: {
            scoreClassName: "category-score",
            percentageClassName: "seperate-percentage"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "category-title-label"
    }, "Vision & Impact")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.vision__impact) || (survey === null || survey === void 0 ? void 0 : (_survey_categories2 = survey.categories) === null || _survey_categories2 === void 0 ? void 0 : _survey_categories2.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "vision__impact";
        })),
        onLearnMoreClick: onLearnMoreClick,
        i18n: i18n
    })))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: "bg-gray-104 container-fluid"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("justify-content-center", {
            "pl-2": !showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex flex-column mt-3-5 mb-3-5 col-12 col-lg-11 px-md-30", {
            "pl-lg-3": !showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "explore-insight-title font-bold leading-9 mb-3"
    }, "Interpreting Results"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "explore-insight-description font-semibold leading-7 letter-spacing-minus-02"
    }, "Below we have further broken down your assessment results. To learn more about each subcategory, click the info buttons. To better understand your results, we highly recommend you", " ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        className: "text-saffron-700",
        href: "mailto:service@abroad.io?subject=Schedule a growth plan session with an Abroad coach."
    }, "schedule a session"), " ", "with one of our coaches who will ask further questions to uncover the assumptions, mindsets and behaviors driving your results with the goal of generating a targeted growth plan."))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-3-5 mb-3-5 font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-circle text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#69B1D8",
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_self_awareness1 = _survey_results3.self_awareness) === null || _survey_results_self_awareness1 === void 0 ? void 0 : _survey_results_self_awareness1.percent,
        className: "score",
        size: "85%",
        labelProps: {
            scoreClassName: "category-total-score text-blue-100",
            percentageClassName: "percentage-icon text-blue-100"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-blue-100 font-semibold leading-7-half letter-spacing-minus-02 category-assessment-label"
    }, "Self Awareness"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.self_awareness) || (survey === null || survey === void 0 ? void 0 : (_survey_categories3 = survey.categories) === null || _survey_categories3 === void 0 ? void 0 : _survey_categories3.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "self_awareness";
        })),
        onLearnMoreClick: onLearnMoreClick,
        i18n: i18n
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-score"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-wrp"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative self-awareness-courses-lable leading-5 letter-spacing-2 text-uppercase font-montserrat text-blue-100"
    }, "Key Aspects of Self Awareness", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $33b04ac1332410ed$export$2e2bcd8739ae039), {
        controllId: "Key Aspects of Self Awareness",
        contentText: "Clicking the 'Information buttons' next to any subcategory will provide you instant access to a video and write-up to understand your results.",
        className: "d-none d-lg-flex self-awareness-tooltip-icon"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $33b04ac1332410ed$export$2e2bcd8739ae039), {
        placement: "auto-end",
        controllId: "Key Aspects of Self Awareness",
        contentText: "Clicking the 'Information buttons' next to any subcategory will provide you instant access to a video and write-up to understand your results.",
        className: "d-flex d-lg-none self-awareness-tooltip-icon"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-title-wrp"
    }, survey === null || survey === void 0 ? void 0 : (_survey_results4 = survey.results) === null || _survey_results4 === void 0 ? void 0 : (_survey_results_self_awareness2 = _survey_results4.self_awareness) === null || _survey_results_self_awareness2 === void 0 ? void 0 : _survey_results_self_awareness2.order.map((subcategory)=>{
        var _survey_results_self_awareness_subcategories_subcategory, _survey_results, _survey_results_self_awareness, _survey_results_self_awareness_subcategories_subcategory1, _survey_results1, _survey_results_self_awareness1, _survey_results_self_awareness_subcategories_subcategory2, _survey_results2, _survey_results_self_awareness2, _survey_results_self_awareness_subcategories_subcategory3, _survey_results3, _survey_results_self_awareness3, _survey_results_self_awareness_subcategories_subcategory4, _survey_results4, _survey_results_self_awareness4;
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            key: (_survey_results_self_awareness_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_self_awareness = _survey_results.self_awareness) === null || _survey_results_self_awareness === void 0 ? void 0 : _survey_results_self_awareness.subcategories[subcategory]) === null || _survey_results_self_awareness_subcategories_subcategory === void 0 ? void 0 : _survey_results_self_awareness_subcategories_subcategory.title,
            className: "survey-subcat-link"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "self-awareness-courses-title-row",
            "data-id": (_survey_results_self_awareness_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_self_awareness1 = _survey_results1.self_awareness) === null || _survey_results_self_awareness1 === void 0 ? void 0 : _survey_results_self_awareness1.subcategories[subcategory]) === null || _survey_results_self_awareness_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_self_awareness_subcategories_subcategory1.title
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "course-title-span font-semibold font-open-sans leading-6 letter-spacing-minus-02"
        }, (_survey_results_self_awareness_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_self_awareness2 = _survey_results2.self_awareness) === null || _survey_results_self_awareness2 === void 0 ? void 0 : _survey_results_self_awareness2.subcategories[subcategory]) === null || _survey_results_self_awareness_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_self_awareness_subcategories_subcategory2.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score font-semibold font-open-sans leading-6 letter-spacing-minus-02 mr-3 ms-3 align-self-center"
        }, Number.isInteger((_survey_results_self_awareness_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_self_awareness3 = _survey_results3.self_awareness) === null || _survey_results_self_awareness3 === void 0 ? void 0 : _survey_results_self_awareness3.subcategories[subcategory]) === null || _survey_results_self_awareness_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_self_awareness_subcategories_subcategory3.percent) ? `${(_survey_results_self_awareness_subcategories_subcategory4 = survey === null || survey === void 0 ? void 0 : (_survey_results4 = survey.results) === null || _survey_results4 === void 0 ? void 0 : (_survey_results_self_awareness4 = _survey_results4.self_awareness) === null || _survey_results_self_awareness4 === void 0 ? void 0 : _survey_results_self_awareness4.subcategories[subcategory]) === null || _survey_results_self_awareness_subcategories_subcategory4 === void 0 ? void 0 : _survey_results_self_awareness_subcategories_subcategory4.percent}%` : "N/A"), navigateToSurveyCategory(subcategory))));
    })))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "py-3-5 bg-gray-104 font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-circle text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#509f92",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results5 = survey.results) === null || _survey_results5 === void 0 ? void 0 : (_survey_results_team_cohesion1 = _survey_results5.team_cohesion) === null || _survey_results_team_cohesion1 === void 0 ? void 0 : _survey_results_team_cohesion1.percent,
        className: "score",
        size: "85%",
        labelProps: {
            scoreClassName: "category-total-score text-green-100",
            percentageClassName: "percentage-icon text-green-100"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-green-100 font-semibold leading-7-half letter-spacing-minus-02 category-assessment-label"
    }, "Team Cohesion"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.team_cohesion) || (survey === null || survey === void 0 ? void 0 : (_survey_categories4 = survey.categories) === null || _survey_categories4 === void 0 ? void 0 : _survey_categories4.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "team_cohesion";
        })),
        onLearnMoreClick: onLearnMoreClick,
        i18n: i18n
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-score"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-wrp"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-lable leading-5 letter-spacing-2 text-uppercase font-montserrat text-green-100"
    }, "Key Aspects of Team Cohesion"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-title-wrp"
    }, survey === null || survey === void 0 ? void 0 : (_survey_results6 = survey.results) === null || _survey_results6 === void 0 ? void 0 : (_survey_results_team_cohesion2 = _survey_results6.team_cohesion) === null || _survey_results_team_cohesion2 === void 0 ? void 0 : _survey_results_team_cohesion2.order.map((subcategory)=>{
        var _survey_results_team_cohesion_subcategories_subcategory, _survey_results, _survey_results_team_cohesion, _survey_results_team_cohesion_subcategories_subcategory1, _survey_results1, _survey_results_team_cohesion1, _survey_results_team_cohesion_subcategories_subcategory2, _survey_results2, _survey_results_team_cohesion2, _survey_results_team_cohesion_subcategories_subcategory3, _survey_results3, _survey_results_team_cohesion3, _survey_results_team_cohesion_subcategories_subcategory4, _survey_results4, _survey_results_team_cohesion4;
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            key: (_survey_results_team_cohesion_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_team_cohesion = _survey_results.team_cohesion) === null || _survey_results_team_cohesion === void 0 ? void 0 : _survey_results_team_cohesion.subcategories[subcategory]) === null || _survey_results_team_cohesion_subcategories_subcategory === void 0 ? void 0 : _survey_results_team_cohesion_subcategories_subcategory.title,
            className: "survey-subcat-link"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "self-awareness-courses-title-row",
            "data-id": (_survey_results_team_cohesion_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_team_cohesion1 = _survey_results1.team_cohesion) === null || _survey_results_team_cohesion1 === void 0 ? void 0 : _survey_results_team_cohesion1.subcategories[subcategory]) === null || _survey_results_team_cohesion_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_team_cohesion_subcategories_subcategory1.title
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "course-title-span font-semibold font-open-sans leading-6 letter-spacing-minus-02"
        }, (_survey_results_team_cohesion_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_team_cohesion2 = _survey_results2.team_cohesion) === null || _survey_results_team_cohesion2 === void 0 ? void 0 : _survey_results_team_cohesion2.subcategories[subcategory]) === null || _survey_results_team_cohesion_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_team_cohesion_subcategories_subcategory2.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score font-semibold font-open-sans leading-6 letter-spacing-minus-02 mr-3 ms-3 align-self-center"
        }, (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? "N/A" : Number.isInteger((_survey_results_team_cohesion_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_team_cohesion3 = _survey_results3.team_cohesion) === null || _survey_results_team_cohesion3 === void 0 ? void 0 : _survey_results_team_cohesion3.subcategories[subcategory]) === null || _survey_results_team_cohesion_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_team_cohesion_subcategories_subcategory3.percent) ? `${(_survey_results_team_cohesion_subcategories_subcategory4 = survey === null || survey === void 0 ? void 0 : (_survey_results4 = survey.results) === null || _survey_results4 === void 0 ? void 0 : (_survey_results_team_cohesion4 = _survey_results4.team_cohesion) === null || _survey_results_team_cohesion4 === void 0 ? void 0 : _survey_results_team_cohesion4.subcategories[subcategory]) === null || _survey_results_team_cohesion_subcategories_subcategory4 === void 0 ? void 0 : _survey_results_team_cohesion_subcategories_subcategory4.percent}%` : "N/A"), navigateToSurveyCategory(subcategory))));
    })))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-3-5 mb-3-5 font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-circle text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $63a2d890b0d016d6$export$2e2bcd8739ae039), {
        backgroundColor: "#e5e5e5",
        color: "#BC4C6A",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results7 = survey.results) === null || _survey_results7 === void 0 ? void 0 : (_survey_results_vision__impact1 = _survey_results7.vision__impact) === null || _survey_results_vision__impact1 === void 0 ? void 0 : _survey_results_vision__impact1.percent,
        className: "score",
        size: "85%",
        labelProps: {
            scoreClassName: "category-total-score text-red-500",
            percentageClassName: "percentage-icon text-red-500"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-red-500 font-semibold leading-7-half letter-spacing-minus-02 category-assessment-label"
    }, "Vision & Impact"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $211762d35a7f4198$export$2e2bcd8739ae039), {
        category: (survey === null || survey === void 0 ? void 0 : survey.categories.vision__impact) || (survey === null || survey === void 0 ? void 0 : (_survey_categories5 = survey.categories) === null || _survey_categories5 === void 0 ? void 0 : _survey_categories5.find((subCat)=>{
            return (subCat === null || subCat === void 0 ? void 0 : subCat.key) === "vision__impact";
        })),
        onLearnMoreClick: onLearnMoreClick,
        i18n: i18n
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-score"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-wrp"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-lable leading-5 letter-spacing-2 text-uppercase font-montserrat text-red-500"
    }, "Key Aspects of Vision & Impact"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "self-awareness-courses-title-wrp"
    }, survey === null || survey === void 0 ? void 0 : (_survey_results8 = survey.results) === null || _survey_results8 === void 0 ? void 0 : (_survey_results_vision__impact2 = _survey_results8.vision__impact) === null || _survey_results_vision__impact2 === void 0 ? void 0 : _survey_results_vision__impact2.order.map((subcategory)=>{
        var _survey_results_vision__impact_subcategories_subcategory, _survey_results, _survey_results_vision__impact, _survey_results_vision__impact_subcategories_subcategory1, _survey_results1, _survey_results_vision__impact1, _survey_results_vision__impact_subcategories_subcategory2, _survey_results2, _survey_results_vision__impact2, _survey_results_vision__impact_subcategories_subcategory3, _survey_results3, _survey_results_vision__impact3, _survey_results_vision__impact_subcategories_subcategory4, _survey_results4, _survey_results_vision__impact4;
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            key: (_survey_results_vision__impact_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_vision__impact = _survey_results.vision__impact) === null || _survey_results_vision__impact === void 0 ? void 0 : _survey_results_vision__impact.subcategories[subcategory]) === null || _survey_results_vision__impact_subcategories_subcategory === void 0 ? void 0 : _survey_results_vision__impact_subcategories_subcategory.title,
            className: "survey-subcat-link"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "self-awareness-courses-title-row",
            "data-id": (_survey_results_vision__impact_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_vision__impact1 = _survey_results1.vision__impact) === null || _survey_results_vision__impact1 === void 0 ? void 0 : _survey_results_vision__impact1.subcategories[subcategory]) === null || _survey_results_vision__impact_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_vision__impact_subcategories_subcategory1.title
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "course-title-span font-semibold font-open-sans leading-6 letter-spacing-minus-02"
        }, (_survey_results_vision__impact_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_vision__impact2 = _survey_results2.vision__impact) === null || _survey_results_vision__impact2 === void 0 ? void 0 : _survey_results_vision__impact2.subcategories[subcategory]) === null || _survey_results_vision__impact_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_vision__impact_subcategories_subcategory2.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score font-semibold font-open-sans leading-6 letter-spacing-minus-02 mr-3 ms-3 align-self-center"
        }, (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? "N/A" : Number.isInteger((_survey_results_vision__impact_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_vision__impact3 = _survey_results3.vision__impact) === null || _survey_results_vision__impact3 === void 0 ? void 0 : _survey_results_vision__impact3.subcategories[subcategory]) === null || _survey_results_vision__impact_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_vision__impact_subcategories_subcategory3.percent) ? `${(_survey_results_vision__impact_subcategories_subcategory4 = survey === null || survey === void 0 ? void 0 : (_survey_results4 = survey.results) === null || _survey_results4 === void 0 ? void 0 : (_survey_results_vision__impact4 = _survey_results4.vision__impact) === null || _survey_results_vision__impact4 === void 0 ? void 0 : _survey_results_vision__impact4.subcategories[subcategory]) === null || _survey_results_vision__impact_subcategories_subcategory4 === void 0 ? void 0 : _survey_results_vision__impact_subcategories_subcategory4.percent}%` : "N/A"), navigateToSurveyCategory(subcategory))));
    })))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-3 px-md-5 px-sm-5": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, clientId ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, "Assessment User"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Survey Type"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, survey.fullName), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-capitalize"
    }, survey.surveyType))))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, "Assessment Users"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "5%"
    }, "#"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "10%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Email"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, (survey === null || survey === void 0 ? void 0 : survey.users) && (survey === null || survey === void 0 ? void 0 : (_survey_users = survey.users) === null || _survey_users === void 0 ? void 0 : _survey_users.length) > 0 ? survey === null || survey === void 0 ? void 0 : survey.users.map((user, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, index + 1), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.fullName), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.email))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        colSpan: "3",
        className: "text-center"
    }, "Assessment users not available at this moment."))))))), showBreakthroughProgramInfo === false && (recommendedData === null || recommendedData === void 0 ? void 0 : recommendedData.length) === 0 ? null : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: "bg-gray-104"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": !showBreakthroughProgramInfo,
            "custom-col-lg-8 custom-col-10 custom-offset-lg-1": showBreakthroughProgramInfo
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "justify-content-center recommended-audios"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-11 px-lg-4 px-075"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h2", {
        className: "font-open-sans font-18pt font-bold leading-9 letter-spacing-minus-04 mb-2 px-lg-0"
    }, "Recommended for You"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "font-open-sans font-12pt font-semibold leading-7 letter-spacing-minus-02 mb-2-5 px-lg-0"
    }, "The Breakthrough Program has been scientifically-evidenced to create breakthrough results for leaders globally, and is the same program featured in our landmark global."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6cc7c1c352fdaa37$export$2e2bcd8739ae039), {
        NavLink: NavLink,
        recommendedData: recommendedData,
        isRecommendedLoading: isRecommendedLoading,
        limit: limit,
        setRecommendPage: setRecommendPage,
        recommendedSwiperRef: recommendedSwiperRef,
        playRecommendedAudio: playRecommendedAudio
    }))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f5e2cc126c098556$export$2e2bcd8739ae039), {
        i18n: i18n
    })));
};
var $37e9eb5c1b76d025$export$2e2bcd8739ae039 = $37e9eb5c1b76d025$var$SurveyResult;













(0, ($parcel$interopDefault($feLGi$highchartshighchartsmore)))((0, ($parcel$interopDefault($feLGi$highcharts))));
const $189bb98b3f895790$var$CATEGORY_COMPARISON_OUTER_PANE_SIZE = "60%";
const $189bb98b3f895790$var$CATEGORY_COMPARISON_INNER_PANE_SIZE = "55%";
const $189bb98b3f895790$var$CATEGORY_COMPARISON_AXIS_LABEL_COLOR = "#666666";
const $189bb98b3f895790$var$COMPARISON_TOOLTIP_HEADER_COLOR = "#666666";
const $189bb98b3f895790$var$syncCategoryComparisonPointHover = (point)=>{
    const pointIndex = point.index;
    point.series.chart.series.forEach((series)=>{
        const peerPoint = series.points[pointIndex];
        if (peerPoint) peerPoint.setState("hover");
    });
};
const $189bb98b3f895790$var$clearCategoryComparisonPointHover = (point)=>{
    const pointIndex = point.index;
    point.series.chart.series.forEach((series)=>{
        const peerPoint = series.points[pointIndex];
        if (peerPoint) peerPoint.setState("");
    });
};
const $189bb98b3f895790$var$categoryComparisonMarkerHover = (radius)=>({
        enabled: true,
        radius: radius,
        states: {
            hover: {
                enabled: true,
                lineColor: "#ffffff",
                lineWidth: 2,
                radius: radius + 2
            }
        }
    });
const $189bb98b3f895790$var$buildSeriesData = (values, pointColors, uniformLineColor)=>{
    if (!(pointColors === null || pointColors === void 0 ? void 0 : pointColors.length)) return values;
    return values.map((value, index)=>{
        const pointColor = pointColors[index];
        if (uniformLineColor) return {
            y: value,
            marker: {
                fillColor: pointColor,
                lineColor: pointColor,
                lineWidth: 1
            }
        };
        return {
            y: value,
            color: pointColor
        };
    });
};
const $189bb98b3f895790$var$buildComparisonTooltipOptions = ({ categories: categories , surveyOne: surveyOne , surveyTwo: surveyTwo , chartColors: chartColors  })=>{
    return {
        shared: true,
        useHTML: true,
        followPointer: true,
        outside: false,
        padding: 0,
        backgroundColor: "transparent",
        borderWidth: 0,
        shadow: false,
        formatter () {
            var _this_points, _this_points_, _this_point, _this_point_series, _this_series, _this_point1, _this_series1;
            const hoveredPoint = this.point || ((_this_points = this.points) === null || _this_points === void 0 ? void 0 : (_this_points_ = _this_points[0]) === null || _this_points_ === void 0 ? void 0 : _this_points_.point);
            const pointIndex = hoveredPoint === null || hoveredPoint === void 0 ? void 0 : hoveredPoint.index;
            if (pointIndex == null || pointIndex < 0) return false;
            const categoryName = categories[pointIndex] || (hoveredPoint === null || hoveredPoint === void 0 ? void 0 : hoveredPoint.category) || this.key || "";
            var _this_point_series_index, _ref;
            const hoveredSeriesIndex = (_ref = (_this_point_series_index = (_this_point = this.point) === null || _this_point === void 0 ? void 0 : (_this_point_series = _this_point.series) === null || _this_point_series === void 0 ? void 0 : _this_point_series.index) !== null && _this_point_series_index !== void 0 ? _this_point_series_index : (_this_series = this.series) === null || _this_series === void 0 ? void 0 : _this_series.index) !== null && _ref !== void 0 ? _ref : 0;
            const borderColor = ((_this_point1 = this.point) === null || _this_point1 === void 0 ? void 0 : _this_point1.color) || ((_this_series1 = this.series) === null || _this_series1 === void 0 ? void 0 : _this_series1.color) || chartColors[hoveredSeriesIndex] || chartColors[0];
            const scoreOne = Number(surveyOne[pointIndex]);
            const scoreTwo = Number(surveyTwo[pointIndex]);
            let html = `<div style="background:#fff;border:1px solid ${borderColor};` + 'padding:8px 10px;font-size:12px;color:#000;box-shadow:0 1px 4px rgba(0,0,0,0.12);">';
            html += `<div style="font-weight:600;color:${$189bb98b3f895790$var$COMPARISON_TOOLTIP_HEADER_COLOR};margin-bottom:4px;">`;
            html += `${categoryName}</div>`;
            if (!Number.isNaN(scoreOne)) html += `<div>Score #1: <b>${Math.round(scoreOne)}%</b></div>`;
            if (!Number.isNaN(scoreTwo)) html += `<div>Score #2: <b>${Math.round(scoreTwo)}%</b></div>`;
            return `${html}</div>`;
        }
    };
};
const $189bb98b3f895790$var$PolygonChart = ({ categories: categories , surveyOne: surveyOne , surveyTwo: surveyTwo , colors: colors , surveyOnePointColors: surveyOnePointColors , surveyTwoPointColors: surveyTwoPointColors , lineColor: uniformLineColor , categoryComparisonChart: categoryComparisonChart = false , backgroundColor: backgroundColor = "#fff" , className: className = "mb-4" , height: height = 400 , chartWidth: chartWidth , paneSize: paneSize , lineWidth: lineWidth = 2 , markerRadius: markerRadius = 4 , axisLabelFontSize: axisLabelFontSize  })=>{
    const { isLGScreen: isLGScreen , isXSScreen: isXSScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    const usePointColors = (surveyOnePointColors === null || surveyOnePointColors === void 0 ? void 0 : surveyOnePointColors.length) > 0 || (surveyTwoPointColors === null || surveyTwoPointColors === void 0 ? void 0 : surveyTwoPointColors.length) > 0;
    const chartColors = usePointColors ? [
        ...surveyOnePointColors || [],
        ...surveyTwoPointColors || []
    ] : colors || [
        "#69B1d8",
        "#0076BD"
    ];
    const buildSeriesOptions = (values, pointColors, seriesName = "", syncCategoryHover = false)=>({
            name: seriesName,
            showInLegend: false,
            data: $189bb98b3f895790$var$buildSeriesData(values, pointColors, uniformLineColor),
            pointPlacement: "on",
            color: uniformLineColor || undefined,
            lineColor: uniformLineColor || undefined,
            colorByPoint: usePointColors && !uniformLineColor,
            lineWidth: lineWidth,
            marker: syncCategoryHover ? $189bb98b3f895790$var$categoryComparisonMarkerHover(markerRadius) : {
                enabled: true,
                radius: markerRadius
            },
            ...syncCategoryHover ? {
                point: {
                    events: {
                        mouseOver () {
                            $189bb98b3f895790$var$syncCategoryComparisonPointHover(this);
                        },
                        mouseOut () {
                            $189bb98b3f895790$var$clearCategoryComparisonPointHover(this);
                        }
                    }
                }
            } : {}
        });
    const resolvedChartWidth = chartWidth !== null && chartWidth !== void 0 ? chartWidth : categoryComparisonChart ? isLGScreen ? 640 : isXSScreen ? 360 : 400 : isLGScreen ? 520 : isXSScreen ? 320 : 360;
    const axisLabelStyle = axisLabelFontSize ? {
        fontSize: `${axisLabelFontSize}px`,
        fontWeight: "500",
        ...categoryComparisonChart ? {
            color: $189bb98b3f895790$var$CATEGORY_COMPARISON_AXIS_LABEL_COLOR
        } : {},
        whiteSpace: "nowrap"
    } : undefined;
    const categoryYAxis = {
        gridLineInterpolation: "polygon",
        lineWidth: 0,
        min: 0,
        max: 100,
        tickInterval: 50,
        endOnTick: true,
        startOnTick: true
    };
    const outerPaneSize = paneSize || $189bb98b3f895790$var$CATEGORY_COMPARISON_OUTER_PANE_SIZE;
    const categoryComparisonPaneConfig = categoryComparisonChart ? {
        pane: [
            {
                size: $189bb98b3f895790$var$CATEGORY_COMPARISON_INNER_PANE_SIZE
            },
            {
                size: outerPaneSize
            }
        ],
        xAxis: [
            {
                pane: 0,
                categories: categories,
                tickmarkPlacement: "on",
                lineWidth: 0,
                labels: {
                    enabled: false
                }
            },
            {
                pane: 1,
                categories: categories,
                tickmarkPlacement: "on",
                lineWidth: 0,
                labels: {
                    distance: 42,
                    style: axisLabelStyle
                }
            }
        ],
        yAxis: [
            {
                ...categoryYAxis,
                pane: 0,
                gridLineWidth: 0,
                labels: {
                    enabled: false
                }
            },
            {
                ...categoryYAxis,
                pane: 1,
                labels: axisLabelStyle ? {
                    style: axisLabelStyle
                } : {}
            }
        ],
        series: [
            {
                ...buildSeriesOptions(surveyOne, surveyOnePointColors, "Score #1", true),
                xAxis: 0,
                yAxis: 0
            },
            {
                ...buildSeriesOptions(surveyTwo, surveyTwoPointColors, "Score #2", true),
                xAxis: 1,
                yAxis: 1
            }
        ]
    } : null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$highchartsreactofficial))), {
        containerProps: {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))(className, {
                "category-comparison-polygon-chart": categoryComparisonChart
            }),
            style: categoryComparisonChart ? {
                overflow: "visible"
            } : undefined
        },
        highcharts: (0, ($parcel$interopDefault($feLGi$highcharts))),
        options: {
            chart: {
                polar: true,
                type: "line",
                width: resolvedChartWidth,
                backgroundColor: backgroundColor,
                height: height,
                ...categoryComparisonChart ? {
                    spacing: [
                        36,
                        120,
                        36,
                        120
                    ]
                } : {}
            },
            title: {
                text: ""
            },
            ...categoryComparisonPaneConfig ? {
                pane: categoryComparisonPaneConfig.pane,
                xAxis: categoryComparisonPaneConfig.xAxis,
                yAxis: categoryComparisonPaneConfig.yAxis
            } : {
                pane: {
                    size: paneSize !== null && paneSize !== void 0 ? paneSize : categoryComparisonChart ? "68%" : isLGScreen ? "60%" : "40%"
                },
                xAxis: {
                    categories: categories,
                    tickmarkPlacement: "on",
                    lineWidth: 0,
                    labels: axisLabelStyle ? {
                        style: axisLabelStyle
                    } : {}
                },
                yAxis: {
                    gridLineInterpolation: "polygon",
                    lineWidth: 0,
                    min: 0,
                    labels: axisLabelStyle ? {
                        style: axisLabelStyle
                    } : {}
                }
            },
            tooltip: $189bb98b3f895790$var$buildComparisonTooltipOptions({
                categories: categories,
                surveyOne: surveyOne,
                surveyTwo: surveyTwo,
                chartColors: chartColors
            }),
            legend: {
                align: "right",
                verticalAlign: "top",
                y: 70,
                layout: "vertical"
            },
            plotOptions: {
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                },
                line: {
                    lineWidth: lineWidth,
                    marker: categoryComparisonChart ? $189bb98b3f895790$var$categoryComparisonMarkerHover(markerRadius) : {
                        enabled: true,
                        radius: markerRadius
                    },
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                }
            },
            series: categoryComparisonPaneConfig ? categoryComparisonPaneConfig.series : [
                buildSeriesOptions(surveyOne, surveyOnePointColors, "Score #1"),
                buildSeriesOptions(surveyTwo, surveyTwoPointColors, "Score #2")
            ],
            colors: chartColors,
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                align: "center",
                                layout: "horizontal"
                            },
                            yAxis: {
                                labels: {
                                    align: "left",
                                    x: 0,
                                    y: -5
                                },
                                title: {
                                    text: null
                                }
                            },
                            credits: {
                                enabled: false
                            }
                        }
                    }
                ]
            }
        }
    });
};
$189bb98b3f895790$var$PolygonChart.propTypes = {
    categories: (0, ($parcel$interopDefault($feLGi$proptypes))).array.isRequired,
    surveyOne: (0, ($parcel$interopDefault($feLGi$proptypes))).array.isRequired,
    surveyTwo: (0, ($parcel$interopDefault($feLGi$proptypes))).array.isRequired,
    colors: (0, ($parcel$interopDefault($feLGi$proptypes))).arrayOf((0, ($parcel$interopDefault($feLGi$proptypes))).string),
    surveyOnePointColors: (0, ($parcel$interopDefault($feLGi$proptypes))).arrayOf((0, ($parcel$interopDefault($feLGi$proptypes))).string),
    surveyTwoPointColors: (0, ($parcel$interopDefault($feLGi$proptypes))).arrayOf((0, ($parcel$interopDefault($feLGi$proptypes))).string),
    lineColor: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    categoryComparisonChart: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    lineWidth: (0, ($parcel$interopDefault($feLGi$proptypes))).number,
    markerRadius: (0, ($parcel$interopDefault($feLGi$proptypes))).number,
    chartWidth: (0, ($parcel$interopDefault($feLGi$proptypes))).number,
    paneSize: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    axisLabelFontSize: (0, ($parcel$interopDefault($feLGi$proptypes))).number
};
var $189bb98b3f895790$export$2e2bcd8739ae039 = $189bb98b3f895790$var$PolygonChart;



const $4932261e9054e49d$var$SurveyComparisonTabelRow = ({ title: title , survey0: survey0 , survey1: survey1  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-center"
    }, Number.isInteger(survey0) ? `${survey0}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-center"
    }, Number.isInteger(survey1) ? `${survey1}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-center"
    }, Number.isInteger(survey0 && survey1) ? survey1 - survey0 > 0 ? `+${parseInt(survey1) - parseInt(survey0)}%` : `${parseInt(survey1) - parseInt(survey0)}%` : "N/A"));
};
var $4932261e9054e49d$export$2e2bcd8739ae039 = $4932261e9054e49d$var$SurveyComparisonTabelRow;






const $a342f5c2d7c66d88$var$Feedback = ({ i18n: i18n  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: "assessment-feedback"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "text-center py-5"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "text-gray-201 font-normal"
    }, "Have feedback or suggestions for the ABROAD assessment or report?"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "text-gray-201 font-normal"
    }, "Impact stories inspire our team, so please click the button below to send us feedback."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        href: "mailto:service@abroad.io",
        subject: "hello"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: "black",
        size: "sm",
        className: "d-none d-lg-inline-block align-self-center"
    }, "SEND FEEDBACK"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: "black",
        size: "lg",
        className: "d-inline-block d-lg-none"
    }, "SEND FEEDBACK"))));
};
var $a342f5c2d7c66d88$export$2e2bcd8739ae039 = $a342f5c2d7c66d88$var$Feedback;











const $1cfc42530e602aae$var$AssessmentLearnMore = ({ category: category , onLearnMoreClick: onLearnMoreClick , linkClasses: linkClasses = ""  })=>{
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
    /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        onClick: ()=>{
            onShow();
            setModalData(category);
            onLearnMoreClick(category === null || category === void 0 ? void 0 : category._id);
        },
        "data-toggle": "modal",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("learn-more-link", linkClasses)
    }, "Learn more"));
};
var $1cfc42530e602aae$export$2e2bcd8739ae039 = $1cfc42530e602aae$var$AssessmentLearnMore;


const $f67033a3063168fa$var$AssessmentScoreCard = ({ title: title , percentage: percentage , wrapperClasses: wrapperClasses , variant: variant , linkClasses: linkClasses , category: category , onLearnMoreClick: onLearnMoreClick , outerBackgroudColor: outerBackgroudColor , innerBackgroudColor: innerBackgroudColor , width: width , height: height , titleClasses: titleClasses = "" , titlePosition: titlePosition = "bottom"  })=>{
    const outerCardStyle = {
        width: width,
        height: height,
        borderRadius: "0.313rem",
        background: outerBackgroudColor,
        position: "relative"
    };
    const innerCardStyle = {
        content: "",
        position: "absolute",
        background: innerBackgroudColor,
        borderRadius: "0.313rem",
        bottom: 0,
        left: 0,
        height: Number.isInteger(percentage) ? percentage <= 35 ? "35%" : `${percentage}%` : "0%",
        width: width,
        animation: "card-score-filler 2s ease-in-out"
    };
    const pageBreakStyle = {
        pageBreakInside: "avoid"
    };
    (0, $feLGi$react.useEffect)(()=>{
        const style = document.createElement("style");
        style.innerHTML = `
      @media print {

        .print-inner-card {
          height: ${Number.isInteger(percentage) ? percentage <= 35 ? "35%" : `${percentage}%` : "0%"} !important;

        }
        .
      }
    `;
        document.head.appendChild(style);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        percentage
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(wrapperClasses)
    }, variant === "normal-card" ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: pageBreakStyle
    }, titlePosition === "top" && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("s2 mb-4", titleClasses)
    }, title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: outerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "print-inner-card score-card",
        style: innerCardStyle
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "category-percentage position-absolute w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, Number.isInteger(percentage) ? `${percentage}%` : "N/A")))), titlePosition === "bottom" && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("s2 my-0 mt-3 my-lg-2", titleClasses)
    }, title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "mt-4": titlePosition === "top"
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $1cfc42530e602aae$export$2e2bcd8739ae039), {
        linkClasses: linkClasses,
        category: category,
        onLearnMoreClick: onLearnMoreClick
    }))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative d-flex justify-content-lg-start justify-content-center",
        style: pageBreakStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "score-height",
        style: outerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "print-inner-card score-card",
        style: innerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "score-text w-100 d-flex justify-content-center align-items-center h-100"
    }, Number.isInteger(percentage) ? `${percentage}%` : "N/A"))))));
};
$f67033a3063168fa$var$AssessmentScoreCard.propTypes = {
    title: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    variant: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        "table-attached-card",
        "normal-card"
    ]),
    titlePosition: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        "top",
        "bottom"
    ]),
    wrapperClasses: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
$f67033a3063168fa$var$AssessmentScoreCard.defaultProps = {
    variant: "normal-card",
    wrapperClasses: "",
    titlePosition: "bottom"
};
var $f67033a3063168fa$export$2e2bcd8739ae039 = $f67033a3063168fa$var$AssessmentScoreCard;


const $e1d7a1a853779002$var$tableMaxWidth = 1080;
const $e1d7a1a853779002$var$tableMinWidth = 1024;
const $e1d7a1a853779002$export$9fc0cb86cdf25c75 = window.innerWidth <= $e1d7a1a853779002$var$tableMaxWidth && window.innerWidth >= $e1d7a1a853779002$var$tableMinWidth;
const $e1d7a1a853779002$var$findCategory = (survey, key)=>{
    var _survey_categories;
    return survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((categories)=>{
        return (categories === null || categories === void 0 ? void 0 : categories.key) === key;
    });
};
const $e1d7a1a853779002$var$OverviewAwarenessResults = ({ survey: survey , onLearnMoreClick: onLearnMoreClick , wrapperClasses: wrapperClasses = "" , titlePosition: titlePosition = "bottom" , titleClasses: titleClasses = ""  })=>{
    var _survey_results, _survey_results_self_awareness, _survey_results1, _survey_results_team_cohesion, _survey_results2, _survey_results_vision__impact;
    if (survey === null || survey === void 0 ? void 0 : survey.inTransition) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 3,
        xl: 3,
        className: wrapperClasses
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "position-relative text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: "Self Awareness",
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_self_awareness = _survey_results.self_awareness) === null || _survey_results_self_awareness === void 0 ? void 0 : _survey_results_self_awareness.percent,
        category: $e1d7a1a853779002$var$findCategory(survey, "self_awareness"),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(10, 34, 60, 0.25)",
        innerBackgroudColor: "#0A223C",
        width: $e1d7a1a853779002$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: "Team Cohesion",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_team_cohesion = _survey_results1.team_cohesion) === null || _survey_results_team_cohesion === void 0 ? void 0 : _survey_results_team_cohesion.percent,
        category: $e1d7a1a853779002$var$findCategory(survey, "team_cohesion"),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(206, 129, 71, 0.25)",
        innerBackgroudColor: "#CE8147",
        width: $e1d7a1a853779002$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: "Vision & Impact",
        percentage: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? null : survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_vision__impact = _survey_results2.vision__impact) === null || _survey_results_vision__impact === void 0 ? void 0 : _survey_results_vision__impact.percent,
        category: $e1d7a1a853779002$var$findCategory(survey, "vision__impact"),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(239, 192, 48, 0.25)",
        innerBackgroudColor: "#EFC030",
        width: $e1d7a1a853779002$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })));
};
var $e1d7a1a853779002$export$2e2bcd8739ae039 = $e1d7a1a853779002$var$OverviewAwarenessResults;








const $ce5228e32bf420a8$var$AssessmentPlayIcon = ({ wrapperClasses: wrapperClasses = "" , iconClasses: iconClasses = "" , onClick: onClick , isPlaying: isPlaying = false  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(wrapperClasses)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 48 48",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("mr-3 align-self-center cursor-pointer", iconClasses),
        onClick: onClick
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        cx: "24",
        cy: "24",
        r: "24",
        fill: "#BF9000"
    }), isPlaying ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("rect", {
        x: "18",
        y: "16",
        width: "3",
        height: "16",
        rx: "0.5",
        fill: "#fff"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("rect", {
        x: "27",
        y: "16",
        width: "3",
        height: "16",
        rx: "0.5",
        fill: "#fff"
    })) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M33.625 23.7835C33.7917 23.8797 33.7917 24.1203 33.625 24.2165L19.375 32.4437C19.2083 32.54 19 32.4197 19 32.2272L19 15.7728C19 15.5803 19.2083 15.46 19.375 15.5563L33.625 23.7835Z",
        fill: "white"
    })));
};
var $ce5228e32bf420a8$export$2e2bcd8739ae039 = $ce5228e32bf420a8$var$AssessmentPlayIcon;


const $36c899ccb50671c8$var$isSafari = typeof navigator !== "undefined" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const $36c899ccb50671c8$var$AssessmentCategoryAudio = ({ categoryKeyName: categoryKeyName , mediaUrl: mediaUrl , setMediaUrl: setMediaUrl , setLoadedAudioId: setLoadedAudioId , loadedAudioId: loadedAudioId , iconClasses: iconClasses = "" , pauseOthers: pauseOthers  })=>{
    const [audio, setAudio] = (0, $feLGi$react.useState)(null);
    const [isPlaying, setIsPlaying] = (0, $feLGi$react.useState)(false);
    const categoryAudioEleId = "category-audio";
    const pauseOtherPlayers = ()=>{
        const allPlayers = document.querySelectorAll("audio");
        allPlayers.forEach((player)=>{
            if (player !== audio) {
                player.pause();
                setAudio(null);
                setLoadedAudioId(null);
                setIsPlaying(false);
            }
        });
    };
    const audioEndedHandler = (0, $feLGi$react.useCallback)(()=>{
        if (!audio) return;
        audio.pause();
        setAudio(null);
        setLoadedAudioId(null);
        setIsPlaying(false);
    }, [
        audio,
        setLoadedAudioId
    ]);
    const canPlayHandler = ()=>{
        if (!audio) return;
        const promise = audio.play();
        if (promise !== undefined) promise.then(()=>{
            if (audio && !$36c899ccb50671c8$var$isSafari) audio.play();
        }).catch(()=>{});
    };
    (0, $feLGi$react.useEffect)(()=>{
        if (audio) {
            audio.volume = 0.8;
            audio.loop = false;
            audio.addEventListener("canplaythrough", canPlayHandler);
            audio.addEventListener("ended", audioEndedHandler);
        }
        return ()=>{
            if (audio) {
                audio.removeEventListener("canplaythrough", canPlayHandler);
                audio.removeEventListener("ended", audioEndedHandler);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        audio
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ce5228e32bf420a8$export$2e2bcd8739ae039), {
        isPlaying: loadedAudioId === categoryKeyName ? isPlaying : false,
        onClick: ()=>{
            if (audio && loadedAudioId === categoryKeyName) {
                audio.pause();
                setLoadedAudioId(null);
                setAudio(null);
                setIsPlaying(false);
            } else {
                if (pauseOthers) pauseOtherPlayers();
                const categoryAudioEle = document.getElementById(categoryAudioEleId);
                setMediaUrl(mediaUrl);
                setAudio(categoryAudioEle);
                setLoadedAudioId(categoryKeyName);
                setIsPlaying(true);
                categoryAudioEle.load();
            }
        },
        wrapperClasses: "align-self-center",
        iconClasses: iconClasses
    });
};
var $36c899ccb50671c8$export$2e2bcd8739ae039 = $36c899ccb50671c8$var$AssessmentCategoryAudio;





const $a41af764d0830af5$var$BackwardIcon = ({ isDisabled: isDisabled , className: className , fontSize: fontSize = "1.375rem" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-left-arrow text-black text-dark-900", {
            "cursor-pointer": !isDisabled,
            "pointer-event-none": isDisabled
        }, className),
        style: {
            fontSize: fontSize,
            ...isDisabled && {
                color: "rgba(255,255,255, 0.50)"
            }
        },
        ...rest
    });
};
var $a41af764d0830af5$export$2e2bcd8739ae039 = $a41af764d0830af5$var$BackwardIcon;




const $421a794e95cab7fd$var$PreviousIcon = ({ className: className , isPreviousDisabled: isPreviousDisabled , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-previous text-white hover:text-saffron-700", {
            "cursor-pointer": !isPreviousDisabled,
            "pointer-event-none": isPreviousDisabled
        }),
        style: {
            fontSize: "22px",
            ...isPreviousDisabled && {
                color: "rgba(255,255,255, 0.50)"
            }
        },
        ...rest
    });
};
var $421a794e95cab7fd$export$2e2bcd8739ae039 = $421a794e95cab7fd$var$PreviousIcon;



const $e39ad7008e61b323$var$PauseIcon = ({ isLoading: isLoading , ...rest })=>{
    const [goldColorVisible, setGoldColorVisible] = (0, $feLGi$react.useState)(null);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        ...rest,
        className: "cursor-pointer",
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 68 68",
        onMouseOver: (e)=>{
            setGoldColorVisible(true);
        },
        onMouseEnter: (e)=>{
            setGoldColorVisible(true);
        },
        onMouseLeave: (e)=>{
            setGoldColorVisible(null);
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("defs", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("linearGradient", {
        id: "gradAnimation"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "y2",
        values: "0;0;1;1;0",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "x2",
        values: "0;1;1;0;0",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "y1",
        values: "1;1;0;0;1",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("animate", {
        attributeName: "x1",
        values: "1;0;0;1;1",
        keyTimes: "0;.25;.5;.75;1",
        dur: "1s",
        repeatCount: "indefinite"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.2",
        style: {
            stopColor: "rgb(255,255,255)",
            stopOpacity: 1
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.3",
        style: {
            stopColor: "rgb(191,144,0)",
            stopOpacity: 1
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("stop", {
        offset: "0.5",
        style: {
            stopColor: "rgb(191,144,0)",
            stopOpacity: 1
        }
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        id: "Group_329",
        "data-name": "Group 329",
        transform: "translate(-926.452 -631)"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        id: "Ellipse_14",
        "data-name": "Ellipse 14",
        transform: "translate(926.452 631)",
        fill: "none",
        stroke: isLoading ? "url('#gradAnimation')" : goldColorVisible ? "#efc030" : "#fff",
        strokeWidth: "2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        cx: "34",
        cy: "34",
        r: "34",
        stroke: "none"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        cx: "34",
        cy: "34",
        r: "33",
        fill: "none"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("line", {
        id: "Line_15",
        "data-name": "Line 15",
        y2: "26.054",
        transform: "translate(952.532 652)",
        fill: "none",
        stroke: goldColorVisible ? "#efc030" : "#fff",
        strokeLinecap: "round",
        strokeWidth: "3"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        id: "Path_64",
        "data-name": "Path 64",
        d: "M0,0V26.054",
        transform: "translate(969.148 652)",
        fill: "none",
        stroke: goldColorVisible ? "#efc030" : "#fff",
        strokeLinecap: "round",
        strokeWidth: "3"
    })));
};
var $e39ad7008e61b323$export$2e2bcd8739ae039 = $e39ad7008e61b323$var$PauseIcon;




const $8259f5e91aaf63c4$var$NextIcon = ({ isNextDisabled: isNextDisabled , className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-next text-black text-dark-900 hover:text-saffron-700", {
            "cursor-pointer": !isNextDisabled,
            "pointer-event-none": isNextDisabled
        }),
        style: {
            fontSize: "22px",
            ...isNextDisabled && {
                color: "rgba(255,255,255, 0.50)"
            }
        },
        ...rest
    });
};
var $8259f5e91aaf63c4$export$2e2bcd8739ae039 = $8259f5e91aaf63c4$var$NextIcon;




const $aa447dcb2c314f21$var$ForwardIcon = ({ isDisabled: isDisabled , className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-forward hover:text-saffron-700", {
            "cursor-pointer": !isDisabled,
            "pointer-event-none": isDisabled
        }, className),
        style: {
            fontSize: "22px",
            ...isDisabled && {
                color: "rgba(255,255,255, 0.50)"
            }
        },
        ...rest
    });
};
var $aa447dcb2c314f21$export$2e2bcd8739ae039 = $aa447dcb2c314f21$var$ForwardIcon;




const $281c2e3099f752e6$var$JournalIcon = ({ width: width , height: height , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "icon icon-journal text-black hover:text-saffron-700",
        style: {
            fontSize: width
        }
    });
};
$281c2e3099f752e6$var$JournalIcon.defaultProps = {
    width: 26,
    height: 26
};
var $281c2e3099f752e6$export$2e2bcd8739ae039 = $281c2e3099f752e6$var$JournalIcon;



const $d49ea8814e522437$var$VolumeIcon = (props)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        className: "icon-volume cursor-pointer",
        ...props
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M23.0399 5.8339C24.6934 8.1325 25.6673 10.9528 25.6673 14.0005C25.6673 17.0483 24.6934 19.8686 23.0399 22.1672M18.3702 9.3339C19.2929 10.6567 19.834 12.2655 19.834 14.0005C19.834 15.7357 19.2929 17.3444 18.3702 18.6672M11.2407 6.26052L7.54739 9.95383C7.34561 10.1556 7.24472 10.2565 7.12698 10.3286C7.0226 10.3926 6.9088 10.4397 6.78975 10.4683C6.65548 10.5006 6.51281 10.5006 6.22745 10.5006H4.20065C3.54726 10.5006 3.22056 10.5006 2.971 10.6277C2.75148 10.7396 2.573 10.918 2.46114 11.1376C2.33398 11.3871 2.33398 11.7139 2.33398 12.3672V15.6339C2.33398 16.2873 2.33398 16.614 2.46114 16.8635C2.573 17.0831 2.75148 17.2616 2.971 17.3734C3.22056 17.5005 3.54726 17.5005 4.20065 17.5005H6.22745C6.51281 17.5005 6.65548 17.5005 6.78975 17.5328C6.9088 17.5614 7.0226 17.6086 7.12698 17.6725C7.24472 17.7446 7.34561 17.8455 7.54739 18.0473L11.2407 21.7405C11.7405 22.2403 11.9904 22.4902 12.2049 22.5072C12.391 22.5217 12.573 22.4464 12.6942 22.3044C12.834 22.1408 12.834 21.7874 12.834 21.0807V6.9205C12.834 6.21371 12.834 5.86031 12.6942 5.69667C12.573 5.55469 12.391 5.47934 12.2049 5.49399C11.9904 5.51087 11.7405 5.76076 11.2407 6.26052Z",
        // stroke='#BF9000'
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
var $d49ea8814e522437$export$2e2bcd8739ae039 = $d49ea8814e522437$var$VolumeIcon;



const $f02f206622e4e8ba$var$VolumeMuteIcon = (props)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        className: "icon-mute cursor-pointer",
        ...props
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11.2401 6.25988L7.54674 9.95318C7.34497 10.155 7.24408 10.2558 7.12634 10.328C7.02196 10.392 6.90816 10.4391 6.78911 10.4677C6.65484 10.4999 6.51217 10.4999 6.22681 10.4999H4.20001C3.54662 10.4999 3.21992 10.4999 2.97036 10.6271C2.75084 10.7389 2.57236 10.9174 2.4605 11.1369C2.33334 11.3865 2.33334 11.7132 2.33334 12.3665V15.6332C2.33334 16.2867 2.33334 16.6133 2.4605 16.8629C2.57236 17.0824 2.75084 17.2609 2.97036 17.3727C3.21992 17.4999 3.54662 17.4999 4.20001 17.4999H6.22681C6.51217 17.4999 6.65484 17.4999 6.78911 17.5322C6.90816 17.5608 7.02196 17.6079 7.12634 17.6718C7.24408 17.7439 7.34497 17.8449 7.54674 18.0467L11.24 21.7399C11.7398 22.2397 11.9897 22.4896 12.2043 22.5065C12.3904 22.5211 12.5724 22.4457 12.6936 22.3037C12.8333 22.1402 12.8333 21.7868 12.8333 21.08V6.91985C12.8333 6.21306 12.8333 5.85966 12.6936 5.69603C12.5724 5.55404 12.3904 5.47869 12.2043 5.49334C11.9897 5.51022 11.7398 5.76011 11.2401 6.25988Z",
        fill: "#BF9000"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M17.4994 9.49935L26.4994 18.4994M26.4994 9.49935L17.4994 18.4994M11.2401 6.25988L7.54674 9.95318C7.34497 10.155 7.24408 10.2558 7.12634 10.328C7.02196 10.392 6.90816 10.4391 6.78911 10.4677C6.65484 10.4999 6.51217 10.4999 6.22681 10.4999H4.20001C3.54662 10.4999 3.21992 10.4999 2.97036 10.6271C2.75084 10.7389 2.57236 10.9174 2.4605 11.1369C2.33334 11.3865 2.33334 11.7132 2.33334 12.3665V15.6332C2.33334 16.2867 2.33334 16.6133 2.4605 16.8629C2.57236 17.0824 2.75084 17.2609 2.97036 17.3727C3.21992 17.4999 3.54662 17.4999 4.20001 17.4999H6.22681C6.51217 17.4999 6.65484 17.4999 6.78911 17.5322C6.90816 17.5608 7.02196 17.6079 7.12634 17.6718C7.24408 17.7439 7.34497 17.8449 7.54674 18.0467L11.24 21.7399C11.7398 22.2397 11.9897 22.4896 12.2043 22.5065C12.3904 22.5211 12.5724 22.4457 12.6936 22.3037C12.8333 22.1402 12.8333 21.7868 12.8333 21.08V6.91985C12.8333 6.21306 12.8333 5.85966 12.6936 5.69603C12.5724 5.55404 12.3904 5.47869 12.2043 5.49334C11.9897 5.51022 11.7398 5.76011 11.2401 6.25988Z",
        stroke: "#BF9000",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
var $f02f206622e4e8ba$export$2e2bcd8739ae039 = $f02f206622e4e8ba$var$VolumeMuteIcon;








const $8d04a2f4ff06a04c$var$InfoIcon = ({ title: title = "" , className: className = ""  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("info-icon", className)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7.5",
        stroke: "black"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        className: "info-circle",
        cx: "8",
        cy: "4.33594",
        r: "1",
        fill: "black"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("rect", {
        x: "7",
        y: "6.66943",
        width: "2",
        height: "6",
        rx: "1",
        fill: "black"
    }));
var $8d04a2f4ff06a04c$export$2e2bcd8739ae039 = $8d04a2f4ff06a04c$var$InfoIcon;



const $ff4839f57a77df06$var$PaymentSuccessIcon = ({ className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        viewBox: "0 0 60 60",
        className: className,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        transform: "translate(-1061 -406)"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        className: "payment-success-circle",
        cx: "30",
        cy: "30",
        r: "30",
        opacity: "0.3",
        fill: "#509f92",
        transform: "translate(1061 406)"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        transform: "translate(1077 424.583)"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        className: "payment-success-line",
        fill: "#509f92",
        d: "M53.168,33.277,34.215,52.035a2.033,2.033,0,0,1-1.484.565,2.126,2.126,0,0,1-1.484-.565l-6.965-6.893a1.93,1.93,0,0,1,0-2.712,1.865,1.865,0,0,1,1.37-.565,1.78,1.78,0,0,1,1.37.565l5.709,5.65,17.7-17.515A1.865,1.865,0,0,1,51.8,30a1.78,1.78,0,0,1,1.37.565A1.93,1.93,0,0,1,53.168,33.277Z",
        transform: "translate(-23.725 -29.882)"
    }))));
};
var $ff4839f57a77df06$export$2e2bcd8739ae039 = $ff4839f57a77df06$var$PaymentSuccessIcon;




const $b6ee68546aeff868$var$GoBackIcon = ({ className: className = "" , showSmallIcon: showSmallIcon = false , onClick: onClick = ()=>{} , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, showSmallIcon ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "go-back-icon d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        onClick: onClick,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "black",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "black",
        strokeWidth: "2",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        width: "17.15",
        height: "33.29",
        viewBox: "0 0 21 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M19.15 2L2 18.6462",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M19.15 35.2927L2 18.6465",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })));
};
var $b6ee68546aeff868$export$2e2bcd8739ae039 = $b6ee68546aeff868$var$GoBackIcon;



const $dd6d3315f56a98c1$var$FeatherIcon = ({ className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: `icon icon-feather text-white font-26 ${className}`,
        ...rest
    });
};
var $dd6d3315f56a98c1$export$2e2bcd8739ae039 = $dd6d3315f56a98c1$var$FeatherIcon;




const $e56d2de78eb5c0ce$var$DropdownCaretDownIcon = ({ className: className = "" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        width: "12",
        height: "12",
        viewBox: "0 0 10 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M5.86603 7.5C5.48113 8.16667 4.51887 8.16667 4.13397 7.5L0.669874 1.5C0.284974 0.833333 0.766099 -8.94676e-07 1.5359 -8.27378e-07L8.4641 -2.21695e-07C9.2339 -1.54397e-07 9.71503 0.833333 9.33013 1.5L5.86603 7.5Z",
        fill: "black"
    }));
};
var $e56d2de78eb5c0ce$export$2e2bcd8739ae039 = $e56d2de78eb5c0ce$var$DropdownCaretDownIcon;




const $b5104a1b3db51ba6$var$DropdownCaretUpIcon = ({ className: className = "" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        width: "12",
        height: "12",
        viewBox: "0 0 10 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M4.13397 0.5C4.51887 -0.166667 5.48113 -0.166666 5.86603 0.5L9.33013 6.5C9.71503 7.16667 9.2339 8 8.4641 8L1.5359 8C0.766098 8 0.284973 7.16667 0.669873 6.5L4.13397 0.5Z",
        fill: "black"
    }));
};
var $b5104a1b3db51ba6$export$2e2bcd8739ae039 = $b5104a1b3db51ba6$var$DropdownCaretUpIcon;



const $a7419c8e33d1fcac$var$RightClickIcon = ({ className: className = "" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: className,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M6 0C2.68203 0 0 2.68203 0 6C0 9.31797 2.68203 12 6 12C9.31797 12 12 9.31797 12 6C12 2.68203 9.31797 0 6 0ZM8.90323 4.75576L5.35023 8.29493C5.23963 8.40553 5.10138 8.46083 4.96313 8.46083C4.82488 8.46083 4.67281 8.40553 4.57604 8.29493L2.82028 6.553C2.59908 6.3318 2.59908 5.98618 2.82028 5.76498C3.04147 5.54378 3.3871 5.54378 3.60829 5.76498L4.96313 7.11982L8.11521 3.96774C8.33641 3.74654 8.68203 3.74654 8.90323 3.96774C9.1106 4.18894 9.1106 4.54839 8.90323 4.75576Z",
        fill: "#509F92"
    }));
};
var $a7419c8e33d1fcac$export$2e2bcd8739ae039 = $a7419c8e33d1fcac$var$RightClickIcon;




const $a69e2c434439138c$var$SliderIconForNumberTabs = ({ wrapperClasses: wrapperClasses = "" , scollHandler: scollHandler = ()=>{}  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(wrapperClasses),
        onClick: scollHandler
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1 10.707L7 5.8539",
        stroke: "black",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1 1.00038L7 5.85352",
        stroke: "black",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }));
};
var $a69e2c434439138c$export$2e2bcd8739ae039 = $a69e2c434439138c$var$SliderIconForNumberTabs;



const $6f6337ce4cf8e86f$var$AbroadIconForSM = ({ className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: `icon icon-feather text-dark-900 font-24 ${className}`,
        ...rest
    });
};
var $6f6337ce4cf8e86f$export$2e2bcd8739ae039 = $6f6337ce4cf8e86f$var$AbroadIconForSM;




const $9d132ef5e8deebf2$var$AngleRightIconForAdmin = ({ isDropDownOpen: isDropDownOpen = false , className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "18",
        viewBox: "0 0 10 18",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "angle-left-icon": !isDropDownOpen,
            "angle-down-icon": isDropDownOpen
        }, className),
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("line", {
        x1: "0.353553",
        y1: "0.646447",
        x2: "9.35355",
        y2: "9.64645",
        stroke: "white"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("line", {
        x1: "0.646447",
        y1: "17.6464",
        x2: "8.64645",
        y2: "9.64645",
        stroke: "white"
    }));
};
var $9d132ef5e8deebf2$export$2e2bcd8739ae039 = $9d132ef5e8deebf2$var$AngleRightIconForAdmin;




const $ab625231f5d78303$var$AngleRightIconForClient = ({ isDropDownOpen: isDropDownOpen = false , className: className , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "angle-left-icon": !isDropDownOpen,
            "angle-down-icon": isDropDownOpen
        }, className),
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M3.60078 9.95312L7.80078 5.87649",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M3.60078 1.80618L7.80078 5.88281",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }));
};
var $ab625231f5d78303$export$2e2bcd8739ae039 = $ab625231f5d78303$var$AngleRightIconForClient;




const $70b6fafed4b968ca$var$SignupHeaderIcon = (props)=>{
    const { isQuestEntry: isQuestEntry  } = props;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Image), {
        src: `${process.env.PUBLIC_URL}/assets/images/signupHeaderIcon.svg`,
        alt: "header logo",
        width: isQuestEntry ? "100" : "145",
        height: isQuestEntry ? "65" : "87",
        ...props
    });
};
var $70b6fafed4b968ca$export$2e2bcd8739ae039 = $70b6fafed4b968ca$var$SignupHeaderIcon;



const $b240f4d8050e5472$var$CrossIcon = ({ ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "pointer-cursor",
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        clipPath: "url(#clip0_2_115)"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M8.93996 8.00004L11.8066 5.14004C11.9322 5.01451 12.0027 4.84424 12.0027 4.66671C12.0027 4.48917 11.9322 4.31891 11.8066 4.19338C11.6811 4.06784 11.5108 3.99731 11.3333 3.99731C11.1558 3.99731 10.9855 4.06784 10.86 4.19338L7.99996 7.06004L5.13996 4.19338C5.01442 4.06784 4.84416 3.99731 4.66663 3.99731C4.48909 3.99731 4.31883 4.06784 4.19329 4.19338C4.06776 4.31891 3.99723 4.48917 3.99723 4.66671C3.99723 4.84424 4.06776 5.01451 4.19329 5.14004L7.05996 8.00004L4.19329 10.86C4.13081 10.922 4.08121 10.9958 4.04737 11.077C4.01352 11.1582 3.99609 11.2454 3.99609 11.3334C3.99609 11.4214 4.01352 11.5085 4.04737 11.5898C4.08121 11.671 4.13081 11.7447 4.19329 11.8067C4.25527 11.8692 4.329 11.9188 4.41024 11.9526C4.49148 11.9865 4.57862 12.0039 4.66663 12.0039C4.75463 12.0039 4.84177 11.9865 4.92301 11.9526C5.00425 11.9188 5.07798 11.8692 5.13996 11.8067L7.99996 8.94004L10.86 11.8067C10.9219 11.8692 10.9957 11.9188 11.0769 11.9526C11.1581 11.9865 11.2453 12.0039 11.3333 12.0039C11.4213 12.0039 11.5084 11.9865 11.5897 11.9526C11.6709 11.9188 11.7447 11.8692 11.8066 11.8067C11.8691 11.7447 11.9187 11.671 11.9526 11.5898C11.9864 11.5085 12.0038 11.4214 12.0038 11.3334C12.0038 11.2454 11.9864 11.1582 11.9526 11.077C11.9187 10.9958 11.8691 10.922 11.8066 10.86L8.93996 8.00004Z",
        fill: "black"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("defs", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("clipPath", {
        id: "clip0_2_115"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "#000"
    }))));
};
var $b240f4d8050e5472$export$2e2bcd8739ae039 = $b240f4d8050e5472$var$CrossIcon;



const $4236b320e4df4712$var$LeftAngleIcon = ({ className: className = "" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "12",
        height: "19",
        viewBox: "0 0 12 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10.1275 1.60742L2 9.63973",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10.1275 17.672L2 9.63965",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }));
};
var $4236b320e4df4712$export$2e2bcd8739ae039 = $4236b320e4df4712$var$LeftAngleIcon;



const $42a1c68119c41042$var$ReturnLeftIcon = ({ ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "12",
        height: "19",
        viewBox: "0 0 12 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10.1275 1.60742L2 9.63973",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10.1275 17.672L2 9.63965",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }));
};
var $42a1c68119c41042$export$2e2bcd8739ae039 = $42a1c68119c41042$var$ReturnLeftIcon;




const $416404e45e2d34e7$var$InfoIcon = ({ className: className , fillColor: fillColor = "black" , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer", className),
        ...rest
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11.3357 14.0886C11.1312 14.1077 10.9259 14.0615 10.7493 13.9568C10.6202 13.8243 10.5584 13.6403 10.5811 13.4568C10.5859 13.3039 10.6041 13.1518 10.6357 13.0022C10.6662 12.8306 10.7056 12.6607 10.7538 12.4931L11.2902 10.6477C11.3455 10.4655 11.3821 10.2782 11.3993 10.0886C11.3993 9.88402 11.4266 9.74308 11.4266 9.66129C11.438 9.29672 11.2823 8.94687 11.0038 8.71129C10.6613 8.44832 10.2347 8.31906 9.80383 8.34765C9.49504 8.3523 9.18863 8.40285 8.89473 8.49765C8.57352 8.59765 8.23563 8.71734 7.88109 8.85675L7.72656 9.45675C7.83109 9.42039 7.9584 9.37949 8.10383 9.33402C8.24258 9.29293 8.38641 9.27148 8.53109 9.27039C8.73406 9.24839 8.93836 9.29824 9.10836 9.41129C9.22383 9.54906 9.27801 9.72804 9.25836 9.90675C9.25785 10.0596 9.24109 10.212 9.20836 10.3613C9.17652 10.5204 9.13563 10.6886 9.08563 10.8658L8.54473 12.7203C8.50113 12.8927 8.46625 13.0672 8.4402 13.2431C8.41895 13.3937 8.40832 13.5455 8.40836 13.6976C8.40613 14.0647 8.57398 14.4121 8.86289 14.6385C9.2107 14.9056 9.64336 15.038 10.0811 15.0112C10.3893 15.0176 10.6964 14.973 10.9902 14.8794C11.2477 14.7915 11.5917 14.6658 12.022 14.5021L12.1675 13.9294C12.0509 13.9778 11.9309 14.0173 11.8084 14.0476C11.6534 14.083 11.4944 14.0967 11.3357 14.0886Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11.904 5.34913C11.6566 5.12194 11.3307 4.99971 10.9949 5.00823C10.6593 5.00065 10.3337 5.12276 10.0858 5.34913C9.63143 5.74092 9.58069 6.4269 9.97253 6.88132C10.0074 6.92182 10.0453 6.95967 10.0858 6.9946C10.6035 7.4576 11.3864 7.4576 11.904 6.9946C12.3583 6.59893 12.406 5.90987 12.0103 5.45549C11.9774 5.41764 11.9419 5.3821 11.904 5.34913Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 19.0909C4.97922 19.0909 0.909102 15.0208 0.909102 10C0.909102 4.97922 4.97922 0.909102 10 0.909102C15.0208 0.909102 19.0909 4.97922 19.0909 10C19.0909 15.0208 15.0208 19.0909 10 19.0909Z",
        fill: fillColor
    }));
};
var $416404e45e2d34e7$export$2e2bcd8739ae039 = $416404e45e2d34e7$var$InfoIcon;









const $ca001929343b7efa$var$useUserService = ()=>{
    const { user: user , setUser: setUser  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$a0fd8390cfe8ae69));
    return {
        user: user,
        setUser: setUser
    };
};
var $ca001929343b7efa$export$2e2bcd8739ae039 = $ca001929343b7efa$var$useUserService;




const $c37381977905147d$var$useAuth = ()=>{
    const { auth: auth , setAuth: setAuth  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$a0fd8390cfe8ae69));
    return {
        auth: auth,
        setAuth: setAuth
    };
};
var $c37381977905147d$export$2e2bcd8739ae039 = $c37381977905147d$var$useAuth;




const $102ddb9add0f5b8b$var$useNotificationService = ()=>{
    const Notification = (0, $feLGi$react.useContext)((0, $0a01bfcecb6af40f$export$a6e93d8cb5d50678));
    return Notification;
};
var $102ddb9add0f5b8b$export$2e2bcd8739ae039 = $102ddb9add0f5b8b$var$useNotificationService;




const $b51351853dc8ae14$var$useWindowSize = ()=>{
    const [size, setSize] = (0, $feLGi$react.useState)([
        0,
        0
    ]);
    (0, $feLGi$react.useLayoutEffect)(()=>{
        const updateSize = ()=>{
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return ()=>window.removeEventListener("resize", updateSize);
    }, []);
    return size;
};
var $b51351853dc8ae14$export$2e2bcd8739ae039 = $b51351853dc8ae14$var$useWindowSize;






const $6f3ced7f1b045e2b$var$CategoryInfoLink = ({ categoryKey: categoryKey , className: className = "text-decoration-none" , children: children , isRenderOnAdmin: isRenderOnAdmin = false  })=>{
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    const path = `/survey/category/${categoryKey}`;
    if (!categoryKey) return null;
    if (isRenderOnAdmin) {
        const navigate = ()=>history.push(path);
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            role: "link",
            tabIndex: 0,
            className: className,
            onClick: navigate,
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    navigate();
                }
            }
        }, children);
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
        to: path,
        className: className
    }, children);
};
var $6f3ced7f1b045e2b$export$2e2bcd8739ae039 = $6f3ced7f1b045e2b$var$CategoryInfoLink;


const $5c6cc440118fa0ea$var$AwarenessSubcategoriesTable = ({ title: title , survey: survey , onLearnMoreClick: onLearnMoreClick , innerBackgroudColor: innerBackgroudColor , outerBackgroudColor: outerBackgroudColor , categoryKeyName: categoryKeyName , wrapperClasses: wrapperClasses , tableClasses: tableClasses , barHeight: barHeight , mediaUrl: mediaUrl , setMediaUrl: setMediaUrl , loadedAudioId: loadedAudioId , setLoadedAudioId: setLoadedAudioId , showCategoryAudio: showCategoryAudio = false , isRenderOnAdmin: isRenderOnAdmin = false  })=>{
    var _survey_results, _survey_results_categoryKeyName, _survey_results1, _survey_results_categoryKeyName1;
    const tableRef = (0, $feLGi$react.useRef)(null);
    const [height, setHeight] = (0, $feLGi$react.useState)(0);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const { isLGScreen: isLGScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    const findCategory = (key)=>{
        var _survey_categories;
        return survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((categories)=>{
            return (categories === null || categories === void 0 ? void 0 : categories.key) === key;
        });
    };
    (0, $feLGi$react.useLayoutEffect)(()=>{
        setHeight(tableRef.current.clientHeight);
    }, []);
    (0, $feLGi$react.useEffect)(()=>{
        function handleWindowResize() {
            setHeight(tableRef.current.clientHeight);
        }
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: wrapperClasses
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-chart text-center align-self-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: title,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.percent,
        category: findCategory(categoryKeyName),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: outerBackgroudColor,
        innerBackgroudColor: innerBackgroudColor,
        width: "15.79rem",
        height: isLGScreen || (0, $e1d7a1a853779002$export$9fc0cb86cdf25c75) ? `${height}px` : barHeight,
        linkClasses: "s11 mb-0 text-white cursor-pointer",
        variant: "table-attached-card"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("assessment-score mt-lg-0 mt-4", tableClasses),
        ref: tableRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between mb-18px pt-0 px-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, showCategoryAudio && mediaUrl && setMediaUrl && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $36c899ccb50671c8$export$2e2bcd8739ae039), {
        categoryKeyName: categoryKeyName,
        mediaUrl: mediaUrl,
        setMediaUrl: setMediaUrl,
        loadedAudioId: loadedAudioId,
        setLoadedAudioId: setLoadedAudioId,
        pauseOthers: true
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0 "
    }, title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f3ced7f1b045e2b$export$2e2bcd8739ae039), {
        categoryKey: categoryKeyName,
        isRenderOnAdmin: isRenderOnAdmin
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.order.map((subcategory, index)=>{
        var _survey_results_categoryKeyName_subcategories_subcategory, _survey_results, _survey_results_categoryKeyName, _survey_results_categoryKeyName_subcategories_subcategory1, _survey_results1, _survey_results_categoryKeyName1, _survey_results_categoryKeyName_subcategories_subcategory2, _survey_results2, _survey_results_categoryKeyName2, _survey_results_categoryKeyName_subcategories_subcategory3, _survey_results3, _survey_results_categoryKeyName3;
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "survey-subcat-link py-18px",
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("courses-title-row", {
                "first-row": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            "data-id": (_survey_results_categoryKeyName_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory.title,
            onMouseEnter: ()=>setRowNumber(index),
            onMouseLeave: ()=>setRowNumber(null)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "s6 text-black hover-text-bold"
        }, (_survey_results_categoryKeyName_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory1.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            style: {
                color: innerBackgroudColor
            },
            className: "hover-text-bold s6"
        }, (survey === null || survey === void 0 ? void 0 : survey.inTransition) && categoryKeyName !== "self_awareness" ? "N/A" : Number.isInteger((_survey_results_categoryKeyName_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_categoryKeyName2 = _survey_results2[categoryKeyName]) === null || _survey_results_categoryKeyName2 === void 0 ? void 0 : _survey_results_categoryKeyName2.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory2.percent) ? `${(_survey_results_categoryKeyName_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_categoryKeyName3 = _survey_results3[categoryKeyName]) === null || _survey_results_categoryKeyName3 === void 0 ? void 0 : _survey_results_categoryKeyName3.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory3.percent}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f3ced7f1b045e2b$export$2e2bcd8739ae039), {
            categoryKey: subcategory,
            className: "text-decoration-none ml-3",
            isRenderOnAdmin: isRenderOnAdmin
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
            className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none"
        })))));
    })))));
};
var $5c6cc440118fa0ea$export$2e2bcd8739ae039 = $5c6cc440118fa0ea$var$AwarenessSubcategoriesTable;








const $23d3d82267bfc747$var$AwarenessSortedSubCategories = ({ results: results , inTransition: inTransition , isRenderOnAdmin: isRenderOnAdmin = false  })=>{
    const [sortedSubCategories, setSortedSubCategories] = (0, $feLGi$react.useState)([]);
    const selfAwarenessId = "5b46b176ce416b175ff98e17";
    const teamCohesionId = "5b46b176ce416b175ff98e2f";
    const visionImpactId = "5b46b176ce416b175ff98de6";
    (0, $feLGi$react.useEffect)(()=>{
        if (results) {
            var _results_team_cohesion, _results_vision__impact;
            let subCategories = results.self_awareness.order.map((cat)=>({
                    ...results.self_awareness.subcategories[cat],
                    key: cat,
                    parentId: selfAwarenessId
                }));
            if (!inTransition) subCategories = [
                ...subCategories,
                ...results === null || results === void 0 ? void 0 : (_results_team_cohesion = results.team_cohesion) === null || _results_team_cohesion === void 0 ? void 0 : _results_team_cohesion.order.map((cat)=>({
                        ...results.team_cohesion.subcategories[cat],
                        key: cat,
                        parentId: teamCohesionId
                    })),
                ...results === null || results === void 0 ? void 0 : (_results_vision__impact = results.vision__impact) === null || _results_vision__impact === void 0 ? void 0 : _results_vision__impact.order.map((cat)=>({
                        ...results.vision__impact.subcategories[cat],
                        key: cat,
                        parentId: visionImpactId
                    }))
            ];
            subCategories = subCategories.sort((a, b)=>b.percent - a.percent);
            setSortedSubCategories(subCategories);
        }
    }, [
        results,
        inTransition
    ]);
    const renderSubCategoriesBox = (category)=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex category-details"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-9"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
            className: "mb-0 s7 hover-text-bold ms-2"
        }, category === null || category === void 0 ? void 0 : category.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-3 d-flex justify-content-end"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("mb-0 align-self-center hover-text-bold s7", {
                "text-abroad-blue": (category === null || category === void 0 ? void 0 : category.parentId) === selfAwarenessId,
                "text-orange-100": (category === null || category === void 0 ? void 0 : category.parentId) === teamCohesionId,
                "text-saffron-300": (category === null || category === void 0 ? void 0 : category.parentId) === visionImpactId
            })
        }, `${category.percent}%`), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f3ced7f1b045e2b$export$2e2bcd8739ae039), {
            categoryKey: category === null || category === void 0 ? void 0 : category.key,
            className: "text-decoration-none ml-3",
            isRenderOnAdmin: isRenderOnAdmin
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
            className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none"
        }))));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex flex-lg-row flex-column mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 12,
        md: 12,
        sm: 12,
        className: "mb-lg-0 mb-3 d-flex flex-lg-row flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mr-lg-12px w-100 mb-lg-0 mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $e1d7a1a853779002$export$9fc0cb86cdf25c75),
            s2: !(0, $e1d7a1a853779002$export$9fc0cb86cdf25c75)
        })
    }, "Celebrations"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(0, 3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "ml-lg-12px w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $e1d7a1a853779002$export$9fc0cb86cdf25c75),
            s2: !(0, $e1d7a1a853779002$export$9fc0cb86cdf25c75)
        })
    }, "Key Areas for Growth"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(-3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category)))))));
};
var $23d3d82267bfc747$export$2e2bcd8739ae039 = $23d3d82267bfc747$var$AwarenessSortedSubCategories;


const $97b09ac2977ad497$export$128943e5d53d1c59 = "https://abroad-public.s3.us-east-2.amazonaws.com/01+Self+Awareness.mp3";
const $97b09ac2977ad497$export$7702138132db9f8d = "https://abroad-public.s3.us-east-2.amazonaws.com/02+Team+Cohesion.mp3";
const $97b09ac2977ad497$export$1b53fccb35a0c5b7 = "https://abroad-public.s3.us-east-2.amazonaws.com/03+Vision+%26+Impact.mp3";
const $97b09ac2977ad497$export$ab5357865b57562f = "https://abroad-public.s3.us-east-2.amazonaws.com/06+Self+Awareness+(Leaders+in+Transition).mp3";
const $97b09ac2977ad497$export$8af87c63ff2e23b5 = "https://abroad-public.s3.us-east-2.amazonaws.com/04+Manager+Efficacy.mp3";
const $97b09ac2977ad497$export$ab403d451b1a5674 = "https://abroad-public.s3.us-east-2.amazonaws.com/05+Self+Awareness+Perception.mp3";
const $97b09ac2977ad497$export$cc2e3e24acd33d48 = "#0076bd";
const $97b09ac2977ad497$export$5f5f421f6ab7e55a = "#37763b";
const $97b09ac2977ad497$export$6372909648378c3b = "#7e2d55";
const $97b09ac2977ad497$export$3058285f049a0176 = [
    {
        key: "self_awareness",
        title: "Self Awareness",
        outerBackgroudColor: "rgba(10, 34, 60, 0.25)",
        surveyOneInnerColor: "rgba(10, 34, 60, 0.55)",
        surveyTwoInnerColor: "#0A223C",
        chartSurveyOneColor: "#4d6b85",
        chartSurveyTwoColor: $97b09ac2977ad497$export$cc2e3e24acd33d48,
        chartAxisLabelColor: $97b09ac2977ad497$export$cc2e3e24acd33d48
    },
    {
        key: "team_cohesion",
        title: "Team Cohesion",
        outerBackgroudColor: "rgba(206, 129, 71, 0.25)",
        surveyOneInnerColor: "rgba(206, 129, 71, 0.55)",
        surveyTwoInnerColor: "#CE8147",
        chartSurveyOneColor: "#d9a67a",
        chartSurveyTwoColor: $97b09ac2977ad497$export$6372909648378c3b,
        chartAxisLabelColor: $97b09ac2977ad497$export$6372909648378c3b
    },
    {
        key: "vision__impact",
        title: "Vision & Impact",
        outerBackgroudColor: "rgba(239, 192, 48, 0.25)",
        surveyOneInnerColor: "rgba(239, 192, 48, 0.55)",
        surveyTwoInnerColor: "#EFC030",
        chartSurveyOneColor: "#f3d878",
        chartSurveyTwoColor: $97b09ac2977ad497$export$5f5f421f6ab7e55a,
        chartAxisLabelColor: $97b09ac2977ad497$export$5f5f421f6ab7e55a
    }
];
const $97b09ac2977ad497$export$d72320d3eb8eec2 = $97b09ac2977ad497$export$3058285f049a0176[1].surveyTwoInnerColor;
const $97b09ac2977ad497$export$4f10492abd16e944 = $97b09ac2977ad497$export$3058285f049a0176[2].surveyTwoInnerColor;


const $e0385fcb19273fcc$var$categoryAudioEleId = "category-audio";
const $e0385fcb19273fcc$var$AwarenessSummaryResult = ({ gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction = ()=>{} , survey: survey , showCategoryAudio: showCategoryAudio = true , isRenderOnAdmin: isRenderOnAdmin = false  })=>{
    const [mediaUrl, setMediaUrl] = (0, $feLGi$react.useState)(null);
    const [loadedAudioId, setLoadedAudioId] = (0, $feLGi$react.useState)();
    const audioProps = showCategoryAudio ? {
        setMediaUrl: setMediaUrl,
        loadedAudioId: loadedAudioId,
        setLoadedAudioId: setLoadedAudioId,
        showCategoryAudio: true
    } : {
        showCategoryAudio: false
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $e1d7a1a853779002$export$2e2bcd8739ae039), {
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        wrapperClasses: "mb-52px",
        titlePosition: "top"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-result-info-text s5 mb-52px py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "text-center mb-0 s6a font-weight-500"
    }, "To better understand your results, we recommend listening to the audios that describes the context of each category. For further information on each subcategory, simply click on the corresponding info icons.")), showCategoryAudio && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("audio", {
        id: $e0385fcb19273fcc$var$categoryAudioEleId,
        allow: "autoplay"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("source", {
        src: mediaUrl
    }), "Your browser does not support the ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("code", null, "audio"), " element."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $5c6cc440118fa0ea$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Self Awareness",
        categoryKeyName: "self_awareness",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#0A223C",
        outerBackgroudColor: "rgba(10, 34, 60, 0.25)",
        barHeight: "22.437rem",
        mediaUrl: (survey === null || survey === void 0 ? void 0 : survey.inTransition) ? (0, $97b09ac2977ad497$export$ab5357865b57562f) : (0, $97b09ac2977ad497$export$128943e5d53d1c59),
        isRenderOnAdmin: isRenderOnAdmin,
        ...audioProps,
        key: "self_awareness"
    }), !(survey === null || survey === void 0 ? void 0 : survey.inTransition) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $5c6cc440118fa0ea$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Team Cohesion",
        categoryKeyName: "team_cohesion",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#CE8147",
        outerBackgroudColor: "#F2DFD1",
        barHeight: "22.437rem",
        mediaUrl: (0, $97b09ac2977ad497$export$7702138132db9f8d),
        isRenderOnAdmin: isRenderOnAdmin,
        ...audioProps,
        key: "team_cohesion"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $5c6cc440118fa0ea$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Vision & Impact",
        categoryKeyName: "vision__impact",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#EFC030",
        outerBackgroudColor: "#FBEFCB",
        tableClasses: "align-self-lg-center",
        barHeight: "22.437rem",
        mediaUrl: (0, $97b09ac2977ad497$export$1b53fccb35a0c5b7),
        isRenderOnAdmin: isRenderOnAdmin,
        ...audioProps,
        key: "vision__impact"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $23d3d82267bfc747$export$2e2bcd8739ae039), {
        results: survey === null || survey === void 0 ? void 0 : survey.results,
        inTransition: survey === null || survey === void 0 ? void 0 : survey.inTransition,
        isRenderOnAdmin: isRenderOnAdmin
    })));
};
var $e0385fcb19273fcc$export$2e2bcd8739ae039 = $e0385fcb19273fcc$var$AwarenessSummaryResult;













const $90e8363415383103$var$CompareResultsDateLegend = ({ formatedPreDate: formatedPreDate , formatedPostDate: formatedPostDate , resultsDateClassName: resultsDateClassName = "results-date"  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: "d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-compare-circle",
        style: {
            backgroundColor: (0, $97b09ac2977ad497$export$d72320d3eb8eec2)
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `text-center ${resultsDateClassName}`
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-compare-circle",
        style: {
            backgroundColor: (0, $97b09ac2977ad497$export$4f10492abd16e944)
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `text-center ${resultsDateClassName}`
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))));
$90e8363415383103$var$CompareResultsDateLegend.propTypes = {
    formatedPreDate: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    formatedPostDate: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    resultsDateClassName: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
var $90e8363415383103$export$2e2bcd8739ae039 = $90e8363415383103$var$CompareResultsDateLegend;


const $30e5ffbc60d94d81$var$CategoryComparisonOverviewLayout = ({ formatedPreDate: formatedPreDate , formatedPostDate: formatedPostDate , isRenderFromOP: isRenderFromOP = false , overviewClassName: overviewClassName , chartClassName: chartClassName , children: children  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(overviewClassName, "mb-4", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $90e8363415383103$export$2e2bcd8739ae039), {
        formatedPreDate: formatedPreDate,
        formatedPostDate: formatedPostDate,
        resultsDateClassName: "results-date category-comparison-results-date"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex flex-column align-items-center category-comparison-chart-wrap", chartClassName)
    }, children)))));
$30e5ffbc60d94d81$var$CategoryComparisonOverviewLayout.propTypes = {
    formatedPreDate: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    formatedPostDate: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    isRenderFromOP: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    overviewClassName: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    chartClassName: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    children: (0, ($parcel$interopDefault($feLGi$proptypes))).node.isRequired
};
var $30e5ffbc60d94d81$export$2e2bcd8739ae039 = $30e5ffbc60d94d81$var$CategoryComparisonOverviewLayout;



const $b1d11348346a5b8e$var$parsePercent = (value)=>{
    const percent = parseInt(value, 10);
    return Number.isInteger(percent) ? percent : null;
};
const $b1d11348346a5b8e$var$CategoryComparisonOverview = ({ comparisonData: comparisonData , formatedPreDate: formatedPreDate , formatedPostDate: formatedPostDate , isRenderFromOP: isRenderFromOP = false , categoryConfig: categoryConfig , overviewClassName: overviewClassName , chartClassName: chartClassName  })=>{
    var _comparisonData_, _comparisonData_1;
    if (!(comparisonData === null || comparisonData === void 0 ? void 0 : (_comparisonData_ = comparisonData[0]) === null || _comparisonData_ === void 0 ? void 0 : _comparisonData_.results) || !(comparisonData === null || comparisonData === void 0 ? void 0 : (_comparisonData_1 = comparisonData[1]) === null || _comparisonData_1 === void 0 ? void 0 : _comparisonData_1.results)) return null;
    var _parsePercent;
    const surveyOneScores = categoryConfig.map((category)=>{
        var _comparisonData_, _comparisonData__results, _comparisonData__results_category_key;
        return (_parsePercent = $b1d11348346a5b8e$var$parsePercent((_comparisonData_ = comparisonData[0]) === null || _comparisonData_ === void 0 ? void 0 : (_comparisonData__results = _comparisonData_.results) === null || _comparisonData__results === void 0 ? void 0 : (_comparisonData__results_category_key = _comparisonData__results[category.key]) === null || _comparisonData__results_category_key === void 0 ? void 0 : _comparisonData__results_category_key.percent)) !== null && _parsePercent !== void 0 ? _parsePercent : 0;
    });
    var _parsePercent1;
    const surveyTwoScores = categoryConfig.map((category)=>{
        var _comparisonData_, _comparisonData__results, _comparisonData__results_category_key;
        return (_parsePercent1 = $b1d11348346a5b8e$var$parsePercent((_comparisonData_ = comparisonData[1]) === null || _comparisonData_ === void 0 ? void 0 : (_comparisonData__results = _comparisonData_.results) === null || _comparisonData__results === void 0 ? void 0 : (_comparisonData__results_category_key = _comparisonData__results[category.key]) === null || _comparisonData__results_category_key === void 0 ? void 0 : _comparisonData__results_category_key.percent)) !== null && _parsePercent1 !== void 0 ? _parsePercent1 : 0;
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $30e5ffbc60d94d81$export$2e2bcd8739ae039), {
        formatedPreDate: formatedPreDate,
        formatedPostDate: formatedPostDate,
        isRenderFromOP: isRenderFromOP,
        overviewClassName: overviewClassName,
        chartClassName: chartClassName
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: categoryConfig.map((category)=>category.title),
        surveyOne: surveyOneScores,
        surveyTwo: surveyTwoScores,
        colors: [
            (0, $97b09ac2977ad497$export$d72320d3eb8eec2),
            (0, $97b09ac2977ad497$export$4f10492abd16e944)
        ],
        categoryComparisonChart: true,
        height: 520,
        paneSize: "75%",
        lineWidth: 3,
        markerRadius: 5,
        axisLabelFontSize: 16
    }));
};
var $b1d11348346a5b8e$export$2e2bcd8739ae039 = $b1d11348346a5b8e$var$CategoryComparisonOverview;



const $1847fab3bb0b54b4$var$AwarenessCategoryComparisonOverview = (props)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b1d11348346a5b8e$export$2e2bcd8739ae039), {
        ...props,
        categoryConfig: (0, $97b09ac2977ad497$export$3058285f049a0176),
        overviewClassName: "awareness-category-comparison-overview",
        chartClassName: "awareness-category-comparison-chart"
    });
var $1847fab3bb0b54b4$export$2e2bcd8739ae039 = $1847fab3bb0b54b4$var$AwarenessCategoryComparisonOverview;







const $8cd010ee20c8a311$var$CompareResultsPageHeader = ({ assessmentTitle: assessmentTitle , pageTitle: pageTitle = "Compare Results" , onGoBack: onGoBack = ()=>{} , headerRight: headerRight = null , titleAccessory: titleAccessory = null , wrapperClassName: wrapperClassName = ""  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("survey-category-page-header", wrapperClassName)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "page-header mt-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center justify-content-between"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center survey-category-breadcrumb"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b6ee68546aeff868$export$2e2bcd8739ae039), {
        showSmallIcon: true,
        onClick: onGoBack,
        className: "mr-2 me-2"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        role: "button",
        tabIndex: 0,
        className: "s-captions text-capitalize cursor-pointer",
        onClick: onGoBack,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onGoBack();
            }
        }
    }, assessmentTitle)), headerRight)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center mb-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s1 survey-category-title mb-0"
    }, pageTitle), titleAccessory));
var $8cd010ee20c8a311$export$2e2bcd8739ae039 = $8cd010ee20c8a311$var$CompareResultsPageHeader;





const $f036bbe39d78cd8f$var$AssessmentComparisionLoader = ({ isRenderFromOP: isRenderFromOP = false  })=>{
    const loaderContent = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 4,
        className: "mt-5"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 50
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
        line: 7,
        gap: 20
    }))), Array.from({
        length: 3
    }, (_, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: `comparison-loader-section-${index}`
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 5,
            className: "mt-2"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
            width: 250,
            height: 50
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            md: 12,
            lg: 4,
            xl: 3,
            className: "mt-2 compare-thumbnail-responsive"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            md: 12,
            lg: 8,
            xl: 9,
            className: "mt-2 compared-thumbnail-responsive"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTable), {
            row: 3,
            col: 3
        }))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-center mt-5"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 9,
        lg: 9,
        xl: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTitle), {
        line: 1
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 11,
        lg: 11,
        xl: 8
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTitle), {
        line: 1
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))));
    if (!isRenderFromOP) return loaderContent;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: "px-0 custom-offset-lg-1 custom-col-lg-12"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pt-4 px-0",
        fluid: true
    }, loaderContent)));
};
var $f036bbe39d78cd8f$export$2e2bcd8739ae039 = $f036bbe39d78cd8f$var$AssessmentComparisionLoader;










const $dc3e8dc1c67b3a4b$var$DownloadPdfIcon = ({ onClick: onClick , disabled: disabled = false , isLoading: isLoading = false , className: className = "" , size: size = 32  })=>{
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("download-pdf-icon download-pdf-icon--loading d-inline-flex align-items-center justify-content-center", className),
        style: {
            width: size,
            height: size,
            pointerEvents: "none"
        },
        role: "status",
        "aria-label": "Downloading PDF",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Spinner), {
        animation: "border",
        size: "sm",
        className: "text-saffron-700",
        role: "status",
        "aria-hidden": "true"
    }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("download-pdf-icon", className),
        onClick: disabled ? undefined : onClick,
        xmlns: "http://www.w3.org/2000/svg",
        role: "button",
        "aria-label": "Download PDF",
        style: disabled ? {
            pointerEvents: "none"
        } : undefined
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        className: "download-pdf-icon__track",
        cx: "20",
        cy: "20",
        r: "19",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("g", {
        className: "download-pdf-icon__arrow"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M20.8462 25.6565C20.4539 26.2793 19.5461 26.2793 19.1538 25.6566L15.7693 20.2829C15.3499 19.617 15.8285 18.75 16.6155 18.75L23.3845 18.75C24.1715 18.75 24.6501 19.617 24.2307 20.2829L20.8462 25.6565Z"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("line", {
        x1: "20",
        y1: "20.4287",
        x2: "20",
        y2: "11.0001",
        strokeWidth: "2",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("line", {
        className: "download-pdf-icon__tray",
        x1: "11.5",
        y1: "28.5",
        x2: "28.5",
        y2: "28.5",
        strokeLinecap: "round"
    }));
};
$dc3e8dc1c67b3a4b$var$DownloadPdfIcon.propTypes = {
    onClick: (0, ($parcel$interopDefault($feLGi$proptypes))).func,
    disabled: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    isLoading: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    className: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    size: (0, ($parcel$interopDefault($feLGi$proptypes))).number
};
var $dc3e8dc1c67b3a4b$export$2e2bcd8739ae039 = $dc3e8dc1c67b3a4b$var$DownloadPdfIcon;





const $50f91df4720112ee$export$3ae94a2503e890a1 = (date)=>{
    return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(date).format("MM/DD/YYYY");
};
const $50f91df4720112ee$export$bffff7662ad2cb68 = (months)=>{
    return (0, ($parcel$interopDefault($feLGi$momenttimezone)))().add(months, "M").format("MM/DD/YYYY");
};
const $50f91df4720112ee$export$6cac2c4ed6c8d624 = (date, dateFormat)=>{
    if (date) return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(date).format(dateFormat || "MMM Do, YYYY");
    else return (0, ($parcel$interopDefault($feLGi$momenttimezone)))().format(dateFormat || "MMM Do, YYYY");
};
const $50f91df4720112ee$export$307103d2a6db5e8d = (date)=>{
    return (0, ($parcel$interopDefault($feLGi$momenttimezone))).utc(date).format("MMMM Do");
};
const $50f91df4720112ee$export$cf5705bae9972c44 = (time, format = "HH:mm")=>{
    return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(time, format).format("h:mm a").replace("am", "a.m.").replace("pm", "p.m.");
};
const $50f91df4720112ee$export$9073f608e603115b = (dateValue, submittedAt)=>{
    const raw = Array.isArray(dateValue) ? dateValue[0] : dateValue;
    const startPart = String(raw || "").split(" - ")[0].trim();
    if (startPart) {
        const fromRange = (0, ($parcel$interopDefault($feLGi$momenttimezone)))(startPart, [
            "YYYY-MM-DD",
            "MM-DD-YYYY",
            "MMM DD, YYYY"
        ], true);
        if (fromRange.isValid()) return fromRange;
        const loose = (0, ($parcel$interopDefault($feLGi$momenttimezone)))(startPart);
        if (loose.isValid()) return loose;
    }
    if (submittedAt) {
        const fromSubmitted = (0, ($parcel$interopDefault($feLGi$momenttimezone)))(submittedAt);
        if (fromSubmitted.isValid()) return fromSubmitted;
    }
    return (0, ($parcel$interopDefault($feLGi$momenttimezone))).invalid();
};



// Chrome/Edge replace ASCII ":" with "_" in download filenames.
// Modifier letter colon (U+A789) looks like ":" without extra spacing and is kept.
const $89420a3db7aa95f0$var$FILE_SAFE_COLON = "꞉";
const $89420a3db7aa95f0$var$QUARTER_MONTH_LABELS = {
    1: "JAN - MARCH",
    2: "APRIL - JUNE",
    3: "JULY - SEPTEMBER",
    4: "OCTOBER - DECEMBER"
};
const $89420a3db7aa95f0$export$9520d446222eef3c = (date = new Date())=>(0, ($parcel$interopDefault($feLGi$momenttimezone)))(date).format("MM-DD-YYYY_HH:mm:ss").replace(/:/g, $89420a3db7aa95f0$var$FILE_SAFE_COLON);
const $89420a3db7aa95f0$export$a05b62b0b8453404 = (date = new Date())=>`${$89420a3db7aa95f0$export$9520d446222eef3c(date)}`;
const $89420a3db7aa95f0$export$5d0ccbd57c6f4340 = (value = "")=>String(value || "").replace(/[<>:"/\\|?*]+/g, "").replace(/\s+/g, "_").replace(/'+/g, "").trim();
const $89420a3db7aa95f0$export$df30674c511b335d = (value = "")=>String(value || "").replace(/[<>:"/\\|?*]+/g, "").replace(/\s+/g, " ").replace(/'+/g, "").trim();
const $89420a3db7aa95f0$var$safeDecodeURIComponent = (value = "")=>{
    try {
        return decodeURIComponent(String(value || ""));
    } catch (e) {
        return String(value || "");
    }
};
const $89420a3db7aa95f0$export$1a142a86e2eeb509 = (entityName = "")=>$89420a3db7aa95f0$export$df30674c511b335d($89420a3db7aa95f0$var$safeDecodeURIComponent(entityName).toUpperCase());
const $89420a3db7aa95f0$export$5c8a4f5d2eeaad = (type)=>{
    if (type === "wisdom") return "AggregatedWisdomAssessment";
    if (type === "prosperity") return "AggregatedTrueProsperityAssessment";
    return "AggregatedAwarenessAssessment";
};
const $89420a3db7aa95f0$export$6dce16fec17ac59e = (type)=>{
    if (type === "wisdom") return "GroupWisdomAssessment";
    if (type === "prosperity") return "GroupTrueProsperityAssessment";
    return "GroupAwarenessAssessment";
};
const $89420a3db7aa95f0$export$2dbc9cb8c61c8b45 = (type)=>{
    if (type === "wisdom") return "WisdomAssessment";
    if (type === "prosperity") return "TrueProsperityAssessment";
    return "AwarenessAssessment";
};
const $89420a3db7aa95f0$export$ee41ca24a5c12249 = (quarter, year)=>{
    const quarterNumber = Number(quarter);
    const monthLabel = $89420a3db7aa95f0$var$QUARTER_MONTH_LABELS[quarterNumber] || $89420a3db7aa95f0$var$QUARTER_MONTH_LABELS[4];
    return `QUARTER - ${quarterNumber} (${monthLabel}) - ${year}`;
};
const $89420a3db7aa95f0$export$1f1007e3e43483a1 = (entityName, type)=>`${$89420a3db7aa95f0$export$1a142a86e2eeb509(entityName)}_${$89420a3db7aa95f0$export$5c8a4f5d2eeaad(type)}_CombinedSummaryResults`;
const $89420a3db7aa95f0$export$4d86f60c02acee6 = (entityName, type)=>`${$89420a3db7aa95f0$export$1a142a86e2eeb509(entityName)}_${$89420a3db7aa95f0$export$6dce16fec17ac59e(type)}_CombinedSummaryResults`;
const $89420a3db7aa95f0$export$1ecd35faaf992528 = (entityName, quarterLabel, type)=>`${$89420a3db7aa95f0$export$1a142a86e2eeb509(entityName)}_${$89420a3db7aa95f0$export$df30674c511b335d(quarterLabel)}_${$89420a3db7aa95f0$export$2dbc9cb8c61c8b45(type)}`;
const $89420a3db7aa95f0$export$c9562625c3822691 = (entityName)=>`${$89420a3db7aa95f0$export$1a142a86e2eeb509(entityName)}_AggregatedAssessmentUsers_CombinedSummaryResults`;
const $89420a3db7aa95f0$export$ba9fdf0369491da = (fileNameBase)=>`${$89420a3db7aa95f0$export$df30674c511b335d(fileNameBase)}_${$89420a3db7aa95f0$export$9520d446222eef3c()}.pdf`;


const $b5f12f83c4275d44$export$ec8a5eeacff9f002 = "manage-group";
const $b5f12f83c4275d44$export$effd300369b6ebd2 = {
    breakthroughProgramId: "5fddc237a483be3860dea6f2",
    evolutionProgramId: "60e885f48ea7c31048bc553d",
    resilienceProgramId: "639970530a71c612b0026943",
    essentialsProgramId: "656dc22e079eab484d6e3288"
};
const $b5f12f83c4275d44$export$16f8adc1f5353264 = {
    POETIC: "POETIC",
    PRACTICAL: "PRACTICAL",
    KEY_SKILL: "KEY_SKILL"
};
const $b5f12f83c4275d44$export$c24fb550983679aa = {
    AUDIO: "AUDIO",
    PDF: "PDF"
};
const $b5f12f83c4275d44$export$7f4c6ae6cd2bdde3 = {
    breakthrough: {
        id: "5fddc237a483be3860dea6f2",
        name: "Breakthrough",
        title: "Breakthrough Program",
        hasFirstModuleIsIntro: false,
        key: "breakthrough_program",
        pageUrl: "/program/5fddc237a483be3860dea6f2",
        description: "The content below has been personalized based on the results of your assessments."
    },
    evolution: {
        id: "60e885f48ea7c31048bc553d",
        name: "Evolution",
        title: "Evolution Program",
        hasFirstModuleIsIntro: false,
        key: "evolution_program",
        pageUrl: "/program/60e885f48ea7c31048bc553d",
        description: "The content below has been personalized based on the results of your assessments."
    },
    resilience: {
        id: "639970530a71c612b0026943",
        name: "Trauma Informed Leadership",
        title: "Trauma Informed Leadership Program",
        hasFirstModuleIsIntro: false,
        key: "resilience_program",
        pageUrl: "/program/639970530a71c612b0026943",
        description: "The content below has been personalized based on the results of your assessments."
    },
    essentials: {
        id: "656dc22e079eab484d6e3288",
        name: "Leadership Essentials",
        title: "Leadership Essentials Program",
        hasFirstModuleIsIntro: false,
        key: "leadership_essentials",
        pageUrl: "/program/656dc22e079eab484d6e3288",
        description: "The content below has been personalized based on the results of your assessments."
    },
    "5fddc237a483be3860dea6f2": {
        id: "5fddc237a483be3860dea6f2",
        name: "Breakthrough",
        title: "Breakthrough Program",
        hasFirstModuleIsIntro: false,
        key: "breakthrough_program",
        pageUrl: "/program/5fddc237a483be3860dea6f2",
        description: "The content below has been personalized based on the results of your assessments."
    },
    "60e885f48ea7c31048bc553d": {
        id: "60e885f48ea7c31048bc553d",
        name: "Evolution",
        title: "Evolution Program",
        hasFirstModuleIsIntro: false,
        key: "evolution_program",
        pageUrl: "/program/60e885f48ea7c31048bc553d",
        description: "The content below has been personalized based on the results of your assessments."
    },
    "639970530a71c612b0026943": {
        id: "639970530a71c612b0026943",
        name: "Trauma Informed Leadership",
        title: "Trauma Informed Leadership Program",
        hasFirstModuleIsIntro: false,
        key: "resilience_program",
        pageUrl: "/program/639970530a71c612b0026943",
        description: "The content below has been personalized based on the results of your assessments."
    },
    "656dc22e079eab484d6e3288": {
        id: "656dc22e079eab484d6e3288",
        name: "Leadership Essentials",
        title: "Leadership Essentials Program",
        hasFirstModuleIsIntro: false,
        key: "leadership_essentials",
        pageUrl: "/program/656dc22e079eab484d6e3288",
        description: "The content below has been personalized based on the results of your assessments."
    }
};
const $b5f12f83c4275d44$export$3103d3761b63f14d = [
    "http://localhost:3001",
    "http://localhost:3002",
    "https://rc.abroad.io",
    "https://rc-admin.abroad.io"
];
const $b5f12f83c4275d44$export$f1fd5412d5e57eca = [
    {
        id: "5b46b176ce416b175ff98e17",
        name: "Self Awareness",
        key: "self_awareness",
        description: "The content below has been personalized based on the results of your assessment(s).",
        to: "/self-awareness/5b46b176ce416b175ff98e17",
        hidden: [],
        hiddenInPlans: [],
        urlWords: [
            "self-awareness"
        ]
    },
    {
        id: "5b46b176ce416b175ff98e2f",
        name: "Team Cohesion",
        key: "team_cohesion",
        description: "The content below has been personalized based on the results of your assessment(s).",
        to: "/team-cohesion/5b46b176ce416b175ff98e2f",
        hidden: [],
        hiddenInPlans: [],
        urlWords: [
            "team-cohesion"
        ]
    },
    {
        id: "5b46b176ce416b175ff98de6",
        name: "Vision & Impact",
        key: "Vision_&_Impact",
        description: "The content below has been personalized based on the results of your assessment(s).",
        to: "/vision-and-impact/5b46b176ce416b175ff98de6",
        hidden: [],
        hiddenInPlans: [],
        urlWords: [
            "vision-and-impact"
        ]
    },
    {
        id: "639c067da4d9940fd87f216d",
        name: "Manager Efficacy",
        key: "manager_efficacy",
        description: "",
        to: "/manager-efficacy/639c067da4d9940fd87f216d",
        hidden: [],
        hiddenInPlans: [],
        urlWords: [
            "manager-efficacy"
        ]
    },
    {
        id: "60eef62e0c2ca67244cbdb9a",
        name: "Mindfulness & Somatics",
        key: "mindfulness_&_somatics",
        description: "This library includes mindfulness and somatic practices that bring you into greater presence and relaxation",
        to: "/mindfulness-and-somatics/60eef62e0c2ca67244cbdb9a",
        hidden: [
            "prod"
        ],
        hiddenInPlans: [],
        urlWords: [
            "mindfulness-and-somatics"
        ]
    },
    {
        id: "6144525714454a1a5609d5c1",
        name: "Leadership Stories",
        key: "leadership_stories",
        description: "The content below has been personalized based on the results of your assessment(s).",
        to: "/leadership-stories/6144525714454a1a5609d5c1",
        hidden: [
            "prod"
        ],
        hiddenInPlans: [],
        urlWords: [
            "leadership-stories"
        ]
    }
];
const $b5f12f83c4275d44$export$53fd046cd6eac48 = {
    selfAwarenessId: "5b46b176ce416b175ff98e17",
    teamCohesionId: "5b46b176ce416b175ff98e2f",
    visionAndImpactId: "5b46b176ce416b175ff98de6",
    managerEfficacyId: "639c067da4d9940fd87f216d"
};
const $b5f12f83c4275d44$export$7846f3dca8bd5e36 = "Simple 360";
const $b5f12f83c4275d44$export$258b8fda08817d66 = "simple-360";
const $b5f12f83c4275d44$export$517c6d5dba4c50ae = {
    prefix: {
        individual: "B2C: ",
        b2b: "B2B: ",
        b2bGroup: "B2B: Groups",
        normalGroup: "B2C: Groups",
        growth: "Growth:"
    },
    label: {
        individual: "B2C",
        b2b: "B2B",
        b2bGroup: "B2B Groups",
        normalGroup: "B2C Groups",
        clientSideIndividual: "Individual",
        clientSideB2B: "B2B",
        clientSideGroup: "Group",
        growth: "Growth"
    },
    planType: {
        individual: "individual",
        b2b: "b2b",
        growth: "growth"
    }
};
const $b5f12f83c4275d44$export$a18da5e670f0b062 = {
    IN_PROGRESS: "IN_PROGRESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    WAITING_FOR_PAYMENT: "WAITING_FOR_PAYMENT",
    DRAFT: "DRAFT",
    TERMINATED: "TERMINATED"
};
const $b5f12f83c4275d44$export$821a12f7ff141b92 = {
    IN_PROGRESS: "IN_PROGRESS",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    WAITING_FOR_PAYMENT: "WAITING_FOR_PAYMENT",
    DRAFT: "DRAFT",
    TERMINATED: "TERMINATED"
};
const $b5f12f83c4275d44$export$40bae20db5989375 = [
    {
        value: "DRAFT",
        label: "Draft"
    },
    {
        value: "IN_PROGRESS",
        label: "In Progress"
    },
    {
        value: "TERMINATED",
        label: "Terminated"
    },
    {
        value: "PAYMENT_FAILED",
        label: "Payment Failed"
    },
    {
        value: "WAITING_FOR_PAYMENT",
        label: "Waiting For Payment"
    }
];
const $b5f12f83c4275d44$export$28dd478a8c6c6590 = [
    {
        value: "PAID",
        label: "Paid"
    },
    {
        value: "FAILED",
        label: "Failed"
    },
    {
        value: "PAUSED",
        label: "Paused"
    },
    {
        value: "CANCELLED",
        label: "Cancelled"
    },
    {
        value: "PENDING",
        label: "Pending"
    },
    {
        value: "NOT_INITIATED",
        label: "Payment Required (The link will be sent to the client)"
    },
    {
        value: "NO_BILLING_REQUIRED",
        label: "Payment Not Required"
    },
    {
        value: "RESUMED",
        label: "Resumed"
    }
];
const $b5f12f83c4275d44$export$cf6c01cadfc8fe18 = {
    RECURRING: "recurring",
    ONETIME: "onetime",
    BOTH: "both"
};
const $b5f12f83c4275d44$export$2d54bae301ecd176 = [
    {
        label: "Draft",
        value: "DRAFT"
    },
    {
        label: "In Progress",
        value: "IN_PROGRESS"
    },
    {
        label: "Terminate",
        value: "STOPPED"
    },
    // { label: 'Pending', value: 'PENDING' },
    {
        label: "Resumed",
        value: "RESUMED"
    },
    {
        label: "Paused",
        value: "PAUSED"
    }
];
const $b5f12f83c4275d44$export$777f84cc921315f3 = "Coach Recommends";
const $b5f12f83c4275d44$export$bd747daeacd12df3 = "coach-recommends";
const $b5f12f83c4275d44$export$e3c9dc9ffebfa801 = "Leader Assessment";
const $b5f12f83c4275d44$export$d106f1f368cdf806 = "leader-assessments";
const $b5f12f83c4275d44$export$2048b4b7dcce9e34 = {
    AWARENESS: "awareness",
    LEADER: "leader",
    WISDOM: "wisdom",
    PROSPERITY: "prosperity"
};
const $b5f12f83c4275d44$var$ASSESSMENT_COMPARE_ROUTE_PREFIX = {
    [$b5f12f83c4275d44$export$2048b4b7dcce9e34.AWARENESS]: "survey",
    [$b5f12f83c4275d44$export$2048b4b7dcce9e34.PROSPERITY]: "prosperity",
    [$b5f12f83c4275d44$export$2048b4b7dcce9e34.WISDOM]: "wisdom"
};
const $b5f12f83c4275d44$export$802fe12baad01513 = (compareSurveyType)=>$b5f12f83c4275d44$var$ASSESSMENT_COMPARE_ROUTE_PREFIX[compareSurveyType] || "survey";


const $48146d44b0fa9b23$var$showJourneyMediaDescription = (media)=>{
    var _media_categoryId;
    let description = "";
    if ((media === null || media === void 0 ? void 0 : media.type) === "module") {
        var _media_parentId, _media_parentId_title;
        const title = (media === null || media === void 0 ? void 0 : (_media_parentId = media.parentId) === null || _media_parentId === void 0 ? void 0 : (_media_parentId_title = _media_parentId.title) === null || _media_parentId_title === void 0 ? void 0 : _media_parentId_title.replace(" Program", ", ")) || "";
        return description.concat(`${title} Module ${(media === null || media === void 0 ? void 0 : media.sequence) + 1}`);
    } else if ((media === null || media === void 0 ? void 0 : media.type) === "media" && Object.values((0, $b5f12f83c4275d44$export$effd300369b6ebd2)).includes(media === null || media === void 0 ? void 0 : (_media_categoryId = media.categoryId) === null || _media_categoryId === void 0 ? void 0 : _media_categoryId._id)) {
        var _media_categoryId1, _media_categoryId_title, _media_subCategoryId, _media_subCategoryId1;
        const title = (media === null || media === void 0 ? void 0 : (_media_categoryId1 = media.categoryId) === null || _media_categoryId1 === void 0 ? void 0 : (_media_categoryId_title = _media_categoryId1.title) === null || _media_categoryId_title === void 0 ? void 0 : _media_categoryId_title.replace(" Program", ", ")) || "";
        return description.concat(`${title} Module ${(media === null || media === void 0 ? void 0 : (_media_subCategoryId = media.subCategoryId) === null || _media_subCategoryId === void 0 ? void 0 : _media_subCategoryId.sequence) ? (media === null || media === void 0 ? void 0 : (_media_subCategoryId1 = media.subCategoryId) === null || _media_subCategoryId1 === void 0 ? void 0 : _media_subCategoryId1.sequence) + 1 : ""}`);
    } else {
        var _media_categoryId2, _media_subCategoryId2;
        description = description.concat(`${media === null || media === void 0 ? void 0 : (_media_categoryId2 = media.categoryId) === null || _media_categoryId2 === void 0 ? void 0 : _media_categoryId2.title}, ${media === null || media === void 0 ? void 0 : (_media_subCategoryId2 = media.subCategoryId) === null || _media_subCategoryId2 === void 0 ? void 0 : _media_subCategoryId2.title}`);
        return description;
    }
};
var $48146d44b0fa9b23$export$2e2bcd8739ae039 = $48146d44b0fa9b23$var$showJourneyMediaDescription;


const $625df15f91b44219$var$plans = {
    free: {
        name: "Awareness",
        code: "free",
        sequence: 0,
        license: 1,
        price: 0.0,
        duration: 7300 // in days
    },
    growth: {
        name: "Growth",
        code: "growth",
        sequence: 1,
        license: 1,
        price: 500.0,
        duration: 393
    },
    coaching: {
        name: "Coaching",
        code: "coaching",
        sequence: 2,
        license: 1,
        price: 2500.0,
        duration: 393
    }
};
var $625df15f91b44219$export$2e2bcd8739ae039 = $625df15f91b44219$var$plans;





const $1ca4df0143566e72$var$TEXT_COLOR = "#010101";
const $1ca4df0143566e72$var$BORDER_COLOR = "#D9D9D9";
const $1ca4df0143566e72$var$BOX_BORDER_COLOR = "#000000";
const $1ca4df0143566e72$var$BOX_BACKGROUND_COLOR = "#F3F6F6";
const $1ca4df0143566e72$var$RENDER_WIDTH = 800;
const $1ca4df0143566e72$var$PDF_WIDTH_MM = 210;
const $1ca4df0143566e72$var$PDF_HEIGHT_MM = 297;
const $1ca4df0143566e72$var$PAGE_HEIGHT_PX = $1ca4df0143566e72$var$RENDER_WIDTH * $1ca4df0143566e72$var$PDF_HEIGHT_MM / $1ca4df0143566e72$var$PDF_WIDTH_MM;
const $1ca4df0143566e72$var$PAGE_PADDING_X = 32;
const $1ca4df0143566e72$var$PAGE_PADDING_BOTTOM = 36;
// Prevents last rows from being clipped by overflow:hidden when measured
// height is slightly smaller than the final rendered height.
const $1ca4df0143566e72$var$PAGE_FIT_SAFETY_PX = 24;
const $1ca4df0143566e72$var$PDF_PAGE_BREAK = "<!--assessment-pdf-page-break-->";
// Matches UI typography tokens: .s1 / .s2 / .s6 / .s7
const $1ca4df0143566e72$var$TITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:44px;line-height:56px;letter-spacing:-1.76px;";
const $1ca4df0143566e72$var$SUBTITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:30px;line-height:40px;letter-spacing:-1.2px;";
const $1ca4df0143566e72$var$SECTION_TITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:38px;line-height:52px;letter-spacing:-1.52px;";
// .s6 — subcategory row labels (medium, not bold)
const $1ca4df0143566e72$var$BODY_TEXT_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:500;font-size:16px;line-height:26px;letter-spacing:-0.32px;";
// .s7 — celebrations / growth area labels
const $1ca4df0143566e72$var$CELEBRATION_TEXT_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:600;font-size:15px;line-height:26px;letter-spacing:-0.32px;";
const $1ca4df0143566e72$var$PERCENT_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:44px;line-height:56px;letter-spacing:-1.76px;";
const $1ca4df0143566e72$var$DETAIL_PERCENT_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:66px;line-height:1;letter-spacing:-1.76px;";
const $1ca4df0143566e72$var$waitForFonts = async ()=>{
    var _document_fonts;
    if ((_document_fonts = document.fonts) === null || _document_fonts === void 0 ? void 0 : _document_fonts.ready) await document.fonts.ready;
};
const $1ca4df0143566e72$var$getOverviewTitleStyle = (titles = [], cardWidth)=>{
    const baseSize = 38;
    const minSize = 22;
    const longestTitle = titles.reduce((longest, title)=>Math.max(longest, String(title || "").length), 0);
    let fontSize = baseSize;
    // Keep all overview titles on one line at the same size.
    while(fontSize > minSize && longestTitle * fontSize * 0.52 > cardWidth)fontSize -= 1;
    const lineHeight = Math.round(fontSize * 1.3);
    const letterSpacing = Number((fontSize * -0.04).toFixed(2));
    return `font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:${fontSize}px;line-height:${lineHeight}px;letter-spacing:${letterSpacing}px;white-space:nowrap;`;
};
const $1ca4df0143566e72$var$MANAGER_EFFICACY_ID = "62963961a279e16eeb3aa867";
const $1ca4df0143566e72$var$PERCEIVED_AWARENESS_ID = "5b46b176ce416b175ff98e17";
const $1ca4df0143566e72$var$ASSESSMENT_CONFIG = {
    [(0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).LEADER]: {
        title: "Leader Assessment",
        fileLabel: "Leader_Assessment",
        skipCelebrations: true,
        overviewCategories: [
            {
                key: $1ca4df0143566e72$var$MANAGER_EFFICACY_ID,
                title: "Manager Efficacy",
                inner: "#84A07C",
                outer: "#E0E7DE",
                percentColor: "#FFFFFF"
            },
            {
                key: $1ca4df0143566e72$var$PERCEIVED_AWARENESS_ID,
                title: "Perceived Awareness",
                inner: "#4978AB",
                outer: "rgba(73, 120, 171, 0.25)",
                percentColor: "#FFFFFF"
            }
        ],
        detailCategories: [
            {
                key: $1ca4df0143566e72$var$MANAGER_EFFICACY_ID,
                title: "Manager Efficacy",
                inner: "#84A07C",
                outer: "#E0E7DE",
                percentColor: "#FFFFFF"
            }
        ],
        getSortedSubcategories: ()=>[]
    },
    [(0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM]: {
        title: "Wisdom Assessment",
        fileLabel: "Wisdom_Assessment",
        overviewCategories: [
            {
                key: "self_understanding",
                title: "Self Understanding",
                inner: "#123C69",
                outer: "rgba(18,60,105,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "wisdom__connection",
                title: "Wisdom & Connection",
                inner: "#285238",
                outer: "rgba(40,82,56,0.25)",
                percentColor: "#FFFFFF"
            }
        ],
        detailCategories: [
            {
                key: "self_understanding",
                title: "Self Understanding",
                inner: "#123C69",
                outer: "rgba(18,60,105,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "wisdom__connection",
                title: "Wisdom & Connection",
                inner: "#285238",
                outer: "rgba(40,82,56,0.25)",
                percentColor: "#FFFFFF"
            }
        ],
        getSortedSubcategories: (results)=>{
            var _results_self_understanding, _results_wisdom__connection;
            if (!results) return [];
            const self = (((_results_self_understanding = results.self_understanding) === null || _results_self_understanding === void 0 ? void 0 : _results_self_understanding.order) || []).map((cat)=>({
                    ...results.self_understanding.subcategories[cat],
                    key: cat,
                    color: "#123C69"
                }));
            const wisdom = (((_results_wisdom__connection = results.wisdom__connection) === null || _results_wisdom__connection === void 0 ? void 0 : _results_wisdom__connection.order) || []).map((cat)=>({
                    ...results.wisdom__connection.subcategories[cat],
                    key: cat,
                    color: "#285238"
                }));
            return [
                ...self,
                ...wisdom
            ].sort((a, b)=>b.percent - a.percent);
        }
    },
    [(0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY]: {
        title: "True Prosperity Assessment",
        fileLabel: "True_Prosperity_Assessment",
        overviewCategories: [
            {
                key: "life__work",
                title: "Life & Work",
                inner: "#0A223C",
                outer: "rgba(10,34,60,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "self_awareness",
                title: "Self Awareness",
                inner: "#CE8147",
                outer: "rgba(206,129,71,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "timeless_wisdom",
                title: "Timeless Wisdom",
                inner: "#EFC030",
                outer: "rgba(239,192,48,0.25)",
                percentColor: "#FFFFFF"
            }
        ],
        detailCategories: [
            {
                key: "life__work",
                title: "Life & Work",
                inner: "#0A223C",
                outer: "rgba(10,34,60,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "self_awareness",
                title: "Self Awareness",
                inner: "#CE8147",
                outer: "#F2DFD1",
                percentColor: "#FFFFFF"
            },
            {
                key: "timeless_wisdom",
                title: "Timeless Wisdom",
                inner: "#EFC030",
                outer: "#FBEFCB",
                percentColor: "#FFFFFF"
            }
        ],
        getSortedSubcategories: (results)=>{
            var _results_life__work, _results_self_awareness, _results_timeless_wisdom;
            if (!results) return [];
            const life = (((_results_life__work = results.life__work) === null || _results_life__work === void 0 ? void 0 : _results_life__work.order) || []).map((cat)=>({
                    ...results.life__work.subcategories[cat],
                    key: cat,
                    color: "#0A223C"
                }));
            const self = (((_results_self_awareness = results.self_awareness) === null || _results_self_awareness === void 0 ? void 0 : _results_self_awareness.order) || []).map((cat)=>({
                    ...results.self_awareness.subcategories[cat],
                    key: cat,
                    color: "#CE8147"
                }));
            const wisdom = (((_results_timeless_wisdom = results.timeless_wisdom) === null || _results_timeless_wisdom === void 0 ? void 0 : _results_timeless_wisdom.order) || []).map((cat)=>({
                    ...results.timeless_wisdom.subcategories[cat],
                    key: cat,
                    color: "#EFC030"
                }));
            return [
                ...life,
                ...self,
                ...wisdom
            ].sort((a, b)=>b.percent - a.percent);
        }
    },
    [(0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS]: {
        title: "Awareness Assessment",
        fileLabel: "Awareness_Assessment",
        overviewCategories: [
            {
                key: "self_awareness",
                title: "Self Awareness",
                inner: "#0A223C",
                outer: "rgba(10,34,60,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "team_cohesion",
                title: "Team Cohesion",
                inner: "#CE8147",
                outer: "rgba(206,129,71,0.25)",
                percentColor: "#FFFFFF",
                hideWhenInTransition: true
            },
            {
                key: "vision__impact",
                title: "Vision & Impact",
                inner: "#EFC030",
                outer: "rgba(239,192,48,0.25)",
                percentColor: "#FFFFFF",
                hideWhenInTransition: true
            }
        ],
        detailCategories: [
            {
                key: "self_awareness",
                title: "Self Awareness",
                inner: "#0A223C",
                outer: "rgba(10,34,60,0.25)",
                percentColor: "#FFFFFF"
            },
            {
                key: "team_cohesion",
                title: "Team Cohesion",
                inner: "#CE8147",
                outer: "#F2DFD1",
                percentColor: "#FFFFFF",
                hideWhenInTransition: true
            },
            {
                key: "vision__impact",
                title: "Vision & Impact",
                inner: "#EFC030",
                outer: "#FBEFCB",
                percentColor: "#FFFFFF",
                hideWhenInTransition: true
            }
        ],
        getSortedSubcategories: (results, inTransition)=>{
            var _results_self_awareness, _results_team_cohesion, _results_vision__impact;
            if (!results) return [];
            let items = (((_results_self_awareness = results.self_awareness) === null || _results_self_awareness === void 0 ? void 0 : _results_self_awareness.order) || []).map((cat)=>({
                    ...results.self_awareness.subcategories[cat],
                    key: cat,
                    color: "#0A223C"
                }));
            if (!inTransition) items = [
                ...items,
                ...(((_results_team_cohesion = results.team_cohesion) === null || _results_team_cohesion === void 0 ? void 0 : _results_team_cohesion.order) || []).map((cat)=>({
                        ...results.team_cohesion.subcategories[cat],
                        key: cat,
                        color: "#CE8147"
                    })),
                ...(((_results_vision__impact = results.vision__impact) === null || _results_vision__impact === void 0 ? void 0 : _results_vision__impact.order) || []).map((cat)=>({
                        ...results.vision__impact.subcategories[cat],
                        key: cat,
                        color: "#EFC030"
                    }))
            ];
            return items.sort((a, b)=>b.percent - a.percent);
        }
    }
};
const $1ca4df0143566e72$var$getAbroadLogoUrl = ()=>{
    const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return `${window.location.origin}${publicUrl}/assets/images/signupHeaderIcon.svg`;
};
const $1ca4df0143566e72$var$escapeHtml = (value = "")=>String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
const $1ca4df0143566e72$var$getSafeFileName = (title)=>String(title || "").replace(/[<>:"/\\|?*]+/g, "").replace(/\s+/g, " ").trim();
const $1ca4df0143566e72$var$formatPercent = (percent)=>Number.isInteger(percent) ? `${percent}%` : "N/A";
const $1ca4df0143566e72$var$getFillHeight = (percent)=>{
    if (!Number.isInteger(percent)) return "0%";
    return percent <= 35 ? "35%" : `${percent}%`;
};
const $1ca4df0143566e72$var$waitForImages = (element)=>{
    const images = Array.from(element.querySelectorAll("img"));
    if (images.length === 0) return Promise.resolve();
    return Promise.all(images.map((img)=>new Promise((resolve)=>{
            if (img.complete && img.naturalWidth > 0) {
                resolve();
                return;
            }
            img.onload = ()=>resolve();
            img.onerror = ()=>resolve();
        })));
};
const $1ca4df0143566e72$var$getVisibleCategories = (categories = [], inTransition)=>categories.filter((category)=>!(inTransition && category.hideWhenInTransition));
const $1ca4df0143566e72$var$buildOverviewCardsHtml = (categories, results)=>{
    const cardWidth = categories.length >= 3 ? 220 : 260;
    const cardHeight = 200;
    const titleStyle = $1ca4df0143566e72$var$getOverviewTitleStyle(categories.map((category)=>category.title), cardWidth);
    const cardsHtml = categories.map((category)=>{
        var _results_category_key;
        const percent = results === null || results === void 0 ? void 0 : (_results_category_key = results[category.key]) === null || _results_category_key === void 0 ? void 0 : _results_category_key.percent;
        return `
        <div style="flex:0 0 ${cardWidth}px;width:${cardWidth}px;text-align:center;">
          <div style="${titleStyle}margin-bottom:12px;color:${$1ca4df0143566e72$var$TEXT_COLOR};">
            ${$1ca4df0143566e72$var$escapeHtml(category.title)}
          </div>
          <div
            style="
              width:${cardWidth}px;
              height:${cardHeight}px;
              border-radius:5px;
              background:${category.outer};
              position:relative;
              overflow:hidden;
              margin:0 auto;
            ">
            <div
              style="
                position:absolute;
                left:0;
                bottom:0;
                width:100%;
                height:${$1ca4df0143566e72$var$getFillHeight(percent)};
                background:${category.inner};
                border-radius:5px;
                display:flex;
                align-items:center;
                justify-content:center;
                ${$1ca4df0143566e72$var$PERCENT_STYLE}
                color:${category.percentColor};
              ">
              ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(percent))}
            </div>
          </div>
        </div>
      `;
    }).join("");
    return `
    <div style="display:flex;justify-content:center;gap:24px;flex-wrap:nowrap;margin-bottom:36px;">
      ${cardsHtml}
    </div>
  `;
};
const $1ca4df0143566e72$var$getCategoryTitleById = (categories = [], categoryId, fallback = "")=>{
    var _categories_find;
    return ((_categories_find = categories.find((category)=>{
        return (category === null || category === void 0 ? void 0 : category._id) === categoryId;
    })) === null || _categories_find === void 0 ? void 0 : _categories_find.title) || fallback;
};
const $1ca4df0143566e72$var$buildSubcategoryRowsHtml = (categoryResult, color, { categories: categories = [] , resolveTitleFromCategories: resolveTitleFromCategories = false  } = {})=>{
    const order = (categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.order) || [];
    if (!order.length) return `<div style="${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};padding:12px 0;">No subcategory results.</div>`;
    return order.map((subcategoryKey, index)=>{
        var _categoryResult_subcategories;
        const subcategory = categoryResult === null || categoryResult === void 0 ? void 0 : (_categoryResult_subcategories = categoryResult.subcategories) === null || _categoryResult_subcategories === void 0 ? void 0 : _categoryResult_subcategories[subcategoryKey];
        const title = resolveTitleFromCategories ? $1ca4df0143566e72$var$getCategoryTitleById(categories, subcategoryKey, subcategory === null || subcategory === void 0 ? void 0 : subcategory.title) : (subcategory === null || subcategory === void 0 ? void 0 : subcategory.title) || "";
        return `
        <div
          style="
            display:flex;
            justify-content:space-between;
            align-items:center;
            padding:14px 8px;
            border-bottom:${index === order.length - 1 ? "none" : `1px solid ${$1ca4df0143566e72$var$BORDER_COLOR}`};
          ">
          <div style="${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};padding-right:16px;">
            ${$1ca4df0143566e72$var$escapeHtml(title)}
          </div>
          <div style="${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${color};white-space:nowrap;">
            ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(subcategory === null || subcategory === void 0 ? void 0 : subcategory.percent))}
          </div>
        </div>
      `;
    }).join("");
};
const $1ca4df0143566e72$var$buildDetailSectionHtml = (category, categoryResult, { categories: categories = [] , resolveTitleFromCategories: resolveTitleFromCategories = false  } = {})=>{
    const percent = categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.percent;
    const percentColor = category.percentColor || "#FFFFFF";
    return `
    <div style="display:flex;gap:24px;margin-bottom:36px;align-items:stretch;">
      <div
        style="
          width:180px;
          min-height:220px;
          flex-shrink:0;
          border-radius:5px;
          background:${category.outer};
          position:relative;
          overflow:hidden;
        ">
        <div
          style="
            position:absolute;
            left:0;
            bottom:0;
            width:100%;
            height:${$1ca4df0143566e72$var$getFillHeight(percent)};
            background:${category.inner};
            border-radius:5px;
            display:flex;
            align-items:center;
            justify-content:center;
            ${$1ca4df0143566e72$var$DETAIL_PERCENT_STYLE}
            color:${percentColor};
            text-shadow:0 1px 2px rgba(0,0,0,0.18);
          ">
          ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(percent))}
        </div>
      </div>
      <div style="flex:1;min-width:0;">
        <div style="${$1ca4df0143566e72$var$SECTION_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-bottom:8px;">
          ${$1ca4df0143566e72$var$escapeHtml(category.title)}
        </div>
        <div style="border-top:1px solid ${$1ca4df0143566e72$var$BORDER_COLOR};">
          ${$1ca4df0143566e72$var$buildSubcategoryRowsHtml(categoryResult, category.inner, {
        categories: categories,
        resolveTitleFromCategories: resolveTitleFromCategories
    })}
        </div>
      </div>
    </div>
  `;
};
const $1ca4df0143566e72$var$buildLeaderStatsHtml = (survey)=>{
    var _survey_results, _survey_results1;
    const completed = survey === null || survey === void 0 ? void 0 : survey.totalRequestsCompletedCount;
    const total = survey === null || survey === void 0 ? void 0 : survey.totalRequestsCount;
    const responsesValue = Number.isInteger(completed) && Number.isInteger(total) ? `${completed}/${total}` : "N/A";
    const professional = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : _survey_results.workingRelationshipPercentage;
    const personal = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : _survey_results1.personalRelationshipPercentage;
    const stats = [
        {
            value: responsesValue,
            label: "RESPONSES COMPLETE"
        },
        {
            value: Number.isInteger(professional) ? `${professional}%` : "N/A",
            label: "PROFESSIONAL CONNECTION"
        },
        {
            value: Number.isInteger(personal) ? `${personal}%` : "N/A",
            label: "PERSONAL CONNECTION"
        }
    ];
    const statsHtml = stats.map((stat)=>`
        <div style="flex:1;min-width:0;text-align:center;padding:8px 12px;">
          <div style="${$1ca4df0143566e72$var$PERCENT_STYLE}color:#EFC030;margin-bottom:8px;">
            ${$1ca4df0143566e72$var$escapeHtml(stat.value)}
          </div>
          <div style="${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:#FFFFFF;font-size:13px;line-height:18px;">
            ${$1ca4df0143566e72$var$escapeHtml(stat.label)}
          </div>
        </div>
      `).join("");
    return `
    <div
      style="
        display:flex;
        justify-content:space-between;
        align-items:stretch;
        gap:8px;
        background:#0A223C;
        border-radius:5px;
        padding:24px 12px;
        margin-bottom:36px;
      ">
      ${statsHtml}
    </div>
  `;
};
const $1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR = "#4978AB";
const $1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR = "#69B1D8";
const $1ca4df0143566e72$var$getLeaderComparisonRows = (leaderSurvey, awarenessSurvey, categories = [])=>{
    var _leaderSurvey_results, _awarenessSurvey_results, _awarenessSurvey_results_self_awareness;
    const perceivedResult = leaderSurvey === null || leaderSurvey === void 0 ? void 0 : (_leaderSurvey_results = leaderSurvey.results) === null || _leaderSurvey_results === void 0 ? void 0 : _leaderSurvey_results[$1ca4df0143566e72$var$PERCEIVED_AWARENESS_ID];
    const order = (perceivedResult === null || perceivedResult === void 0 ? void 0 : perceivedResult.order) || [];
    const perceivedSubcategories = (perceivedResult === null || perceivedResult === void 0 ? void 0 : perceivedResult.subcategories) || {};
    const selfAwarenessSubcategories = (awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness = _awarenessSurvey_results.self_awareness) === null || _awarenessSurvey_results_self_awareness === void 0 ? void 0 : _awarenessSurvey_results_self_awareness.subcategories) || {};
    return order.map((subcategoryId)=>{
        var _categories_find, _selfAwarenessSubcategories_categoryKey, _perceivedSubcategories_subcategoryId, _selfAwarenessSubcategories_categoryKey1;
        const categoryKey = (_categories_find = categories.find((category)=>{
            return (category === null || category === void 0 ? void 0 : category._id) === subcategoryId;
        })) === null || _categories_find === void 0 ? void 0 : _categories_find.key;
        if (!categoryKey) return null;
        const selfAwarenessValue = (_selfAwarenessSubcategories_categoryKey = selfAwarenessSubcategories[categoryKey]) === null || _selfAwarenessSubcategories_categoryKey === void 0 ? void 0 : _selfAwarenessSubcategories_categoryKey.percent;
        const perceivedValue = (_perceivedSubcategories_subcategoryId = perceivedSubcategories[subcategoryId]) === null || _perceivedSubcategories_subcategoryId === void 0 ? void 0 : _perceivedSubcategories_subcategoryId.percent;
        const title = ((_selfAwarenessSubcategories_categoryKey1 = selfAwarenessSubcategories[categoryKey]) === null || _selfAwarenessSubcategories_categoryKey1 === void 0 ? void 0 : _selfAwarenessSubcategories_categoryKey1.title) || $1ca4df0143566e72$var$getCategoryTitleById(categories, subcategoryId);
        return {
            title: title,
            perceivedValue: perceivedValue,
            selfAwarenessValue: selfAwarenessValue,
            difference: Number.isInteger(perceivedValue) && Number.isInteger(selfAwarenessValue) ? perceivedValue - selfAwarenessValue : null
        };
    }).filter(Boolean);
};
const $1ca4df0143566e72$var$getRadarPoint = (cx, cy, radius, index, total, value = 100)=>{
    const angle = Math.PI * 2 * index / total - Math.PI / 2;
    const scaledRadius = radius * Math.max(0, Math.min(100, value)) / 100;
    return {
        x: cx + scaledRadius * Math.cos(angle),
        y: cy + scaledRadius * Math.sin(angle),
        angle: angle
    };
};
const $1ca4df0143566e72$var$buildPolygonPoints = (cx, cy, radius, values)=>values.map((value, index)=>{
        const point = $1ca4df0143566e72$var$getRadarPoint(cx, cy, radius, index, values.length, value);
        return `${point.x},${point.y}`;
    }).join(" ");
const $1ca4df0143566e72$var$wrapRadarLabel = (label = "", maxCharsPerLine = 16)=>{
    const words = String(label || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) return [
        ""
    ];
    const lines = [];
    let currentLine = "";
    words.forEach((word)=>{
        const nextLine = currentLine ? `${currentLine} ${word}` : word;
        if (nextLine.length <= maxCharsPerLine) {
            currentLine = nextLine;
            return;
        }
        if (currentLine) lines.push(currentLine);
        // Keep long words intact rather than truncating key names.
        currentLine = word;
    });
    if (currentLine) lines.push(currentLine);
    return lines;
};
const $1ca4df0143566e72$var$buildLeaderGapChartHtml = ({ comparisonRows: comparisonRows = [] , perceivedTitle: perceivedTitle , selfAwarenessTitle: selfAwarenessTitle , perceivedPercent: perceivedPercent , selfAwarenessPercent: selfAwarenessPercent  })=>{
    if (comparisonRows.length < 3) return "";
    const size = 520;
    const center = size / 2;
    const radius = 160;
    const labelRadius = radius + 36;
    const count = comparisonRows.length;
    const lineHeight = 13;
    const perceivedValues = comparisonRows.map((row)=>Number.isInteger(row.perceivedValue) ? row.perceivedValue : 0);
    const selfAwarenessValues = comparisonRows.map((row)=>Number.isInteger(row.selfAwarenessValue) ? row.selfAwarenessValue : 0);
    const gridLevels = [
        50,
        100
    ];
    const gridPolygons = gridLevels.map((level)=>{
        const points = Array.from({
            length: count
        }, (_, index)=>{
            const point = $1ca4df0143566e72$var$getRadarPoint(center, center, radius, index, count, level);
            return `${point.x},${point.y}`;
        }).join(" ");
        return `
        <polygon
          points="${points}"
          fill="none"
          stroke="#D0D7DD"
          stroke-width="1"
        />
      `;
    }).join("");
    const axisLines = Array.from({
        length: count
    }, (_, index)=>{
        const point = $1ca4df0143566e72$var$getRadarPoint(center, center, radius, index, count, 100);
        return `
      <line
        x1="${center}"
        y1="${center}"
        x2="${point.x}"
        y2="${point.y}"
        stroke="#D0D7DD"
        stroke-width="1"
      />
    `;
    }).join("");
    const scaleLabels = [
        0,
        50,
        100
    ].map((level)=>{
        const y = center - radius * level / 100;
        return `
        <text
          x="${center + 4}"
          y="${y}"
          fill="#666666"
          font-family="Open Sans, Arial, sans-serif"
          font-size="10"
          dominant-baseline="middle"
        >${level}</text>
      `;
    }).join("");
    const labels = comparisonRows.map((row, index)=>{
        const point = $1ca4df0143566e72$var$getRadarPoint(center, center, labelRadius, index, count, 100);
        const lines = $1ca4df0143566e72$var$wrapRadarLabel(row.title, 16);
        const startY = point.y - (lines.length - 1) * lineHeight / 2;
        const tspans = lines.map((line, lineIndex)=>{
            if (lineIndex === 0) return `<tspan x="${point.x}" y="${startY}">${$1ca4df0143566e72$var$escapeHtml(line)}</tspan>`;
            return `<tspan x="${point.x}" dy="${lineHeight}">${$1ca4df0143566e72$var$escapeHtml(line)}</tspan>`;
        }).join("");
        return `
        <text
          text-anchor="middle"
          dominant-baseline="middle"
          fill="#666666"
          font-family="Open Sans, Arial, sans-serif"
          font-size="11"
          font-weight="600"
        >${tspans}</text>
      `;
    }).join("");
    const perceivedPoints = $1ca4df0143566e72$var$buildPolygonPoints(center, center, radius, perceivedValues);
    const selfAwarenessPoints = $1ca4df0143566e72$var$buildPolygonPoints(center, center, radius, selfAwarenessValues);
    const perceivedMarkers = perceivedValues.map((value, index)=>{
        const point = $1ca4df0143566e72$var$getRadarPoint(center, center, radius, index, count, value);
        return `
        <circle
          cx="${point.x}"
          cy="${point.y}"
          r="3.5"
          fill="${$1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR}"
        />
      `;
    }).join("");
    const selfAwarenessMarkers = selfAwarenessValues.map((value, index)=>{
        const point = $1ca4df0143566e72$var$getRadarPoint(center, center, radius, index, count, value);
        return `
        <rect
          x="${point.x - 3}"
          y="${point.y - 3}"
          width="6"
          height="6"
          fill="${$1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR}"
        />
      `;
    }).join("");
    const perceivedLegendLabel = Number.isInteger(perceivedPercent) ? `${perceivedTitle} (${perceivedPercent}%)` : perceivedTitle;
    const selfAwarenessLegendLabel = Number.isInteger(selfAwarenessPercent) ? `${selfAwarenessTitle} (${selfAwarenessPercent}%)` : selfAwarenessTitle;
    return `
    <div style="margin-bottom:20px;">
      <div
        style="
          display:flex;
          flex-wrap:wrap;
          gap:16px;
          margin-bottom:4px;
          ${$1ca4df0143566e72$var$BODY_TEXT_STYLE}
          color:${$1ca4df0143566e72$var$TEXT_COLOR};
        ">
        <div style="display:flex;align-items:center;gap:8px;">
          <span
            style="
              width:12px;
              height:12px;
              border-radius:50%;
              background:${$1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR};
              display:inline-block;
              flex-shrink:0;
            "></span>
          <span>${$1ca4df0143566e72$var$escapeHtml(perceivedLegendLabel)}</span>
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          <span
            style="
              width:12px;
              height:12px;
              background:${$1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR};
              display:inline-block;
              flex-shrink:0;
            "></span>
          <span>${$1ca4df0143566e72$var$escapeHtml(selfAwarenessLegendLabel)}</span>
        </div>
      </div>
      <div style="display:flex;justify-content:center;background:#FFFFFF;">
        <svg
          width="${size}"
          height="${size}"
          viewBox="0 0 ${size} ${size}"
          xmlns="http://www.w3.org/2000/svg"
          style="display:block;max-width:100%;height:auto;background:#FFFFFF;"
        >
          ${gridPolygons}
          ${axisLines}
          ${scaleLabels}
          <polygon
            points="${perceivedPoints}"
            fill="none"
            stroke="${$1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR}"
            stroke-width="2"
          />
          <polygon
            points="${selfAwarenessPoints}"
            fill="none"
            stroke="${$1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR}"
            stroke-width="2"
          />
          ${perceivedMarkers}
          ${selfAwarenessMarkers}
          ${labels}
        </svg>
      </div>
    </div>
  `;
};
const $1ca4df0143566e72$var$buildLeaderGapComparisonHtml = (leaderSurvey, awarenessSurvey, categories = [])=>{
    var _leaderSurvey_results, _leaderSurvey_results_PERCEIVED_AWARENESS_ID, _awarenessSurvey_results, _awarenessSurvey_results_self_awareness, _awarenessSurvey_results1, _awarenessSurvey_results_self_awareness1;
    const comparisonRows = $1ca4df0143566e72$var$getLeaderComparisonRows(leaderSurvey, awarenessSurvey, categories);
    if (!comparisonRows.length) return "";
    const perceivedPercent = leaderSurvey === null || leaderSurvey === void 0 ? void 0 : (_leaderSurvey_results = leaderSurvey.results) === null || _leaderSurvey_results === void 0 ? void 0 : (_leaderSurvey_results_PERCEIVED_AWARENESS_ID = _leaderSurvey_results[$1ca4df0143566e72$var$PERCEIVED_AWARENESS_ID]) === null || _leaderSurvey_results_PERCEIVED_AWARENESS_ID === void 0 ? void 0 : _leaderSurvey_results_PERCEIVED_AWARENESS_ID.percent;
    const selfAwarenessPercent = awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness = _awarenessSurvey_results.self_awareness) === null || _awarenessSurvey_results_self_awareness === void 0 ? void 0 : _awarenessSurvey_results_self_awareness.percent;
    const perceivedTitle = $1ca4df0143566e72$var$getCategoryTitleById(categories, $1ca4df0143566e72$var$PERCEIVED_AWARENESS_ID) || "Perceived Awareness";
    const selfAwarenessTitle = (awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results1 = awarenessSurvey.results) === null || _awarenessSurvey_results1 === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness1 = _awarenessSurvey_results1.self_awareness) === null || _awarenessSurvey_results_self_awareness1 === void 0 ? void 0 : _awarenessSurvey_results_self_awareness1.title) || "Self Awareness";
    const chartHtml = $1ca4df0143566e72$var$buildLeaderGapChartHtml({
        comparisonRows: comparisonRows,
        perceivedTitle: perceivedTitle,
        selfAwarenessTitle: selfAwarenessTitle,
        perceivedPercent: perceivedPercent,
        selfAwarenessPercent: selfAwarenessPercent
    });
    const headerRow = `
    <div
      style="
        display:flex;
        align-items:center;
        padding:12px 8px;
        border-bottom:1px solid ${$1ca4df0143566e72$var$BORDER_COLOR};
        ${$1ca4df0143566e72$var$BODY_TEXT_STYLE}
        color:${$1ca4df0143566e72$var$TEXT_COLOR};
        font-size:13px;
        line-height:18px;
      ">
      <div style="flex:2;padding-right:8px;">SUBCATEGORY</div>
      <div style="flex:1;text-align:center;color:${$1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR};">
        ${$1ca4df0143566e72$var$escapeHtml(perceivedTitle)}
        ${Number.isInteger(perceivedPercent) ? ` (${$1ca4df0143566e72$var$escapeHtml(String(perceivedPercent))}%)` : ""}
      </div>
      <div style="flex:1;text-align:center;color:${$1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR};">
        ${$1ca4df0143566e72$var$escapeHtml(selfAwarenessTitle)}
        ${Number.isInteger(selfAwarenessPercent) ? ` (${$1ca4df0143566e72$var$escapeHtml(String(selfAwarenessPercent))}%)` : ""}
      </div>
      <div style="flex:1;text-align:center;">DIFFERENCE (+/-)</div>
    </div>
  `;
    const rowsHtml = comparisonRows.map((row, index)=>{
        const differenceLabel = Number.isInteger(row.difference) ? `${row.difference}%` : "N/A";
        return `
        <div
          style="
            display:flex;
            align-items:center;
            padding:12px 8px;
            border-bottom:${index === comparisonRows.length - 1 ? "none" : `1px solid ${$1ca4df0143566e72$var$BORDER_COLOR}`};
          ">
          <div style="flex:2;${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};padding-right:8px;">
            ${$1ca4df0143566e72$var$escapeHtml(row.title || "")}
          </div>
          <div style="flex:1;text-align:center;${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$LEADER_PERCEIVED_COLOR};">
            ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(row.perceivedValue))}
          </div>
          <div style="flex:1;text-align:center;${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$LEADER_SELF_AWARENESS_COLOR};">
            ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(row.selfAwarenessValue))}
          </div>
          <div style="flex:1;text-align:center;${$1ca4df0143566e72$var$BODY_TEXT_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};">
            ${$1ca4df0143566e72$var$escapeHtml(differenceLabel)}
          </div>
        </div>
      `;
    }).join("");
    return `
    <div style="margin-bottom:36px;">
      <div style="${$1ca4df0143566e72$var$SECTION_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-bottom:12px;">
        Self Awareness Gap Analysis
      </div>
      ${chartHtml}
      <div
        style="
          border:1px solid ${$1ca4df0143566e72$var$BORDER_COLOR};
          border-radius:5px;
          overflow:hidden;
          background:#FFFFFF;
        ">
        ${headerRow}
        ${rowsHtml}
      </div>
    </div>
  `;
};
const $1ca4df0143566e72$var$buildSortedItemHtml = (item, index, total)=>{
    return `
  <div
    style="
      display:flex;
      justify-content:space-between;
      align-items:center;
      padding:12px 8px;
      border-bottom:${index === total - 1 ? "none" : `1px solid ${$1ca4df0143566e72$var$BORDER_COLOR}`};
    ">
    <div style="${$1ca4df0143566e72$var$CELEBRATION_TEXT_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};padding-right:12px;">
      ${$1ca4df0143566e72$var$escapeHtml((item === null || item === void 0 ? void 0 : item.title) || "")}
    </div>
    <div style="${$1ca4df0143566e72$var$CELEBRATION_TEXT_STYLE}color:${(item === null || item === void 0 ? void 0 : item.color) || $1ca4df0143566e72$var$TEXT_COLOR};white-space:nowrap;">
      ${$1ca4df0143566e72$var$escapeHtml($1ca4df0143566e72$var$formatPercent(item === null || item === void 0 ? void 0 : item.percent))}
    </div>
  </div>
`;
};
const $1ca4df0143566e72$var$buildCelebrationsHtml = (sortedSubcategories = [])=>{
    if (!sortedSubcategories.length) return "";
    const celebrations = sortedSubcategories.slice(0, 3);
    const growthAreas = sortedSubcategories.slice(-3);
    return `
    <div style="display:flex;gap:24px;margin-bottom:24px;">
      <div style="flex:1;min-width:0;">
        <div style="${$1ca4df0143566e72$var$SECTION_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-bottom:12px;">
          Celebrations
        </div>
        <div
          style="
            border:1.5px solid ${$1ca4df0143566e72$var$BOX_BORDER_COLOR};
            border-radius:5px;
            padding:4px 16px;
            background:${$1ca4df0143566e72$var$BOX_BACKGROUND_COLOR};
          ">
          ${celebrations.map((item, index)=>$1ca4df0143566e72$var$buildSortedItemHtml(item, index, celebrations.length)).join("")}
        </div>
      </div>
      <div style="flex:1;min-width:0;">
        <div style="${$1ca4df0143566e72$var$SECTION_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-bottom:12px;">
          Key Areas for Growth
        </div>
        <div
          style="
            border:1.5px solid ${$1ca4df0143566e72$var$BOX_BORDER_COLOR};
            border-radius:5px;
            padding:4px 16px;
            background:${$1ca4df0143566e72$var$BOX_BACKGROUND_COLOR};
          ">
          ${growthAreas.map((item, index)=>$1ca4df0143566e72$var$buildSortedItemHtml(item, index, growthAreas.length)).join("")}
        </div>
      </div>
    </div>
  `;
};
const $1ca4df0143566e72$var$ASSESSMENT_USERS_ROWS_PER_SECTION = 18;
// Matches admin assessment-result .s2 heading
const $1ca4df0143566e72$var$ASSESSMENT_USERS_TITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:38px;line-height:52px;letter-spacing:-1.52px;";
// Matches .custom-table thead th (.s8)
const $1ca4df0143566e72$var$ASSESSMENT_USERS_HEADER_STYLE = "font-family:Montserrat,Arial,sans-serif;font-weight:600;font-size:10px;line-height:12px;letter-spacing:0.25em;text-transform:uppercase;color:#000000;text-align:left;padding:8px 9px 8px 12px;border-bottom:1px solid #000000;border-top:none;background:transparent;";
// Matches .assessment-users-table tbody td
const $1ca4df0143566e72$var$ASSESSMENT_USERS_CELL_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:500;font-size:14px;line-height:24px;letter-spacing:-0.02em;color:#000000;text-align:left;vertical-align:middle;padding:8px 9px 8px 12px;border-top:none;border-bottom:1px solid #F2F5F5;background:transparent;";
const $1ca4df0143566e72$var$buildAssessmentUsersHtml = (users = [], { startIndex: startIndex = 0 , showTitle: showTitle = true  } = {})=>{
    if (!Array.isArray(users) || !users.length) return "";
    const rowsHtml = users.map((user, index)=>{
        const isLast = index === users.length - 1;
        const cellStyle = isLast ? $1ca4df0143566e72$var$ASSESSMENT_USERS_CELL_STYLE.replace("border-bottom:1px solid #F2F5F5;", "border-bottom:none;") : $1ca4df0143566e72$var$ASSESSMENT_USERS_CELL_STYLE;
        return `
        <tr>
          <td style="${cellStyle}width:5%;">${startIndex + index + 1}</td>
          <td style="${cellStyle}width:35%;">
            ${$1ca4df0143566e72$var$escapeHtml((user === null || user === void 0 ? void 0 : user.fullName) || "")}
          </td>
          <td style="${cellStyle}width:60%;">
            ${$1ca4df0143566e72$var$escapeHtml((user === null || user === void 0 ? void 0 : user.email) || "")}
          </td>
        </tr>
      `;
    }).join("");
    return `
    <div style="margin-bottom:24px;width:100%;">
      ${showTitle ? `<div style="${$1ca4df0143566e72$var$ASSESSMENT_USERS_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin:0 0 16px 0;">
        Assessment Users
      </div>` : ""}
      <table
        style="
          width:100%;
          border-collapse:collapse;
          border:none;
          margin:0;
          background:#FFFFFF;
        ">
        <thead>
          <tr>
            <th style="${$1ca4df0143566e72$var$ASSESSMENT_USERS_HEADER_STYLE}width:5%;">#</th>
            <th style="${$1ca4df0143566e72$var$ASSESSMENT_USERS_HEADER_STYLE}width:35%;">
              Full Name
            </th>
            <th style="${$1ca4df0143566e72$var$ASSESSMENT_USERS_HEADER_STYLE}width:60%;">Email</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>
    </div>
  `;
};
const $1ca4df0143566e72$var$buildAssessmentUsersHtmlSections = (users = [])=>{
    if (!Array.isArray(users) || !users.length) return [];
    const sections = [];
    for(let startIndex = 0; startIndex < users.length; startIndex += $1ca4df0143566e72$var$ASSESSMENT_USERS_ROWS_PER_SECTION){
        const chunk = users.slice(startIndex, startIndex + $1ca4df0143566e72$var$ASSESSMENT_USERS_ROWS_PER_SECTION);
        sections.push($1ca4df0143566e72$var$buildAssessmentUsersHtml(chunk, {
            startIndex: startIndex,
            showTitle: startIndex === 0
        }));
    }
    return sections;
};
const $1ca4df0143566e72$var$createPageMarkup = ({ assessmentTitle: assessmentTitle , assessmentSubtitle: assessmentSubtitle = "" , assessmentDate: assessmentDate , showHeader: showHeader = true , bodyHtml: bodyHtml = ""  })=>`
  <div
    class="assessment-pdf-page"
    style="
      width:${$1ca4df0143566e72$var$RENDER_WIDTH}px;
      height:${$1ca4df0143566e72$var$PAGE_HEIGHT_PX}px;
      background:#ffffff;
      color:${$1ca4df0143566e72$var$TEXT_COLOR};
      box-sizing:border-box;
      overflow:hidden;
      display:flex;
      flex-direction:column;
    ">
    ${showHeader ? `
    <div style="padding:32px ${$1ca4df0143566e72$var$PAGE_PADDING_X}px 8px ${$1ca4df0143566e72$var$PAGE_PADDING_X}px;text-align:center;background:#ffffff;">
      <img
        src="${$1ca4df0143566e72$var$getAbroadLogoUrl()}"
        alt="Abroad"
        width="120"
        height="80"
        style="display:block;margin:0 auto 16px auto;width:120px;height:auto;"
        crossorigin="anonymous"
      />
      <div style="${$1ca4df0143566e72$var$TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};word-break:break-word;">
        ${$1ca4df0143566e72$var$escapeHtml(assessmentTitle)}
        ${assessmentDate ? ` - ${$1ca4df0143566e72$var$escapeHtml(assessmentDate)}` : ""}
      </div>
      ${assessmentSubtitle ? `
      <div style="${$1ca4df0143566e72$var$SUBTITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-top:12px;word-break:break-word;">
        ${$1ca4df0143566e72$var$escapeHtml(assessmentSubtitle)}
      </div>
      ` : ""}
    </div>
    ` : ""}
    <div
      style="
        padding:${showHeader ? "24px" : "32px"} ${$1ca4df0143566e72$var$PAGE_PADDING_X}px ${$1ca4df0143566e72$var$PAGE_PADDING_BOTTOM}px ${$1ca4df0143566e72$var$PAGE_PADDING_X}px;
        display:flex;
        flex-direction:column;
        flex:1;
        min-height:0;
      ">
      <div class="assessment-pdf-content" style="flex:1;min-height:0;">
        ${bodyHtml}
      </div>
    </div>
  </div>
`;
const $1ca4df0143566e72$var$createMeasurementRoot = ()=>{
    const root = document.createElement("div");
    root.setAttribute("aria-hidden", "true");
    root.style.cssText = `
    position: fixed;
    left: -10000px;
    top: 0;
    width: ${$1ca4df0143566e72$var$RENDER_WIDTH}px;
    background: #ffffff;
    z-index: -1;
    pointer-events: none;
  `;
    document.body.appendChild(root);
    return root;
};
const $1ca4df0143566e72$var$measurePageContentHeight = async ({ root: root , assessmentTitle: assessmentTitle , assessmentSubtitle: assessmentSubtitle = "" , assessmentDate: assessmentDate , showHeader: showHeader  })=>{
    root.innerHTML = $1ca4df0143566e72$var$createPageMarkup({
        assessmentTitle: assessmentTitle,
        assessmentSubtitle: assessmentSubtitle,
        assessmentDate: assessmentDate,
        showHeader: showHeader,
        bodyHtml: ""
    });
    await $1ca4df0143566e72$var$waitForImages(root);
    return root.querySelector(".assessment-pdf-content").getBoundingClientRect().height;
};
const $1ca4df0143566e72$var$measureHtmlHeight = (root, html)=>{
    const measureContainer = document.createElement("div");
    measureContainer.style.cssText = `
    width: ${$1ca4df0143566e72$var$RENDER_WIDTH - $1ca4df0143566e72$var$PAGE_PADDING_X * 2}px;
    box-sizing: border-box;
  `;
    measureContainer.innerHTML = html;
    root.appendChild(measureContainer);
    const height = measureContainer.getBoundingClientRect().height;
    root.removeChild(measureContainer);
    return height;
};
const $1ca4df0143566e72$var$paginateSections = ({ sections: sections , firstPageContentHeight: firstPageContentHeight , nextPageContentHeight: nextPageContentHeight , root: root  })=>{
    const pages = [];
    let currentHeightLimit = firstPageContentHeight;
    let currentPageFragments = [];
    let currentHeight = 0;
    const finalizePage = ()=>{
        if (!currentPageFragments.length) return;
        pages.push({
            showHeader: pages.length === 0,
            bodyHtml: currentPageFragments.map((fragment)=>fragment.html).join("")
        });
        currentPageFragments = [];
        currentHeight = 0;
        currentHeightLimit = nextPageContentHeight;
    };
    sections.forEach((sectionHtml)=>{
        if (sectionHtml === $1ca4df0143566e72$var$PDF_PAGE_BREAK) {
            finalizePage();
            return;
        }
        const height = $1ca4df0143566e72$var$measureHtmlHeight(root, sectionHtml);
        if (currentHeight + height > currentHeightLimit - $1ca4df0143566e72$var$PAGE_FIT_SAFETY_PX && currentPageFragments.length) finalizePage();
        currentPageFragments.push({
            html: sectionHtml,
            height: height
        });
        currentHeight += height;
    });
    finalizePage();
    return pages;
};
const $1ca4df0143566e72$var$createPdf = async (pageElements)=>{
    // jsPDF's exported constructor starts with a lowercase letter
    // eslint-disable-next-line new-cap
    const pdf = new (0, $feLGi$jspdf.jsPDF)({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
    });
    for(let index = 0; index < pageElements.length; index += 1){
        if (index > 0) pdf.addPage();
        const canvas = await (0, ($parcel$interopDefault($feLGi$html2canvas)))(pageElements[index], {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: false,
            width: $1ca4df0143566e72$var$RENDER_WIDTH,
            height: $1ca4df0143566e72$var$PAGE_HEIGHT_PX,
            windowWidth: $1ca4df0143566e72$var$RENDER_WIDTH,
            windowHeight: $1ca4df0143566e72$var$PAGE_HEIGHT_PX
        });
        const imgData = canvas.toDataURL("image/png", 1.0);
        pdf.addImage(imgData, "PNG", 0, 0, $1ca4df0143566e72$var$PDF_WIDTH_MM, $1ca4df0143566e72$var$PDF_HEIGHT_MM, undefined, "FAST");
    }
    return pdf;
};
const $1ca4df0143566e72$var$savePdfWithExactFileName = (pdf, fileName)=>{
    const blob = pdf.output("blob");
    const objectUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = objectUrl;
    downloadLink.download = fileName;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(objectUrl);
};
const $1ca4df0143566e72$var$getClientEmail = (survey)=>{
    return (survey === null || survey === void 0 ? void 0 : survey.email) || "";
};
const $1ca4df0143566e72$var$resolvePdfTitle = (config, assessmentTitle)=>{
    const customTitle = String(assessmentTitle || "").trim();
    return customTitle || config.title;
};
const $1ca4df0143566e72$var$resolveFileLabel = (config, assessmentTitle)=>{
    const customTitle = String(assessmentTitle || "").trim();
    if (!customTitle) return config.fileLabel;
    return customTitle.replace(/\s+/g, "_");
};
const $1ca4df0143566e72$var$getPdfFileName = (config, survey, assessmentDate, assessmentTitle, assessmentSubtitle)=>{
    const assessmentName = $1ca4df0143566e72$var$getSafeFileName($1ca4df0143566e72$var$resolveFileLabel(config, assessmentTitle)).replace(/_/g, "");
    const subtitlePart = $1ca4df0143566e72$var$getSafeFileName(String(assessmentSubtitle || "").trim()).replace(/_/g, "").replace(/'/g, "");
    const takenDate = $1ca4df0143566e72$var$getSafeFileName(assessmentDate).replace(/,/g, "");
    const downloadDate = (0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(null, "MM-DD-YYYY");
    const email = $1ca4df0143566e72$var$getSafeFileName($1ca4df0143566e72$var$getClientEmail(survey));
    const baseName = subtitlePart ? `${assessmentName}_${subtitlePart}` : assessmentName;
    const nameWithOptionalTakenDate = takenDate ? `${baseName}(${takenDate})` : baseName;
    if (email) return `${email}-${nameWithOptionalTakenDate}-${downloadDate}.pdf`;
    return `${nameWithOptionalTakenDate}-${downloadDate}.pdf`;
};
const $1ca4df0143566e72$var$getComparisonPdfFileName = (fileNameBase)=>{
    const sanitized = (0, $89420a3db7aa95f0$export$5d0ccbd57c6f4340)(fileNameBase);
    const compareIndex = sanitized.search(/_Compare/i);
    const withUpperEntity = compareIndex > 0 ? `${sanitized.slice(0, compareIndex).toUpperCase()}${sanitized.slice(compareIndex)}` : sanitized;
    return `${withUpperEntity}_${(0, $89420a3db7aa95f0$export$a05b62b0b8453404)()}.pdf`;
};
// eslint-disable-next-line no-unused-vars
const $1ca4df0143566e72$var$buildPeriodLabelHtml = (label)=>`
  <div style="${$1ca4df0143566e72$var$SECTION_TITLE_STYLE}color:${$1ca4df0143566e72$var$TEXT_COLOR};margin-bottom:20px;text-align:center;">
    ${$1ca4df0143566e72$var$escapeHtml(label)}
  </div>
`;
const $1ca4df0143566e72$var$buildAssessmentSections = ({ survey: survey , assessmentType: assessmentType , config: config , awarenessSurvey: awarenessSurvey , includeCelebrations: includeCelebrations = true  })=>{
    const inTransition = Boolean(survey.inTransition);
    const overviewCategories = $1ca4df0143566e72$var$getVisibleCategories(config.overviewCategories, inTransition);
    const detailCategories = $1ca4df0143566e72$var$getVisibleCategories(config.detailCategories, inTransition);
    const sortedSubcategories = config.getSortedSubcategories(survey.results, inTransition);
    const isLeaderAssessment = assessmentType === (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).LEADER;
    const resolvedAwarenessSurvey = awarenessSurvey || survey.latestAwarenessSurveyResult;
    const sections = [];
    // Awareness in-transition has no overview cards (same as UI)
    if (!(assessmentType === (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS && inTransition) && overviewCategories.length) sections.push($1ca4df0143566e72$var$buildOverviewCardsHtml(overviewCategories, survey.results));
    if (isLeaderAssessment) sections.push($1ca4df0143566e72$var$buildLeaderStatsHtml(survey));
    detailCategories.forEach((category)=>{
        var _survey_results;
        sections.push($1ca4df0143566e72$var$buildDetailSectionHtml(category, (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : _survey_results[category.key], {
            categories: survey.categories,
            resolveTitleFromCategories: isLeaderAssessment
        }));
    });
    if (isLeaderAssessment) {
        const gapComparisonHtml = $1ca4df0143566e72$var$buildLeaderGapComparisonHtml(survey, resolvedAwarenessSurvey, survey.categories);
        if (gapComparisonHtml) sections.push(gapComparisonHtml);
    }
    if (includeCelebrations && !config.skipCelebrations) {
        const celebrationsHtml = $1ca4df0143566e72$var$buildCelebrationsHtml(sortedSubcategories);
        if (celebrationsHtml) sections.push(celebrationsHtml);
    }
    // Group / organization / network aggregate results show Assessment Users.
    // Start on a new page so a short list (e.g. 1 user) is not clipped under
    // Celebrations by the fixed page overflow:hidden.
    const assessmentUsersSections = $1ca4df0143566e72$var$buildAssessmentUsersHtmlSections(survey === null || survey === void 0 ? void 0 : survey.users);
    if (assessmentUsersSections.length) sections.push($1ca4df0143566e72$var$PDF_PAGE_BREAK, ...assessmentUsersSections);
    return sections;
};
const $1ca4df0143566e72$var$renderAndSavePdf = async ({ sections: sections , assessmentTitle: assessmentTitle , assessmentSubtitle: assessmentSubtitle = "" , assessmentDate: assessmentDate , fileName: fileName  })=>{
    const container = $1ca4df0143566e72$var$createMeasurementRoot();
    try {
        await $1ca4df0143566e72$var$waitForFonts();
        const firstPageContentHeight = await $1ca4df0143566e72$var$measurePageContentHeight({
            root: container,
            assessmentTitle: assessmentTitle,
            assessmentSubtitle: assessmentSubtitle,
            assessmentDate: assessmentDate,
            showHeader: true
        });
        const nextPageContentHeight = await $1ca4df0143566e72$var$measurePageContentHeight({
            root: container,
            assessmentTitle: assessmentTitle,
            assessmentSubtitle: "",
            assessmentDate: assessmentDate,
            showHeader: false
        });
        const pages = $1ca4df0143566e72$var$paginateSections({
            sections: sections,
            firstPageContentHeight: firstPageContentHeight,
            nextPageContentHeight: nextPageContentHeight,
            root: container
        });
        container.innerHTML = pages.map((page)=>$1ca4df0143566e72$var$createPageMarkup({
                assessmentTitle: assessmentTitle,
                assessmentSubtitle: page.showHeader ? assessmentSubtitle : "",
                assessmentDate: assessmentDate,
                showHeader: page.showHeader,
                bodyHtml: page.bodyHtml
            })).join("");
        await $1ca4df0143566e72$var$waitForFonts();
        await $1ca4df0143566e72$var$waitForImages(container);
        const pageElements = Array.from(container.querySelectorAll(".assessment-pdf-page"));
        const pdf = await $1ca4df0143566e72$var$createPdf(pageElements);
        $1ca4df0143566e72$var$savePdfWithExactFileName(pdf, fileName);
    } finally{
        if (container.parentNode) container.parentNode.removeChild(container);
    }
};
const $1ca4df0143566e72$var$COMPARE_SECTION_MIN_FIT_SCALE = 0.7;
const $1ca4df0143566e72$var$cloneElementForPdf = (sourceElement)=>{
    const root = $1ca4df0143566e72$var$createMeasurementRoot();
    root.style.left = "0";
    root.style.top = "0";
    root.style.zIndex = "-1";
    root.style.opacity = "0";
    const clonedElement = sourceElement.cloneNode(true);
    clonedElement.style.width = `${sourceElement.scrollWidth}px`;
    clonedElement.style.background = "#ffffff";
    root.innerHTML = "";
    root.style.width = `${sourceElement.scrollWidth}px`;
    root.appendChild(clonedElement);
    [
        ".download-pdf-icon",
        ".download-pdf-icon--loading",
        ".back-btn",
        ".assessment-feedback",
        '[aria-label="Download PDF"]',
        '[aria-label="Downloading PDF"]'
    ].forEach((selector)=>{
        root.querySelectorAll(selector).forEach((node)=>node.remove());
    });
    return {
        root: root,
        clonedElement: clonedElement
    };
};
const $1ca4df0143566e72$var$createBlankPdf = ()=>// jsPDF's exported constructor starts with a lowercase letter
    // eslint-disable-next-line new-cap
    new (0, $feLGi$jspdf.jsPDF)({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
    });
const $1ca4df0143566e72$var$drawCanvasSliceOnPdf = (pdf, canvas, startY, sliceHeight)=>{
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = sliceHeight;
    const pageContext = pageCanvas.getContext("2d");
    pageContext.fillStyle = "#ffffff";
    pageContext.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
    pageContext.drawImage(canvas, 0, startY, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);
    const pageImage = pageCanvas.toDataURL("image/png", 1.0);
    const renderedHeightMm = sliceHeight * $1ca4df0143566e72$var$PDF_WIDTH_MM / canvas.width;
    pdf.addImage(pageImage, "PNG", 0, 0, $1ca4df0143566e72$var$PDF_WIDTH_MM, renderedHeightMm, undefined, "FAST");
};
const $1ca4df0143566e72$var$appendCanvasAsPdfPages = (pdf, canvas, { isFirstSection: isFirstSection = false  } = {})=>{
    if (!(canvas === null || canvas === void 0 ? void 0 : canvas.width) || !(canvas === null || canvas === void 0 ? void 0 : canvas.height)) throw new Error("Comparison PDF canvas is empty.");
    const heightAtFullWidthMm = canvas.height * $1ca4df0143566e72$var$PDF_WIDTH_MM / canvas.width;
    if (!isFirstSection) pdf.addPage();
    if (heightAtFullWidthMm <= $1ca4df0143566e72$var$PDF_HEIGHT_MM) {
        pdf.addImage(canvas.toDataURL("image/png", 1.0), "PNG", 0, 0, $1ca4df0143566e72$var$PDF_WIDTH_MM, heightAtFullWidthMm, undefined, "FAST");
        return;
    }
    // Keep chart + table together when the section only slightly overflows A4.
    const fitScale = $1ca4df0143566e72$var$PDF_HEIGHT_MM / heightAtFullWidthMm;
    if (fitScale >= $1ca4df0143566e72$var$COMPARE_SECTION_MIN_FIT_SCALE) {
        const renderWidthMm = $1ca4df0143566e72$var$PDF_WIDTH_MM * fitScale;
        const offsetX = ($1ca4df0143566e72$var$PDF_WIDTH_MM - renderWidthMm) / 2;
        pdf.addImage(canvas.toDataURL("image/png", 1.0), "PNG", offsetX, 0, renderWidthMm, $1ca4df0143566e72$var$PDF_HEIGHT_MM, undefined, "FAST");
        return;
    }
    const pageHeightPx = Math.floor(canvas.width * $1ca4df0143566e72$var$PDF_HEIGHT_MM / $1ca4df0143566e72$var$PDF_WIDTH_MM);
    const pageCount = Math.max(1, Math.ceil(canvas.height / pageHeightPx));
    for(let index = 0; index < pageCount; index += 1){
        if (index > 0) pdf.addPage();
        const startY = index * pageHeightPx;
        const sliceHeight = Math.min(pageHeightPx, canvas.height - startY);
        $1ca4df0143566e72$var$drawCanvasSliceOnPdf(pdf, canvas, startY, sliceHeight);
    }
};
const $1ca4df0143566e72$var$buildComparePdfPageElements = (clonedElement)=>{
    const markedSections = Array.from(clonedElement.querySelectorAll(".compare-pdf-section"));
    if (!markedSections.length) return [
        clonedElement
    ];
    const pages = [];
    const firstMarked = markedSections[0];
    const parent = firstMarked.parentElement;
    const siblings = Array.from((parent === null || parent === void 0 ? void 0 : parent.children) || []);
    const firstIndex = siblings.indexOf(firstMarked);
    if (firstIndex > 0) {
        const intro = document.createElement("div");
        intro.className = "compare-pdf-intro";
        intro.style.background = "#ffffff";
        intro.style.width = "100%";
        siblings.slice(0, firstIndex).forEach((child)=>{
            var _child_classList;
            if ((_child_classList = child.classList) === null || _child_classList === void 0 ? void 0 : _child_classList.contains("assessment-feedback")) return;
            intro.appendChild(child);
        });
        if (intro.childNodes.length) {
            // Keep intro in the document so html2canvas can measure layout.
            parent.insertBefore(intro, firstMarked);
            pages.push(intro);
        }
    }
    markedSections.forEach((section)=>{
        section.classList.remove("offset-lg-1", "col-lg-10", "px-lg-0", "px-sm-2", "pt-2");
        pages.push(section);
    });
    return pages;
};
const $1ca4df0143566e72$var$captureElementToCanvas = async (element, captureWidth)=>{
    const previousWidth = element.style.width;
    element.style.width = `${captureWidth}px`;
    element.style.maxWidth = `${captureWidth}px`;
    element.style.background = "#ffffff";
    element.style.boxSizing = "border-box";
    element.style.padding = element.style.padding || "16px 12px";
    element.style.display = "block";
    element.style.visibility = "visible";
    element.style.opacity = "1";
    const captureHeight = Math.max(element.scrollHeight, element.offsetHeight, Math.ceil(element.getBoundingClientRect().height));
    if (!captureHeight) throw new Error("Comparison section has no measurable height for PDF.");
    try {
        return await (0, ($parcel$interopDefault($feLGi$html2canvas)))(element, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: false,
            width: captureWidth,
            height: captureHeight,
            windowWidth: captureWidth,
            windowHeight: captureHeight,
            scrollX: 0,
            scrollY: 0
        });
    } finally{
        element.style.width = previousWidth;
    }
};
const $1ca4df0143566e72$var$renderComparePageAndSavePdf = async ({ sourceElement: sourceElement , fileName: fileName  })=>{
    const { root: root , clonedElement: clonedElement  } = $1ca4df0143566e72$var$cloneElementForPdf(sourceElement);
    try {
        await $1ca4df0143566e72$var$waitForFonts();
        await $1ca4df0143566e72$var$waitForImages(root);
        const captureWidth = Math.min(sourceElement.scrollWidth || $1ca4df0143566e72$var$RENDER_WIDTH, $1ca4df0143566e72$var$RENDER_WIDTH);
        clonedElement.style.width = `${captureWidth}px`;
        root.style.width = `${captureWidth}px`;
        root.style.left = "0";
        root.style.opacity = "0";
        root.style.pointerEvents = "none";
        root.style.zIndex = "-1";
        const pageElements = $1ca4df0143566e72$var$buildComparePdfPageElements(clonedElement);
        if (!pageElements.length) throw new Error("No comparison content available for PDF download.");
        const pdf = $1ca4df0143566e72$var$createBlankPdf();
        for(let index = 0; index < pageElements.length; index += 1){
            const pageElement = pageElements[index];
            if (!root.contains(pageElement)) root.appendChild(pageElement);
            const canvas = await $1ca4df0143566e72$var$captureElementToCanvas(pageElement, captureWidth);
            $1ca4df0143566e72$var$appendCanvasAsPdfPages(pdf, canvas, {
                isFirstSection: index === 0
            });
        }
        $1ca4df0143566e72$var$savePdfWithExactFileName(pdf, fileName);
    } finally{
        if (root.parentNode) root.parentNode.removeChild(root);
    }
};
const $1ca4df0143566e72$export$6eb62a57cb117d2c = async ({ survey: survey , assessmentType: assessmentType , awarenessSurvey: awarenessSurvey , assessmentTitle: assessmentTitle , assessmentSubtitle: assessmentSubtitle , fileNameBase: fileNameBase  })=>{
    var _survey_results;
    const config = $1ca4df0143566e72$var$ASSESSMENT_CONFIG[assessmentType];
    if (!config || !(survey === null || survey === void 0 ? void 0 : survey.results)) throw new Error("Assessment results are not available for PDF download.");
    // Only show a date in the PDF header when the assessment has a real date.
    // Download date is still included in the filename.
    const surveyDateSource = survey.createdAt || ((_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : _survey_results.createdAt);
    const assessmentDate = surveyDateSource ? (0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(surveyDateSource, "MMMM Do, YYYY") : "";
    const resolvedTitle = $1ca4df0143566e72$var$resolvePdfTitle(config, assessmentTitle);
    const resolvedSubtitle = String(assessmentSubtitle || "").trim();
    const sections = $1ca4df0143566e72$var$buildAssessmentSections({
        survey: survey,
        assessmentType: assessmentType,
        config: config,
        awarenessSurvey: awarenessSurvey
    });
    const fileName = fileNameBase ? (0, $89420a3db7aa95f0$export$ba9fdf0369491da)(fileNameBase) : $1ca4df0143566e72$var$getPdfFileName(config, survey, assessmentDate, assessmentTitle, resolvedSubtitle);
    await $1ca4df0143566e72$var$renderAndSavePdf({
        sections: sections,
        assessmentTitle: resolvedTitle,
        assessmentSubtitle: resolvedSubtitle,
        assessmentDate: assessmentDate,
        fileName: fileName
    });
};
const $1ca4df0143566e72$export$4d3866480a5f3c6c = async ({ comparisonData: comparisonData = [] , assessmentType: assessmentType , periodLabels: periodLabels = [] , assessmentTitle: assessmentTitle , fileNameBase: fileNameBase , sourceElement: sourceElement  })=>{
    const config = $1ca4df0143566e72$var$ASSESSMENT_CONFIG[assessmentType];
    const surveysWithResults = (comparisonData || []).filter((survey)=>{
        return survey === null || survey === void 0 ? void 0 : survey.results;
    });
    if (!config || surveysWithResults.length < 2) throw new Error("Comparison assessment results are not available for PDF download.");
    const fallbackSourceElement = document.querySelector("main");
    const resolvedSourceElement = sourceElement || fallbackSourceElement;
    if (!resolvedSourceElement) throw new Error("Compare results page is not available for PDF download.");
    const defaultFileNameBase = $1ca4df0143566e72$var$resolveFileLabel(config, assessmentTitle);
    await $1ca4df0143566e72$var$renderComparePageAndSavePdf({
        sourceElement: resolvedSourceElement,
        fileName: $1ca4df0143566e72$var$getComparisonPdfFileName(fileNameBase || defaultFileNameBase)
    });
};
var $1ca4df0143566e72$export$2e2bcd8739ae039 = $1ca4df0143566e72$export$6eb62a57cb117d2c;




const $09226703b1b735cd$var$AssessmentComparisonPdfDownload = ({ comparisonData: comparisonData , assessmentType: assessmentType , periodLabels: periodLabels = [] , assessmentTitle: assessmentTitle , fileNameBase: fileNameBase , className: className = "" , iconSize: iconSize = 32  })=>{
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const [isDownloadingPdf, setIsDownloadingPdf] = (0, $feLGi$react.useState)(false);
    const surveysWithResults = (comparisonData || []).filter((survey)=>{
        return survey === null || survey === void 0 ? void 0 : survey.results;
    });
    if (surveysWithResults.length < 2 || !assessmentType) return null;
    const handleDownloadPdf = async ()=>{
        if (isDownloadingPdf) return;
        setIsDownloadingPdf(true);
        try {
            await (0, $1ca4df0143566e72$export$4d3866480a5f3c6c)({
                comparisonData: surveysWithResults,
                assessmentType: assessmentType,
                periodLabels: periodLabels,
                assessmentTitle: assessmentTitle,
                fileNameBase: fileNameBase,
                sourceElement: document.querySelector("main")
            });
        } catch (e) {
            // Keep the real reason in console; ErrorService defaults to a generic toast.
            // eslint-disable-next-line no-console
            console.error("Comparison PDF download failed:", e);
            Error.showError({
                code: "validation_error",
                message: "Unable to download comparison PDF. Please try again."
            });
        } finally{
            setIsDownloadingPdf(false);
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.OverlayTrigger), {
        placement: "bottom",
        overlay: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Tooltip), {
            id: "download-comparison-assessment-tooltip"
        }, "Download PDF")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-inline-flex align-items-center", className)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $dc3e8dc1c67b3a4b$export$2e2bcd8739ae039), {
        onClick: handleDownloadPdf,
        disabled: isDownloadingPdf,
        isLoading: isDownloadingPdf,
        size: iconSize,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex align-self-center", {
            "cursor-pointer": !isDownloadingPdf
        })
    })));
};
$09226703b1b735cd$var$AssessmentComparisonPdfDownload.propTypes = {
    comparisonData: (0, ($parcel$interopDefault($feLGi$proptypes))).array,
    assessmentType: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS,
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY
    ]).isRequired,
    periodLabels: (0, ($parcel$interopDefault($feLGi$proptypes))).arrayOf((0, ($parcel$interopDefault($feLGi$proptypes))).string),
    assessmentTitle: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    fileNameBase: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    className: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    iconSize: (0, ($parcel$interopDefault($feLGi$proptypes))).number
};
var $09226703b1b735cd$export$2e2bcd8739ae039 = $09226703b1b735cd$var$AssessmentComparisonPdfDownload;




const $80d9961445c5e23a$var$SurveyComparisonReport = ({ isLoading: isLoading , preDate: preDate , postDate: postDate , comparisonData: comparisonData , i18n: i18n , header: header , onGoBack: onGoBack = ()=>{} , isRequiredToFormatDate: isRequiredToFormatDate = true , showGoBackButton: showGoBackButton = true , showClientCompareHeader: showClientCompareHeader = false , compareHeaderTitle: compareHeaderTitle = "Awareness Assessment" , isRenderFromOP: isRenderFromOP = false , downloadFileNameBase: downloadFileNameBase , props: props  })=>{
    var _comparisonData_, _comparisonData_1, _comparisonData_2, _comparisonData_3, _comparisonData__results_self_awareness_subcategories_burnout_buffer, _comparisonData_4, _comparisonData__results_self_awareness_subcategories_fear__decision_making, _comparisonData_5, _comparisonData__results_self_awareness_subcategories_healthy_responsibility, _comparisonData_6, _comparisonData__results_self_awareness_subcategories_psychological_adaptability, _comparisonData_7, _comparisonData__results_self_awareness_subcategories_self_compassion, _comparisonData_8, _comparisonData__results_self_awareness_subcategories_time_management__mindset, _comparisonData_9, _comparisonData__results_self_awareness_subcategories_burnout_buffer1, _comparisonData_10, _comparisonData__results_self_awareness_subcategories_fear__decision_making1, _comparisonData_11, _comparisonData__results_self_awareness_subcategories_healthy_responsibility1, _comparisonData_12, _comparisonData__results_self_awareness_subcategories_psychological_adaptability1, _comparisonData_13, _comparisonData__results_self_awareness_subcategories_self_compassion1, _comparisonData_14, _comparisonData__results_self_awareness_subcategories_time_management__mindset1, _comparisonData_15, _comparisonData__results_self_awareness_subcategories_burnout_buffer2, _comparisonData_16, _comparisonData__results_self_awareness_subcategories_burnout_buffer3, _comparisonData_17, _comparisonData__results_self_awareness_subcategories_fear__decision_making2, _comparisonData_18, _comparisonData__results_self_awareness_subcategories_fear__decision_making3, _comparisonData_19, _comparisonData__results_self_awareness_subcategories_healthy_responsibility2, _comparisonData_20, _comparisonData__results_self_awareness_subcategories_healthy_responsibility3, _comparisonData_21, _comparisonData__results_self_awareness_subcategories_psychological_adaptability2, _comparisonData_22, _comparisonData__results_self_awareness_subcategories_psychological_adaptability3, _comparisonData_23, _comparisonData__results_self_awareness_subcategories_self_compassion2, _comparisonData_24, _comparisonData__results_self_awareness_subcategories_self_compassion3, _comparisonData_25, _comparisonData__results_self_awareness_subcategories_time_management__mindset2, _comparisonData_26, _comparisonData__results_self_awareness_subcategories_time_management__mindset3, _comparisonData_27, _comparisonData__results_team_cohesion_subcategories_agreements, _comparisonData_28, _comparisonData__results_team_cohesion_subcategories_collaboration, _comparisonData_29, _comparisonData__results_team_cohesion_subcategories_communication, _comparisonData_30, _comparisonData__results_team_cohesion_subcategories_culture, _comparisonData_31, _comparisonData__results_team_cohesion_subcategories_decision_making, _comparisonData_32, _comparisonData__results_team_cohesion_subcategories_emotional_intelligence, _comparisonData_33, _comparisonData__results_team_cohesion_subcategories_team_quality, _comparisonData_34, _comparisonData__results_team_cohesion_subcategories_trust, _comparisonData_35, _comparisonData__results_team_cohesion_subcategories_agreements1, _comparisonData_36, _comparisonData__results_team_cohesion_subcategories_collaboration1, _comparisonData_37, _comparisonData__results_team_cohesion_subcategories_communication1, _comparisonData_38, _comparisonData__results_team_cohesion_subcategories_culture1, _comparisonData_39, _comparisonData__results_team_cohesion_subcategories_decision_making1, _comparisonData_40, _comparisonData__results_team_cohesion_subcategories_emotional_intelligence1, _comparisonData_41, _comparisonData__results_team_cohesion_subcategories_team_quality1, _comparisonData_42, _comparisonData__results_team_cohesion_subcategories_trust1, _comparisonData_43, _comparisonData__results_team_cohesion_subcategories_agreements2, _comparisonData_44, _comparisonData__results_team_cohesion_subcategories_agreements3, _comparisonData_45, _comparisonData__results_team_cohesion_subcategories_collaboration2, _comparisonData_46, _comparisonData__results_team_cohesion_subcategories_collaboration3, _comparisonData_47, _comparisonData__results_team_cohesion_subcategories_communication2, _comparisonData_48, _comparisonData__results_team_cohesion_subcategories_communication3, _comparisonData_49, _comparisonData__results_team_cohesion_subcategories_culture2, _comparisonData_50, _comparisonData__results_team_cohesion_subcategories_culture3, _comparisonData_51, _comparisonData__results_team_cohesion_subcategories_decision_making2, _comparisonData_52, _comparisonData__results_team_cohesion_subcategories_decision_making3, _comparisonData_53, _comparisonData__results_team_cohesion_subcategories_emotional_intelligence2, _comparisonData_54, _comparisonData__results_team_cohesion_subcategories_emotional_intelligence3, _comparisonData_55, _comparisonData__results_team_cohesion_subcategories_team_quality2, _comparisonData_56, _comparisonData__results_team_cohesion_subcategories_team_quality3, _comparisonData_57, _comparisonData__results_team_cohesion_subcategories_trust2, _comparisonData_58, _comparisonData__results_team_cohesion_subcategories_trust3, _comparisonData_59, _comparisonData__results_vision__impact_subcategories_compassion_for_others, _comparisonData_60, _comparisonData__results_vision__impact_subcategories_intrinsic_motivation, _comparisonData_61, _comparisonData__results_vision__impact_subcategories_leadership_strength, _comparisonData_62, _comparisonData__results_vision__impact_subcategories_global_impact_goals, _comparisonData_63, _comparisonData__results_vision__impact_subcategories_compassion_for_others1, _comparisonData_64, _comparisonData__results_vision__impact_subcategories_intrinsic_motivation1, _comparisonData_65, _comparisonData__results_vision__impact_subcategories_leadership_strength1, _comparisonData_66, _comparisonData__results_vision__impact_subcategories_global_impact_goals1, _comparisonData_67, _comparisonData__results_vision__impact_subcategories_compassion_for_others2, _comparisonData_68, _comparisonData__results_vision__impact_subcategories_compassion_for_others3, _comparisonData_69, _comparisonData__results_vision__impact_subcategories_intrinsic_motivation2, _comparisonData_70, _comparisonData__results_vision__impact_subcategories_intrinsic_motivation3, _comparisonData_71, _comparisonData__results_vision__impact_subcategories_leadership_strength2, _comparisonData_72, _comparisonData__results_vision__impact_subcategories_leadership_strength3, _comparisonData_73, _comparisonData__results_vision__impact_subcategories_global_impact_goals2, _comparisonData_74, _comparisonData__results_vision__impact_subcategories_global_impact_goals3, _comparisonData_75, _comparisonData_76;
    const resolvedPreDate = preDate || (((_comparisonData_ = comparisonData[0]) === null || _comparisonData_ === void 0 ? void 0 : _comparisonData_.submittedAt) ? (0, ($parcel$interopDefault($feLGi$momenttimezone)))(comparisonData[0].submittedAt).format("MMM DD, YYYY") : "");
    const resolvedPostDate = postDate || (((_comparisonData_1 = comparisonData[1]) === null || _comparisonData_1 === void 0 ? void 0 : _comparisonData_1.submittedAt) ? (0, ($parcel$interopDefault($feLGi$momenttimezone)))(comparisonData[1].submittedAt).format("MMM DD, YYYY") : "");
    const spitedPreDate = resolvedPreDate.toString().split(" - ");
    const spitedPostDate = resolvedPostDate.toString().split(" - ");
    const formatedPreDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(resolvedPreDate).format("MM-DD-YYYY")}`;
    const formatedPostDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(resolvedPostDate).format("MM-DD-YYYY")}`;
    let userDataIndex = 0;
    const preMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(preDate || resolvedPreDate, (_comparisonData_2 = comparisonData[0]) === null || _comparisonData_2 === void 0 ? void 0 : _comparisonData_2.submittedAt);
    const postMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(postDate || resolvedPostDate, (_comparisonData_3 = comparisonData[1]) === null || _comparisonData_3 === void 0 ? void 0 : _comparisonData_3.submittedAt);
    const preQuarter = preMoment.quarter();
    const postQuarter = postMoment.quarter();
    const preYear = preMoment.year();
    const postYear = postMoment.year();
    const headerContent = typeof header === "function" ? header() : header;
    const showPageHeaderRow = showGoBackButton || headerContent;
    const comparisonPeriodLabels = [
        formatedPreDate,
        formatedPostDate
    ];
    const comparisonPdfDownload = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $09226703b1b735cd$export$2e2bcd8739ae039), {
        comparisonData: comparisonData,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS,
        periodLabels: comparisonPeriodLabels,
        assessmentTitle: typeof headerContent === "string" && headerContent.trim() ? headerContent : "Awareness Assessment",
        fileNameBase: downloadFileNameBase,
        className: "ml-3"
    });
    if (isLoading) return showClientCompareHeader ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f036bbe39d78cd8f$export$2e2bcd8739ae039), {
        isRenderFromOP: isRenderFromOP
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a41d748d78d3a02e$export$2e2bcd8739ae039), null);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "px-0 custom-offset-lg-1 custom-col-lg-12": isRenderFromOP
        })
    }, isRenderFromOP ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pt-4 px-0",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "page-header"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "icon icon-assessments font-40"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100 justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h2", {
        className: "font-montserrat font-semibold text-dark-600 mb-0"
    }, headerContent), comparisonPdfDownload))))) : showClientCompareHeader ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $8cd010ee20c8a311$export$2e2bcd8739ae039), {
        assessmentTitle: compareHeaderTitle,
        onGoBack: onGoBack,
        headerRight: headerContent,
        titleAccessory: comparisonPdfDownload
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, showPageHeaderRow && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "px-0",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), headerContent))))), !showClientCompareHeader && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center pt-2 mb-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s1 mb-0"
    }, "Compare Results"), comparisonPdfDownload))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pb-4",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column text-gray-800 align-items-center font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "The following charts and quantitative data help you see how your Self Awareness, Team Cohesion, and Vision & Impact scores have changed between the two assessment periods you selected."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "We invite you not to be overly concerned with whether your scores have increased or decreased. Sometimes life and business present challenges that require us to change our working habits for a period of time. If an area decreases, that is good awareness around opportunities to course correct. Similarly, if an area increases, we invite you to celebrate, but also not attach to it always being that way.")))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $1847fab3bb0b54b4$export$2e2bcd8739ae039), {
        comparisonData: comparisonData,
        formatedPreDate: formatedPreDate,
        formatedPostDate: formatedPostDate,
        isRenderFromOP: isRenderFromOP
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-blue-100"
    }, "Self Awareness"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: "d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Burnout Buffer",
            "Fear & Anxiety",
            "Healthy Responsibility",
            "Psychological Adaptability",
            "Self Compassion",
            "Time Management & Mindset"
        ],
        colors: [
            "#69B1d8",
            "#0076BD"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_self_awareness_subcategories_burnout_buffer = (_comparisonData_4 = comparisonData[0]) === null || _comparisonData_4 === void 0 ? void 0 : _comparisonData_4.results.self_awareness.subcategories.burnout_buffer) === null || _comparisonData__results_self_awareness_subcategories_burnout_buffer === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_buffer.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_fear__decision_making = (_comparisonData_5 = comparisonData[0]) === null || _comparisonData_5 === void 0 ? void 0 : _comparisonData_5.results.self_awareness.subcategories.fear__decision_making) === null || _comparisonData__results_self_awareness_subcategories_fear__decision_making === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__decision_making.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_healthy_responsibility = (_comparisonData_6 = comparisonData[0]) === null || _comparisonData_6 === void 0 ? void 0 : _comparisonData_6.results.self_awareness.subcategories.healthy_responsibility) === null || _comparisonData__results_self_awareness_subcategories_healthy_responsibility === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_healthy_responsibility.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_psychological_adaptability = (_comparisonData_7 = comparisonData[0]) === null || _comparisonData_7 === void 0 ? void 0 : _comparisonData_7.results.self_awareness.subcategories.psychological_adaptability) === null || _comparisonData__results_self_awareness_subcategories_psychological_adaptability === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_psychological_adaptability.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_self_compassion = (_comparisonData_8 = comparisonData[0]) === null || _comparisonData_8 === void 0 ? void 0 : _comparisonData_8.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_time_management__mindset = (_comparisonData_9 = comparisonData[0]) === null || _comparisonData_9 === void 0 ? void 0 : _comparisonData_9.results.self_awareness.subcategories.time_management__mindset) === null || _comparisonData__results_self_awareness_subcategories_time_management__mindset === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_time_management__mindset.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_self_awareness_subcategories_burnout_buffer1 = (_comparisonData_10 = comparisonData[1]) === null || _comparisonData_10 === void 0 ? void 0 : _comparisonData_10.results.self_awareness.subcategories.burnout_buffer) === null || _comparisonData__results_self_awareness_subcategories_burnout_buffer1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_buffer1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_fear__decision_making1 = (_comparisonData_11 = comparisonData[1]) === null || _comparisonData_11 === void 0 ? void 0 : _comparisonData_11.results.self_awareness.subcategories.fear__decision_making) === null || _comparisonData__results_self_awareness_subcategories_fear__decision_making1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__decision_making1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_healthy_responsibility1 = (_comparisonData_12 = comparisonData[1]) === null || _comparisonData_12 === void 0 ? void 0 : _comparisonData_12.results.self_awareness.subcategories.healthy_responsibility) === null || _comparisonData__results_self_awareness_subcategories_healthy_responsibility1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_healthy_responsibility1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_psychological_adaptability1 = (_comparisonData_13 = comparisonData[1]) === null || _comparisonData_13 === void 0 ? void 0 : _comparisonData_13.results.self_awareness.subcategories.psychological_adaptability) === null || _comparisonData__results_self_awareness_subcategories_psychological_adaptability1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_psychological_adaptability1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_self_compassion1 = (_comparisonData_14 = comparisonData[1]) === null || _comparisonData_14 === void 0 ? void 0 : _comparisonData_14.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_time_management__mindset1 = (_comparisonData_15 = comparisonData[1]) === null || _comparisonData_15 === void 0 ? void 0 : _comparisonData_15.results.self_awareness.subcategories.time_management__mindset) === null || _comparisonData__results_self_awareness_subcategories_time_management__mindset1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_time_management__mindset1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Burnout Buffer",
        survey0: (_comparisonData__results_self_awareness_subcategories_burnout_buffer2 = (_comparisonData_16 = comparisonData[0]) === null || _comparisonData_16 === void 0 ? void 0 : _comparisonData_16.results.self_awareness.subcategories.burnout_buffer) === null || _comparisonData__results_self_awareness_subcategories_burnout_buffer2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_buffer2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_burnout_buffer3 = (_comparisonData_17 = comparisonData[1]) === null || _comparisonData_17 === void 0 ? void 0 : _comparisonData_17.results.self_awareness.subcategories.burnout_buffer) === null || _comparisonData__results_self_awareness_subcategories_burnout_buffer3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_buffer3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Fear & Anxiety",
        survey0: (_comparisonData__results_self_awareness_subcategories_fear__decision_making2 = (_comparisonData_18 = comparisonData[0]) === null || _comparisonData_18 === void 0 ? void 0 : _comparisonData_18.results.self_awareness.subcategories.fear__decision_making) === null || _comparisonData__results_self_awareness_subcategories_fear__decision_making2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__decision_making2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_fear__decision_making3 = (_comparisonData_19 = comparisonData[1]) === null || _comparisonData_19 === void 0 ? void 0 : _comparisonData_19.results.self_awareness.subcategories.fear__decision_making) === null || _comparisonData__results_self_awareness_subcategories_fear__decision_making3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__decision_making3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Healthy Responsibility",
        survey0: (_comparisonData__results_self_awareness_subcategories_healthy_responsibility2 = (_comparisonData_20 = comparisonData[0]) === null || _comparisonData_20 === void 0 ? void 0 : _comparisonData_20.results.self_awareness.subcategories.healthy_responsibility) === null || _comparisonData__results_self_awareness_subcategories_healthy_responsibility2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_healthy_responsibility2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_healthy_responsibility3 = (_comparisonData_21 = comparisonData[1]) === null || _comparisonData_21 === void 0 ? void 0 : _comparisonData_21.results.self_awareness.subcategories.healthy_responsibility) === null || _comparisonData__results_self_awareness_subcategories_healthy_responsibility3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_healthy_responsibility3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Psychological Adaptability",
        survey0: (_comparisonData__results_self_awareness_subcategories_psychological_adaptability2 = (_comparisonData_22 = comparisonData[0]) === null || _comparisonData_22 === void 0 ? void 0 : _comparisonData_22.results.self_awareness.subcategories.psychological_adaptability) === null || _comparisonData__results_self_awareness_subcategories_psychological_adaptability2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_psychological_adaptability2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_psychological_adaptability3 = (_comparisonData_23 = comparisonData[1]) === null || _comparisonData_23 === void 0 ? void 0 : _comparisonData_23.results.self_awareness.subcategories.psychological_adaptability) === null || _comparisonData__results_self_awareness_subcategories_psychological_adaptability3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_psychological_adaptability3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Self Compassion",
        survey0: (_comparisonData__results_self_awareness_subcategories_self_compassion2 = (_comparisonData_24 = comparisonData[0]) === null || _comparisonData_24 === void 0 ? void 0 : _comparisonData_24.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_self_compassion3 = (_comparisonData_25 = comparisonData[1]) === null || _comparisonData_25 === void 0 ? void 0 : _comparisonData_25.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Time Management & Mindset",
        survey0: (_comparisonData__results_self_awareness_subcategories_time_management__mindset2 = (_comparisonData_26 = comparisonData[0]) === null || _comparisonData_26 === void 0 ? void 0 : _comparisonData_26.results.self_awareness.subcategories.time_management__mindset) === null || _comparisonData__results_self_awareness_subcategories_time_management__mindset2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_time_management__mindset2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_time_management__mindset3 = (_comparisonData_27 = comparisonData[1]) === null || _comparisonData_27 === void 0 ? void 0 : _comparisonData_27.results.self_awareness.subcategories.time_management__mindset) === null || _comparisonData__results_self_awareness_subcategories_time_management__mindset3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_time_management__mindset3.percent
    }))))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-green-100"
    }, "Team Cohesion"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: "d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Agreements & Accountability",
            "Collaboration",
            "Communication",
            "Culture",
            "Decision Making",
            "Emotional Intelligence",
            "Team Quality",
            "Trust"
        ],
        colors: [
            "#509f92",
            "#37763B"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_team_cohesion_subcategories_agreements = (_comparisonData_28 = comparisonData[0]) === null || _comparisonData_28 === void 0 ? void 0 : _comparisonData_28.results.team_cohesion.subcategories.agreements) === null || _comparisonData__results_team_cohesion_subcategories_agreements === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_agreements.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_collaboration = (_comparisonData_29 = comparisonData[0]) === null || _comparisonData_29 === void 0 ? void 0 : _comparisonData_29.results.team_cohesion.subcategories.collaboration) === null || _comparisonData__results_team_cohesion_subcategories_collaboration === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_collaboration.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_communication = (_comparisonData_30 = comparisonData[0]) === null || _comparisonData_30 === void 0 ? void 0 : _comparisonData_30.results.team_cohesion.subcategories.communication) === null || _comparisonData__results_team_cohesion_subcategories_communication === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_communication.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_culture = (_comparisonData_31 = comparisonData[0]) === null || _comparisonData_31 === void 0 ? void 0 : _comparisonData_31.results.team_cohesion.subcategories.culture) === null || _comparisonData__results_team_cohesion_subcategories_culture === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_culture.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_decision_making = (_comparisonData_32 = comparisonData[0]) === null || _comparisonData_32 === void 0 ? void 0 : _comparisonData_32.results.team_cohesion.subcategories.decision_making) === null || _comparisonData__results_team_cohesion_subcategories_decision_making === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_decision_making.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_emotional_intelligence = (_comparisonData_33 = comparisonData[0]) === null || _comparisonData_33 === void 0 ? void 0 : _comparisonData_33.results.team_cohesion.subcategories.emotional_intelligence) === null || _comparisonData__results_team_cohesion_subcategories_emotional_intelligence === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_emotional_intelligence.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_team_quality = (_comparisonData_34 = comparisonData[0]) === null || _comparisonData_34 === void 0 ? void 0 : _comparisonData_34.results.team_cohesion.subcategories.team_quality) === null || _comparisonData__results_team_cohesion_subcategories_team_quality === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_team_quality.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_trust = (_comparisonData_35 = comparisonData[0]) === null || _comparisonData_35 === void 0 ? void 0 : _comparisonData_35.results.team_cohesion.subcategories.trust) === null || _comparisonData__results_team_cohesion_subcategories_trust === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_trust.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_team_cohesion_subcategories_agreements1 = (_comparisonData_36 = comparisonData[1]) === null || _comparisonData_36 === void 0 ? void 0 : _comparisonData_36.results.team_cohesion.subcategories.agreements) === null || _comparisonData__results_team_cohesion_subcategories_agreements1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_agreements1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_collaboration1 = (_comparisonData_37 = comparisonData[1]) === null || _comparisonData_37 === void 0 ? void 0 : _comparisonData_37.results.team_cohesion.subcategories.collaboration) === null || _comparisonData__results_team_cohesion_subcategories_collaboration1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_collaboration1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_communication1 = (_comparisonData_38 = comparisonData[1]) === null || _comparisonData_38 === void 0 ? void 0 : _comparisonData_38.results.team_cohesion.subcategories.communication) === null || _comparisonData__results_team_cohesion_subcategories_communication1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_communication1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_culture1 = (_comparisonData_39 = comparisonData[1]) === null || _comparisonData_39 === void 0 ? void 0 : _comparisonData_39.results.team_cohesion.subcategories.culture) === null || _comparisonData__results_team_cohesion_subcategories_culture1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_culture1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_decision_making1 = (_comparisonData_40 = comparisonData[1]) === null || _comparisonData_40 === void 0 ? void 0 : _comparisonData_40.results.team_cohesion.subcategories.decision_making) === null || _comparisonData__results_team_cohesion_subcategories_decision_making1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_decision_making1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_emotional_intelligence1 = (_comparisonData_41 = comparisonData[1]) === null || _comparisonData_41 === void 0 ? void 0 : _comparisonData_41.results.team_cohesion.subcategories.emotional_intelligence) === null || _comparisonData__results_team_cohesion_subcategories_emotional_intelligence1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_emotional_intelligence1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_team_quality1 = (_comparisonData_42 = comparisonData[1]) === null || _comparisonData_42 === void 0 ? void 0 : _comparisonData_42.results.team_cohesion.subcategories.team_quality) === null || _comparisonData__results_team_cohesion_subcategories_team_quality1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_team_quality1.percent),
            parseInt((_comparisonData__results_team_cohesion_subcategories_trust1 = (_comparisonData_43 = comparisonData[1]) === null || _comparisonData_43 === void 0 ? void 0 : _comparisonData_43.results.team_cohesion.subcategories.trust) === null || _comparisonData__results_team_cohesion_subcategories_trust1 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_trust1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Agreements & Accountability",
        survey0: (_comparisonData__results_team_cohesion_subcategories_agreements2 = (_comparisonData_44 = comparisonData[0]) === null || _comparisonData_44 === void 0 ? void 0 : _comparisonData_44.results.team_cohesion.subcategories.agreements) === null || _comparisonData__results_team_cohesion_subcategories_agreements2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_agreements2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_agreements3 = (_comparisonData_45 = comparisonData[1]) === null || _comparisonData_45 === void 0 ? void 0 : _comparisonData_45.results.team_cohesion.subcategories.agreements) === null || _comparisonData__results_team_cohesion_subcategories_agreements3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_agreements3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Collaboration",
        survey0: (_comparisonData__results_team_cohesion_subcategories_collaboration2 = (_comparisonData_46 = comparisonData[0]) === null || _comparisonData_46 === void 0 ? void 0 : _comparisonData_46.results.team_cohesion.subcategories.collaboration) === null || _comparisonData__results_team_cohesion_subcategories_collaboration2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_collaboration2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_collaboration3 = (_comparisonData_47 = comparisonData[1]) === null || _comparisonData_47 === void 0 ? void 0 : _comparisonData_47.results.team_cohesion.subcategories.collaboration) === null || _comparisonData__results_team_cohesion_subcategories_collaboration3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_collaboration3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Communication",
        survey0: (_comparisonData__results_team_cohesion_subcategories_communication2 = (_comparisonData_48 = comparisonData[0]) === null || _comparisonData_48 === void 0 ? void 0 : _comparisonData_48.results.team_cohesion.subcategories.communication) === null || _comparisonData__results_team_cohesion_subcategories_communication2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_communication2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_communication3 = (_comparisonData_49 = comparisonData[1]) === null || _comparisonData_49 === void 0 ? void 0 : _comparisonData_49.results.team_cohesion.subcategories.communication) === null || _comparisonData__results_team_cohesion_subcategories_communication3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_communication3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Culture",
        survey0: (_comparisonData__results_team_cohesion_subcategories_culture2 = (_comparisonData_50 = comparisonData[0]) === null || _comparisonData_50 === void 0 ? void 0 : _comparisonData_50.results.team_cohesion.subcategories.culture) === null || _comparisonData__results_team_cohesion_subcategories_culture2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_culture2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_culture3 = (_comparisonData_51 = comparisonData[1]) === null || _comparisonData_51 === void 0 ? void 0 : _comparisonData_51.results.team_cohesion.subcategories.culture) === null || _comparisonData__results_team_cohesion_subcategories_culture3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_culture3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Decision Making",
        survey0: (_comparisonData__results_team_cohesion_subcategories_decision_making2 = (_comparisonData_52 = comparisonData[0]) === null || _comparisonData_52 === void 0 ? void 0 : _comparisonData_52.results.team_cohesion.subcategories.decision_making) === null || _comparisonData__results_team_cohesion_subcategories_decision_making2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_decision_making2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_decision_making3 = (_comparisonData_53 = comparisonData[1]) === null || _comparisonData_53 === void 0 ? void 0 : _comparisonData_53.results.team_cohesion.subcategories.decision_making) === null || _comparisonData__results_team_cohesion_subcategories_decision_making3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_decision_making3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Emotional Intelligence",
        survey0: (_comparisonData__results_team_cohesion_subcategories_emotional_intelligence2 = (_comparisonData_54 = comparisonData[0]) === null || _comparisonData_54 === void 0 ? void 0 : _comparisonData_54.results.team_cohesion.subcategories.emotional_intelligence) === null || _comparisonData__results_team_cohesion_subcategories_emotional_intelligence2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_emotional_intelligence2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_emotional_intelligence3 = (_comparisonData_55 = comparisonData[1]) === null || _comparisonData_55 === void 0 ? void 0 : _comparisonData_55.results.team_cohesion.subcategories.emotional_intelligence) === null || _comparisonData__results_team_cohesion_subcategories_emotional_intelligence3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_emotional_intelligence3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Team Quality",
        survey0: (_comparisonData__results_team_cohesion_subcategories_team_quality2 = (_comparisonData_56 = comparisonData[0]) === null || _comparisonData_56 === void 0 ? void 0 : _comparisonData_56.results.team_cohesion.subcategories.team_quality) === null || _comparisonData__results_team_cohesion_subcategories_team_quality2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_team_quality2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_team_quality3 = (_comparisonData_57 = comparisonData[1]) === null || _comparisonData_57 === void 0 ? void 0 : _comparisonData_57.results.team_cohesion.subcategories.team_quality) === null || _comparisonData__results_team_cohesion_subcategories_team_quality3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_team_quality3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Trust",
        survey0: (_comparisonData__results_team_cohesion_subcategories_trust2 = (_comparisonData_58 = comparisonData[0]) === null || _comparisonData_58 === void 0 ? void 0 : _comparisonData_58.results.team_cohesion.subcategories.trust) === null || _comparisonData__results_team_cohesion_subcategories_trust2 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_trust2.percent,
        survey1: (_comparisonData__results_team_cohesion_subcategories_trust3 = (_comparisonData_59 = comparisonData[1]) === null || _comparisonData_59 === void 0 ? void 0 : _comparisonData_59.results.team_cohesion.subcategories.trust) === null || _comparisonData__results_team_cohesion_subcategories_trust3 === void 0 ? void 0 : _comparisonData__results_team_cohesion_subcategories_trust3.percent
    }))))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-red-500"
    }, "Vision & Impact"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: "d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-red-500 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-red-700 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Compassion for Others",
            "Intrinsic Motivation",
            "Leadership Strength",
            "Superordinate Goals"
        ],
        colors: [
            "#BC4C6A",
            "#7E2D55"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_vision__impact_subcategories_compassion_for_others = (_comparisonData_60 = comparisonData[0]) === null || _comparisonData_60 === void 0 ? void 0 : _comparisonData_60.results.vision__impact.subcategories.compassion_for_others) === null || _comparisonData__results_vision__impact_subcategories_compassion_for_others === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_compassion_for_others.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_intrinsic_motivation = (_comparisonData_61 = comparisonData[0]) === null || _comparisonData_61 === void 0 ? void 0 : _comparisonData_61.results.vision__impact.subcategories.intrinsic_motivation) === null || _comparisonData__results_vision__impact_subcategories_intrinsic_motivation === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_intrinsic_motivation.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_leadership_strength = (_comparisonData_62 = comparisonData[0]) === null || _comparisonData_62 === void 0 ? void 0 : _comparisonData_62.results.vision__impact.subcategories.leadership_strength) === null || _comparisonData__results_vision__impact_subcategories_leadership_strength === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_leadership_strength.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_global_impact_goals = (_comparisonData_63 = comparisonData[0]) === null || _comparisonData_63 === void 0 ? void 0 : _comparisonData_63.results.vision__impact.subcategories.global_impact_goals) === null || _comparisonData__results_vision__impact_subcategories_global_impact_goals === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_global_impact_goals.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_vision__impact_subcategories_compassion_for_others1 = (_comparisonData_64 = comparisonData[1]) === null || _comparisonData_64 === void 0 ? void 0 : _comparisonData_64.results.vision__impact.subcategories.compassion_for_others) === null || _comparisonData__results_vision__impact_subcategories_compassion_for_others1 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_compassion_for_others1.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_intrinsic_motivation1 = (_comparisonData_65 = comparisonData[1]) === null || _comparisonData_65 === void 0 ? void 0 : _comparisonData_65.results.vision__impact.subcategories.intrinsic_motivation) === null || _comparisonData__results_vision__impact_subcategories_intrinsic_motivation1 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_intrinsic_motivation1.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_leadership_strength1 = (_comparisonData_66 = comparisonData[1]) === null || _comparisonData_66 === void 0 ? void 0 : _comparisonData_66.results.vision__impact.subcategories.leadership_strength) === null || _comparisonData__results_vision__impact_subcategories_leadership_strength1 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_leadership_strength1.percent),
            parseInt((_comparisonData__results_vision__impact_subcategories_global_impact_goals1 = (_comparisonData_67 = comparisonData[1]) === null || _comparisonData_67 === void 0 ? void 0 : _comparisonData_67.results.vision__impact.subcategories.global_impact_goals) === null || _comparisonData__results_vision__impact_subcategories_global_impact_goals1 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_global_impact_goals1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-red-500"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-red-700"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Compassion for Others",
        survey0: (_comparisonData__results_vision__impact_subcategories_compassion_for_others2 = (_comparisonData_68 = comparisonData[0]) === null || _comparisonData_68 === void 0 ? void 0 : _comparisonData_68.results.vision__impact.subcategories.compassion_for_others) === null || _comparisonData__results_vision__impact_subcategories_compassion_for_others2 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_compassion_for_others2.percent,
        survey1: (_comparisonData__results_vision__impact_subcategories_compassion_for_others3 = (_comparisonData_69 = comparisonData[1]) === null || _comparisonData_69 === void 0 ? void 0 : _comparisonData_69.results.vision__impact.subcategories.compassion_for_others) === null || _comparisonData__results_vision__impact_subcategories_compassion_for_others3 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_compassion_for_others3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Intrinsic Motivation",
        survey0: (_comparisonData__results_vision__impact_subcategories_intrinsic_motivation2 = (_comparisonData_70 = comparisonData[0]) === null || _comparisonData_70 === void 0 ? void 0 : _comparisonData_70.results.vision__impact.subcategories.intrinsic_motivation) === null || _comparisonData__results_vision__impact_subcategories_intrinsic_motivation2 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_intrinsic_motivation2.percent,
        survey1: (_comparisonData__results_vision__impact_subcategories_intrinsic_motivation3 = (_comparisonData_71 = comparisonData[1]) === null || _comparisonData_71 === void 0 ? void 0 : _comparisonData_71.results.vision__impact.subcategories.intrinsic_motivation) === null || _comparisonData__results_vision__impact_subcategories_intrinsic_motivation3 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_intrinsic_motivation3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Leadership Strength",
        survey0: (_comparisonData__results_vision__impact_subcategories_leadership_strength2 = (_comparisonData_72 = comparisonData[0]) === null || _comparisonData_72 === void 0 ? void 0 : _comparisonData_72.results.vision__impact.subcategories.leadership_strength) === null || _comparisonData__results_vision__impact_subcategories_leadership_strength2 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_leadership_strength2.percent,
        survey1: (_comparisonData__results_vision__impact_subcategories_leadership_strength3 = (_comparisonData_73 = comparisonData[1]) === null || _comparisonData_73 === void 0 ? void 0 : _comparisonData_73.results.vision__impact.subcategories.leadership_strength) === null || _comparisonData__results_vision__impact_subcategories_leadership_strength3 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_leadership_strength3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Superordinate Goals",
        survey0: (_comparisonData__results_vision__impact_subcategories_global_impact_goals2 = (_comparisonData_74 = comparisonData[0]) === null || _comparisonData_74 === void 0 ? void 0 : _comparisonData_74.results.vision__impact.subcategories.global_impact_goals) === null || _comparisonData__results_vision__impact_subcategories_global_impact_goals2 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_global_impact_goals2.percent,
        survey1: (_comparisonData__results_vision__impact_subcategories_global_impact_goals3 = (_comparisonData_75 = comparisonData[1]) === null || _comparisonData_75 === void 0 ? void 0 : _comparisonData_75.results.vision__impact.subcategories.global_impact_goals) === null || _comparisonData__results_vision__impact_subcategories_global_impact_goals3 === void 0 ? void 0 : _comparisonData__results_vision__impact_subcategories_global_impact_goals3.percent
    }))))))))), ((_comparisonData_76 = comparisonData[0]) === null || _comparisonData_76 === void 0 ? void 0 : _comparisonData_76.users) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0 px-sm-2 pt-2": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label"
    }, "Assessment Users"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "10%"
    }, "#"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Email"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Quarter"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, comparisonData.length > 0 ? comparisonData.map((item, dataIndex)=>{
        const quarter = dataIndex === 0 ? preQuarter : postQuarter;
        const year = dataIndex === 0 ? preYear : postYear;
        const allUsers = comparisonData.map((data)=>data.users || []).flat();
        const filteredUsers = (props === null || props === void 0 ? void 0 : props.apiFor) === "common-users" ? (item.users || []).filter((user)=>allUsers.filter((u)=>u._id === user._id).length > 1) : item.users || [];
        return filteredUsers.map((user)=>{
            userDataIndex = userDataIndex + 1;
            return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
                key: `${user._id}-${dataIndex}`
            }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, userDataIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.fullName), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.email), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, `Quarter ${quarter} ${year}`));
        });
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        colSpan: "4",
        className: "text-center"
    }, "Assessment users not available at this moment."))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a342f5c2d7c66d88$export$2e2bcd8739ae039), {
        i18n: i18n
    }));
};
var $80d9961445c5e23a$export$2e2bcd8739ae039 = $80d9961445c5e23a$var$SurveyComparisonReport;












const $e28d628c3e837aec$var$LeaderSelect = ({ name: name , options: options , defaultValue: defaultValue = null , setFirstDefault: setFirstDefault = false , onChange: onChange = ()=>{} , placeholder: placeholder = "" , disabled: disabled = false , customDropdown: customDropdown = false , onOptionClick: onOptionClick = ()=>{} , keyProp: keyProp = null , isLoading: isLoading = false , loader: loader = null , isRenderOnClientSide: isRenderOnClientSide = false , ...rest })=>{
    const [dropdownValue, setDropdownValue] = (0, $feLGi$react.useState)(defaultValue);
    (0, $feLGi$react.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.length) > 0 && setFirstDefault) setDropdownValue(options[0]);
        else setDropdownValue(defaultValue);
    }, [
        defaultValue,
        options,
        setFirstDefault,
        keyProp
    ]);
    const customStyles = {
        menuList: (provided, state)=>({
                ...provided,
                paddingTop: 0,
                paddingBottom: 0,
                borderBottom: "1px solid #000",
                borderLeft: "1px solid #000",
                borderRight: "1px solid #000",
                boxShadow: "none",
                borderRadius: "none",
                borderBottomLeftRadius: "3px",
                borderBottomRightRadius: "3px"
            }),
        container: (provided, state)=>({
                ...provided,
                width: "95%"
            }),
        menu: (provided, state)=>({
                ...provided,
                marginTop: 0,
                boxShadow: "none",
                zIndex: 25
            }),
        option: (provided, state)=>{
            return {
                ...provided,
                // display: state.isSelected ? 'none' : 'block',
                color: state.isSelected ? "#BF9000" : "black",
                backgroundColor: "transparent",
                padding: "0.5rem 1rem",
                "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer"
                },
                "&:active": {
                    backgroundColor: "transparent"
                },
                fontFamily: "Open Sans",
                fontSize: "0.875rem",
                lineHeight: "1.5rem",
                fontStyle: "normal",
                fontWeight: state.isSelected ? 700 : 600,
                letterSpacing: "-0.02em",
                boxSizing: "border-box",
                maxWidth: "50%"
            };
        },
        control: (provided, state)=>{
            return {
                ...provided,
                minHeight: "auto",
                borderColor: "#000",
                boxShadow: 0,
                padding: 0,
                borderTopLeftRadius: isRenderOnClientSide ? "5px" : "3px",
                borderTopRightRadius: isRenderOnClientSide ? "5px" : "3px",
                borderBottomColor: state.menuIsOpen ? "transparent !important" : "#000",
                borderBottomLeftRadius: state.menuIsOpen ? "0px" : isRenderOnClientSide ? "5px" : "3px",
                borderBottomRightRadius: state.menuIsOpen ? "0px" : isRenderOnClientSide ? "5px" : "3px",
                borderBottom: state.menuIsOpen ? 0 : "1px solid #000",
                "&:hover": {
                    borderColor: "#000"
                }
            };
        },
        indicatorSeparator: (provided)=>{
            return {
                ...provided,
                opacity: 0
            };
        },
        groupHeading: (base)=>({
                ...base,
                flex: "1 1",
                color: "white",
                margin: 0
            }),
        singleValue: (provided, state)=>({
                ...provided,
                display: "none"
            }),
        placeholder: (provided, state)=>({
                ...provided,
                width: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden !important",
                textOverflow: "ellipsis"
            })
    };
    if (customDropdown) customStyles.singleValue = (provided, state)=>{
        return {
            ...provided,
            opacity: 1,
            "&:hover": {
                textDecoration: "underline",
                cursor: "pointer"
            }
        };
    };
    const MenuList = (props)=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactselect.components).MenuList, props, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "font-open-sans font-semibold font-12 leading-5 letter-spacing-minus-02 px-3 custom-mb-0-625"
        }, "Select which awareness assessment you would like to compare with."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "leader-select-options-wrp"
        }, props.children)));
    };
    const SingleValue = ({ children: children , ...props })=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactselect.components).SingleValue, props, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            onClick: (e)=>onOptionClick(props.data)
        }, children));
    };
    const DropdownIndicator = (props)=>{
        return (0, $feLGi$reactselect.components).DropdownIndicator && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactselect.components).DropdownIndicator, props, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, isRenderOnClientSide ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "icon icon-left-arrow font-20 text-black"
        }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, props.selectProps.menuIsOpen ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b5104a1b3db51ba6$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $e56d2de78eb5c0ce$export$2e2bcd8739ae039), null))));
    };
    const CustomValueContainer = ({ children: children , ...props })=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactselect.components).ValueContainer, props, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactselect.components).Placeholder, {
            ...props,
            isFocused: props.isFocused
        }, props.selectProps.placeholder), (0, ($parcel$interopDefault($feLGi$react))).Children.map(children, (child)=>child && child.type !== (0, $feLGi$reactselect.components).Placeholder ? child : null));
    };
    let customComponents = {};
    if (customDropdown) customComponents = {
        SingleValue: SingleValue
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex compare-date"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactselect))), {
        name: name,
        options: options,
        classNamePrefix: "ab-select",
        styles: customStyles,
        isSearchable: false,
        components: {
            DropdownIndicator: DropdownIndicator,
            ...customComponents,
            MenuList: MenuList,
            ValueContainer: CustomValueContainer
        },
        // menuPortalTarget={document.body}
        onChange: (e)=>{
            setDropdownValue(e);
            if ((dropdownValue === null || dropdownValue === void 0 ? void 0 : dropdownValue.value) !== (e === null || e === void 0 ? void 0 : e.value)) onChange(e);
        },
        placeholder: "Select Awareness Assessment",
        isDisabled: disabled,
        openMenuOnClick: "true",
        controlShouldRenderValue: "true",
        value: dropdownValue,
        ...rest
    }), isLoading && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center align-items-center ml-1 ms-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Spinner), {
        animation: "border",
        className: "text-saffron-700 report-loader"
    })));
};
var $e28d628c3e837aec$export$2e2bcd8739ae039 = $e28d628c3e837aec$var$LeaderSelect;








const $6f4239ec5e13392b$var$InfoIconOverlay = ({ contentText: contentText , title: title , placement: placement = "bottom"  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.OverlayTrigger), {
        key: placement,
        placement: placement,
        overlay: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Tooltip), {
            id: `tooltip-${placement}-${title}`,
            className: "s11 text-center info-tooltip"
        }, contentText)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "d-inline-block ms-3 ml-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none"
    })));
};
var $6f4239ec5e13392b$export$2e2bcd8739ae039 = $6f4239ec5e13392b$var$InfoIconOverlay;













const $2804ed17bfb2a01c$var$AssessmentPdfDownload = ({ survey: survey , assessmentType: assessmentType , awarenessSurvey: awarenessSurvey , assessmentTitle: assessmentTitle , assessmentSubtitle: assessmentSubtitle , fileNameBase: fileNameBase , className: className = "" , iconSize: iconSize = 32  })=>{
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const [isDownloadingPdf, setIsDownloadingPdf] = (0, $feLGi$react.useState)(false);
    if (!(survey === null || survey === void 0 ? void 0 : survey.results) || !assessmentType) return null;
    const handleDownloadPdf = async ()=>{
        if (isDownloadingPdf) return;
        setIsDownloadingPdf(true);
        try {
            await (0, $1ca4df0143566e72$export$6eb62a57cb117d2c)({
                survey: survey,
                assessmentType: assessmentType,
                awarenessSurvey: awarenessSurvey,
                assessmentTitle: assessmentTitle,
                assessmentSubtitle: assessmentSubtitle,
                fileNameBase: fileNameBase
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Assessment PDF download failed:", e);
            Error.showError({
                code: "validation_error",
                message: "Unable to download assessment PDF. Please try again."
            });
        } finally{
            setIsDownloadingPdf(false);
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.OverlayTrigger), {
        placement: "bottom",
        overlay: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Tooltip), {
            id: "download-assessment-tooltip"
        }, "Download PDF")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-inline-flex align-items-center", className)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $dc3e8dc1c67b3a4b$export$2e2bcd8739ae039), {
        onClick: handleDownloadPdf,
        disabled: isDownloadingPdf,
        isLoading: isDownloadingPdf,
        size: iconSize,
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex align-self-center", {
            "cursor-pointer": !isDownloadingPdf
        })
    })));
};
$2804ed17bfb2a01c$var$AssessmentPdfDownload.propTypes = {
    survey: (0, ($parcel$interopDefault($feLGi$proptypes))).object,
    assessmentType: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS,
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY,
        (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).LEADER
    ]).isRequired,
    awarenessSurvey: (0, ($parcel$interopDefault($feLGi$proptypes))).object,
    assessmentTitle: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    assessmentSubtitle: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    fileNameBase: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    className: (0, ($parcel$interopDefault($feLGi$proptypes))).string,
    iconSize: (0, ($parcel$interopDefault($feLGi$proptypes))).number
};
var $2804ed17bfb2a01c$export$2e2bcd8739ae039 = $2804ed17bfb2a01c$var$AssessmentPdfDownload;







const $05257cc48a8ffec7$var$MANAGER_EFFICACY_ID = "62963961a279e16eeb3aa867";
const $05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID = "5b46b176ce416b175ff98e17";
const $05257cc48a8ffec7$var$perceivedAwarenessKeyTitle = "Perceived Awareness";
const $05257cc48a8ffec7$var$managerEfficacyBGColor = "#84A07C";
const $05257cc48a8ffec7$var$perceivedAwarenessBGColor = "#4978AB";
const $05257cc48a8ffec7$var$tableMaxWidth = 1080;
const $05257cc48a8ffec7$var$tableMinWidth = 1024;
const $05257cc48a8ffec7$var$conditionMatched = typeof window !== "undefined" && window.innerWidth <= $05257cc48a8ffec7$var$tableMaxWidth && window.innerWidth >= $05257cc48a8ffec7$var$tableMinWidth;
const $05257cc48a8ffec7$var$categoryAudioEleId = "category-audio";
const $05257cc48a8ffec7$var$LeaderAssessmentResult = ({ isRenderOnClientSide: isRenderOnClientSide = true , source: source , id: id , compareDateWise: compareDateWise , awarenessSurvey: awarenessSurvey , leaderSurvey: leaderSurvey , isFetchData: isFetchData , isDateArrayLoading: isDateArrayLoading , dateArray: dateArray , clickOnLearnMoreBtn: clickOnLearnMoreBtn = ()=>{} , onGoBack: onGoBack = ()=>{}  })=>{
    var _leaderSurvey_results, _leaderSurvey_results1, _leaderSurvey_results2;
    const { categories: categories  } = leaderSurvey;
    // Match Awareness admin client-view: enable category audio on admin result pages
    const showCategoryAudio = !isRenderOnClientSide;
    const [comparisonChartTitleArray, setComparisonChartTitleArrray] = (0, $feLGi$react.useState)([]);
    const { isXSScreen: isXSScreen , isLGScreen: isLGScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    const [perceivedArray, setPerceivedArray] = (0, $feLGi$react.useState)([]);
    const [selfAwarenessArray, setSelfAwarenessArray] = (0, $feLGi$react.useState)([]);
    const [comparisonArray, setComparisonArray] = (0, $feLGi$react.useState)([]);
    const [selfAwarenessKeyTitle, setSelfAwarenessKeyTitle] = (0, $feLGi$react.useState)("");
    const [managerEfficacyKeyTitle, setManagerEfficacyKeyTitle] = (0, $feLGi$react.useState)("");
    const [awarenessSurveyTitlePercent, setAwarenessSurveyTitlePercent] = (0, $feLGi$react.useState)({});
    const [mediaUrl, setMediaUrl] = (0, $feLGi$react.useState)(null);
    const [loadedAudioId, setLoadedAudioId] = (0, $feLGi$react.useState)(null);
    const audioProps = showCategoryAudio ? {
        setMediaUrl: setMediaUrl,
        loadedAudioId: loadedAudioId,
        setLoadedAudioId: setLoadedAudioId,
        pauseOthers: true
    } : null;
    const getValueByIdFromLeaderSurvey = (categoryId, queryKey)=>{
        return leaderSurvey === null || leaderSurvey === void 0 ? void 0 : leaderSurvey.results[categoryId][queryKey];
    };
    const getSubCategoryValueByKey = (subcategories, key, queryKey)=>{
        return subcategories[key][queryKey];
    };
    const getCategoryName = (categoryId)=>{
        var _categories_find;
        return (_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === categoryId)) === null || _categories_find === void 0 ? void 0 : _categories_find.title;
    };
    const getCategoryDescription = (categoryId)=>{
        var _categories_find;
        return (_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === categoryId)) === null || _categories_find === void 0 ? void 0 : _categories_find.description;
    };
    const getPerceivedArrayForComparison = ()=>{
        const idsArray = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "order");
        const perceivedSubcategories = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "subcategories");
        const resultArr = idsArray.map((idProp)=>{
            var _perceivedSubcategories_idProp;
            return (_perceivedSubcategories_idProp = perceivedSubcategories[idProp]) === null || _perceivedSubcategories_idProp === void 0 ? void 0 : _perceivedSubcategories_idProp.percent;
        });
        setPerceivedArray(resultArr);
    };
    const getSelfAwarenessArrayForComparison = ()=>{
        var _awarenessSurvey_results;
        const idsArray = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "order");
        const keyArray = [];
        idsArray.forEach((categoryId)=>{
            var _categories_find;
            keyArray.push((_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e._id) === categoryId;
            })) === null || _categories_find === void 0 ? void 0 : _categories_find.key);
        });
        const { subcategories: subcategories  } = awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : _awarenessSurvey_results.self_awareness;
        const resultArray = keyArray.map((key)=>{
            var _subcategories_key;
            return (_subcategories_key = subcategories[key]) === null || _subcategories_key === void 0 ? void 0 : _subcategories_key.percent;
        });
        setSelfAwarenessArray(resultArray);
    };
    const getComparisonChartTitleArray = ()=>{
        var _awarenessSurvey_results, _awarenessSurvey_results_self_awareness;
        const idsArray = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "order");
        const keyArray = [];
        idsArray.forEach((categoryId)=>{
            var _categories_find;
            keyArray.push((_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e._id) === categoryId;
            })) === null || _categories_find === void 0 ? void 0 : _categories_find.key);
        });
        const mainArr = [];
        const selfAwarenessSubcategories = awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness = _awarenessSurvey_results.self_awareness) === null || _awarenessSurvey_results_self_awareness === void 0 ? void 0 : _awarenessSurvey_results_self_awareness.subcategories;
        keyArray.forEach((keyProp)=>{
            var _selfAwarenessSubcategories_keyProp;
            mainArr.push((_selfAwarenessSubcategories_keyProp = selfAwarenessSubcategories[keyProp]) === null || _selfAwarenessSubcategories_keyProp === void 0 ? void 0 : _selfAwarenessSubcategories_keyProp.title);
        });
        setComparisonChartTitleArrray(mainArr);
    };
    const getComparisonArray = ()=>{
        var _awarenessSurvey_results, _awarenessSurvey_results_self_awareness;
        const idsArray = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "order");
        const keyArray = [];
        idsArray.forEach((categoryId)=>{
            var _categories_find;
            keyArray.push((_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e._id) === categoryId;
            })) === null || _categories_find === void 0 ? void 0 : _categories_find.key);
        });
        const mainArr = [];
        const selfAwarenessSubcategories = awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness = _awarenessSurvey_results.self_awareness) === null || _awarenessSurvey_results_self_awareness === void 0 ? void 0 : _awarenessSurvey_results_self_awareness.subcategories;
        const perceivedSubcategories = getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "subcategories");
        keyArray.forEach((keyProp)=>{
            var _categories_find, _selfAwarenessSubcategories_keyProp, _selfAwarenessSubcategories_keyProp1, _perceivedSubcategories_categories_find__id, _categories_find1;
            mainArr.push({
                id: (_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                    return (e === null || e === void 0 ? void 0 : e.key) === keyProp;
                })) === null || _categories_find === void 0 ? void 0 : _categories_find._id,
                title: (_selfAwarenessSubcategories_keyProp = selfAwarenessSubcategories[keyProp]) === null || _selfAwarenessSubcategories_keyProp === void 0 ? void 0 : _selfAwarenessSubcategories_keyProp.title,
                selfAwarenessValue: (_selfAwarenessSubcategories_keyProp1 = selfAwarenessSubcategories[keyProp]) === null || _selfAwarenessSubcategories_keyProp1 === void 0 ? void 0 : _selfAwarenessSubcategories_keyProp1.percent,
                perceivedValue: (_perceivedSubcategories_categories_find__id = perceivedSubcategories[(_categories_find1 = categories === null || categories === void 0 ? void 0 : categories.find((c)=>{
                    return (c === null || c === void 0 ? void 0 : c.key) === keyProp;
                })) === null || _categories_find1 === void 0 ? void 0 : _categories_find1._id]) === null || _perceivedSubcategories_categories_find__id === void 0 ? void 0 : _perceivedSubcategories_categories_find__id.percent
            });
        });
        setComparisonArray(mainArr);
    };
    (0, $feLGi$react.useEffect)(()=>{
        if (awarenessSurvey) {
            var _categories_find, _categories_find1, _awarenessSurvey_results, _awarenessSurvey_results_self_awareness, _awarenessSurvey_results1, _awarenessSurvey_results_self_awareness1;
            getComparisonChartTitleArray();
            getPerceivedArrayForComparison();
            getSelfAwarenessArrayForComparison();
            getComparisonArray();
            setSelfAwarenessKeyTitle((_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID)) === null || _categories_find === void 0 ? void 0 : _categories_find.title);
            setManagerEfficacyKeyTitle((_categories_find1 = categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$MANAGER_EFFICACY_ID)) === null || _categories_find1 === void 0 ? void 0 : _categories_find1.title);
            setAwarenessSurveyTitlePercent({
                title: awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results = awarenessSurvey.results) === null || _awarenessSurvey_results === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness = _awarenessSurvey_results.self_awareness) === null || _awarenessSurvey_results_self_awareness === void 0 ? void 0 : _awarenessSurvey_results_self_awareness.title,
                percent: awarenessSurvey === null || awarenessSurvey === void 0 ? void 0 : (_awarenessSurvey_results1 = awarenessSurvey.results) === null || _awarenessSurvey_results1 === void 0 ? void 0 : (_awarenessSurvey_results_self_awareness1 = _awarenessSurvey_results1.self_awareness) === null || _awarenessSurvey_results_self_awareness1 === void 0 ? void 0 : _awarenessSurvey_results_self_awareness1.percent
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        awarenessSurvey
    ]);
    if (!awarenessSurvey || !leaderSurvey) return null;
    const scoreCardWidth = $05257cc48a8ffec7$var$conditionMatched || isXSScreen ? "14rem" : "19.5rem";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reacthelmet.Helmet), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("title", null, "Leader Result | Abroad"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("meta", {
        name: "title",
        content: "Leader Result | Abroad"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("meta", {
        property: "og:title",
        content: "Leader Result | Abroad"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("meta", {
        property: "twitter:title",
        content: "Leader Result | Abroad"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("link", {
        rel: "canonical",
        href: `${source}/survey/leader/${id}`
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("meta", {
        property: "og:url",
        content: `${source}/survey/leader/${id}`
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("meta", {
        property: "twitter:url",
        content: `${source}/survey/leader/${id}`
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("main", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $046f139f7bee52e1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("wisdom-assessment", {
            "custom-offset-lg-1 custom-col-lg-12 px-0": !isRenderOnClientSide
        })
    }, !isRenderOnClientSide && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true,
        className: "px-0 pt-4 mb-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-left"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn mr-lg-4 mr-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s1 tracking-normal mb-0"
    }, (0, $b5f12f83c4275d44$export$e3c9dc9ffebfa801), ` - ${(0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(leaderSurvey === null || leaderSurvey === void 0 ? void 0 : (_leaderSurvey_results = leaderSurvey.results) === null || _leaderSurvey_results === void 0 ? void 0 : _leaderSurvey_results.createdAt, "MMMM Do, YYYY")}`), (leaderSurvey === null || leaderSurvey === void 0 ? void 0 : leaderSurvey.results) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $2804ed17bfb2a01c$export$2e2bcd8739ae039), {
        survey: leaderSurvey,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).LEADER,
        awarenessSurvey: awarenessSurvey,
        className: "ml-3 ms-3"
    }))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true,
        className: "px-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-52px d-flex justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-lg-row flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 12,
        md: 12,
        sm: 12,
        className: "text-center d-lg-flex justify-content-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: managerEfficacyKeyTitle,
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        category: categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$MANAGER_EFFICACY_ID),
        onLearnMoreClick: ()=>{
            clickOnLearnMoreBtn(categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$MANAGER_EFFICACY_ID));
        },
        percentage: getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$MANAGER_EFFICACY_ID, "percent"),
        wrapperClasses: "mr-lg-36px",
        outerBackgroudColor: "#E0E7DE",
        innerBackgroudColor: $05257cc48a8ffec7$var$managerEfficacyBGColor,
        width: scoreCardWidth,
        height: "14.745rem",
        titlePosition: "top"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: $05257cc48a8ffec7$var$perceivedAwarenessKeyTitle,
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        category: categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID),
        onLearnMoreClick: ()=>{
            clickOnLearnMoreBtn(categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID));
        },
        percentage: getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "percent"),
        wrapperClasses: "ml-lg-36px mt-lg-0 mt-4",
        outerBackgroudColor: "rgba(73, 120, 171, 0.25)",
        innerBackgroudColor: $05257cc48a8ffec7$var$perceivedAwarenessBGColor,
        width: scoreCardWidth,
        height: "14.745rem",
        titlePosition: "top"
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($05257cc48a8ffec7$var$DirectReportsStats, {
        totalRequestsCompletedCount: leaderSurvey === null || leaderSurvey === void 0 ? void 0 : leaderSurvey.totalRequestsCompletedCount,
        totalRequestsCount: leaderSurvey === null || leaderSurvey === void 0 ? void 0 : leaderSurvey.totalRequestsCount,
        workingRelationshipPercentage: leaderSurvey === null || leaderSurvey === void 0 ? void 0 : (_leaderSurvey_results1 = leaderSurvey.results) === null || _leaderSurvey_results1 === void 0 ? void 0 : _leaderSurvey_results1.workingRelationshipPercentage,
        personalRelationshipPercentage: leaderSurvey === null || leaderSurvey === void 0 ? void 0 : (_leaderSurvey_results2 = leaderSurvey.results) === null || _leaderSurvey_results2 === void 0 ? void 0 : _leaderSurvey_results2.personalRelationshipPercentage
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-result-info-text s5 mb-52px py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "text-center mb-0 s6a font-weight-500"
    }, "To better understand your results, we recommend listening to the audios that describes the context of each category. For further information on each subcategory, simply click on the corresponding info icons.")), showCategoryAudio && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("audio", {
        id: $05257cc48a8ffec7$var$categoryAudioEleId,
        allow: "autoplay"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("source", {
        src: mediaUrl
    }), "Your browser does not support the ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("code", null, "audio"), " element."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($05257cc48a8ffec7$var$EfficacySubCategorySection, {
        managerEfficacyKeyTitle: managerEfficacyKeyTitle,
        categories: categories,
        clickOnLearnMoreBtn: clickOnLearnMoreBtn,
        getValueByIdFromLeaderSurvey: getValueByIdFromLeaderSurvey,
        getCategoryName: getCategoryName,
        getSubCategoryValueByKey: getSubCategoryValueByKey,
        getCategoryDescription: getCategoryDescription,
        isLGScreen: isLGScreen,
        showCategoryAudio: showCategoryAudio,
        mediaUrl: (0, $97b09ac2977ad497$export$8af87c63ff2e23b5),
        categoryKeyName: "manager_efficacy",
        ...audioProps || {}
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($05257cc48a8ffec7$var$AwarenessGapSection, {
        selfAwarenessKeyTitle: selfAwarenessKeyTitle,
        getValueByIdFromLeaderSurvey: getValueByIdFromLeaderSurvey,
        awarenessSurveyTitlePercent: awarenessSurveyTitlePercent,
        comparisonChartTitleArray: comparisonChartTitleArray,
        perceivedArray: perceivedArray,
        selfAwarenessArray: selfAwarenessArray,
        isDateArrayLoading: isDateArrayLoading,
        dateArray: dateArray,
        compareDateWise: compareDateWise,
        isFetchData: isFetchData,
        isXSScreen: isXSScreen,
        showCategoryAudio: showCategoryAudio,
        mediaUrl: (0, $97b09ac2977ad497$export$ab403d451b1a5674),
        categoryKeyName: "perceived_self_awareness",
        ...audioProps || {}
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($05257cc48a8ffec7$var$CompareSubCategorySection, {
        comparisonArray: comparisonArray,
        getCategoryDescription: getCategoryDescription
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f5e2cc126c098556$export$2e2bcd8739ae039), null))));
};
const $05257cc48a8ffec7$var$DirectReportsStats = ({ totalRequestsCompletedCount: totalRequestsCompletedCount , totalRequestsCount: totalRequestsCount , workingRelationshipPercentage: workingRelationshipPercentage , personalRelationshipPercentage: personalRelationshipPercentage  })=>{
    const renderResponseConnection = (value, label)=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            lg: 4,
            md: 4,
            sm: 12,
            className: "mb-2 d-flex flex-column text-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex justify-content-center align-items-center mb-lg-3 mb-1"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
            className: "text-saffron-300 s2 report-score mb-0"
        }, value)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "s10a align-self-center text-white"
        }, label));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "direct-reports mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-between"
    }, renderResponseConnection(`${totalRequestsCompletedCount}/${totalRequestsCount}`, "RESPONSES COMPLETE"), renderResponseConnection(`${workingRelationshipPercentage}%`, "PROFESSIONAL CONNECTION"), renderResponseConnection(`${personalRelationshipPercentage}%`, "PERSONAL CONNECTION")));
};
const $05257cc48a8ffec7$var$EfficacySubCategorySection = ({ managerEfficacyKeyTitle: managerEfficacyKeyTitle , categories: categories , clickOnLearnMoreBtn: clickOnLearnMoreBtn , getValueByIdFromLeaderSurvey: getValueByIdFromLeaderSurvey , getCategoryName: getCategoryName , getSubCategoryValueByKey: getSubCategoryValueByKey , getCategoryDescription: getCategoryDescription , isLGScreen: isLGScreen , showCategoryAudio: showCategoryAudio = false , mediaUrl: mediaUrl , setMediaUrl: setMediaUrl , loadedAudioId: loadedAudioId , setLoadedAudioId: setLoadedAudioId , pauseOthers: pauseOthers , categoryKeyName: categoryKeyName  })=>{
    const tableRef = (0, $feLGi$react.useRef)(null);
    const [height, setHeight] = (0, $feLGi$react.useState)(0);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const category = categories === null || categories === void 0 ? void 0 : categories.find((e)=>e._id === $05257cc48a8ffec7$var$MANAGER_EFFICACY_ID);
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    (0, $feLGi$react.useLayoutEffect)(()=>{
        if (tableRef.current) setHeight(tableRef.current.clientHeight);
    }, []);
    (0, $feLGi$react.useEffect)(()=>{
        function handleWindowResize() {
            if (tableRef.current) setHeight(tableRef.current.clientHeight);
        }
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-chart text-center align-self-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: managerEfficacyKeyTitle,
        linkClasses: "s11 mb-0 text-white cursor-pointer",
        category: category,
        onLearnMoreClick: ()=>{
            clickOnLearnMoreBtn(category);
        },
        percentage: getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$MANAGER_EFFICACY_ID, "percent"),
        variant: "table-attached-card",
        outerBackgroudColor: "#E0E7DE",
        innerBackgroudColor: $05257cc48a8ffec7$var$managerEfficacyBGColor,
        width: "15.79rem",
        height: isLGScreen || $05257cc48a8ffec7$var$conditionMatched ? `${height}px` : "22.437rem"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-score mt-lg-0 mt-4",
        ref: tableRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between mb-18px pt-0 px-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, showCategoryAudio && mediaUrl && setMediaUrl && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $36c899ccb50671c8$export$2e2bcd8739ae039), {
        key: categoryKeyName,
        categoryKeyName: categoryKeyName,
        mediaUrl: mediaUrl,
        setMediaUrl: setMediaUrl,
        loadedAudioId: loadedAudioId,
        setLoadedAudioId: setLoadedAudioId,
        pauseOthers: pauseOthers
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, managerEfficacyKeyTitle)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none",
        onClick: ()=>{
            onShow();
            setModalData(category);
            clickOnLearnMoreBtn(category);
        }
    })), getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$MANAGER_EFFICACY_ID, "order").map((subcategoryId, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "survey-subcat-link py-18px",
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("courses-title-row", {
                "first-row": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            onMouseEnter: ()=>setRowNumber(index),
            onMouseLeave: ()=>setRowNumber(null)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "s6 text-black hover-text-bold"
        }, getCategoryName(subcategoryId))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "text-manager-efficacy s6 hover-text-bold"
        }, Number.isInteger(getSubCategoryValueByKey(getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$MANAGER_EFFICACY_ID, "subcategories"), subcategoryId, "percent")) ? `${getSubCategoryValueByKey(getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$MANAGER_EFFICACY_ID, "subcategories"), subcategoryId, "percent")}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f4239ec5e13392b$export$2e2bcd8739ae039), {
            contentText: getCategoryDescription(subcategoryId)
        }))))))));
};
const $05257cc48a8ffec7$var$AwarenessGapSection = ({ selfAwarenessKeyTitle: selfAwarenessKeyTitle , getValueByIdFromLeaderSurvey: getValueByIdFromLeaderSurvey , awarenessSurveyTitlePercent: awarenessSurveyTitlePercent , comparisonChartTitleArray: comparisonChartTitleArray , perceivedArray: perceivedArray , selfAwarenessArray: selfAwarenessArray , isDateArrayLoading: isDateArrayLoading , dateArray: dateArray , compareDateWise: compareDateWise , isFetchData: isFetchData , isXSScreen: isXSScreen , showCategoryAudio: showCategoryAudio = false , mediaUrl: mediaUrl , setMediaUrl: setMediaUrl , loadedAudioId: loadedAudioId , setLoadedAudioId: setLoadedAudioId , pauseOthers: pauseOthers , categoryKeyName: categoryKeyName  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "awareness-gap mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex mb-12px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center justify-content-between"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, showCategoryAudio && mediaUrl && setMediaUrl && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $36c899ccb50671c8$export$2e2bcd8739ae039), {
        key: categoryKeyName,
        categoryKeyName: categoryKeyName,
        mediaUrl: mediaUrl,
        setMediaUrl: setMediaUrl,
        loadedAudioId: loadedAudioId,
        setLoadedAudioId: setLoadedAudioId,
        pauseOthers: pauseOthers,
        iconClasses: "mr-4"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s3 title mb-0"
    }, "Self Awareness Gap Analysis")))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "s5 mb-52px"
    }, "This is a tool to compare your Self Awareness scores from your Abroad Awareness Assessment with the Perceived Awareness scores provided by your direct reports. As leaders, there may be times when we are not seeing ourselves clearly. For example, we might believe we are handling our stress gracefully, while our team members feel that our stress is having an impact on our energy and actions."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 4,
        md: 12,
        sm: 12,
        className: "d-flex flex-column justify-content-between"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "order-lg-1 order-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center mr-3 mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-manager manager-result-compare-circle m-0 mr-3"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("s5", {
            "overflow-category-name": !isXSScreen
        })
    }, selfAwarenessKeyTitle, " (", getValueByIdFromLeaderSurvey($05257cc48a8ffec7$var$PERCEIVED_AWARENESS_ID, "percent"), "%)")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center mr-3 mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-light-blue-manager manager-result-compare-square m-0 mr-3"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "s5"
    }, awarenessSurveyTitlePercent === null || awarenessSurveyTitlePercent === void 0 ? void 0 : awarenessSurveyTitlePercent.title, " (", awarenessSurveyTitlePercent === null || awarenessSurveyTitlePercent === void 0 ? void 0 : awarenessSurveyTitlePercent.percent, "%)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "leader-select order-lg-2 order-1 pb-lg-0 pb-3"
    }, isDateArrayLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Spinner), {
        animation: "border",
        className: "text-saffron-700",
        role: "status",
        size: "sm"
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $e28d628c3e837aec$export$2e2bcd8739ae039), {
        setFirstDefault: "true",
        name: "user-pl",
        options: dateArray,
        onChange: (e)=>{
            return compareDateWise(e === null || e === void 0 ? void 0 : e.value);
        },
        isLoading: isFetchData
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 2,
        md: 12,
        sm: 12
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 4,
        md: 12,
        sm: 12
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        className: "mb-0",
        categories: comparisonChartTitleArray,
        backgroundColor: "#f3f6f6",
        colors: [
            "#4978ab",
            "#69b1d8"
        ],
        surveyOne: perceivedArray,
        surveyTwo: selfAwarenessArray
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 2,
        md: 12,
        sm: 12
    })));
};
const $05257cc48a8ffec7$var$CompareSubCategorySection = ({ comparisonArray: comparisonArray , getCategoryDescription: getCategoryDescription  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        className: "custom-table compare-subcatgory-table mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "40%",
        className: "pl-0"
    }, "SUBCATEGORY"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%",
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-manager manager-result-compare-circle small-size-circle m-0-auto"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%",
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-light-blue-manager manager-result-compare-square small-size-square m-0-auto"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%",
        className: "text-center"
    }, "DIFFERENCE (+/-)"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, comparisonArray.map((e, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
            key: index,
            className: "cursor-pointer"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "40%",
            className: "pl-0"
        }, e === null || e === void 0 ? void 0 : e.title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "15%",
            className: "text-center text-blue-manager"
        }, e === null || e === void 0 ? void 0 : e.perceivedValue, "%"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "20%",
            className: "text-center text-light-blue-manager"
        }, e === null || e === void 0 ? void 0 : e.selfAwarenessValue, "%"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "10%",
            className: "text-center"
        }, (e === null || e === void 0 ? void 0 : e.perceivedValue) - (e === null || e === void 0 ? void 0 : e.selfAwarenessValue), "%"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            className: "text-right pr-0"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f4239ec5e13392b$export$2e2bcd8739ae039), {
            contentText: getCategoryDescription(e === null || e === void 0 ? void 0 : e.id)
        })));
    })));
};
var $05257cc48a8ffec7$export$2e2bcd8739ae039 = $05257cc48a8ffec7$var$LeaderAssessmentResult;












const $72e091e8719e10ec$var$TakeNewAssessment = ({ variant: variant , className: className , title: title , wrapperProps: wrapperProps , getTypeFormLink: getTypeFormLink = false , API: API , type: type = (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY , gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction , ...rest })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [error, setError] = (0, $feLGi$react.useState)(null);
    const [link, setLink] = (0, $feLGi$react.useState)("");
    const Notification = (0, $102ddb9add0f5b8b$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getUrl = async ()=>{
            try {
                const { data: data  } = await API.survey.getLink(type);
                setLink(data.link);
                setIsLoading(false);
                if ((data === null || data === void 0 ? void 0 : data.code) === "upgrade_plan") setError(data === null || data === void 0 ? void 0 : data.message);
                else setError(null);
            } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === "survey_limit_reached") setError(e.message);
                setIsLoading(false);
            }
        };
        getUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const takeNewAssessment = ()=>{
        Notification.showNotification(error);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        ...link && {
            href: link,
            target: "_self",
            rel: "noopener noreferrer"
        },
        ...error ? {
            onClick: takeNewAssessment
        } : {
            onClick: gtmAssessmentBtnClickedAction
        },
        ...wrapperProps
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        disabled: isLoading,
        variant: variant,
        className: className,
        ...rest
    }, title || /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, "Take new assessment")));
};
var $72e091e8719e10ec$export$2e2bcd8739ae039 = $72e091e8719e10ec$var$TakeNewAssessment;






const $1e72e0479dbb5016$var$tableMaxWidth = 1080;
const $1e72e0479dbb5016$var$tableMinWidth = 1024;
const $1e72e0479dbb5016$export$9fc0cb86cdf25c75 = window.innerWidth <= $1e72e0479dbb5016$var$tableMaxWidth && window.innerWidth >= $1e72e0479dbb5016$var$tableMinWidth;
const $1e72e0479dbb5016$var$OverviewSurveyResults = ({ survey: survey , onLearnMoreClick: onLearnMoreClick , wrapperClasses: wrapperClasses = "" , titlePosition: titlePosition = "bottom" , titleClasses: titleClasses = ""  })=>{
    var _survey_results, _survey_results_self_understanding, _survey_categories, _survey_categories1, _survey_results1, _survey_results_wisdom__connection, _survey_categories2, _survey_categories3;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-center align-items-center mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 12,
        md: 12,
        sm: 12,
        className: "text-center d-lg-flex justify-content-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: "Self Understanding",
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_self_understanding = _survey_results.self_understanding) === null || _survey_results_self_understanding === void 0 ? void 0 : _survey_results_self_understanding.percent,
        category: (survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.self_understanding) || (survey === null || survey === void 0 ? void 0 : (_survey_categories1 = survey.categories) === null || _survey_categories1 === void 0 ? void 0 : _survey_categories1.find((e)=>e._id === "6639261151fc141698164cb6")),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(18,60,105, 0.25)",
        innerBackgroudColor: "#123C69",
        width: $1e72e0479dbb5016$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        titlePosition: titlePosition,
        titleClasses: titleClasses,
        wrapperClasses: "mr-lg-36px mb-5 mb-lg-0"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: "Wisdom & Connection",
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_wisdom__connection = _survey_results1.wisdom__connection) === null || _survey_results_wisdom__connection === void 0 ? void 0 : _survey_results_wisdom__connection.percent,
        category: (survey === null || survey === void 0 ? void 0 : (_survey_categories2 = survey.categories) === null || _survey_categories2 === void 0 ? void 0 : _survey_categories2.wisdom__connection) || (survey === null || survey === void 0 ? void 0 : (_survey_categories3 = survey.categories) === null || _survey_categories3 === void 0 ? void 0 : _survey_categories3.find((e)=>e._id === "6639261151fc141698164cb7")),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(40,82,56, 0.25)",
        innerBackgroudColor: "#285238",
        width: $1e72e0479dbb5016$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer",
        titlePosition: titlePosition,
        titleClasses: titleClasses,
        wrapperClasses: "mr-lg-36px"
    })));
};
var $1e72e0479dbb5016$export$2e2bcd8739ae039 = $1e72e0479dbb5016$var$OverviewSurveyResults;










const $d36dce4196a820f3$var$SurveySubcategoriesTable = ({ title: title , survey: survey , onLearnMoreClick: onLearnMoreClick , innerBackgroudColor: innerBackgroudColor , outerBackgroudColor: outerBackgroudColor , categoryKeyName: categoryKeyName , wrapperClasses: wrapperClasses , tableClasses: tableClasses , barHeight: barHeight , parentId: parentId  })=>{
    var _survey_results, _survey_results_categoryKeyName, _survey_categories, _survey_results1, _survey_results_categoryKeyName1;
    const tableRef = (0, $feLGi$react.useRef)(null);
    const [height, setHeight] = (0, $feLGi$react.useState)(0);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const { isLGScreen: isLGScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    (0, $feLGi$react.useLayoutEffect)(()=>{
        setHeight(tableRef.current.clientHeight);
    }, []);
    (0, $feLGi$react.useEffect)(()=>{
        function handleWindowResize() {
            setHeight(tableRef.current.clientHeight);
        }
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: wrapperClasses
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-chart text-center align-self-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f67033a3063168fa$export$2e2bcd8739ae039), {
        title: title,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.percent,
        category: survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories[categoryKeyName],
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: outerBackgroudColor,
        innerBackgroudColor: innerBackgroudColor,
        width: "15.79rem",
        height: isLGScreen || (0, $1e72e0479dbb5016$export$9fc0cb86cdf25c75) ? `${height}px` : barHeight,
        linkClasses: "s11 mb-0 text-white cursor-pointer",
        variant: "table-attached-card"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("assessment-score mt-lg-0 mt-4", tableClasses),
        ref: tableRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between mb-18px pt-0 px-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0 "
    }, title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none",
        onClick: ()=>{
            var _survey_categories, _survey_categories_find, _survey_categories1;
            onShow();
            setModalData(survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((e)=>e._id === parentId));
            onLearnMoreClick((_survey_categories_find = survey === null || survey === void 0 ? void 0 : (_survey_categories1 = survey.categories) === null || _survey_categories1 === void 0 ? void 0 : _survey_categories1.find((e)=>e._id === parentId)) === null || _survey_categories_find === void 0 ? void 0 : _survey_categories_find._id);
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.order.map((subcategory, index)=>{
        var _survey_results_categoryKeyName_subcategories_subcategory, _survey_results, _survey_results_categoryKeyName, _survey_results_categoryKeyName_subcategories_subcategory1, _survey_results1, _survey_results_categoryKeyName1, _survey_results_categoryKeyName_subcategories_subcategory2, _survey_results2, _survey_results_categoryKeyName2, _survey_results_categoryKeyName_subcategories_subcategory3, _survey_results3, _survey_results_categoryKeyName3, _survey_categories_find, _survey_categories;
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "survey-subcat-link py-18px",
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("courses-title-row", {
                "first-row": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            "data-id": (_survey_results_categoryKeyName_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory.title,
            onMouseEnter: ()=>{
                setRowNumber(index);
            },
            onMouseLeave: ()=>{
                setRowNumber(null);
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "s6 text-black hover-text-bold"
        }, (_survey_results_categoryKeyName_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory1.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            style: {
                color: innerBackgroudColor
            },
            className: "hover-text-bold s6"
        }, Number.isInteger((_survey_results_categoryKeyName_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_categoryKeyName2 = _survey_results2[categoryKeyName]) === null || _survey_results_categoryKeyName2 === void 0 ? void 0 : _survey_results_categoryKeyName2.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory2.percent) ? `${(_survey_results_categoryKeyName_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_categoryKeyName3 = _survey_results3[categoryKeyName]) === null || _survey_results_categoryKeyName3 === void 0 ? void 0 : _survey_results_categoryKeyName3.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory3.percent}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f4239ec5e13392b$export$2e2bcd8739ae039), {
            contentText: (_survey_categories_find = survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e.key) === subcategory;
            })) === null || _survey_categories_find === void 0 ? void 0 : _survey_categories_find.description
        }))));
    })))));
};
var $d36dce4196a820f3$export$2e2bcd8739ae039 = $d36dce4196a820f3$var$SurveySubcategoriesTable;







const $032ec36ca91264ad$var$SortedSubCategories = ({ results: results , categories: categories  })=>{
    const [sortedSubCategories, setSortedSubCategories] = (0, $feLGi$react.useState)([]);
    const SelfUnderstandingId = "6639261151fc141698164cb6";
    const wisdomAndConnectionId = "6639261151fc141698164cb7";
    (0, $feLGi$react.useEffect)(()=>{
        if (results) {
            var _results_wisdom__connection;
            let subCategories = results.self_understanding.order.map((cat)=>({
                    ...results.self_understanding.subcategories[cat],
                    key: cat,
                    parentId: SelfUnderstandingId
                }));
            subCategories = [
                ...subCategories,
                ...results === null || results === void 0 ? void 0 : (_results_wisdom__connection = results.wisdom__connection) === null || _results_wisdom__connection === void 0 ? void 0 : _results_wisdom__connection.order.map((cat)=>({
                        ...results.wisdom__connection.subcategories[cat],
                        key: cat,
                        parentId: wisdomAndConnectionId
                    }))
            ];
            subCategories = subCategories.sort((a, b)=>b.percent - a.percent);
            setSortedSubCategories(subCategories);
        }
    }, [
        results
    ]);
    const renderSubCategoriesBox = (category, index)=>{
        var _categories_find;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex category-details"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-9"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
            className: "mb-0 s7 hover-text-bold ms-2"
        }, category === null || category === void 0 ? void 0 : category.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-3 d-flex justify-content-end"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("mb-0 align-self-center hover-text-bold s7", {
                "text-blue-600": (category === null || category === void 0 ? void 0 : category.parentId) === SelfUnderstandingId,
                "text-green-500": (category === null || category === void 0 ? void 0 : category.parentId) === wisdomAndConnectionId
            })
        }, `${category.percent}%`), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f4239ec5e13392b$export$2e2bcd8739ae039), {
            contentText: (_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e.key) === (category === null || category === void 0 ? void 0 : category.key);
            })) === null || _categories_find === void 0 ? void 0 : _categories_find.description
        })));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex flex-lg-row flex-column mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 12,
        md: 12,
        sm: 12,
        className: "mb-lg-0 mb-3 d-flex flex-lg-row flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mr-lg-12px w-100 mb-lg-0 mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $1e72e0479dbb5016$export$9fc0cb86cdf25c75),
            s2: !(0, $1e72e0479dbb5016$export$9fc0cb86cdf25c75)
        })
    }, "Celebrations"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(0, 3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category, index))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "ml-lg-12px w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $1e72e0479dbb5016$export$9fc0cb86cdf25c75),
            s2: !(0, $1e72e0479dbb5016$export$9fc0cb86cdf25c75)
        })
    }, "Key Areas for Growth"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(-3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category, index)))))));
};
var $032ec36ca91264ad$export$2e2bcd8739ae039 = $032ec36ca91264ad$var$SortedSubCategories;


const $d1af843886830771$var$WisdomSummaryResult = ({ gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction = ()=>{} , survey: survey  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $1e72e0479dbb5016$export$2e2bcd8739ae039), {
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        titlePosition: "top"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $d36dce4196a820f3$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Self Understanding",
        categoryKeyName: "self_understanding",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#123C69",
        outerBackgroudColor: "rgba(18,60,105, 0.25)",
        barHeight: "22.437rem",
        key: "self_understanding",
        parentId: "6639261151fc141698164cb6"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $d36dce4196a820f3$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Wisdom & Connection",
        categoryKeyName: "wisdom__connection",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#285238",
        outerBackgroudColor: "rgba(40,82,56, 0.25)",
        barHeight: "22.437rem",
        key: "wisdom__connection",
        parentId: "6639261151fc141698164cb7"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $032ec36ca91264ad$export$2e2bcd8739ae039), {
        results: survey === null || survey === void 0 ? void 0 : survey.results,
        categories: survey === null || survey === void 0 ? void 0 : survey.categories
    }));
};
var $d1af843886830771$export$2e2bcd8739ae039 = $d1af843886830771$var$WisdomSummaryResult;







const $c940715c92ec6515$var$GrowthPlanBtn = ({ buttonClasses: buttonClasses = "" , buttonText: buttonText = "Inquire about Growth Plan" , buttonEvent: buttonEvent , gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction  })=>{
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: "saffron",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("btn s10a text-uppercase", buttonClasses),
        onClick: ()=>{
            gtmUpgradeButtonClickedAction(buttonText);
            history.push(`/upgrade-inquiry?plan=${(0, $625df15f91b44219$export$2e2bcd8739ae039).growth.code}`);
        }
    }, buttonText);
};
var $c940715c92ec6515$export$2e2bcd8739ae039 = $c940715c92ec6515$var$GrowthPlanBtn;









const $0b75568b022555cf$var$type = "personal";
const $0b75568b022555cf$var$SurveyPreviousResults = ({ surveyType: surveyType = "awareness" , compareAssessmentEvent: compareAssessmentEvent , gtmCompareAssessmentAction: gtmCompareAssessmentAction , API: API , isRenderOnAdmin: isRenderOnAdmin  })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [previousResults, setPreviousResults] = (0, $feLGi$react.useState)([]);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const { id: id , clientId: clientId  } = (0, $feLGi$reactrouterdom.useParams)();
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getSurveys = async ()=>{
            try {
                var _data_surveys;
                const { data: data  } = await API.survey.getSurveys($0b75568b022555cf$var$type, surveyType) // (surveyType, filterBy))
                ;
                if (data && (data === null || data === void 0 ? void 0 : (_data_surveys = data.surveys) === null || _data_surveys === void 0 ? void 0 : _data_surveys.length) > 0) {
                    var _data_surveys1;
                    const filteredData = data === null || data === void 0 ? void 0 : (_data_surveys1 = data.surveys) === null || _data_surveys1 === void 0 ? void 0 : _data_surveys1.filter((survey)=>{
                        return (survey === null || survey === void 0 ? void 0 : survey._id) !== id;
                    });
                    const sortedSurveys = filteredData.sort((a, b)=>{
                        return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(a.createdAt) > (0, ($parcel$interopDefault($feLGi$momenttimezone)))(b.createdAt) ? -1 : 1;
                    });
                    setPreviousResults(sortedSurveys);
                    setIsLoading(false);
                }
            } catch (e) {
                setIsLoading(false);
                Error.showError(e);
            }
        };
        if (id) getSurveys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "previous-result"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "w-25 mb-18px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTitle), {
        line: 1
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTable), {
        row: 2,
        col: 3
    }));
    if ((previousResults === null || previousResults === void 0 ? void 0 : previousResults.length) === 0) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "previous-result"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex mb-18px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "previous-result-title mb-0 ms-2"
    }, "Previous Results")), previousResults === null || previousResults === void 0 ? void 0 : previousResults.map((survey, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, (survey === null || survey === void 0 ? void 0 : survey._id) !== id && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: index,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("result-link d-flex justify-content-between assessment-result-link", {
                "first-result-link": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            onMouseEnter: ()=>{
                setRowNumber(index);
            },
            onMouseLeave: ()=>{
                setRowNumber(null);
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: isRenderOnAdmin ? `/wisdom/${survey === null || survey === void 0 ? void 0 : survey._id}/clients/${clientId}` : `${surveyType === "awareness" ? "/survey" : "/wisdom"}/${survey === null || survey === void 0 ? void 0 : survey._id}`,
            target: isRenderOnAdmin ? "_blank" : undefined,
            rel: isRenderOnAdmin ? "noopener noreferrer" : undefined,
            className: "result-active-link hover-text-bold ms-2 assessment-result-link"
        }, (0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(survey === null || survey === void 0 ? void 0 : survey.createdAt, "MMMM Do YYYY")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: `${surveyType === "awareness" ? "/survey" : "/wisdom"}/comparison-report?survey=${id}&survey=${survey === null || survey === void 0 ? void 0 : survey._id}&surveyType=${surveyType}`,
            onClick: ()=>gtmCompareAssessmentAction(),
            className: "s11 align-self-center cursor-pointer text-saffron-700 text-decoration-none hover-text-bold me-2"
        }, "Compare")));
    }));
};
var $0b75568b022555cf$export$2e2bcd8739ae039 = $0b75568b022555cf$var$SurveyPreviousResults;





const $4981807084a09ca7$var$CustomDropdownToggle = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).forwardRef(({ children: children , onClick: onClick  }, ref)=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        ref: ref,
        onClick: (e)=>{
            e.preventDefault();
            onClick(e);
        }
    }, children);
});
var $4981807084a09ca7$export$2e2bcd8739ae039 = $4981807084a09ca7$var$CustomDropdownToggle;






const $62ffb3622b928f7d$export$91ee5070df9c3469 = window.innerWidth > 1080;
const $62ffb3622b928f7d$export$42dd0d1ed0cf3d7c = window.innerWidth > 576 && window.innerWidth < 768;
const $62ffb3622b928f7d$export$587fdaad9f4198d8 = window.innerWidth > 768 && window.innerWidth < 1080;
const $62ffb3622b928f7d$export$3a3f8dfd69f3fd8 = (string, maxWords, forceDots = false)=>{
    if (!string) return string;
    const strippedString = string.trim();
    const array = strippedString.split(" ");
    const wordCount = array.length;
    let resultString = array.splice(0, maxWords).join(" ");
    if (resultString.length > 22) resultString = resultString.substr(0, 21);
    if (wordCount > maxWords || forceDots) resultString += "...";
    return resultString;
};
const $62ffb3622b928f7d$export$bb982375c1b0798f = /^[A-Za-z\s-]+$/;


const $e841dd9ba70a7ecf$var$ErrorView = ({ redirectToHomepage: redirectToHomepage = ()=>{} , i18n: i18n  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative h-100 w-100 vh-100 vw-100 not-found"
    }, (0, $62ffb3622b928f7d$export$91ee5070df9c3469) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
        className: "lazyload w-100 h-lg-100",
        imgixParams: {
            ar: "16:9",
            fil: "crop",
            auto: "format"
        },
        src: `${process.env.REACT_APP_IMG_SOURCE}/not-found.png`
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
        className: "lazyload vh-100 h-md-100 vw-100",
        imgixParams: {
            ar: "16:9",
            fil: "crop",
            auto: "format"
        },
        src: `${process.env.REACT_APP_IMG_SOURCE}/not-found-sm.png`
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true,
        className: "position-absolute inset-0 h-100 p-lg-5 p-md-5 p-2 text-lg-left text-md-left text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "w-100 h-100 m-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "w-lg-35 w-sm-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "font-lg-24 font-md-24 font-sm-14 font-weight-medium text-break"
    }, "Something went wrong! Please try again later.")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "font-lg-24 font-md-24 tracking-lg-wide home-link"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        onClick: ()=>{
            redirectToHomepage();
            setTimeout(()=>{
                window.location.reload();
            }, 50);
        },
        className: "text-saffron-600 hover:text-saffron-700 cursor:pointer"
    }, "CLICK HERE TO RETURN TO HOME.")))))));
};
var $e841dd9ba70a7ecf$export$2e2bcd8739ae039 = $e841dd9ba70a7ecf$var$ErrorView;






function $1967c4823d3fb15b$var$ContextAwareToggle({ title: title , eventKey: eventKey , callback: callback  }) {
    const currentEventKey = (0, $feLGi$react.useContext)((0, $feLGi$reactbootstrap.AccordionContext));
    const decoratedOnClick = (0, $feLGi$reactbootstrap.useAccordionToggle)(eventKey, ()=>callback && callback(eventKey));
    const isCurrentEventKey = currentEventKey === eventKey;
    const scrollToBottom = ()=>{
        const contentId = document.getElementById("content");
        setTimeout(()=>{
            contentId.scrollTo(0, contentId.scrollHeight);
        }, 250);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        onClick: ()=>{
            decoratedOnClick();
            scrollToBottom();
        },
        className: "font-open-sans font-bold font-24 leading-9 cursor-pointer mb-0 letter-spacing-minus-04"
    }, title, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b5104a1b3db51ba6$export$2e2bcd8739ae039), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("polygon-icon", {
            "rotate-180": isCurrentEventKey
        })
    }));
}
const $1967c4823d3fb15b$var$BottomAccordion = ({ title: title , rightBtn: rightBtn , children: children  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Accordion), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "bottom-accordion",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-between flex-column-reverse flex-md-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "px-0 mt-2 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($1967c4823d3fb15b$var$ContextAwareToggle, {
        eventKey: title,
        title: title
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "px-0 text-md-right"
    }, rightBtn))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Accordion).Collapse, {
        eventKey: title
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, children)));
};
var $1967c4823d3fb15b$export$2e2bcd8739ae039 = $1967c4823d3fb15b$var$BottomAccordion;




const $b0c4be3d31d7f430$var$ArrowWrapper = ({ children: children , parentRef: parentRef , classProps: classProps , parentId: parentId , childId: childId , shiftValueForPrevBtn: shiftValueForPrevBtn = -50 , shiftValueForNextBtn: shiftValueForNextBtn = 50  })=>{
    const [scrollX, setscrollX] = (0, $feLGi$react.useState)(0);
    const [scrolEnd, setscrolEnd] = (0, $feLGi$react.useState)(false);
    const [showArrows, setShowArrows] = (0, $feLGi$react.useState)(false);
    const isLGScreen = window.innerWidth > 1080;
    const tabsScoll = (shift)=>{
        parentRef.current.scrollLeft += shift;
        setscrollX(scrollX + shift);
    };
    (0, $feLGi$react.useEffect)(()=>{
        const nav = document === null || document === void 0 ? void 0 : document.getElementById(childId);
        if (!nav) return undefined;
        // arrows are only needed when the last tab is cut off by the nav's edge.
        // Compare the tab itself, not scrollWidth: wrapper rows with negative
        // margins inflate scrollWidth even when every tab is fully visible.
        const updateArrows = ()=>{
            const tabs = nav.querySelectorAll("a, button");
            const lastTab = tabs[tabs.length - 1];
            const navRight = nav.getBoundingClientRect().right;
            const lastRight = lastTab ? lastTab.getBoundingClientRect().right : navRight;
            setShowArrows(lastRight - navRight > 1 || nav.scrollLeft > 0);
            setscrolEnd(lastRight - navRight <= 1);
        };
        updateArrows();
        window.addEventListener("resize", updateArrows);
        nav.addEventListener("scroll", updateArrows);
        let observer;
        if (typeof ResizeObserver !== "undefined") {
            observer = new ResizeObserver(updateArrows);
            observer.observe(nav);
            const container = document.getElementById(parentId);
            if (container) observer.observe(container);
        }
        return ()=>{
            window.removeEventListener("resize", updateArrows);
            nav.removeEventListener("scroll", updateArrows);
            if (observer) observer.disconnect();
        };
    }, [
        childId,
        parentId,
        classProps
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, showArrows && scrollX !== 0 && isLGScreen && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a69e2c434439138c$export$2e2bcd8739ae039), {
        scollHandler: ()=>tabsScoll(shiftValueForPrevBtn),
        wrapperClasses: "tab-button-prev cursor-pointer"
    }), children, showArrows && !scrolEnd && isLGScreen && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a69e2c434439138c$export$2e2bcd8739ae039), {
        scollHandler: ()=>tabsScoll(shiftValueForNextBtn),
        wrapperClasses: "tab-button-next cursor-pointer"
    }));
};
var $b0c4be3d31d7f430$export$2e2bcd8739ae039 = $b0c4be3d31d7f430$var$ArrowWrapper;









const $aa29f57a76350ed7$var$SidebarDropdown = ({ links: links = [] , name: name , path: path , pathname: pathname , NavLink: NavLink , matchPath: matchPath = ()=>{} , isMenuOpen: isMenuOpen = false , isRenderOnClientSide: isRenderOnClientSide = true , removeDefaultActive: removeDefaultActive = false , linkClasses: linkClasses = "" , listWrapperClasses: listWrapperClasses = "" , icon: icon = null  })=>{
    const [isDropDownOpen, setIsDropDownOpen] = (0, $feLGi$react.useState)(isMenuOpen);
    const [isDropDownItemActive, setIsDropDownItemActive] = (0, $feLGi$react.useState)(false);
    const [matchWord, setMatchWord] = (0, $feLGi$react.useState)(null);
    const discardDefaultMatchPath = [
        "/coach/groups"
    ];
    const discardDefaultMatchWord = [
        "sow-groups",
        ":sowGroupId"
    ];
    const hasMatchAnyDropdownItem = (0, $feLGi$react.useCallback)(()=>{
        if (discardDefaultMatchPath.includes(path) || discardDefaultMatchWord.includes(path.split("/").pop())) return false;
        const hasMatchPath = links === null || links === void 0 ? void 0 : links.map((link)=>link.to === path).includes(true);
        const hasMatchWord = links === null || links === void 0 ? void 0 : links.map((link)=>{
            return link === null || link === void 0 ? void 0 : link.urlWords;
        }).flat(2).some((word)=>pathname.includes(word));
        const matchWordStr = links.map((link)=>{
            return link === null || link === void 0 ? void 0 : link.urlWords;
        }).flat().filter((word)=>{
            return pathname === null || pathname === void 0 ? void 0 : pathname.includes(word);
        }).toString();
        setMatchWord(matchWordStr);
        return hasMatchPath || hasMatchWord;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        links,
        path,
        name,
        pathname
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        const isMatch = hasMatchAnyDropdownItem();
        if (isMatch) {
            setIsDropDownItemActive(true);
            setIsDropDownOpen(true);
        } else {
            setIsDropDownItemActive(false);
            setIsDropDownOpen(false);
        }
        if (isMenuOpen) setIsDropDownOpen(true);
    }, [
        hasMatchAnyDropdownItem,
        pathname,
        isMenuOpen
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("li", {
        className: "nav-item"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        // eslint-disable-next-line no-script-url
        href: "javascript:void(0)",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("nav-link sidebar-link", {
            active: isDropDownItemActive,
            "text-decoration-none s6 line-height-normal": isRenderOnClientSide,
            "pb-2": isDropDownOpen && isRenderOnClientSide,
            "custom-dropdown-link": !isRenderOnClientSide
        }),
        id: "sidebar-navlink",
        onClick: ()=>setIsDropDownOpen(!isDropDownOpen)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactbootstrapRow))), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "align-items-center": !isRenderOnClientSide
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactbootstrapCol))), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("d-flex align-items-center", {
            "font-14 leading-6": !isRenderOnClientSide,
            "text-white text-capitalize s6": isRenderOnClientSide && !isDropDownItemActive,
            "text-saffron-300 text-capitalize s6": isRenderOnClientSide && isDropDownItemActive
        })
    }, icon, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "sidebar-dropdown-heading"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "sidebar-dropdown-label"
    }, name), isRenderOnClientSide ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ab625231f5d78303$export$2e2bcd8739ae039), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("ml-12px flex-shrink-0", {
            active: isDropDownItemActive
        }),
        isDropDownOpen: isDropDownOpen
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $9d132ef5e8deebf2$export$2e2bcd8739ae039), {
        className: "ml-3 flex-shrink-0",
        isDropDownOpen: isDropDownOpen
    }))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("ul", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("nav", {
            "d-none": !isDropDownOpen
        }, {
            "d-flex flex-column show-dropdown-items": isDropDownOpen || isDropDownItemActive && isDropDownOpen
        }, listWrapperClasses)
    }, links === null || links === void 0 ? void 0 : links.map((link, index)=>{
        var _link_urlWords;
        if ((link === null || link === void 0 ? void 0 : link.onlyRC) && !(0, $b5f12f83c4275d44$export$3103d3761b63f14d).includes(window.location.origin)) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("li", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("nav-item"),
            key: link.name
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactbootstrapNav))).Link, {
            to: link.to,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("nav-link", {
                active: removeDefaultActive ? matchPath(pathname, {
                    path: link === null || link === void 0 ? void 0 : link.pageUrls,
                    exact: true,
                    strict: false
                }) : pathname === link.to || (link === null || link === void 0 ? void 0 : (_link_urlWords = link.urlWords) === null || _link_urlWords === void 0 ? void 0 : _link_urlWords.includes(matchWord)),
                "clickable-nav-link mb-2 py-0": isRenderOnClientSide,
                "mb-3": isRenderOnClientSide && index + 1 === (links === null || links === void 0 ? void 0 : links.length),
                "custom-dropdown-link": !isRenderOnClientSide
            }),
            as: NavLink,
            ...removeDefaultActive && {
                isActive: ()=>false
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("mb-0", linkClasses)
        }, link.name)));
    })));
};
var $aa29f57a76350ed7$export$2e2bcd8739ae039 = $aa29f57a76350ed7$var$SidebarDropdown;



const $5ea950ea68d4b864$var$PrintableArea = ({ printSelector: printSelector  })=>{
    const handlePrint = ()=>{
        const printContent = document.querySelector(printSelector);
        if (!printContent) return;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        document.body.style.overflow = "hidden";
        const iframeDoc = iframe.contentWindow.document;
        const styles = Array.from(document.styleSheets).reduce((styleString, sheet)=>{
            try {
                return styleString += sheet.ownerNode.outerHTML;
            } catch (e) {
                return styleString;
            }
        }, "");
        iframeDoc.open();
        iframeDoc.write(`
      <html>
        <head>
          <title>Print</title>
          ${styles}
          <style>
            @media print {
              @page {
                size: auto; 
              }
            }
          </style>
        </head>
        <body>
          ${printContent.outerHTML}
        </body>
      </html>
    `);
        iframeDoc.close();
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(()=>{
            document.body.removeChild(iframe);
        }, 1000);
    };
    (0, $feLGi$react.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ((event.ctrlKey || event.metaKey) && event.key === "p") {
                event.preventDefault();
                handlePrint();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
};
var $5ea950ea68d4b864$export$2e2bcd8739ae039 = $5ea950ea68d4b864$var$PrintableArea;











const $8227729a699e1ad8$var$PdfPreviewModal = ({ show: show , onHide: onHide , buildHtml: buildHtml , emptyMessage: emptyMessage = "No content available for preview."  })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(false);
    const [html, setHtml] = (0, $feLGi$react.useState)("");
    const [errorMessage, setErrorMessage] = (0, $feLGi$react.useState)("");
    (0, $feLGi$react.useEffect)(()=>{
        let isMounted = true;
        const loadPreview = async ()=>{
            if (!show || typeof buildHtml !== "function") return;
            setIsLoading(true);
            setErrorMessage("");
            setHtml("");
            try {
                const nextHtml = await buildHtml();
                if (!isMounted) return;
                setHtml(nextHtml || "");
            } catch (e) {
                if (!isMounted) return;
                setErrorMessage((e === null || e === void 0 ? void 0 : e.message) || "Unable to generate PDF preview. Please try again.");
            } finally{
                if (isMounted) setIsLoading(false);
            }
        };
        loadPreview();
        return ()=>{
            isMounted = false;
        };
    }, [
        show,
        buildHtml
    ]);
    const handleClose = ()=>{
        setHtml("");
        setErrorMessage("");
        setIsLoading(false);
        onHide();
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal), {
        show: show,
        fullscreen: true,
        onHide: handleClose,
        className: "pdf-preview-overlay",
        dialogClassName: "pdf-preview-modal"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal).Body, {
        className: "p-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        type: "button",
        className: "pdf-preview-close",
        onClick: handleClose,
        "aria-label": "Close preview"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $000a07b0d337ce91$export$2e2bcd8739ae039), {
        color: "#0A223C",
        discardMargin: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pdf-preview-body"
    }, isLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pdf-preview-loading"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a41d748d78d3a02e$export$2e2bcd8739ae039), {
        animation: "border"
    })) : errorMessage ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pdf-preview-empty"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "mb-0"
    }, errorMessage)) : !html ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pdf-preview-empty"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "mb-0"
    }, emptyMessage)) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pdf-preview-pages",
        dangerouslySetInnerHTML: {
            __html: html
        }
    }))));
};
$8227729a699e1ad8$var$PdfPreviewModal.propTypes = {
    show: (0, ($parcel$interopDefault($feLGi$proptypes))).bool,
    onHide: (0, ($parcel$interopDefault($feLGi$proptypes))).func,
    buildHtml: (0, ($parcel$interopDefault($feLGi$proptypes))).func,
    emptyMessage: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
var $8227729a699e1ad8$export$2e2bcd8739ae039 = $8227729a699e1ad8$var$PdfPreviewModal;











const $2725f3cac93899b8$var$AssessmentLoader = ({ isWisdom: isWisdom = false  })=>{
    const ShimmerEffect = ()=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
            className: "my-3"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 11
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
            line: 1,
            gap: 20,
            className: "shimmer-text-height"
        })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 1
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
            line: 1,
            gap: 20,
            className: "shimmer-text-height"
        })));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 5
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    }))), isWisdom ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 3,
        className: "mt-5 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4,
        className: "mt-5 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4,
        className: "mt-5 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
        className: "shimmer-text-height mt-2"
    }))), Array.from({
        length: isWisdom ? 2 : 3
    }, (_, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            lg: 4
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex justify-content-sm-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
            height: 450,
            width: 250
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            lg: 8,
            className: "mt-4"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
            size: "md"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null)))), isWisdom ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 470
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 470
    }))) : " ");
};
var $2725f3cac93899b8$export$2e2bcd8739ae039 = $2725f3cac93899b8$var$AssessmentLoader;


const $686360e717aae731$var$WisdomAssessmentResultSection = ({ showEnrollBtn: showEnrollBtn = false , isLGScreen: isLGScreen , API: API , isRenderOnAdmin: isRenderOnAdmin = false , gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction = ()=>{} , gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction = ()=>{} , gtmCompareAssessmentAction: gtmCompareAssessmentAction = ()=>{} , gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction = ()=>{} , renderHeader: renderHeader , AssessmentEvent: AssessmentEvent , apiFunction: apiFunction , clientId: clientId , showHeader: showHeader  })=>{
    const { id: id  } = (0, $feLGi$reactrouterdom.useParams)();
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [survey, setSurvey] = (0, $feLGi$react.useState)(null);
    const { user: user  } = (0, $ca001929343b7efa$export$2e2bcd8739ae039)();
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getWisdomSurveyById = async ()=>{
            setIsLoading(true);
            try {
                const { data: data  } = await apiFunction();
                if (data) setSurvey(data);
                setIsLoading(false);
            } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === "forbidden" || (e === null || e === void 0 ? void 0 : e.code) === "not_taken_survey") {
                    Error.showError(e);
                    history.replace("/home");
                } else if ((e === null || e === void 0 ? void 0 : e.code) === "ValidationError" || (e === null || e === void 0 ? void 0 : e.code) === "resource_not_found" || (e === null || e === void 0 ? void 0 : e.code) === "not_found") history.replace("/404");
                else {
                    setIsLoading(false);
                    Error.showError(e);
                }
            }
        };
        if (id) getWisdomSurveyById();
        else history.replace(isRenderOnAdmin ? "/home" : "/survey");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("main", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("abroad-fs-exclude wisdom-assessment", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": isRenderOnAdmin
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $046f139f7bee52e1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("page-header", {
            "mb-32px": (0, ($parcel$interopDefault($feLGi$momenttimezone)))().diff((0, ($parcel$interopDefault($feLGi$momenttimezone)))(survey === null || survey === void 0 ? void 0 : survey.createdAt), "days") === 0
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-start d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: " s1 tracking-normal mb-0 mt-3"
    }, "Wisdom Assessment", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", {
        className: showEnrollBtn && isLGScreen ? "d-block" : "d-none"
    }), isLoading ? " " : ` - ${(0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(survey === null || survey === void 0 ? void 0 : survey.createdAt, "MMMM Do, YYYY")}`), !isLoading && survey && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $2804ed17bfb2a01c$export$2e2bcd8739ae039), {
        survey: survey,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
        className: "mt-3 ml-3 ms-3"
    })), !showHeader && renderHeader())), isLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $2725f3cac93899b8$export$2e2bcd8739ae039), {
        isWisdom: true
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, !isRenderOnAdmin && (0, ($parcel$interopDefault($feLGi$momenttimezone)))().diff((0, ($parcel$interopDefault($feLGi$momenttimezone)))(survey === null || survey === void 0 ? void 0 : survey.createdAt), "days") >= 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $72e091e8719e10ec$export$2e2bcd8739ae039), {
        variant: "abroad-blue",
        title: "TAKE NEW ASSESSMENT",
        className: "mt-32px mb-32px",
        API: API,
        gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $d1af843886830771$export$2e2bcd8739ae039), {
        gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction,
        survey: survey
    }), !isRenderOnAdmin && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (user === null || user === void 0 ? void 0 : user.planCode) === (0, $625df15f91b44219$export$2e2bcd8739ae039).free.code ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "upgrade-now bg-abroad-blue text-white mt-52px mb-52px border-radius-full"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 text-center text-white mb-0"
    }, "Unleash Unlimited Insights"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h5", {
        className: "mt-3 s5 text-center mb-0"
    }, "Upgrade to the Growth Plan for unlimited access to your Awareness Assessment", " ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", {
        className: "d-lg-block d-none"
    }), " and chart your progress in real-time."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $c940715c92ec6515$export$2e2bcd8739ae039), {
        buttonText: "Inquire about Growth Plan",
        buttonClasses: "btn s10a text-uppercase leading-4 py-12px leading-4 mt-32px",
        buttonEvent: AssessmentEvent,
        gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction
    }))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $0b75568b022555cf$export$2e2bcd8739ae039), {
        compareAssessmentEvent: AssessmentEvent,
        surveyType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
        gtmCompareAssessmentAction: gtmCompareAssessmentAction,
        API: API,
        isRenderOnAdmin: isRenderOnAdmin
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f5e2cc126c098556$export$2e2bcd8739ae039), null), clientId && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, "Assessment User"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Survey Type"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, survey.fullName), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-capitalize"
    }, survey.surveyType))))))))));
};
var $686360e717aae731$export$2e2bcd8739ae039 = $686360e717aae731$var$WisdomAssessmentResultSection;

















const $8c0346575f5896b8$var$WisdomComparisonReport = ({ isLoading: isLoading , preDate: preDate , postDate: postDate , comparisonData: comparisonData , header: header , onGoBack: onGoBack = ()=>{} , isRequiredToFormatDate: isRequiredToFormatDate = true , showGoBackButton: showGoBackButton = true , isRenderFromOP: isRenderFromOP = false , downloadFileNameBase: downloadFileNameBase , props: props  })=>{
    var _comparisonData_, _comparisonData_1, _comparisonData__results_self_understanding_subcategories_time_management__focus, _comparisonData_2, _comparisonData__results_self_understanding_subcategories_fear__attachment, _comparisonData_3, _comparisonData__results_self_understanding_subcategories_burnout_resistance, _comparisonData_4, _comparisonData__results_self_understanding_subcategories_emotional_intelligence, _comparisonData_5, _comparisonData__results_self_understanding_subcategories_self_compassion, _comparisonData_6, _comparisonData__results_self_understanding_subcategories_time_management__focus1, _comparisonData_7, _comparisonData__results_self_understanding_subcategories_fear__attachment1, _comparisonData_8, _comparisonData__results_self_understanding_subcategories_burnout_resistance1, _comparisonData_9, _comparisonData__results_self_understanding_subcategories_emotional_intelligence1, _comparisonData_10, _comparisonData__results_self_understanding_subcategories_self_compassion1, _comparisonData_11, _comparisonData__results_self_understanding_subcategories_time_management__focus2, _comparisonData_12, _comparisonData__results_self_understanding_subcategories_time_management__focus3, _comparisonData_13, _comparisonData__results_self_understanding_subcategories_fear__attachment2, _comparisonData_14, _comparisonData__results_self_understanding_subcategories_fear__attachment3, _comparisonData_15, _comparisonData__results_self_understanding_subcategories_burnout_resistance2, _comparisonData_16, _comparisonData__results_self_understanding_subcategories_burnout_resistance3, _comparisonData_17, _comparisonData__results_self_understanding_subcategories_emotional_intelligence2, _comparisonData_18, _comparisonData__results_self_understanding_subcategories_emotional_intelligence3, _comparisonData_19, _comparisonData__results_self_understanding_subcategories_self_compassion2, _comparisonData_20, _comparisonData__results_self_understanding_subcategories_self_compassion3, _comparisonData_21, _comparisonData__results_wisdom__connection_subcategories_purpose__meaning, _comparisonData_22, _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics, _comparisonData_23, _comparisonData__results_wisdom__connection_subcategories_belonging, _comparisonData_24, _comparisonData__results_wisdom__connection_subcategories_community, _comparisonData_25, _comparisonData__results_wisdom__connection_subcategories_compassion, _comparisonData_26, _comparisonData__results_wisdom__connection_subcategories_nature, _comparisonData_27, _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace, _comparisonData_28, _comparisonData__results_wisdom__connection_subcategories_purpose__meaning1, _comparisonData_29, _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics1, _comparisonData_30, _comparisonData__results_wisdom__connection_subcategories_belonging1, _comparisonData_31, _comparisonData__results_wisdom__connection_subcategories_community1, _comparisonData_32, _comparisonData__results_wisdom__connection_subcategories_compassion1, _comparisonData_33, _comparisonData__results_wisdom__connection_subcategories_nature1, _comparisonData_34, _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace1, _comparisonData_35, _comparisonData__results_wisdom__connection_subcategories_purpose__meaning2, _comparisonData_36, _comparisonData__results_wisdom__connection_subcategories_purpose__meaning3, _comparisonData_37, _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics2, _comparisonData_38, _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics3, _comparisonData_39, _comparisonData__results_wisdom__connection_subcategories_belonging2, _comparisonData_40, _comparisonData__results_wisdom__connection_subcategories_belonging3, _comparisonData_41, _comparisonData__results_wisdom__connection_subcategories_community2, _comparisonData_42, _comparisonData__results_wisdom__connection_subcategories_community3, _comparisonData_43, _comparisonData__results_wisdom__connection_subcategories_compassion2, _comparisonData_44, _comparisonData__results_wisdom__connection_subcategories_compassion3, _comparisonData_45, _comparisonData__results_wisdom__connection_subcategories_nature2, _comparisonData_46, _comparisonData__results_wisdom__connection_subcategories_nature3, _comparisonData_47, _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace2, _comparisonData_48, _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace3, _comparisonData_49;
    // Handle preDate and postDate - they can be strings or arrays
    const preDateStr = Array.isArray(preDate) ? preDate[0] : (preDate === null || preDate === void 0 ? void 0 : preDate.toString()) || "";
    const postDateStr = Array.isArray(postDate) ? postDate[0] : (postDate === null || postDate === void 0 ? void 0 : postDate.toString()) || "";
    const spitedPreDate = preDateStr.split(" - ");
    const spitedPostDate = postDateStr.split(" - ");
    const formatedPreDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(preDateStr).format("MM-DD-YYYY")}`;
    const formatedPostDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(postDateStr).format("MM-DD-YYYY")}`;
    let userDataIndex = 0;
    const preMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(preDate, (_comparisonData_ = comparisonData[0]) === null || _comparisonData_ === void 0 ? void 0 : _comparisonData_.submittedAt);
    const postMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(postDate, (_comparisonData_1 = comparisonData[1]) === null || _comparisonData_1 === void 0 ? void 0 : _comparisonData_1.submittedAt);
    const preQuarter = preMoment.quarter();
    const postQuarter = postMoment.quarter();
    const preYear = preMoment.year();
    const postYear = postMoment.year();
    const comparisonPeriodLabels = [
        formatedPreDate,
        formatedPostDate
    ];
    const comparisonPdfDownload = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $09226703b1b735cd$export$2e2bcd8739ae039), {
        comparisonData: comparisonData,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
        periodLabels: comparisonPeriodLabels,
        assessmentTitle: typeof header === "function" ? header() : typeof header === "string" ? header : "Wisdom Assessment",
        fileNameBase: downloadFileNameBase,
        className: "ml-3"
    });
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f036bbe39d78cd8f$export$2e2bcd8739ae039), null);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "px-0 custom-offset-lg-1 custom-col-lg-12": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pt-4 px-0",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "page-header"
    }, isRenderFromOP ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "icon icon-assessments font-40"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100 justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h2", {
        className: "font-montserrat font-semibold text-dark-600 mb-0"
    }, header()), comparisonPdfDownload))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b6ee68546aeff868$export$2e2bcd8739ae039), {
        showSmallIcon: "true",
        onClick: onGoBack,
        className: "me-2"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "s-captions text-capitalize cursor-pointer",
        onClick: onGoBack
    }, "Wisdom Assessment")), header())), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center mt-minus-04 mb-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s1 mb-0"
    }, "Compare Results"), comparisonPdfDownload))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pb-4",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column text-gray-800 align-items-center font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "The following charts and quantitative data help you see how your Self Understanding, and Wisdom & Connection scores have changed between the two assessment periods you selected."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "We invite you not to be overly concerned with whether your scores have increased or decreased. Sometimes life and business present challenges that require us to change our working habits for a period of time. If an area decreases, that is good awareness around opportunities to course correct. Similarly, if an area increases, we invite you to celebrate, but also not attach to it always being that way.")))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-blue-100"
    }, "Self Understanding"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: " d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Focus & Flow",
            "Fear & Attachment",
            "Burnout Resistance",
            "Emotional Intelligence",
            "Self Compassion"
        ],
        colors: [
            "#69B1d8",
            "#0076BD"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_self_understanding_subcategories_time_management__focus = (_comparisonData_2 = comparisonData[0]) === null || _comparisonData_2 === void 0 ? void 0 : _comparisonData_2.results.self_understanding.subcategories.time_management__focus) === null || _comparisonData__results_self_understanding_subcategories_time_management__focus === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_time_management__focus.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_fear__attachment = (_comparisonData_3 = comparisonData[0]) === null || _comparisonData_3 === void 0 ? void 0 : _comparisonData_3.results.self_understanding.subcategories.fear__attachment) === null || _comparisonData__results_self_understanding_subcategories_fear__attachment === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_fear__attachment.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_burnout_resistance = (_comparisonData_4 = comparisonData[0]) === null || _comparisonData_4 === void 0 ? void 0 : _comparisonData_4.results.self_understanding.subcategories.burnout_resistance) === null || _comparisonData__results_self_understanding_subcategories_burnout_resistance === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_burnout_resistance.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_emotional_intelligence = (_comparisonData_5 = comparisonData[0]) === null || _comparisonData_5 === void 0 ? void 0 : _comparisonData_5.results.self_understanding.subcategories.emotional_intelligence) === null || _comparisonData__results_self_understanding_subcategories_emotional_intelligence === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_emotional_intelligence.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_self_compassion = (_comparisonData_6 = comparisonData[0]) === null || _comparisonData_6 === void 0 ? void 0 : _comparisonData_6.results.self_understanding.subcategories.self_compassion) === null || _comparisonData__results_self_understanding_subcategories_self_compassion === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_self_compassion.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_self_understanding_subcategories_time_management__focus1 = (_comparisonData_7 = comparisonData[1]) === null || _comparisonData_7 === void 0 ? void 0 : _comparisonData_7.results.self_understanding.subcategories.time_management__focus) === null || _comparisonData__results_self_understanding_subcategories_time_management__focus1 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_time_management__focus1.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_fear__attachment1 = (_comparisonData_8 = comparisonData[1]) === null || _comparisonData_8 === void 0 ? void 0 : _comparisonData_8.results.self_understanding.subcategories.fear__attachment) === null || _comparisonData__results_self_understanding_subcategories_fear__attachment1 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_fear__attachment1.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_burnout_resistance1 = (_comparisonData_9 = comparisonData[1]) === null || _comparisonData_9 === void 0 ? void 0 : _comparisonData_9.results.self_understanding.subcategories.burnout_resistance) === null || _comparisonData__results_self_understanding_subcategories_burnout_resistance1 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_burnout_resistance1.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_emotional_intelligence1 = (_comparisonData_10 = comparisonData[1]) === null || _comparisonData_10 === void 0 ? void 0 : _comparisonData_10.results.self_understanding.subcategories.emotional_intelligence) === null || _comparisonData__results_self_understanding_subcategories_emotional_intelligence1 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_emotional_intelligence1.percent),
            parseInt((_comparisonData__results_self_understanding_subcategories_self_compassion1 = (_comparisonData_11 = comparisonData[1]) === null || _comparisonData_11 === void 0 ? void 0 : _comparisonData_11.results.self_understanding.subcategories.self_compassion) === null || _comparisonData__results_self_understanding_subcategories_self_compassion1 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_self_compassion1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Focus & Flow",
        survey0: (_comparisonData__results_self_understanding_subcategories_time_management__focus2 = (_comparisonData_12 = comparisonData[0]) === null || _comparisonData_12 === void 0 ? void 0 : _comparisonData_12.results.self_understanding.subcategories.time_management__focus) === null || _comparisonData__results_self_understanding_subcategories_time_management__focus2 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_time_management__focus2.percent,
        survey1: (_comparisonData__results_self_understanding_subcategories_time_management__focus3 = (_comparisonData_13 = comparisonData[1]) === null || _comparisonData_13 === void 0 ? void 0 : _comparisonData_13.results.self_understanding.subcategories.time_management__focus) === null || _comparisonData__results_self_understanding_subcategories_time_management__focus3 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_time_management__focus3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Fear & Attachment",
        survey0: (_comparisonData__results_self_understanding_subcategories_fear__attachment2 = (_comparisonData_14 = comparisonData[0]) === null || _comparisonData_14 === void 0 ? void 0 : _comparisonData_14.results.self_understanding.subcategories.fear__attachment) === null || _comparisonData__results_self_understanding_subcategories_fear__attachment2 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_fear__attachment2.percent,
        survey1: (_comparisonData__results_self_understanding_subcategories_fear__attachment3 = (_comparisonData_15 = comparisonData[1]) === null || _comparisonData_15 === void 0 ? void 0 : _comparisonData_15.results.self_understanding.subcategories.fear__attachment) === null || _comparisonData__results_self_understanding_subcategories_fear__attachment3 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_fear__attachment3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Burnout Resistance",
        survey0: (_comparisonData__results_self_understanding_subcategories_burnout_resistance2 = (_comparisonData_16 = comparisonData[0]) === null || _comparisonData_16 === void 0 ? void 0 : _comparisonData_16.results.self_understanding.subcategories.burnout_resistance) === null || _comparisonData__results_self_understanding_subcategories_burnout_resistance2 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_burnout_resistance2.percent,
        survey1: (_comparisonData__results_self_understanding_subcategories_burnout_resistance3 = (_comparisonData_17 = comparisonData[1]) === null || _comparisonData_17 === void 0 ? void 0 : _comparisonData_17.results.self_understanding.subcategories.burnout_resistance) === null || _comparisonData__results_self_understanding_subcategories_burnout_resistance3 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_burnout_resistance3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Emotional Intelligence",
        survey0: (_comparisonData__results_self_understanding_subcategories_emotional_intelligence2 = (_comparisonData_18 = comparisonData[0]) === null || _comparisonData_18 === void 0 ? void 0 : _comparisonData_18.results.self_understanding.subcategories.emotional_intelligence) === null || _comparisonData__results_self_understanding_subcategories_emotional_intelligence2 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_emotional_intelligence2.percent,
        survey1: (_comparisonData__results_self_understanding_subcategories_emotional_intelligence3 = (_comparisonData_19 = comparisonData[1]) === null || _comparisonData_19 === void 0 ? void 0 : _comparisonData_19.results.self_understanding.subcategories.emotional_intelligence) === null || _comparisonData__results_self_understanding_subcategories_emotional_intelligence3 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_emotional_intelligence3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Self Compassion",
        survey0: (_comparisonData__results_self_understanding_subcategories_self_compassion2 = (_comparisonData_20 = comparisonData[0]) === null || _comparisonData_20 === void 0 ? void 0 : _comparisonData_20.results.self_understanding.subcategories.self_compassion) === null || _comparisonData__results_self_understanding_subcategories_self_compassion2 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_self_compassion2.percent,
        survey1: (_comparisonData__results_self_understanding_subcategories_self_compassion3 = (_comparisonData_21 = comparisonData[1]) === null || _comparisonData_21 === void 0 ? void 0 : _comparisonData_21.results.self_understanding.subcategories.self_compassion) === null || _comparisonData__results_self_understanding_subcategories_self_compassion3 === void 0 ? void 0 : _comparisonData__results_self_understanding_subcategories_self_compassion3.percent
    })))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-green-100"
    }, "Wisdom & Connection"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: " d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Purpose & Meaning",
            "Ethics & Decision-Making",
            "Belonging",
            "Community",
            "Compassion",
            "Nature",
            "Balance & Inner Peace"
        ],
        colors: [
            "#509f92",
            "#37763B"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_wisdom__connection_subcategories_purpose__meaning = (_comparisonData_22 = comparisonData[0]) === null || _comparisonData_22 === void 0 ? void 0 : _comparisonData_22.results.wisdom__connection.subcategories.purpose__meaning) === null || _comparisonData__results_wisdom__connection_subcategories_purpose__meaning === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_purpose__meaning.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_decision_making__ethics = (_comparisonData_23 = comparisonData[0]) === null || _comparisonData_23 === void 0 ? void 0 : _comparisonData_23.results.wisdom__connection.subcategories.decision_making__ethics) === null || _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_belonging = (_comparisonData_24 = comparisonData[0]) === null || _comparisonData_24 === void 0 ? void 0 : _comparisonData_24.results.wisdom__connection.subcategories.belonging) === null || _comparisonData__results_wisdom__connection_subcategories_belonging === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_belonging.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_community = (_comparisonData_25 = comparisonData[0]) === null || _comparisonData_25 === void 0 ? void 0 : _comparisonData_25.results.wisdom__connection.subcategories.community) === null || _comparisonData__results_wisdom__connection_subcategories_community === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_community.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_compassion = (_comparisonData_26 = comparisonData[0]) === null || _comparisonData_26 === void 0 ? void 0 : _comparisonData_26.results.wisdom__connection.subcategories.compassion) === null || _comparisonData__results_wisdom__connection_subcategories_compassion === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_compassion.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_nature = (_comparisonData_27 = comparisonData[0]) === null || _comparisonData_27 === void 0 ? void 0 : _comparisonData_27.results.wisdom__connection.subcategories.nature) === null || _comparisonData__results_wisdom__connection_subcategories_nature === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_nature.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_balance__inner_peace = (_comparisonData_28 = comparisonData[0]) === null || _comparisonData_28 === void 0 ? void 0 : _comparisonData_28.results.wisdom__connection.subcategories.balance__inner_peace) === null || _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_wisdom__connection_subcategories_purpose__meaning1 = (_comparisonData_29 = comparisonData[1]) === null || _comparisonData_29 === void 0 ? void 0 : _comparisonData_29.results.wisdom__connection.subcategories.purpose__meaning) === null || _comparisonData__results_wisdom__connection_subcategories_purpose__meaning1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_purpose__meaning1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_decision_making__ethics1 = (_comparisonData_30 = comparisonData[1]) === null || _comparisonData_30 === void 0 ? void 0 : _comparisonData_30.results.wisdom__connection.subcategories.decision_making__ethics) === null || _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_belonging1 = (_comparisonData_31 = comparisonData[1]) === null || _comparisonData_31 === void 0 ? void 0 : _comparisonData_31.results.wisdom__connection.subcategories.belonging) === null || _comparisonData__results_wisdom__connection_subcategories_belonging1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_belonging1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_community1 = (_comparisonData_32 = comparisonData[1]) === null || _comparisonData_32 === void 0 ? void 0 : _comparisonData_32.results.wisdom__connection.subcategories.community) === null || _comparisonData__results_wisdom__connection_subcategories_community1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_community1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_compassion1 = (_comparisonData_33 = comparisonData[1]) === null || _comparisonData_33 === void 0 ? void 0 : _comparisonData_33.results.wisdom__connection.subcategories.compassion) === null || _comparisonData__results_wisdom__connection_subcategories_compassion1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_compassion1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_nature1 = (_comparisonData_34 = comparisonData[1]) === null || _comparisonData_34 === void 0 ? void 0 : _comparisonData_34.results.wisdom__connection.subcategories.nature) === null || _comparisonData__results_wisdom__connection_subcategories_nature1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_nature1.percent),
            parseInt((_comparisonData__results_wisdom__connection_subcategories_balance__inner_peace1 = (_comparisonData_35 = comparisonData[1]) === null || _comparisonData_35 === void 0 ? void 0 : _comparisonData_35.results.wisdom__connection.subcategories.balance__inner_peace) === null || _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace1 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Purpose & Meaning",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_purpose__meaning2 = (_comparisonData_36 = comparisonData[0]) === null || _comparisonData_36 === void 0 ? void 0 : _comparisonData_36.results.wisdom__connection.subcategories.purpose__meaning) === null || _comparisonData__results_wisdom__connection_subcategories_purpose__meaning2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_purpose__meaning2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_purpose__meaning3 = (_comparisonData_37 = comparisonData[1]) === null || _comparisonData_37 === void 0 ? void 0 : _comparisonData_37.results.wisdom__connection.subcategories.purpose__meaning) === null || _comparisonData__results_wisdom__connection_subcategories_purpose__meaning3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_purpose__meaning3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Ethics & Decision-Making",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_decision_making__ethics2 = (_comparisonData_38 = comparisonData[0]) === null || _comparisonData_38 === void 0 ? void 0 : _comparisonData_38.results.wisdom__connection.subcategories.decision_making__ethics) === null || _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_decision_making__ethics3 = (_comparisonData_39 = comparisonData[1]) === null || _comparisonData_39 === void 0 ? void 0 : _comparisonData_39.results.wisdom__connection.subcategories.decision_making__ethics) === null || _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_decision_making__ethics3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Belonging",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_belonging2 = (_comparisonData_40 = comparisonData[0]) === null || _comparisonData_40 === void 0 ? void 0 : _comparisonData_40.results.wisdom__connection.subcategories.belonging) === null || _comparisonData__results_wisdom__connection_subcategories_belonging2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_belonging2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_belonging3 = (_comparisonData_41 = comparisonData[1]) === null || _comparisonData_41 === void 0 ? void 0 : _comparisonData_41.results.wisdom__connection.subcategories.belonging) === null || _comparisonData__results_wisdom__connection_subcategories_belonging3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_belonging3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Community",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_community2 = (_comparisonData_42 = comparisonData[0]) === null || _comparisonData_42 === void 0 ? void 0 : _comparisonData_42.results.wisdom__connection.subcategories.community) === null || _comparisonData__results_wisdom__connection_subcategories_community2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_community2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_community3 = (_comparisonData_43 = comparisonData[1]) === null || _comparisonData_43 === void 0 ? void 0 : _comparisonData_43.results.wisdom__connection.subcategories.community) === null || _comparisonData__results_wisdom__connection_subcategories_community3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_community3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Compassion",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_compassion2 = (_comparisonData_44 = comparisonData[0]) === null || _comparisonData_44 === void 0 ? void 0 : _comparisonData_44.results.wisdom__connection.subcategories.compassion) === null || _comparisonData__results_wisdom__connection_subcategories_compassion2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_compassion2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_compassion3 = (_comparisonData_45 = comparisonData[1]) === null || _comparisonData_45 === void 0 ? void 0 : _comparisonData_45.results.wisdom__connection.subcategories.compassion) === null || _comparisonData__results_wisdom__connection_subcategories_compassion3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_compassion3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Nature",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_nature2 = (_comparisonData_46 = comparisonData[0]) === null || _comparisonData_46 === void 0 ? void 0 : _comparisonData_46.results.wisdom__connection.subcategories.nature) === null || _comparisonData__results_wisdom__connection_subcategories_nature2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_nature2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_nature3 = (_comparisonData_47 = comparisonData[1]) === null || _comparisonData_47 === void 0 ? void 0 : _comparisonData_47.results.wisdom__connection.subcategories.nature) === null || _comparisonData__results_wisdom__connection_subcategories_nature3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_nature3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Balance & Inner Peace",
        survey0: (_comparisonData__results_wisdom__connection_subcategories_balance__inner_peace2 = (_comparisonData_48 = comparisonData[0]) === null || _comparisonData_48 === void 0 ? void 0 : _comparisonData_48.results.wisdom__connection.subcategories.balance__inner_peace) === null || _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace2 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace2.percent,
        survey1: (_comparisonData__results_wisdom__connection_subcategories_balance__inner_peace3 = (_comparisonData_49 = comparisonData[1]) === null || _comparisonData_49 === void 0 ? void 0 : _comparisonData_49.results.wisdom__connection.subcategories.balance__inner_peace) === null || _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace3 === void 0 ? void 0 : _comparisonData__results_wisdom__connection_subcategories_balance__inner_peace3.percent
    })))))))), props && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0 px-sm-2 pt-2": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label"
    }, "Assessment Users"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "10%"
    }, "#"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Email"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Quarter"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, comparisonData.length > 0 ? comparisonData.map((item, dataIndex)=>{
        const quarter = dataIndex === 0 ? preQuarter : postQuarter;
        const year = dataIndex === 0 ? preYear : postYear;
        const allUsers = comparisonData.map((data)=>data.users).flat();
        const filteredUsers = (props === null || props === void 0 ? void 0 : props.apiFor) === "common-users" ? item.users.filter((user)=>allUsers.filter((u)=>u._id === user._id).length > 1) : item.users;
        return filteredUsers.map((user)=>{
            userDataIndex = userDataIndex + 1;
            return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
                key: `${user._id}-${dataIndex}`
            }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, userDataIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.fullName || "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.email), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, `Quarter ${quarter} ${year}`));
        });
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        colSpan: "4",
        className: "text-center"
    }, "Assessment users not available at this moment."))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a342f5c2d7c66d88$export$2e2bcd8739ae039), null));
};
var $8c0346575f5896b8$export$2e2bcd8739ae039 = $8c0346575f5896b8$var$WisdomComparisonReport;
















const $b28e6c101dc1ef43$var$TakeNewProsperityAssessment = ({ variant: variant , className: className , title: title , wrapperProps: wrapperProps , getTypeFormLink: getTypeFormLink = false , API: API , type: type = (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY , gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction , ...rest })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [error, setError] = (0, $feLGi$react.useState)(null);
    const [link, setLink] = (0, $feLGi$react.useState)("");
    const Notification = (0, $102ddb9add0f5b8b$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getUrl = async ()=>{
            try {
                const { data: data  } = await API.survey.getLink(type);
                setLink(data.link);
                setIsLoading(false);
                if ((data === null || data === void 0 ? void 0 : data.code) === "upgrade_plan") setError(data === null || data === void 0 ? void 0 : data.message);
                else setError(null);
            } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === "survey_limit_reached") setError(e.message);
                setIsLoading(false);
            }
        };
        getUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const takeNewAssessment = ()=>{
        Notification.showNotification(error);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        ...link && {
            href: link,
            target: "_self",
            rel: "noopener noreferrer"
        },
        ...error ? {
            onClick: takeNewAssessment
        } : {
            onClick: gtmAssessmentBtnClickedAction
        },
        ...wrapperProps
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        disabled: isLoading,
        variant: variant,
        className: className,
        ...rest
    }, title || /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, "Take new assessment")));
};
var $b28e6c101dc1ef43$export$2e2bcd8739ae039 = $b28e6c101dc1ef43$var$TakeNewProsperityAssessment;











const $7c418b5367514a11$var$ProsperityAssessmentLearnMore = ({ category: category , onLearnMoreClick: onLearnMoreClick , linkClasses: linkClasses = ""  })=>{
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
    /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        onClick: ()=>{
            onShow();
            setModalData(category);
            onLearnMoreClick(category === null || category === void 0 ? void 0 : category._id);
        },
        "data-toggle": "modal",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("learn-more-link", linkClasses)
    }, "Learn more"));
};
var $7c418b5367514a11$export$2e2bcd8739ae039 = $7c418b5367514a11$var$ProsperityAssessmentLearnMore;


const $aa1a5cea5c5eb387$var$ProsperityAssessmentScoreCard = ({ title: title , percentage: percentage , wrapperClasses: wrapperClasses , variant: variant , linkClasses: linkClasses , category: category , onLearnMoreClick: onLearnMoreClick , outerBackgroudColor: outerBackgroudColor , innerBackgroudColor: innerBackgroudColor , width: width , height: height , titleClasses: titleClasses = "" , titlePosition: titlePosition = "bottom"  })=>{
    const outerCardStyle = {
        width: width,
        height: height,
        borderRadius: "0.313rem",
        background: outerBackgroudColor,
        position: "relative"
    };
    const innerCardStyle = {
        content: "",
        position: "absolute",
        background: innerBackgroudColor,
        borderRadius: "0.313rem",
        bottom: 0,
        left: 0,
        height: Number.isInteger(percentage) ? percentage <= 35 ? "35%" : `${percentage}%` : "0%",
        width: width,
        animation: "card-score-filler 2s ease-in-out"
    };
    const pageBreakStyle = {
        pageBreakInside: "avoid"
    };
    (0, $feLGi$react.useEffect)(()=>{
        const style = document.createElement("style");
        style.innerHTML = `
      @media print {
        .print-inner-card {
          height: ${Number.isInteger(percentage) ? percentage <= 35 ? "35%" : `${percentage}%` : "0%"} !important;
        }
      }
    `;
        document.head.appendChild(style);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        percentage
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))(wrapperClasses)
    }, variant === "normal-card" ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: pageBreakStyle
    }, titlePosition === "top" && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("s2 mb-4", titleClasses)
    }, title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: outerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "print-inner-card score-card",
        style: innerCardStyle
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "category-percentage position-absolute w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, Number.isInteger(percentage) ? `${percentage}%` : "N/A")))), titlePosition === "bottom" && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("s2 my-0 mt-3 my-lg-2", titleClasses)
    }, title), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "mt-4": titlePosition === "top"
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $7c418b5367514a11$export$2e2bcd8739ae039), {
        linkClasses: linkClasses,
        category: category,
        onLearnMoreClick: onLearnMoreClick
    }))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "position-relative d-flex justify-content-lg-start justify-content-center",
        style: pageBreakStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "score-height",
        style: outerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "print-inner-card score-card",
        style: innerCardStyle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "score-text w-100 d-flex justify-content-center align-items-center h-100"
    }, Number.isInteger(percentage) ? `${percentage}%` : "N/A"))))));
};
$aa1a5cea5c5eb387$var$ProsperityAssessmentScoreCard.propTypes = {
    title: (0, ($parcel$interopDefault($feLGi$proptypes))).string.isRequired,
    variant: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        "table-attached-card",
        "normal-card"
    ]),
    titlePosition: (0, ($parcel$interopDefault($feLGi$proptypes))).oneOf([
        "top",
        "bottom"
    ]),
    wrapperClasses: (0, ($parcel$interopDefault($feLGi$proptypes))).string
};
$aa1a5cea5c5eb387$var$ProsperityAssessmentScoreCard.defaultProps = {
    variant: "normal-card",
    wrapperClasses: "",
    titlePosition: "bottom"
};
var $aa1a5cea5c5eb387$export$2e2bcd8739ae039 = $aa1a5cea5c5eb387$var$ProsperityAssessmentScoreCard;


const $fd10b8c815b7dbfa$var$tableMaxWidth = 1080;
const $fd10b8c815b7dbfa$var$tableMinWidth = 1024;
const $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75 = window.innerWidth <= $fd10b8c815b7dbfa$var$tableMaxWidth && window.innerWidth >= $fd10b8c815b7dbfa$var$tableMinWidth;
const $fd10b8c815b7dbfa$var$defaultTitles = {
    lifeWork: "Life & Work",
    selfAwareness: "Self Awareness",
    timelessWisdom: "Timeless Wisdom"
};
const $fd10b8c815b7dbfa$var$OverviewProsperityResults = ({ survey: survey , onLearnMoreClick: onLearnMoreClick , wrapperClasses: wrapperClasses = "" , titlePosition: titlePosition = "bottom" , titleClasses: titleClasses = "" , linkClasses: linkClasses = "s11 mt-4 mb-0 text-dark-900-5 cursor-pointer" , titles: titles = $fd10b8c815b7dbfa$var$defaultTitles  })=>{
    var _survey_results, _survey_results_life__work, _survey_results1, _survey_results_self_awareness, _survey_results2, _survey_results_timeless_wisdom;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 3,
        xl: 3,
        className: "mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "position-relative text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $aa1a5cea5c5eb387$export$2e2bcd8739ae039), {
        title: titles.lifeWork,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_life__work = _survey_results.life__work) === null || _survey_results_life__work === void 0 ? void 0 : _survey_results_life__work.percent,
        category: survey === null || survey === void 0 ? void 0 : survey.categories.find((categories)=>{
            return (categories === null || categories === void 0 ? void 0 : categories.key) === "life__work";
        }),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(10, 34, 60, 0.25)",
        innerBackgroudColor: "#0A223C",
        width: $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: linkClasses,
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $aa1a5cea5c5eb387$export$2e2bcd8739ae039), {
        title: titles.selfAwareness,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_self_awareness = _survey_results1.self_awareness) === null || _survey_results_self_awareness === void 0 ? void 0 : _survey_results_self_awareness.percent,
        category: survey === null || survey === void 0 ? void 0 : survey.categories.find((categories)=>{
            return (categories === null || categories === void 0 ? void 0 : categories.key) === "self_awareness";
        }),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(206, 129, 71, 0.25)",
        innerBackgroudColor: "#CE8147",
        width: $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: linkClasses,
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $aa1a5cea5c5eb387$export$2e2bcd8739ae039), {
        title: titles.timelessWisdom,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_timeless_wisdom = _survey_results2.timeless_wisdom) === null || _survey_results_timeless_wisdom === void 0 ? void 0 : _survey_results_timeless_wisdom.percent,
        category: survey === null || survey === void 0 ? void 0 : survey.categories.find((categories)=>{
            return (categories === null || categories === void 0 ? void 0 : categories.key) === "timeless_wisdom";
        }),
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: "rgba(239, 192, 48, 0.25)",
        innerBackgroudColor: "#EFC030",
        width: $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75 ? "10rem" : "15.79rem",
        height: "14.745rem",
        linkClasses: linkClasses,
        titlePosition: titlePosition,
        titleClasses: titleClasses
    })));
};
var $fd10b8c815b7dbfa$export$2e2bcd8739ae039 = $fd10b8c815b7dbfa$var$OverviewProsperityResults;









const $20d575733ef29260$var$ProsperityInfoIconOverlay = ({ contentText: contentText , title: title , placement: placement = "bottom"  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.OverlayTrigger), {
        key: placement,
        placement: placement,
        overlay: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Tooltip), {
            id: `tooltip-${placement}-${title}`,
            className: "s11 text-center info-tooltip"
        }, contentText)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "d-inline-block ms-3 ml-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none"
    })));
};
var $20d575733ef29260$export$2e2bcd8739ae039 = $20d575733ef29260$var$ProsperityInfoIconOverlay;





const $683723c9d8689828$var$ProsperitySubcategoriesTable = ({ title: title , survey: survey , onLearnMoreClick: onLearnMoreClick , innerBackgroudColor: innerBackgroudColor , outerBackgroudColor: outerBackgroudColor , categoryKeyName: categoryKeyName , wrapperClasses: wrapperClasses , tableClasses: tableClasses , barHeight: barHeight , parentId: parentId  })=>{
    var _survey_results, _survey_results_categoryKeyName, _survey_categories, _survey_results1, _survey_results_categoryKeyName1;
    const tableRef = (0, $feLGi$react.useRef)(null);
    const [height, setHeight] = (0, $feLGi$react.useState)(0);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const { isLGScreen: isLGScreen  } = (0, $6e18117e8ec75a85$export$2e2bcd8739ae039)();
    const { onShow: onShow , setModalData: setModalData  } = (0, $feLGi$react.useContext)((0, $045e98f186682651$export$caf6d77d41020cdf));
    (0, $feLGi$react.useLayoutEffect)(()=>{
        setHeight(tableRef.current.clientHeight);
    }, []);
    (0, $feLGi$react.useEffect)(()=>{
        function handleWindowResize() {
            setHeight(tableRef.current.clientHeight);
        }
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: wrapperClasses
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column flex-lg-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-chart text-center align-self-lg-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $aa1a5cea5c5eb387$export$2e2bcd8739ae039), {
        title: title,
        percentage: survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.percent,
        category: survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories[categoryKeyName],
        onLearnMoreClick: onLearnMoreClick,
        outerBackgroudColor: outerBackgroudColor,
        innerBackgroudColor: innerBackgroudColor,
        width: "15.79rem",
        height: isLGScreen || (0, $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75) ? `${height}px` : barHeight,
        linkClasses: "s11 mb-0 text-white cursor-pointer",
        variant: "table-attached-card"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("assessment-score mt-lg-0 mt-4", tableClasses),
        ref: tableRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between mb-18px pt-0 px-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0 "
    }, title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $416404e45e2d34e7$export$2e2bcd8739ae039), {
        className: "info-icon align-self-center cursor-pointer font-20 text-decoration-none",
        onClick: ()=>{
            var _survey_categories, _survey_categories_find, _survey_categories1;
            onShow();
            setModalData(survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((e)=>e._id === parentId));
            onLearnMoreClick((_survey_categories_find = survey === null || survey === void 0 ? void 0 : (_survey_categories1 = survey.categories) === null || _survey_categories1 === void 0 ? void 0 : _survey_categories1.find((e)=>e._id === parentId)) === null || _survey_categories_find === void 0 ? void 0 : _survey_categories_find._id);
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.order.map((subcategory, index)=>{
        var _survey_results_categoryKeyName_subcategories_subcategory, _survey_results, _survey_results_categoryKeyName, _survey_results_categoryKeyName_subcategories_subcategory1, _survey_results1, _survey_results_categoryKeyName1, _survey_results_categoryKeyName_subcategories_subcategory2, _survey_results2, _survey_results_categoryKeyName2, _survey_results_categoryKeyName_subcategories_subcategory3, _survey_results3, _survey_results_categoryKeyName3, _survey_categories_find, _survey_categories;
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "survey-subcat-link py-18px",
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("courses-title-row", {
                "first-row": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            "data-id": (_survey_results_categoryKeyName_subcategories_subcategory = survey === null || survey === void 0 ? void 0 : (_survey_results = survey.results) === null || _survey_results === void 0 ? void 0 : (_survey_results_categoryKeyName = _survey_results[categoryKeyName]) === null || _survey_results_categoryKeyName === void 0 ? void 0 : _survey_results_categoryKeyName.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory.title,
            onMouseEnter: ()=>{
                setRowNumber(index);
            },
            onMouseLeave: ()=>{
                setRowNumber(null);
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "s6 text-black hover-text-bold"
        }, (_survey_results_categoryKeyName_subcategories_subcategory1 = survey === null || survey === void 0 ? void 0 : (_survey_results1 = survey.results) === null || _survey_results1 === void 0 ? void 0 : (_survey_results_categoryKeyName1 = _survey_results1[categoryKeyName]) === null || _survey_results_categoryKeyName1 === void 0 ? void 0 : _survey_results_categoryKeyName1.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory1 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory1.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            style: {
                color: innerBackgroudColor
            },
            className: "hover-text-bold s6"
        }, Number.isInteger((_survey_results_categoryKeyName_subcategories_subcategory2 = survey === null || survey === void 0 ? void 0 : (_survey_results2 = survey.results) === null || _survey_results2 === void 0 ? void 0 : (_survey_results_categoryKeyName2 = _survey_results2[categoryKeyName]) === null || _survey_results_categoryKeyName2 === void 0 ? void 0 : _survey_results_categoryKeyName2.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory2 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory2.percent) ? `${(_survey_results_categoryKeyName_subcategories_subcategory3 = survey === null || survey === void 0 ? void 0 : (_survey_results3 = survey.results) === null || _survey_results3 === void 0 ? void 0 : (_survey_results_categoryKeyName3 = _survey_results3[categoryKeyName]) === null || _survey_results_categoryKeyName3 === void 0 ? void 0 : _survey_results_categoryKeyName3.subcategories[subcategory]) === null || _survey_results_categoryKeyName_subcategories_subcategory3 === void 0 ? void 0 : _survey_results_categoryKeyName_subcategories_subcategory3.percent}%` : "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $20d575733ef29260$export$2e2bcd8739ae039), {
            contentText: (_survey_categories_find = survey === null || survey === void 0 ? void 0 : (_survey_categories = survey.categories) === null || _survey_categories === void 0 ? void 0 : _survey_categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e.key) === subcategory;
            })) === null || _survey_categories_find === void 0 ? void 0 : _survey_categories_find.description
        }))));
    })))));
};
var $683723c9d8689828$export$2e2bcd8739ae039 = $683723c9d8689828$var$ProsperitySubcategoriesTable;







const $2c8dd0ccb7b918cc$var$ProsperitySortedSubCategories = ({ results: results , categories: categories  })=>{
    const [sortedSubCategories, setSortedSubCategories] = (0, $feLGi$react.useState)([]);
    const lifeWorkId = "67f525ac628a100932936bb5";
    const selfAwarenessId = "67f52705628a100932936bb7";
    const timeLessWisdomId = "67f52798628a100932936bb8";
    (0, $feLGi$react.useEffect)(()=>{
        if (results) {
            var _results_self_awareness, _results_timeless_wisdom;
            let subCategories = results.life__work.order.map((cat)=>({
                    ...results.life__work.subcategories[cat],
                    key: cat,
                    parentId: lifeWorkId
                }));
            subCategories = [
                ...subCategories,
                ...results === null || results === void 0 ? void 0 : (_results_self_awareness = results.self_awareness) === null || _results_self_awareness === void 0 ? void 0 : _results_self_awareness.order.map((cat)=>({
                        ...results.self_awareness.subcategories[cat],
                        key: cat,
                        parentId: selfAwarenessId
                    })),
                ...results === null || results === void 0 ? void 0 : (_results_timeless_wisdom = results.timeless_wisdom) === null || _results_timeless_wisdom === void 0 ? void 0 : _results_timeless_wisdom.order.map((cat)=>({
                        ...results.timeless_wisdom.subcategories[cat],
                        key: cat,
                        parentId: timeLessWisdomId
                    }))
            ];
            subCategories = subCategories.sort((a, b)=>b.percent - a.percent);
            setSortedSubCategories(subCategories);
        }
    }, [
        results
    ]);
    const renderSubCategoriesBox = (category, index)=>{
        var _categories_find;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex category-details"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-9"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
            className: "mb-0 s7 hover-text-bold ms-2"
        }, category === null || category === void 0 ? void 0 : category.title)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            className: "col-3 d-flex justify-content-end"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("mb-0 align-self-center hover-text-bold s7", {
                "text-abroad-blue": (category === null || category === void 0 ? void 0 : category.parentId) === lifeWorkId,
                "text-orange-100": (category === null || category === void 0 ? void 0 : category.parentId) === selfAwarenessId,
                "text-saffron-300": (category === null || category === void 0 ? void 0 : category.parentId) === timeLessWisdomId
            })
        }, `${category.percent}%`), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $20d575733ef29260$export$2e2bcd8739ae039), {
            contentText: (_categories_find = categories === null || categories === void 0 ? void 0 : categories.find((e)=>{
                return (e === null || e === void 0 ? void 0 : e.key) === (category === null || category === void 0 ? void 0 : category.key);
            })) === null || _categories_find === void 0 ? void 0 : _categories_find.description
        })));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex flex-lg-row flex-column mb-52px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        lg: 12,
        md: 12,
        sm: 12,
        className: "mb-lg-0 mb-3 d-flex flex-lg-row flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mr-lg-12px w-100 mb-lg-0 mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75),
            s2: !(0, $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75)
        })
    }, "Celebrations"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(0, 3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category, index))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "ml-lg-12px w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-black mb-3", {
            s3: (0, $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75),
            s2: !(0, $fd10b8c815b7dbfa$export$9fc0cb86cdf25c75)
        })
    }, "Key Areas for Growth"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "box-content"
    }, sortedSubCategories.slice(-3).map((category, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, {
            key: index
        }, renderSubCategoriesBox(category, index)))))));
};
var $2c8dd0ccb7b918cc$export$2e2bcd8739ae039 = $2c8dd0ccb7b918cc$var$ProsperitySortedSubCategories;


const $e1d5251c383ee501$var$ProsperitySummaryResult = ({ gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction = ()=>{} , survey: survey  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $fd10b8c815b7dbfa$export$2e2bcd8739ae039), {
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        titlePosition: "top"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $683723c9d8689828$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Life & Work",
        categoryKeyName: "life__work",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#0A223C",
        outerBackgroudColor: "rgba(10, 34, 60, 0.25)",
        barHeight: "22.437rem",
        key: "life__work",
        parentId: "67f525ac628a100932936bb5"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $683723c9d8689828$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Self Awareness",
        categoryKeyName: "self_awareness",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#CE8147",
        outerBackgroudColor: "#F2DFD1",
        barHeight: "22.437rem",
        key: "self_awareness",
        parentId: "67f52705628a100932936bb7"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $683723c9d8689828$export$2e2bcd8739ae039), {
        wrapperClasses: "mb-52px",
        title: "Timeless Wisdom",
        categoryKeyName: "timeless_wisdom",
        survey: survey,
        onLearnMoreClick: gtmLearnMoreBtnClickedAction,
        innerBackgroudColor: "#EFC030",
        outerBackgroudColor: "#FBEFCB",
        // tableClasses='align-self-lg-center'
        barHeight: "22.437rem",
        key: "timeless_wisdom",
        parentId: "67f52798628a100932936bb8"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $2c8dd0ccb7b918cc$export$2e2bcd8739ae039), {
        results: survey === null || survey === void 0 ? void 0 : survey.results,
        categories: survey === null || survey === void 0 ? void 0 : survey.categories
    }));
};
var $e1d5251c383ee501$export$2e2bcd8739ae039 = $e1d5251c383ee501$var$ProsperitySummaryResult;







const $3eaaa660ae7be38e$var$GrowthPlanBtnForPA = ({ buttonClasses: buttonClasses = "" , buttonText: buttonText = "Inquire about Growth Plan" , buttonEvent: buttonEvent , gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction  })=>{
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: "saffron",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("btn s10a text-uppercase", buttonClasses),
        onClick: ()=>{
            gtmUpgradeButtonClickedAction(buttonText);
            history.push(`/upgrade-inquiry?plan=${(0, $625df15f91b44219$export$2e2bcd8739ae039).growth.code}`);
        }
    }, buttonText);
};
var $3eaaa660ae7be38e$export$2e2bcd8739ae039 = $3eaaa660ae7be38e$var$GrowthPlanBtnForPA;











const $fdab543446e764ca$var$type = "personal";
const $fdab543446e764ca$var$AssessmentPreviousResults = ({ surveyType: filterSurveyType = (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS , gtmCompareAssessmentAction: gtmCompareAssessmentAction , API: API , isRenderOnAdmin: isRenderOnAdmin = false , onPreviousSurveysCountLoaded: onPreviousSurveysCountLoaded , clientId: clientIdProp  })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [previousResults, setPreviousResults] = (0, $feLGi$react.useState)([]);
    const [rowNumber, setRowNumber] = (0, $feLGi$react.useState)(null);
    const { id: id , clientId: clientIdParam , surveyId: surveyId  } = (0, $feLGi$reactrouterdom.useParams)();
    const clientId = clientIdProp || clientIdParam;
    const currentSurveyId = id || surveyId;
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const routePrefix = (0, $b5f12f83c4275d44$export$802fe12baad01513)(filterSurveyType);
    (0, $feLGi$react.useEffect)(()=>{
        const getSurveys = async ()=>{
            setIsLoading(true);
            try {
                let otherCount = 0;
                if (isRenderOnAdmin && clientId) {
                    const { data: data  } = await API.survey.getLeaderAndAwarenessAssessments(clientId);
                    const allSurveys = Array.isArray(data) ? data : (data === null || data === void 0 ? void 0 : data.surveys) || [];
                    const filteredData = allSurveys.filter((survey)=>{
                        if ((survey === null || survey === void 0 ? void 0 : survey._id) === currentSurveyId || (survey === null || survey === void 0 ? void 0 : survey.type)) return false;
                        if (filterSurveyType === (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).AWARENESS) return ![
                            (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).LEADER,
                            (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).WISDOM,
                            (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY
                        ].includes(survey === null || survey === void 0 ? void 0 : survey.surveyType);
                        return (survey === null || survey === void 0 ? void 0 : survey.surveyType) === filterSurveyType;
                    });
                    const sortedSurveys = filteredData.sort((a, b)=>{
                        return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(a.createdAt) > (0, ($parcel$interopDefault($feLGi$momenttimezone)))(b.createdAt) ? -1 : 1;
                    });
                    otherCount = sortedSurveys.length;
                    setPreviousResults(sortedSurveys);
                } else {
                    var _data_surveys;
                    const { data: data  } = await API.survey.getSurveys($fdab543446e764ca$var$type, filterSurveyType);
                    if (data && (data === null || data === void 0 ? void 0 : (_data_surveys = data.surveys) === null || _data_surveys === void 0 ? void 0 : _data_surveys.length) > 0) {
                        const filteredData = data.surveys.filter((survey)=>{
                            return (survey === null || survey === void 0 ? void 0 : survey._id) !== currentSurveyId;
                        });
                        const sortedSurveys = filteredData.sort((a, b)=>{
                            return (0, ($parcel$interopDefault($feLGi$momenttimezone)))(a.createdAt) > (0, ($parcel$interopDefault($feLGi$momenttimezone)))(b.createdAt) ? -1 : 1;
                        });
                        otherCount = sortedSurveys.length;
                        setPreviousResults(sortedSurveys);
                    } else setPreviousResults([]);
                }
                if (onPreviousSurveysCountLoaded) onPreviousSurveysCountLoaded(otherCount);
                setIsLoading(false);
            } catch (e) {
                if (onPreviousSurveysCountLoaded) onPreviousSurveysCountLoaded(0);
                setIsLoading(false);
                Error.showError(e);
            }
        };
        if (currentSurveyId) getSurveys();
        else {
            if (onPreviousSurveysCountLoaded) onPreviousSurveysCountLoaded(0);
            setIsLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentSurveyId,
        clientId,
        isRenderOnAdmin,
        filterSurveyType
    ]);
    const getResultLink = (survey)=>{
        if (isRenderOnAdmin && clientId) return `/${routePrefix}/${survey === null || survey === void 0 ? void 0 : survey._id}/clients/${clientId}`;
        return `/${routePrefix}/${survey === null || survey === void 0 ? void 0 : survey._id}`;
    };
    const getCompareLink = (survey)=>{
        const compareQuery = `survey=${currentSurveyId}&survey=${survey === null || survey === void 0 ? void 0 : survey._id}&surveyType=${filterSurveyType}`;
        if (isRenderOnAdmin && clientId) return `/${routePrefix}/comparison-report?${compareQuery}&clientId=${clientId}`;
        return `/${routePrefix}/comparison-report?${compareQuery}`;
    };
    const handleCompareClick = ()=>{
        if (gtmCompareAssessmentAction) gtmCompareAssessmentAction();
    };
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "previous-result"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "w-25 mb-18px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTitle), {
        line: 1
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTable), {
        row: 2,
        col: 3
    }));
    if ((previousResults === null || previousResults === void 0 ? void 0 : previousResults.length) === 0) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "previous-result"
    }, isRenderOnAdmin ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3 mt-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, "Previous Results"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex mb-18px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "previous-result-title mb-0 ms-2"
    }, "Previous Results")), previousResults.map((survey, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: (survey === null || survey === void 0 ? void 0 : survey._id) || index,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))("courses-title-row assessment-result-link", {
                "first-row": index === 0,
                "border-bottom-transparent": index === rowNumber - 1
            }),
            onMouseEnter: ()=>{
                setRowNumber(index);
            },
            onMouseLeave: ()=>{
                setRowNumber(null);
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-title"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: getResultLink(survey),
            target: isRenderOnAdmin ? "_blank" : undefined,
            rel: isRenderOnAdmin ? "noopener noreferrer" : undefined,
            className: "result-active-link hover-text-bold s6 text-decoration-none assessment-result-link"
        }, (0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(survey === null || survey === void 0 ? void 0 : survey.createdAt, "MMMM Do YYYY"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "courses-score"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: getCompareLink(survey),
            onClick: handleCompareClick,
            className: "s11 cursor-pointer text-saffron-700 text-decoration-none hover-text-bold"
        }, "Compare")));
    }));
};
var $fdab543446e764ca$export$2e2bcd8739ae039 = $fdab543446e764ca$var$AssessmentPreviousResults;










const $82c8f12444b0cafe$var$ProsperityAssessmentLoader = ()=>{
    const ShimmerEffect = ()=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
            className: "my-3"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 11
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
            line: 1,
            gap: 20,
            className: "shimmer-text-height"
        })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 1
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
            line: 1,
            gap: 20,
            className: "shimmer-text-height"
        })));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 5
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4,
        className: "mt-5 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 4,
        className: "mt-5 mt-lg-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "md"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 300
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
        size: "sm"
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerText), {
        className: "shimmer-text-height mt-2"
    }))), Array.from({
        length: 3
    }, (_, index)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
            key: index
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            lg: 4
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex justify-content-sm-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
            height: 450,
            width: 250
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
            sm: 12,
            lg: 8,
            className: "mt-4"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerButton), {
            size: "md"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement(ShimmerEffect, null)))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 470
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        sm: 12,
        lg: 6
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerThumbnail), {
        height: 250,
        width: 470
    }))));
};
var $82c8f12444b0cafe$export$2e2bcd8739ae039 = $82c8f12444b0cafe$var$ProsperityAssessmentLoader;


const $ac8f3c011e3f7c05$var$ProsperityAssessmentResultSection = ({ showEnrollBtn: showEnrollBtn = false , isLGScreen: isLGScreen , API: API , isRenderOnAdmin: isRenderOnAdmin = false , gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction = ()=>{} , gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction = ()=>{} , gtmCompareAssessmentAction: gtmCompareAssessmentAction = ()=>{} , gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction = ()=>{} , renderHeader: renderHeader , AssessmentEvent: AssessmentEvent , apiFunction: apiFunction , clientId: clientId , showHeader: showHeader  })=>{
    const { id: id  } = (0, $feLGi$reactrouterdom.useParams)();
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [survey, setSurvey] = (0, $feLGi$react.useState)(null);
    const [otherProsperitySurveyCount, setOtherProsperitySurveyCount] = (0, $feLGi$react.useState)(null);
    const { user: user  } = (0, $ca001929343b7efa$export$2e2bcd8739ae039)();
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getProsperityAssessmentById = async ()=>{
            setIsLoading(true);
            try {
                const { data: data  } = await apiFunction();
                if (data) setSurvey(data);
                setIsLoading(false);
            } catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === "forbidden" || (e === null || e === void 0 ? void 0 : e.code) === "not_taken_survey") {
                    Error.showError(e);
                    history.replace("/home");
                } else if ((e === null || e === void 0 ? void 0 : e.code) === "ValidationError" || (e === null || e === void 0 ? void 0 : e.code) === "resource_not_found" || (e === null || e === void 0 ? void 0 : e.code) === "not_found") history.replace("/404");
                else {
                    setIsLoading(false);
                    Error.showError(e);
                }
            }
        };
        if (id) getProsperityAssessmentById();
        else history.replace(isRenderOnAdmin ? "/home" : "/survey");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        setOtherProsperitySurveyCount(null);
    }, [
        id
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("main", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("abroad-fs-exclude wisdom-assessment", {
            "custom-offset-lg-1 custom-col-lg-12 px-lg-0": isRenderOnAdmin
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $046f139f7bee52e1$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("page-header", {
            "mb-32px": (0, ($parcel$interopDefault($feLGi$momenttimezone)))().diff((0, ($parcel$interopDefault($feLGi$momenttimezone)))(survey === null || survey === void 0 ? void 0 : survey.createdAt), "days") === 0
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-start d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: " s1 tracking-normal mb-0 mt-3"
    }, "True Prosperity Assessment", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", {
        className: showEnrollBtn && isLGScreen ? "d-block" : "d-none"
    }), isLoading ? " " : ` - ${(0, $50f91df4720112ee$export$6cac2c4ed6c8d624)(survey === null || survey === void 0 ? void 0 : survey.createdAt, "MMMM Do, YYYY")}`), !isLoading && survey && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $2804ed17bfb2a01c$export$2e2bcd8739ae039), {
        survey: survey,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY,
        className: "mt-3 ml-3 ms-3"
    })), !showHeader && renderHeader())), isLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $82c8f12444b0cafe$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, !isRenderOnAdmin && (0, ($parcel$interopDefault($feLGi$momenttimezone)))().diff((0, ($parcel$interopDefault($feLGi$momenttimezone)))(survey === null || survey === void 0 ? void 0 : survey.createdAt), "days") >= 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b28e6c101dc1ef43$export$2e2bcd8739ae039), {
        variant: "abroad-blue",
        title: "TAKE NEW ASSESSMENT",
        className: "mt-32px mb-32px",
        API: API,
        gtmAssessmentBtnClickedAction: gtmAssessmentBtnClickedAction
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $e1d5251c383ee501$export$2e2bcd8739ae039), {
        gtmLearnMoreBtnClickedAction: gtmLearnMoreBtnClickedAction,
        survey: survey
    }), !isRenderOnAdmin && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (user === null || user === void 0 ? void 0 : user.planCode) === (0, $625df15f91b44219$export$2e2bcd8739ae039).free.code && otherProsperitySurveyCount === 0 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "upgrade-now bg-abroad-blue text-white mt-52px mb-52px border-radius-full"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 text-center text-white mb-0"
    }, "Unleash Unlimited Insights"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h5", {
        className: "mt-3 s5 text-center mb-0"
    }, "Upgrade to the Growth Plan for unlimited access to your Awareness Assessment", " ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", {
        className: "d-lg-block d-none"
    }), "and chart your progress in real-time."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $3eaaa660ae7be38e$export$2e2bcd8739ae039), {
        buttonText: "Inquire about Growth Plan",
        buttonClasses: "btn s10a text-uppercase leading-4 py-12px leading-4 mt-32px",
        buttonEvent: AssessmentEvent,
        gtmUpgradeButtonClickedAction: gtmUpgradeButtonClickedAction
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $fdab543446e764ca$export$2e2bcd8739ae039), {
        surveyType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY,
        gtmCompareAssessmentAction: gtmCompareAssessmentAction,
        API: API,
        isRenderOnAdmin: isRenderOnAdmin,
        clientId: clientId,
        onPreviousSurveysCountLoaded: setOtherProsperitySurveyCount
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f5e2cc126c098556$export$2e2bcd8739ae039), null), clientId && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s2 mb-0"
    }, "Assessment User"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "20%"
    }, "Survey Type"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, survey.fullName), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        className: "text-capitalize"
    }, survey.surveyType)))), isRenderOnAdmin && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $fdab543446e764ca$export$2e2bcd8739ae039), {
        surveyType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY,
        gtmCompareAssessmentAction: gtmCompareAssessmentAction,
        API: API,
        isRenderOnAdmin: isRenderOnAdmin,
        clientId: clientId
    })))))));
};
var $ac8f3c011e3f7c05$export$2e2bcd8739ae039 = $ac8f3c011e3f7c05$var$ProsperityAssessmentResultSection;

















const $39870dcf460aaa1c$export$49f29676b9ae4e3 = [
    {
        key: "life__work",
        title: "Life & Work",
        surveyTwoInnerColor: "#0A223C",
        chartSurveyOneColor: "#4d6b85",
        chartSurveyTwoColor: (0, $97b09ac2977ad497$export$cc2e3e24acd33d48),
        chartAxisLabelColor: (0, $97b09ac2977ad497$export$cc2e3e24acd33d48)
    },
    {
        key: "self_awareness",
        title: "Self Awareness",
        surveyTwoInnerColor: "#CE8147",
        chartSurveyOneColor: "#d9a67a",
        chartSurveyTwoColor: (0, $97b09ac2977ad497$export$6372909648378c3b),
        chartAxisLabelColor: (0, $97b09ac2977ad497$export$6372909648378c3b)
    },
    {
        key: "timeless_wisdom",
        title: "Timeless Wisdom",
        surveyTwoInnerColor: "#EFC030",
        chartSurveyOneColor: "#f3d878",
        chartSurveyTwoColor: (0, $97b09ac2977ad497$export$5f5f421f6ab7e55a),
        chartAxisLabelColor: (0, $97b09ac2977ad497$export$5f5f421f6ab7e55a)
    }
];


const $bc682059b30b0bb8$var$ProsperityCategoryComparisonOverview = (props)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b1d11348346a5b8e$export$2e2bcd8739ae039), {
        ...props,
        categoryConfig: (0, $39870dcf460aaa1c$export$49f29676b9ae4e3),
        overviewClassName: "prosperity-category-comparison-overview",
        chartClassName: "prosperity-category-comparison-chart"
    });
var $bc682059b30b0bb8$export$2e2bcd8739ae039 = $bc682059b30b0bb8$var$ProsperityCategoryComparisonOverview;






const $1b858d3f322ddeab$var$ProsperityComparisonReport = ({ isLoading: isLoading , preDate: preDate , postDate: postDate , comparisonData: comparisonData , header: header , onGoBack: onGoBack = ()=>{} , isRequiredToFormatDate: isRequiredToFormatDate = true , showGoBackButton: showGoBackButton = true , showClientCompareHeader: showClientCompareHeader = false , compareHeaderTitle: compareHeaderTitle = "True Prosperity Assessment" , isRenderFromOP: isRenderFromOP = false , downloadFileNameBase: downloadFileNameBase , props: props  })=>{
    var _comparisonData_, _comparisonData_1, _comparisonData__results_life__work_subcategories_physical_health__vitality, _comparisonData_2, _comparisonData__results_life__work_subcategories_financial_health__security, _comparisonData_3, _comparisonData__results_life__work_subcategories_education__professional_growth, _comparisonData_4, _comparisonData__results_life__work_subcategories_belonging__relationships, _comparisonData_5, _comparisonData__results_life__work_subcategories_purpose__meaning, _comparisonData_6, _comparisonData__results_life__work_subcategories_physical_health__vitality1, _comparisonData_7, _comparisonData__results_life__work_subcategories_financial_health__security1, _comparisonData_8, _comparisonData__results_life__work_subcategories_education__professional_growth1, _comparisonData_9, _comparisonData__results_life__work_subcategories_belonging__relationships1, _comparisonData_10, _comparisonData__results_life__work_subcategories_purpose__meaning1, _comparisonData_11, _comparisonData__results_life__work_subcategories_physical_health__vitality2, _comparisonData_12, _comparisonData__results_life__work_subcategories_physical_health__vitality3, _comparisonData_13, _comparisonData__results_life__work_subcategories_financial_health__security2, _comparisonData_14, _comparisonData__results_life__work_subcategories_financial_health__security3, _comparisonData_15, _comparisonData__results_life__work_subcategories_education__professional_growth2, _comparisonData_16, _comparisonData__results_life__work_subcategories_education__professional_growth3, _comparisonData_17, _comparisonData__results_life__work_subcategories_belonging__relationships2, _comparisonData_18, _comparisonData__results_life__work_subcategories_belonging__relationships3, _comparisonData_19, _comparisonData__results_life__work_subcategories_purpose__meaning2, _comparisonData_20, _comparisonData__results_life__work_subcategories_purpose__meaning3, _comparisonData_21, _comparisonData__results_self_awareness_subcategories_focus__flow, _comparisonData_22, _comparisonData__results_self_awareness_subcategories_fear__attachment, _comparisonData_23, _comparisonData__results_self_awareness_subcategories_burnout_resistance, _comparisonData_24, _comparisonData__results_self_awareness_subcategories_emotional_intelligence, _comparisonData_25, _comparisonData__results_self_awareness_subcategories_self_compassion, _comparisonData_26, _comparisonData__results_self_awareness_subcategories_focus__flow1, _comparisonData_27, _comparisonData__results_self_awareness_subcategories_fear__attachment1, _comparisonData_28, _comparisonData__results_self_awareness_subcategories_burnout_resistance1, _comparisonData_29, _comparisonData__results_self_awareness_subcategories_emotional_intelligence1, _comparisonData_30, _comparisonData__results_self_awareness_subcategories_self_compassion1, _comparisonData_31, _comparisonData__results_self_awareness_subcategories_focus__flow2, _comparisonData_32, _comparisonData__results_self_awareness_subcategories_focus__flow3, _comparisonData_33, _comparisonData__results_self_awareness_subcategories_fear__attachment2, _comparisonData_34, _comparisonData__results_self_awareness_subcategories_fear__attachment3, _comparisonData_35, _comparisonData__results_self_awareness_subcategories_burnout_resistance2, _comparisonData_36, _comparisonData__results_self_awareness_subcategories_burnout_resistance3, _comparisonData_37, _comparisonData__results_self_awareness_subcategories_emotional_intelligence2, _comparisonData_38, _comparisonData__results_self_awareness_subcategories_emotional_intelligence3, _comparisonData_39, _comparisonData__results_self_awareness_subcategories_self_compassion2, _comparisonData_40, _comparisonData__results_self_awareness_subcategories_self_compassion3, _comparisonData_41, _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity, _comparisonData_42, _comparisonData__results_timeless_wisdom_subcategories_community, _comparisonData_43, _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making, _comparisonData_44, _comparisonData__results_timeless_wisdom_subcategories_nature, _comparisonData_45, _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace, _comparisonData_46, _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity1, _comparisonData_47, _comparisonData__results_timeless_wisdom_subcategories_community1, _comparisonData_48, _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making1, _comparisonData_49, _comparisonData__results_timeless_wisdom_subcategories_nature1, _comparisonData_50, _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace1, _comparisonData_51, _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity2, _comparisonData_52, _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity3, _comparisonData_53, _comparisonData__results_timeless_wisdom_subcategories_community2, _comparisonData_54, _comparisonData__results_timeless_wisdom_subcategories_community3, _comparisonData_55, _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making2, _comparisonData_56, _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making3, _comparisonData_57, _comparisonData__results_timeless_wisdom_subcategories_nature2, _comparisonData_58, _comparisonData__results_timeless_wisdom_subcategories_nature3, _comparisonData_59, _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace2, _comparisonData_60, _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace3, _comparisonData_61;
    // Handle preDate and postDate - they can be strings or arrays
    const preDateStr = Array.isArray(preDate) ? preDate[0] : (preDate === null || preDate === void 0 ? void 0 : preDate.toString()) || "";
    const postDateStr = Array.isArray(postDate) ? postDate[0] : (postDate === null || postDate === void 0 ? void 0 : postDate.toString()) || "";
    const spitedPreDate = preDateStr.split(" - ");
    const spitedPostDate = postDateStr.split(" - ");
    const formatedPreDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPreDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(preDateStr).format("MM-DD-YYYY")}`;
    const formatedPostDate = isRequiredToFormatDate ? `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[0]).format("MM-DD-YYYY")} - ${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(spitedPostDate[1]).format("MM-DD-YYYY")}` : `${(0, ($parcel$interopDefault($feLGi$momenttimezone)))(postDateStr).format("MM-DD-YYYY")}`;
    let userDataIndex = 0;
    const preMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(preDate, (_comparisonData_ = comparisonData[0]) === null || _comparisonData_ === void 0 ? void 0 : _comparisonData_.submittedAt);
    const postMoment = (0, $50f91df4720112ee$export$9073f608e603115b)(postDate, (_comparisonData_1 = comparisonData[1]) === null || _comparisonData_1 === void 0 ? void 0 : _comparisonData_1.submittedAt);
    const preQuarter = preMoment.quarter();
    const postQuarter = postMoment.quarter();
    const preYear = preMoment.year();
    const postYear = postMoment.year();
    const headerContent = typeof header === "function" ? header() : header;
    const showPageHeaderRow = showGoBackButton || headerContent;
    const comparisonPeriodLabels = [
        formatedPreDate,
        formatedPostDate
    ];
    const comparisonPdfDownload = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $09226703b1b735cd$export$2e2bcd8739ae039), {
        comparisonData: comparisonData,
        assessmentType: (0, $b5f12f83c4275d44$export$2048b4b7dcce9e34).PROSPERITY,
        periodLabels: comparisonPeriodLabels,
        assessmentTitle: typeof headerContent === "string" && headerContent.trim() ? headerContent : "True Prosperity Assessment",
        fileNameBase: downloadFileNameBase,
        className: "ml-3"
    });
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $f036bbe39d78cd8f$export$2e2bcd8739ae039), {
        isRenderFromOP: isRenderFromOP
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "abroad-fs-exclude"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))({
            "px-0 custom-offset-lg-1 custom-col-lg-12": isRenderFromOP
        })
    }, isRenderFromOP ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pt-4 px-0",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "page-header"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "icon icon-assessments font-40"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "back-btn"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 1.35352L1.4248 17.9997",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M18.5748 34.6462L1.4248 18",
        stroke: "black",
        strokeWidth: "2.5",
        strokeLinecap: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        onClick: onGoBack,
        className: "cursor-pointer",
        width: "20",
        height: "36",
        viewBox: "0 0 22 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5131 20.4459C0.68878 19.6582 0.688778 18.3418 1.5131 17.5541L18.3682 1.44705C19.6407 0.231097 21.75 1.13298 21.75 2.89299L21.75 35.107C21.75 36.867 19.6407 37.7689 18.3682 36.553L1.5131 20.4459Z",
        fill: "black"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100 justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h2", {
        className: "font-montserrat font-semibold text-dark-600 mb-0"
    }, header()), comparisonPdfDownload))))) : showClientCompareHeader ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $8cd010ee20c8a311$export$2e2bcd8739ae039), {
        assessmentTitle: compareHeaderTitle,
        onGoBack: onGoBack,
        headerRight: headerContent,
        titleAccessory: comparisonPdfDownload
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, showPageHeaderRow && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "px-0",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-between"
    }, showGoBackButton && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $b6ee68546aeff868$export$2e2bcd8739ae039), {
        showSmallIcon: "true",
        onClick: onGoBack,
        className: "me-2"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "s-captions text-capitalize cursor-pointer",
        onClick: onGoBack
    }, compareHeaderTitle)), headerContent))))), !showClientCompareHeader && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center pt-2 mb-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "s1 mb-0"
    }, "Compare Results"), comparisonPdfDownload))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        className: "pb-4",
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "mb-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "text-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column text-gray-800 align-items-center font-open-sans"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "The following charts and quantitative data help you see how your Life & Work, Self Awareness, and Timeless Wisdom scores have changed between the two assessment periods you selected."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100 font-normal", {
            "px-0 custom-col-lg-12": isRenderFromOP,
            "w-100 font-normal": !isRenderFromOP
        })
    }, "We invite you not to be overly concerned with whether your scores have increased or decreased. Sometimes life and business present challenges that require us to change our working habits for a period of time. If an area decreases, that is good awareness around opportunities to course correct. Similarly, if an area increases, we invite you to celebrate, but also not attach to it always being that way.")))))), (comparisonData === null || comparisonData === void 0 ? void 0 : comparisonData.length) >= 2 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $bc682059b30b0bb8$export$2e2bcd8739ae039), {
        comparisonData: comparisonData,
        formatedPreDate: formatedPreDate,
        formatedPostDate: formatedPostDate,
        isRenderFromOP: isRenderFromOP
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-blue-100"
    }, "Life & Work"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: " d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-blue-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Physical Health & Vitality",
            "Financial Health & Security",
            "Education & Professional Growth",
            "Belonging & Relationships",
            "Purpose & Meaning"
        ],
        colors: [
            "#69B1d8",
            "#0076BD"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_life__work_subcategories_physical_health__vitality = (_comparisonData_2 = comparisonData[0]) === null || _comparisonData_2 === void 0 ? void 0 : _comparisonData_2.results.life__work.subcategories.physical_health__vitality) === null || _comparisonData__results_life__work_subcategories_physical_health__vitality === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_physical_health__vitality.percent),
            parseInt((_comparisonData__results_life__work_subcategories_financial_health__security = (_comparisonData_3 = comparisonData[0]) === null || _comparisonData_3 === void 0 ? void 0 : _comparisonData_3.results.life__work.subcategories.financial_health__security) === null || _comparisonData__results_life__work_subcategories_financial_health__security === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_financial_health__security.percent),
            parseInt((_comparisonData__results_life__work_subcategories_education__professional_growth = (_comparisonData_4 = comparisonData[0]) === null || _comparisonData_4 === void 0 ? void 0 : _comparisonData_4.results.life__work.subcategories.education__professional_growth) === null || _comparisonData__results_life__work_subcategories_education__professional_growth === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_education__professional_growth.percent),
            parseInt((_comparisonData__results_life__work_subcategories_belonging__relationships = (_comparisonData_5 = comparisonData[0]) === null || _comparisonData_5 === void 0 ? void 0 : _comparisonData_5.results.life__work.subcategories.belonging__relationships) === null || _comparisonData__results_life__work_subcategories_belonging__relationships === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_belonging__relationships.percent),
            parseInt((_comparisonData__results_life__work_subcategories_purpose__meaning = (_comparisonData_6 = comparisonData[0]) === null || _comparisonData_6 === void 0 ? void 0 : _comparisonData_6.results.life__work.subcategories.purpose__meaning) === null || _comparisonData__results_life__work_subcategories_purpose__meaning === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_purpose__meaning.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_life__work_subcategories_physical_health__vitality1 = (_comparisonData_7 = comparisonData[1]) === null || _comparisonData_7 === void 0 ? void 0 : _comparisonData_7.results.life__work.subcategories.physical_health__vitality) === null || _comparisonData__results_life__work_subcategories_physical_health__vitality1 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_physical_health__vitality1.percent),
            parseInt((_comparisonData__results_life__work_subcategories_financial_health__security1 = (_comparisonData_8 = comparisonData[1]) === null || _comparisonData_8 === void 0 ? void 0 : _comparisonData_8.results.life__work.subcategories.financial_health__security) === null || _comparisonData__results_life__work_subcategories_financial_health__security1 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_financial_health__security1.percent),
            parseInt((_comparisonData__results_life__work_subcategories_education__professional_growth1 = (_comparisonData_9 = comparisonData[1]) === null || _comparisonData_9 === void 0 ? void 0 : _comparisonData_9.results.life__work.subcategories.education__professional_growth) === null || _comparisonData__results_life__work_subcategories_education__professional_growth1 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_education__professional_growth1.percent),
            parseInt((_comparisonData__results_life__work_subcategories_belonging__relationships1 = (_comparisonData_10 = comparisonData[1]) === null || _comparisonData_10 === void 0 ? void 0 : _comparisonData_10.results.life__work.subcategories.belonging__relationships) === null || _comparisonData__results_life__work_subcategories_belonging__relationships1 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_belonging__relationships1.percent),
            parseInt((_comparisonData__results_life__work_subcategories_purpose__meaning1 = (_comparisonData_11 = comparisonData[1]) === null || _comparisonData_11 === void 0 ? void 0 : _comparisonData_11.results.life__work.subcategories.purpose__meaning) === null || _comparisonData__results_life__work_subcategories_purpose__meaning1 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_purpose__meaning1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-blue-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Physical Health & Vitality",
        survey0: (_comparisonData__results_life__work_subcategories_physical_health__vitality2 = (_comparisonData_12 = comparisonData[0]) === null || _comparisonData_12 === void 0 ? void 0 : _comparisonData_12.results.life__work.subcategories.physical_health__vitality) === null || _comparisonData__results_life__work_subcategories_physical_health__vitality2 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_physical_health__vitality2.percent,
        survey1: (_comparisonData__results_life__work_subcategories_physical_health__vitality3 = (_comparisonData_13 = comparisonData[1]) === null || _comparisonData_13 === void 0 ? void 0 : _comparisonData_13.results.life__work.subcategories.physical_health__vitality) === null || _comparisonData__results_life__work_subcategories_physical_health__vitality3 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_physical_health__vitality3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Financial Health & Security",
        survey0: (_comparisonData__results_life__work_subcategories_financial_health__security2 = (_comparisonData_14 = comparisonData[0]) === null || _comparisonData_14 === void 0 ? void 0 : _comparisonData_14.results.life__work.subcategories.financial_health__security) === null || _comparisonData__results_life__work_subcategories_financial_health__security2 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_financial_health__security2.percent,
        survey1: (_comparisonData__results_life__work_subcategories_financial_health__security3 = (_comparisonData_15 = comparisonData[1]) === null || _comparisonData_15 === void 0 ? void 0 : _comparisonData_15.results.life__work.subcategories.financial_health__security) === null || _comparisonData__results_life__work_subcategories_financial_health__security3 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_financial_health__security3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Education & Professional Growth",
        survey0: (_comparisonData__results_life__work_subcategories_education__professional_growth2 = (_comparisonData_16 = comparisonData[0]) === null || _comparisonData_16 === void 0 ? void 0 : _comparisonData_16.results.life__work.subcategories.education__professional_growth) === null || _comparisonData__results_life__work_subcategories_education__professional_growth2 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_education__professional_growth2.percent,
        survey1: (_comparisonData__results_life__work_subcategories_education__professional_growth3 = (_comparisonData_17 = comparisonData[1]) === null || _comparisonData_17 === void 0 ? void 0 : _comparisonData_17.results.life__work.subcategories.education__professional_growth) === null || _comparisonData__results_life__work_subcategories_education__professional_growth3 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_education__professional_growth3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Belonging & Relationships",
        survey0: (_comparisonData__results_life__work_subcategories_belonging__relationships2 = (_comparisonData_18 = comparisonData[0]) === null || _comparisonData_18 === void 0 ? void 0 : _comparisonData_18.results.life__work.subcategories.belonging__relationships) === null || _comparisonData__results_life__work_subcategories_belonging__relationships2 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_belonging__relationships2.percent,
        survey1: (_comparisonData__results_life__work_subcategories_belonging__relationships3 = (_comparisonData_19 = comparisonData[1]) === null || _comparisonData_19 === void 0 ? void 0 : _comparisonData_19.results.life__work.subcategories.belonging__relationships) === null || _comparisonData__results_life__work_subcategories_belonging__relationships3 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_belonging__relationships3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Purpose & Meaning",
        survey0: (_comparisonData__results_life__work_subcategories_purpose__meaning2 = (_comparisonData_20 = comparisonData[0]) === null || _comparisonData_20 === void 0 ? void 0 : _comparisonData_20.results.life__work.subcategories.purpose__meaning) === null || _comparisonData__results_life__work_subcategories_purpose__meaning2 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_purpose__meaning2.percent,
        survey1: (_comparisonData__results_life__work_subcategories_purpose__meaning3 = (_comparisonData_21 = comparisonData[1]) === null || _comparisonData_21 === void 0 ? void 0 : _comparisonData_21.results.life__work.subcategories.purpose__meaning) === null || _comparisonData__results_life__work_subcategories_purpose__meaning3 === void 0 ? void 0 : _comparisonData__results_life__work_subcategories_purpose__meaning3.percent
    }))))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-green-100"
    }, "Self Awareness"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: " d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-100 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-green-200 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Focus & Flow",
            "Fear & Attachment",
            "Burnout Resistance",
            "Emotional Intelligence",
            "Self-Compassion"
        ],
        colors: [
            "#509f92",
            "#37763B"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_self_awareness_subcategories_focus__flow = (_comparisonData_22 = comparisonData[0]) === null || _comparisonData_22 === void 0 ? void 0 : _comparisonData_22.results.self_awareness.subcategories.focus__flow) === null || _comparisonData__results_self_awareness_subcategories_focus__flow === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_focus__flow.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_fear__attachment = (_comparisonData_23 = comparisonData[0]) === null || _comparisonData_23 === void 0 ? void 0 : _comparisonData_23.results.self_awareness.subcategories.fear__attachment) === null || _comparisonData__results_self_awareness_subcategories_fear__attachment === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__attachment.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_burnout_resistance = (_comparisonData_24 = comparisonData[0]) === null || _comparisonData_24 === void 0 ? void 0 : _comparisonData_24.results.self_awareness.subcategories.burnout_resistance) === null || _comparisonData__results_self_awareness_subcategories_burnout_resistance === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_resistance.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_emotional_intelligence = (_comparisonData_25 = comparisonData[0]) === null || _comparisonData_25 === void 0 ? void 0 : _comparisonData_25.results.self_awareness.subcategories.emotional_intelligence) === null || _comparisonData__results_self_awareness_subcategories_emotional_intelligence === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_emotional_intelligence.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_self_compassion = (_comparisonData_26 = comparisonData[0]) === null || _comparisonData_26 === void 0 ? void 0 : _comparisonData_26.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_self_awareness_subcategories_focus__flow1 = (_comparisonData_27 = comparisonData[1]) === null || _comparisonData_27 === void 0 ? void 0 : _comparisonData_27.results.self_awareness.subcategories.focus__flow) === null || _comparisonData__results_self_awareness_subcategories_focus__flow1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_focus__flow1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_fear__attachment1 = (_comparisonData_28 = comparisonData[1]) === null || _comparisonData_28 === void 0 ? void 0 : _comparisonData_28.results.self_awareness.subcategories.fear__attachment) === null || _comparisonData__results_self_awareness_subcategories_fear__attachment1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__attachment1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_burnout_resistance1 = (_comparisonData_29 = comparisonData[1]) === null || _comparisonData_29 === void 0 ? void 0 : _comparisonData_29.results.self_awareness.subcategories.burnout_resistance) === null || _comparisonData__results_self_awareness_subcategories_burnout_resistance1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_resistance1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_emotional_intelligence1 = (_comparisonData_30 = comparisonData[1]) === null || _comparisonData_30 === void 0 ? void 0 : _comparisonData_30.results.self_awareness.subcategories.emotional_intelligence) === null || _comparisonData__results_self_awareness_subcategories_emotional_intelligence1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_emotional_intelligence1.percent),
            parseInt((_comparisonData__results_self_awareness_subcategories_self_compassion1 = (_comparisonData_31 = comparisonData[1]) === null || _comparisonData_31 === void 0 ? void 0 : _comparisonData_31.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion1 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-100"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-green-200"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Focus & Flow",
        survey0: (_comparisonData__results_self_awareness_subcategories_focus__flow2 = (_comparisonData_32 = comparisonData[0]) === null || _comparisonData_32 === void 0 ? void 0 : _comparisonData_32.results.self_awareness.subcategories.focus__flow) === null || _comparisonData__results_self_awareness_subcategories_focus__flow2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_focus__flow2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_focus__flow3 = (_comparisonData_33 = comparisonData[1]) === null || _comparisonData_33 === void 0 ? void 0 : _comparisonData_33.results.self_awareness.subcategories.focus__flow) === null || _comparisonData__results_self_awareness_subcategories_focus__flow3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_focus__flow3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Fear & Attachment",
        survey0: (_comparisonData__results_self_awareness_subcategories_fear__attachment2 = (_comparisonData_34 = comparisonData[0]) === null || _comparisonData_34 === void 0 ? void 0 : _comparisonData_34.results.self_awareness.subcategories.fear__attachment) === null || _comparisonData__results_self_awareness_subcategories_fear__attachment2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__attachment2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_fear__attachment3 = (_comparisonData_35 = comparisonData[1]) === null || _comparisonData_35 === void 0 ? void 0 : _comparisonData_35.results.self_awareness.subcategories.fear__attachment) === null || _comparisonData__results_self_awareness_subcategories_fear__attachment3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_fear__attachment3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Burnout Resistance",
        survey0: (_comparisonData__results_self_awareness_subcategories_burnout_resistance2 = (_comparisonData_36 = comparisonData[0]) === null || _comparisonData_36 === void 0 ? void 0 : _comparisonData_36.results.self_awareness.subcategories.burnout_resistance) === null || _comparisonData__results_self_awareness_subcategories_burnout_resistance2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_resistance2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_burnout_resistance3 = (_comparisonData_37 = comparisonData[1]) === null || _comparisonData_37 === void 0 ? void 0 : _comparisonData_37.results.self_awareness.subcategories.burnout_resistance) === null || _comparisonData__results_self_awareness_subcategories_burnout_resistance3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_burnout_resistance3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Emotional Intelligence",
        survey0: (_comparisonData__results_self_awareness_subcategories_emotional_intelligence2 = (_comparisonData_38 = comparisonData[0]) === null || _comparisonData_38 === void 0 ? void 0 : _comparisonData_38.results.self_awareness.subcategories.emotional_intelligence) === null || _comparisonData__results_self_awareness_subcategories_emotional_intelligence2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_emotional_intelligence2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_emotional_intelligence3 = (_comparisonData_39 = comparisonData[1]) === null || _comparisonData_39 === void 0 ? void 0 : _comparisonData_39.results.self_awareness.subcategories.emotional_intelligence) === null || _comparisonData__results_self_awareness_subcategories_emotional_intelligence3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_emotional_intelligence3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Self-Compassion",
        survey0: (_comparisonData__results_self_awareness_subcategories_self_compassion2 = (_comparisonData_40 = comparisonData[0]) === null || _comparisonData_40 === void 0 ? void 0 : _comparisonData_40.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion2 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion2.percent,
        survey1: (_comparisonData__results_self_awareness_subcategories_self_compassion3 = (_comparisonData_41 = comparisonData[1]) === null || _comparisonData_41 === void 0 ? void 0 : _comparisonData_41.results.self_awareness.subcategories.self_compassion) === null || _comparisonData__results_self_awareness_subcategories_self_compassion3 === void 0 ? void 0 : _comparisonData__results_self_awareness_subcategories_self_compassion3.percent
    }))))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "result-category-compare-panel py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label text-red-500"
    }, "Timeless Wisdom"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 bg-gray-101 col-lg-3"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: "lg",
        className: " d-flex flex-row flex-lg-column h-100 justify-content-center align-items-center space-x-2 space-lg-y-3 py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-red-500 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPreDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "assessment-date space-y-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "bg-red-700 result-compare-circle"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-center results-date"
    }, "RESULTS DATED:\xa0", formatedPostDate, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12 col-lg-9 py-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $189bb98b3f895790$export$2e2bcd8739ae039), {
        categories: [
            "Compassion & Generosity",
            "Community",
            "Ethics & Decision-Making",
            "Nature",
            "Balance & Inner Peace"
        ],
        colors: [
            "#BC4C6A",
            "#7E2D55"
        ],
        surveyOne: [
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_compassion__generosity = (_comparisonData_42 = comparisonData[0]) === null || _comparisonData_42 === void 0 ? void 0 : _comparisonData_42.results.timeless_wisdom.subcategories.compassion__generosity) === null || _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_community = (_comparisonData_43 = comparisonData[0]) === null || _comparisonData_43 === void 0 ? void 0 : _comparisonData_43.results.timeless_wisdom.subcategories.community) === null || _comparisonData__results_timeless_wisdom_subcategories_community === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_community.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making = (_comparisonData_44 = comparisonData[0]) === null || _comparisonData_44 === void 0 ? void 0 : _comparisonData_44.results.timeless_wisdom.subcategories.ethics__decision_making) === null || _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_nature = (_comparisonData_45 = comparisonData[0]) === null || _comparisonData_45 === void 0 ? void 0 : _comparisonData_45.results.timeless_wisdom.subcategories.nature) === null || _comparisonData__results_timeless_wisdom_subcategories_nature === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_nature.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace = (_comparisonData_46 = comparisonData[0]) === null || _comparisonData_46 === void 0 ? void 0 : _comparisonData_46.results.timeless_wisdom.subcategories.balance__inner_peace) === null || _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace.percent)
        ],
        surveyTwo: [
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_compassion__generosity1 = (_comparisonData_47 = comparisonData[1]) === null || _comparisonData_47 === void 0 ? void 0 : _comparisonData_47.results.timeless_wisdom.subcategories.compassion__generosity) === null || _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity1 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity1.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_community1 = (_comparisonData_48 = comparisonData[1]) === null || _comparisonData_48 === void 0 ? void 0 : _comparisonData_48.results.timeless_wisdom.subcategories.community) === null || _comparisonData__results_timeless_wisdom_subcategories_community1 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_community1.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making1 = (_comparisonData_49 = comparisonData[1]) === null || _comparisonData_49 === void 0 ? void 0 : _comparisonData_49.results.timeless_wisdom.subcategories.ethics__decision_making) === null || _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making1 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making1.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_nature1 = (_comparisonData_50 = comparisonData[1]) === null || _comparisonData_50 === void 0 ? void 0 : _comparisonData_50.results.timeless_wisdom.subcategories.nature) === null || _comparisonData__results_timeless_wisdom_subcategories_nature1 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_nature1.percent),
            parseInt((_comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace1 = (_comparisonData_51 = comparisonData[1]) === null || _comparisonData_51 === void 0 ? void 0 : _comparisonData_51.results.timeless_wisdom.subcategories.balance__inner_peace) === null || _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace1 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace1.percent)
        ]
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        responsive: true,
        hover: true,
        size: "sm",
        className: "comparison-table m-auto"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", null, "Subcategory"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-red-500"
    }, "Score #1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPreDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center text-red-700"
    }, "Score #2", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), formatedPostDate), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        className: "text-center"
    }, "Change ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("br", null), "(+/-)"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Compassion & Generosity",
        survey0: (_comparisonData__results_timeless_wisdom_subcategories_compassion__generosity2 = (_comparisonData_52 = comparisonData[0]) === null || _comparisonData_52 === void 0 ? void 0 : _comparisonData_52.results.timeless_wisdom.subcategories.compassion__generosity) === null || _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity2 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity2.percent,
        survey1: (_comparisonData__results_timeless_wisdom_subcategories_compassion__generosity3 = (_comparisonData_53 = comparisonData[1]) === null || _comparisonData_53 === void 0 ? void 0 : _comparisonData_53.results.timeless_wisdom.subcategories.compassion__generosity) === null || _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity3 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_compassion__generosity3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Community",
        survey0: (_comparisonData__results_timeless_wisdom_subcategories_community2 = (_comparisonData_54 = comparisonData[0]) === null || _comparisonData_54 === void 0 ? void 0 : _comparisonData_54.results.timeless_wisdom.subcategories.community) === null || _comparisonData__results_timeless_wisdom_subcategories_community2 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_community2.percent,
        survey1: (_comparisonData__results_timeless_wisdom_subcategories_community3 = (_comparisonData_55 = comparisonData[1]) === null || _comparisonData_55 === void 0 ? void 0 : _comparisonData_55.results.timeless_wisdom.subcategories.community) === null || _comparisonData__results_timeless_wisdom_subcategories_community3 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_community3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Ethics & Decision-Making",
        survey0: (_comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making2 = (_comparisonData_56 = comparisonData[0]) === null || _comparisonData_56 === void 0 ? void 0 : _comparisonData_56.results.timeless_wisdom.subcategories.ethics__decision_making) === null || _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making2 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making2.percent,
        survey1: (_comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making3 = (_comparisonData_57 = comparisonData[1]) === null || _comparisonData_57 === void 0 ? void 0 : _comparisonData_57.results.timeless_wisdom.subcategories.ethics__decision_making) === null || _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making3 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_ethics__decision_making3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Nature",
        survey0: (_comparisonData__results_timeless_wisdom_subcategories_nature2 = (_comparisonData_58 = comparisonData[0]) === null || _comparisonData_58 === void 0 ? void 0 : _comparisonData_58.results.timeless_wisdom.subcategories.nature) === null || _comparisonData__results_timeless_wisdom_subcategories_nature2 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_nature2.percent,
        survey1: (_comparisonData__results_timeless_wisdom_subcategories_nature3 = (_comparisonData_59 = comparisonData[1]) === null || _comparisonData_59 === void 0 ? void 0 : _comparisonData_59.results.timeless_wisdom.subcategories.nature) === null || _comparisonData__results_timeless_wisdom_subcategories_nature3 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_nature3.percent
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $4932261e9054e49d$export$2e2bcd8739ae039), {
        title: "Balance & Inner Peace",
        survey0: (_comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace2 = (_comparisonData_60 = comparisonData[0]) === null || _comparisonData_60 === void 0 ? void 0 : _comparisonData_60.results.timeless_wisdom.subcategories.balance__inner_peace) === null || _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace2 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace2.percent,
        survey1: (_comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace3 = (_comparisonData_61 = comparisonData[1]) === null || _comparisonData_61 === void 0 ? void 0 : _comparisonData_61.results.timeless_wisdom.subcategories.balance__inner_peace) === null || _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace3 === void 0 ? void 0 : _comparisonData__results_timeless_wisdom_subcategories_balance__inner_peace3.percent
    }))))))))), props && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("compare-pdf-section", {
            "offset-lg-1 col-lg-10 px-lg-0 px-sm-2 pt-2": isRenderFromOP
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "py-2"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Container), {
        fluid: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "result-category-compare-label"
    }, "Assessment Users"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        noGutters: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-12"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "10%"
    }, "#"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Full Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Email"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Quarter"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, comparisonData.length > 0 ? comparisonData.map((item, dataIndex)=>{
        const quarter = dataIndex === 0 ? preQuarter : postQuarter;
        const year = dataIndex === 0 ? preYear : postYear;
        const allUsers = comparisonData.map((data)=>data.users).flat();
        const filteredUsers = (props === null || props === void 0 ? void 0 : props.apiFor) === "common-users" ? item.users.filter((user)=>allUsers.filter((u)=>u._id === user._id).length > 1) : item.users;
        return filteredUsers.map((user)=>{
            userDataIndex = userDataIndex + 1;
            return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
                key: `${user._id}-${dataIndex}`
            }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, userDataIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.fullName || "N/A"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, user.email), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", null, `Quarter ${quarter} ${year}`));
        });
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        colSpan: "4",
        className: "text-center"
    }, "Assessment users not available at this moment."))))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a342f5c2d7c66d88$export$2e2bcd8739ae039), null));
};
var $1b858d3f322ddeab$export$2e2bcd8739ae039 = $1b858d3f322ddeab$var$ProsperityComparisonReport;
















const $8efd51987544649f$var$UserProfileIcon = ({ className: className , isActive: isActive , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("icon icon-user text-black cursor-pointer font-24", {
            "text-saffron-300 active": isActive
        }, className),
        ...rest
    });
};
var $8efd51987544649f$export$2e2bcd8739ae039 = $8efd51987544649f$var$UserProfileIcon;


const $47128abee7b91e19$var$ProfileButton = ({ isActive: isActive , iconClasses: iconClasses = ""  })=>{
    return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
    /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
        href: "#",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("text-dark-900 text-decoration-none d-flex justify-content-center align-items-center cursor-pointer profile-icon-wrapper", {
            active: isActive
        })
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $8efd51987544649f$export$2e2bcd8739ae039), {
        isActive: isActive,
        className: iconClasses
    })));
};
var $47128abee7b91e19$export$2e2bcd8739ae039 = $47128abee7b91e19$var$ProfileButton;








const $a5cf6b9480d432d8$var$Logout = ({ className: className , onLogout: onLogout , i18n: i18n , url1: url1 , url2: url2  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Dropdown).Item, {
        as: "button",
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("cursor-pointer logout-button", className),
        onClick: ()=>onLogout()
    }, "Sign Out");
};
var $a5cf6b9480d432d8$export$2e2bcd8739ae039 = $a5cf6b9480d432d8$var$Logout;





const $8c6c6c33107b39ee$var$ProfileDropdown = ({ onLogout: onLogout , i18n: i18n , profile: profile , render: render , url1: url1 , url2: url2 , iconClasses: iconClasses  })=>{
    const [showDropdown, setShowDropdown] = (0, $feLGi$react.useState)(false);
    (0, $feLGi$react.useEffect)(()=>{
        render(showDropdown);
    }, [
        showDropdown,
        render
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Dropdown), {
        show: showDropdown,
        className: "z3",
        onToggle: ()=>setShowDropdown(!showDropdown)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Dropdown).Toggle, {
        as: (0, $4981807084a09ca7$export$2e2bcd8739ae039),
        id: "dropdown-profile"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $47128abee7b91e19$export$2e2bcd8739ae039), {
        isActive: showDropdown,
        iconClasses: iconClasses
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Dropdown).Menu, {
        onClick: ()=>setShowDropdown(!showDropdown),
        popperConfig: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            20
                        ]
                    }
                }
            ]
        },
        align: "right",
        className: "profile-dropdown header-drop-down text-center"
    }, profile(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a5cf6b9480d432d8$export$2e2bcd8739ae039), {
        className: "text-left",
        onLogout: onLogout,
        i18n: i18n,
        url1: url1,
        url2: url2
    })));
};
var $8c6c6c33107b39ee$export$2e2bcd8739ae039 = $8c6c6c33107b39ee$var$ProfileDropdown;









const $1d50b8027efcc9eb$var$Loader = ({ featherProps: featherProps , height: height  })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center align-items-center",
        style: {
            height: `${height}vh`
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $0999456108fdf02f$export$2e2bcd8739ae039), {
        width: featherProps.width,
        ...featherProps
    }));
};
$1d50b8027efcc9eb$var$Loader.defaultProps = {
    featherProps: {
        width: 60
    },
    height: 100
};
var $1d50b8027efcc9eb$export$2e2bcd8739ae039 = $1d50b8027efcc9eb$var$Loader;


/* eslint-disable react-hooks/exhaustive-deps */ 







const $0c73f0c36d6393b1$var$TextArea = /*#__PURE__*/ (0, $feLGi$react.forwardRef)((props, ref)=>{
    const textareaRef = (0, $feLGi$react.useRef)(null);
    // Use the forwarded ref if provided, otherwise use the internal ref
    const finalRef = ref || textareaRef;
    (0, $feLGi$react.useEffect)(()=>{
        if (finalRef.current) {
            finalRef.current.style.height = "0px";
            const scrollHeight = finalRef.current.scrollHeight;
            finalRef.current.style.height = scrollHeight + "px";
        }
    }, [
        props,
        finalRef
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("textarea", {
        ref: finalRef,
        rows: "1",
        placeholder: "Type your answer here...",
        className: "bg-transparent s13 focus-visible resize-none mb-3 border-0 w-100",
        style: {
            color: "#fff"
        },
        ...props
    });
});
var $0c73f0c36d6393b1$export$2e2bcd8739ae039 = $0c73f0c36d6393b1$var$TextArea;


const $741477a3bb5af4c8$var$TextQuestion = ({ question: question , questionIndex: questionIndex , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field, meta] = (0, $feLGi$formik.useField)(question._id);
    const textareaRef = (0, $feLGi$react.useRef)(null);
    // Set cursor position to end when component mounts or value changes
    (0, $feLGi$react.useEffect)(()=>{
        if (textareaRef.current && field.value) {
            const textarea = textareaRef.current;
            const length = textarea.value.length;
            textarea.setSelectionRange(length, length);
            textarea.focus();
        }
    }, [
        field.value
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (question.isRequired && (!field.value || !field.value.trim())) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: field.value
        });
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (question.isRequired && (!field.value || !field.value.trim())) {
                setShowError(true);
                return;
            }
            // Only call onSubmit if validation passes
            onSubmit({
                [question._id]: field.value
            });
        }
    };
    const handleChange = (e)=>{
        field.onChange(e);
        // Clear error when user starts typing
        if (showError && e.target.value && e.target.value.trim() !== "") setShowError(false);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "text-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "input-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $0c73f0c36d6393b1$export$2e2bcd8739ae039), {
        ref: textareaRef,
        ...field,
        className: `text-input typeform-text-input px-0 ${meta.touched && meta.error ? "error" : ""}`,
        placeholder: "Type your answer here...",
        onKeyPress: handleKeyPress,
        onChange: handleChange,
        autoFocus: true,
        style: {
            color: "#333"
        }
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "input-underline"
    })), showError ? question.isRequired && (!field.value || !field.value.trim()) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "This field is required"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Shift"), " ⇧ ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, " + Enter"), " ↵ to make a line break")))))));
};
var $741477a3bb5af4c8$export$2e2bcd8739ae039 = $741477a3bb5af4c8$var$TextQuestion;





const $0a2eb85e94a9408d$var$EmailQuestion = ({ question: question , questionIndex: questionIndex , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    // Email validation regex (same as LoginForm)
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Email validation function
    const validateEmail = (email)=>{
        if (!email || !email.trim()) return question.isRequired ? "This field is required" : null;
        if (email.length > 255) return "Email address is too long (maximum 255 characters)";
        if (!emailRegex.test(email)) return "Please enter a valid email address";
        return null;
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const emailError = validateEmail(field.value);
        if (emailError) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: field.value
        });
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            const emailError = validateEmail(field.value);
            if (emailError) {
                setShowError(true);
                return;
            }
            // Only call onSubmit if validation passes
            onSubmit({
                [question._id]: field.value
            });
        }
    };
    const handleChange = (e)=>{
        field.onChange(e);
        // Clear error when user starts typing
        if (showError && e.target.value && e.target.value.trim() !== "") setShowError(false);
    };
    // Get validation error message
    const getErrorMessage = ()=>{
        if (!showError) return null;
        const emailError = validateEmail(field.value);
        if (emailError) return emailError;
        return null;
    };
    const errorMessage = getErrorMessage();
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "email-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "input-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        ...field,
        type: "email",
        className: `email-input pt-0 ${errorMessage ? "error" : ""}`,
        placeholder: "Type your email here",
        onKeyDown: handleKeyPress,
        onChange: handleChange,
        autoFocus: true
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "input-underline"
    })), errorMessage ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, errorMessage))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $0a2eb85e94a9408d$export$2e2bcd8739ae039 = $0a2eb85e94a9408d$var$EmailQuestion;






// Helper function to get flag emoji using Unicode
const $1480b2b91d00b0e1$var$getFlagEmoji = (countryCode)=>{
    try {
        // Convert country code to Unicode flag emoji
        const codePoints = countryCode.toUpperCase().split("").map((char)=>127397 + char.charCodeAt());
        return String.fromCodePoint(...codePoints);
    } catch (error) {
        console.warn(`Could not get flag for country ${countryCode}:`, error);
        return "\uD83C\uDFF3️" // fallback flag
        ;
    }
};
// Get all countries from world-countries library
const $1480b2b91d00b0e1$var$getCountryDataWithDialCodes = ()=>{
    return (0, ($parcel$interopDefault($feLGi$worldcountries))).filter((country)=>country.callingCode && country.callingCode.length > 0) // Only countries with dial codes
    .map((country)=>({
            code: country.cca2.toLowerCase(),
            name: country.name.common,
            dialCode: country.callingCode[0],
            flag: $1480b2b91d00b0e1$var$getFlagEmoji(country.cca2) // Generate flag emoji
        })).sort((a, b)=>a.name.localeCompare(b.name)) // Sort alphabetically by name
    ;
};
const $1480b2b91d00b0e1$export$1edff44e77b160f4 = ()=>{
    const countryData = $1480b2b91d00b0e1$var$getCountryDataWithDialCodes();
    return countryData.map((country)=>({
            ...country,
            label: `${country.flag} ${country.name} (+${country.dialCode})`,
            value: country.code
        }));
};
const $1480b2b91d00b0e1$export$32818d644d898061 = (countryCode)=>{
    const countryData = $1480b2b91d00b0e1$var$getCountryDataWithDialCodes();
    const country = countryData.find((c)=>c.code === countryCode);
    return country ? country.dialCode : "1";
};
const $1480b2b91d00b0e1$export$6974c8fc4e302737 = (dialCode)=>{
    const countryData = $1480b2b91d00b0e1$var$getCountryDataWithDialCodes();
    return countryData.find((c)=>c.dialCode === dialCode);
};



const $6f551deb21170b2b$var$PhoneQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    const [phoneNumber, setPhoneNumber] = (0, $feLGi$react.useState)("");
    const [currentCountry, setCurrentCountry] = (0, $feLGi$react.useState)("us") // Default to US
    ;
    const [selectedCountry, setSelectedCountry] = (0, $feLGi$react.useState)(null);
    const [showCountrySelect, setShowCountrySelect] = (0, $feLGi$react.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $feLGi$react.useState)("");
    const [isScrolled, setIsScrolled] = (0, $feLGi$react.useState)(false);
    const [isClosing, setIsClosing] = (0, $feLGi$react.useState)(false);
    const [isDesktopClosing, setIsDesktopClosing] = (0, $feLGi$react.useState)(false);
    const [isDesktopOpening, setIsDesktopOpening] = (0, $feLGi$react.useState)(false);
    const dropdownRef = (0, $feLGi$react.useRef)(null);
    // Get processed country data with flags and translated names
    const countryData = (0, $feLGi$react.useMemo)(()=>{
        return (0, $1480b2b91d00b0e1$export$1edff44e77b160f4)();
    }, []);
    // Sort countries alphabetically
    const sortedCountries = (0, $feLGi$react.useMemo)(()=>{
        return countryData.sort((a, b)=>a.name.localeCompare(b.name));
    }, [
        countryData
    ]);
    // Filter countries based on search term
    const filteredCountries = (0, $feLGi$react.useMemo)(()=>{
        if (!searchTerm) return sortedCountries;
        const searchLower = searchTerm.toLowerCase();
        return sortedCountries.filter((country)=>country.name.toLowerCase().includes(searchLower) || country.dialCode.includes(searchTerm) || country.code.toLowerCase().includes(searchLower)).sort((a, b)=>{
            // Prioritize exact matches and matches at the beginning
            const aNameLower = a.name.toLowerCase();
            const bNameLower = b.name.toLowerCase();
            // Exact match gets highest priority
            if (aNameLower === searchLower) return -1;
            if (bNameLower === searchLower) return 1;
            // Starts with gets second priority
            if (aNameLower.startsWith(searchLower)) return -1;
            if (bNameLower.startsWith(searchLower)) return 1;
            // Then sort by position of match (earlier = higher priority)
            const aIndex = aNameLower.indexOf(searchLower);
            const bIndex = bNameLower.indexOf(searchLower);
            if (aIndex !== bIndex) return aIndex - bIndex;
            // Finally sort alphabetically
            return aNameLower.localeCompare(bNameLower);
        });
    }, [
        sortedCountries,
        searchTerm
    ]);
    // Helper function to highlight matched text
    const highlightText = (text, searchTerm)=>{
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
        const parts = text.split(regex);
        return parts.map((part, index)=>regex.test(part) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", {
                key: index
            }, part) : part);
    };
    // Handle scroll event for search section shadow
    const handleScroll = (e)=>{
        const scrollTop = e.target.scrollTop;
        setIsScrolled(scrollTop > 0);
    };
    // Handle closing the mobile dropdown with animation
    const handleCloseMobileDropdown = ()=>{
        setIsClosing(true);
        // Wait for animation to complete before actually closing
        setTimeout(()=>{
            setShowCountrySelect(false);
            setIsClosing(false);
            setSearchTerm("");
        }, 300) // Match the animation duration
        ;
    };
    // Handle opening the desktop dropdown with animation
    const handleOpenDesktopDropdown = ()=>{
        setShowCountrySelect(true);
        setIsDesktopOpening(true);
        setSearchTerm("");
        // After a brief moment, remove the opening class to trigger the show animation
        setTimeout(()=>{
            setIsDesktopOpening(false);
        }, 10) // Small delay to ensure the opening state is applied first
        ;
    };
    // Handle closing the desktop dropdown with animation
    const handleCloseDesktopDropdown = ()=>{
        setIsDesktopClosing(true);
        // Wait for animation to complete before actually closing
        setTimeout(()=>{
            setShowCountrySelect(false);
            setIsDesktopClosing(false);
            setSearchTerm("");
        }, 300) // Match the animation duration
        ;
    };
    // Phone number formatting functions
    const formatPhoneNumber = (phone, countryCode = "us")=>{
        if (!phone) return "";
        const digitsOnly = phone.replace(/\D/g, "");
        switch(countryCode.toLowerCase()){
            case "us":
            case "ca":
                if (digitsOnly.length <= 3) return digitsOnly;
                else if (digitsOnly.length <= 6) return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
                else if (digitsOnly.length <= 10) return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
                else return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
            case "gb":
                if (digitsOnly.length <= 4) return digitsOnly;
                else if (digitsOnly.length <= 7) return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4)}`;
                else if (digitsOnly.length <= 10) return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7)}`;
                else return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 10)}`;
            case "in":
                if (digitsOnly.length <= 5) return digitsOnly;
                else if (digitsOnly.length <= 10) return `${digitsOnly.slice(0, 5)} ${digitsOnly.slice(5)}`;
                else return `${digitsOnly.slice(0, 5)} ${digitsOnly.slice(5, 10)}`;
            case "au":
                if (digitsOnly.length <= 4) return digitsOnly;
                else if (digitsOnly.length <= 7) return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4)}`;
                else if (digitsOnly.length <= 9) return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7)}`;
                else return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 9)}`;
            case "de":
                if (digitsOnly.length <= 3) return digitsOnly;
                else if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
                else if (digitsOnly.length <= 9) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6)}`;
                else if (digitsOnly.length <= 11) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6, 9)} ${digitsOnly.slice(9)}`;
                else return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6, 9)} ${digitsOnly.slice(9, 11)}`;
            case "fr":
                if (digitsOnly.length <= 2) return digitsOnly;
                else if (digitsOnly.length <= 4) return `${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2)}`;
                else if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2, 4)} ${digitsOnly.slice(4)}`;
                else if (digitsOnly.length <= 8) return `${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2, 4)} ${digitsOnly.slice(4, 6)} ${digitsOnly.slice(6)}`;
                else if (digitsOnly.length <= 10) return `${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2, 4)} ${digitsOnly.slice(4, 6)} ${digitsOnly.slice(6, 8)} ${digitsOnly.slice(8)}`;
                else return `${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2, 4)} ${digitsOnly.slice(4, 6)} ${digitsOnly.slice(6, 8)} ${digitsOnly.slice(8, 10)}`;
            case "jp":
                if (digitsOnly.length <= 3) return digitsOnly;
                else if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
                else if (digitsOnly.length === 10) {
                    // Landline format: 0X-XXXX-XXXX or 0XX-XXX-XXXX
                    if (digitsOnly.startsWith("0")) {
                        // Check if it's a 2-digit area code (Tokyo, Osaka, etc.)
                        if (digitsOnly.startsWith("03") || digitsOnly.startsWith("06") || digitsOnly.startsWith("011") || digitsOnly.startsWith("0120")) return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2, 6)}-${digitsOnly.slice(6)}`;
                        else // 3-digit area code
                        return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
                    } else // Fallback to 3-3-4 format
                    return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
                } else if (digitsOnly.length === 11) // Mobile format: 090-XXXX-XXXX, 080-XXXX-XXXX, 070-XXXX-XXXX
                return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 7)}-${digitsOnly.slice(7)}`;
                else // Fallback for other lengths
                return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
            case "br":
                if (digitsOnly.length <= 2) return digitsOnly;
                else if (digitsOnly.length <= 6) return `(${digitsOnly.slice(0, 2)}) ${digitsOnly.slice(2)}`;
                else if (digitsOnly.length <= 10) return `(${digitsOnly.slice(0, 2)}) ${digitsOnly.slice(2, 6)}-${digitsOnly.slice(6)}`;
                else return `(${digitsOnly.slice(0, 2)}) ${digitsOnly.slice(2, 6)}-${digitsOnly.slice(6, 10)}`;
            case "mx":
                if (digitsOnly.length <= 3) return digitsOnly;
                else if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
                else if (digitsOnly.length <= 10) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6)}`;
                else return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6, 10)}`;
            default:
                // Generic formatting for other countries
                if (digitsOnly.length <= 3) return digitsOnly;
                else if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
                else if (digitsOnly.length <= 9) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6)}`;
                else if (digitsOnly.length <= 12) return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6, 9)} ${digitsOnly.slice(9)}`;
                else return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 6)} ${digitsOnly.slice(6, 9)} ${digitsOnly.slice(9, 12)}`;
        }
    };
    // Phone validation
    const validatePhone = (phone, countryCode = "us")=>{
        if (!phone || !phone.trim()) return question.isRequired ? "This field is required" : null;
        const digitsOnly = phone.replace(/\D/g, "");
        if (digitsOnly.length < 7) return "Hmm... that phone number doesn't look right";
        if (digitsOnly.length > 15) return "Hmm... that phone number doesn't look right";
        switch(countryCode.toLowerCase()){
            case "us":
            case "ca":
                return digitsOnly.length === 10 || digitsOnly.length === 11 ? null : "Hmm... that phone number doesn't look right";
            case "gb":
                return digitsOnly.length >= 10 && digitsOnly.length <= 11 ? null : "Hmm... that phone number doesn't look right";
            case "in":
                return digitsOnly.length === 10 ? null : "Hmm... that phone number doesn't look right";
            case "au":
                return digitsOnly.length === 9 ? null : "Hmm... that phone number doesn't look right";
            case "jp":
                return digitsOnly.length === 10 || digitsOnly.length === 11 ? null : "Hmm... that phone number doesn't look right";
            default:
                return digitsOnly.length >= 7 && digitsOnly.length <= 15 ? null : "Please enter a valid phone number";
        }
    };
    // Extract country code and phone number from saved value
    const extractCountryAndPhone = (savedValue)=>{
        if (!savedValue || typeof savedValue !== "string") return {
            countryCode: "us",
            phoneNumber: ""
        };
        // Handle old format: +{dialCode}|{countryCode} {phoneNumber}
        const oldFormatMatch = savedValue.match(/^\+(\d+)\|([a-z]{2})\s+(.+)$/);
        if (oldFormatMatch) {
            const countryCode = oldFormatMatch[2];
            const phoneNumber = oldFormatMatch[3];
            return {
                countryCode: countryCode,
                phoneNumber: phoneNumber
            };
        }
        // Handle new format: +{dialCode} {phoneNumber}
        const newFormatMatch = savedValue.match(/^\+(\d+)\s+(.+)$/);
        if (newFormatMatch) {
            const dialCode = newFormatMatch[1];
            const phoneNumber = newFormatMatch[2];
            // Find country by dial code - prefer US for dial code 1
            if (dialCode === "1") return {
                countryCode: "us",
                phoneNumber: phoneNumber
            };
            const countryByDialCode = (0, $1480b2b91d00b0e1$export$6974c8fc4e302737)(dialCode);
            if (countryByDialCode) return {
                countryCode: countryByDialCode.code,
                phoneNumber: phoneNumber
            };
        }
        // If it's just a phone number without country code, assume US
        if (savedValue.match(/^\d+$/)) return {
            countryCode: "us",
            phoneNumber: savedValue
        };
        // If it's a string that doesn't match any format, treat as phone number with US country
        return {
            countryCode: "us",
            phoneNumber: savedValue
        };
    };
    // Initialize selected country and phone number from saved value
    (0, $feLGi$react.useEffect)(()=>{
        if (sortedCountries.length > 0) {
            const sourceValue = value || field.value;
            const { countryCode: countryCode , phoneNumber: extractedPhone  } = extractCountryAndPhone(sourceValue);
            // Set the country
            setCurrentCountry(countryCode);
            // Find and set the selected country object
            const countryObj = sortedCountries.find((c)=>c.code === countryCode) || sortedCountries.find((c)=>c.code === "us") || sortedCountries[0];
            if (countryObj) setSelectedCountry(countryObj);
            // Format and set the phone number
            if (extractedPhone) {
                const formattedNumber = formatPhoneNumber(extractedPhone, countryCode);
                setPhoneNumber(formattedNumber);
            } else setPhoneNumber("");
        }
    }, [
        value,
        field.value,
        sortedCountries
    ]);
    // Handle click outside to close dropdown
    (0, $feLGi$react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) handleCloseDesktopDropdown();
        };
        if (showCountrySelect) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showCountrySelect
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        const digitsOnly = phoneNumber.replace(/\D/g, "");
        const phoneError = validatePhone(digitsOnly, currentCountry);
        if (phoneError) {
            setShowError(true);
            return;
        }
        const fullValue = `+${(0, $1480b2b91d00b0e1$export$32818d644d898061)(currentCountry)} ${digitsOnly}`;
        onSubmit({
            [question._id]: fullValue
        });
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            const digitsOnly = phoneNumber.replace(/\D/g, "");
            const phoneError = validatePhone(digitsOnly, currentCountry);
            if (phoneError) {
                setShowError(true);
                return;
            }
            const fullValue = `+${(0, $1480b2b91d00b0e1$export$32818d644d898061)(currentCountry)} ${digitsOnly}`;
            onSubmit({
                [question._id]: fullValue
            });
        }
    };
    const handlePhoneChange = (e)=>{
        const inputValue = e.target.value;
        const digitsOnly = inputValue.replace(/\D/g, "");
        // Format the phone number based on the current country
        const formattedNumber = formatPhoneNumber(digitsOnly, currentCountry);
        setPhoneNumber(formattedNumber);
        if (selectedCountry) {
            // Store the full format in formik field for submission (with digits only for backend)
            const fullValue = `+${selectedCountry.dialCode} ${digitsOnly}`;
            field.onChange({
                target: {
                    name: field.name,
                    value: fullValue
                }
            });
            // Clear error if phone number is valid
            if (showError && digitsOnly && digitsOnly.trim() !== "") {
                const phoneError = validatePhone(digitsOnly, currentCountry);
                if (!phoneError) setShowError(false);
            }
        }
    };
    const handleCountryChange = (selectedOption)=>{
        setSelectedCountry(selectedOption);
        setCurrentCountry(selectedOption.code);
        // Use the animated close function instead of directly closing
        handleCloseMobileDropdown();
        // Reformat existing phone number with new country format
        if (phoneNumber && phoneNumber.trim()) {
            const digitsOnly = phoneNumber.replace(/\D/g, "");
            const formattedNumber = formatPhoneNumber(digitsOnly, selectedOption.code);
            setPhoneNumber(formattedNumber);
            // Store the full format in formik field for submission (with digits only for backend)
            const fullValue = `+${selectedOption.dialCode} ${digitsOnly}`;
            field.onChange({
                target: {
                    name: field.name,
                    value: fullValue
                }
            });
        }
    };
    const handleCountryClick = ()=>{
        if (!submitting) {
            if (showCountrySelect) // If dropdown is open, close it with animation
            handleCloseDesktopDropdown();
            else // If dropdown is closed, open it with animation
            handleOpenDesktopDropdown();
        }
    };
    const handleSearchChange = (e)=>{
        setSearchTerm(e.target.value);
    };
    const getErrorMessage = ()=>{
        if (!showError) return null;
        const digitsOnly = phoneNumber.replace(/\D/g, "");
        const phoneError = validatePhone(digitsOnly, currentCountry);
        return phoneError || null;
    };
    const errorMessage = getErrorMessage();
    const renderErrorContainer = ()=>{
        if (!errorMessage) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "error-container mt-16px",
            style: {
                opacity: showCountrySelect ? 0.3 : 1
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "error-message d-flex align-items-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "error-icon"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, errorMessage)));
    };
    const renderActionContainer = ()=>{
        if (errorMessage) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "action-container mt-16px",
            style: {
                opacity: showCountrySelect ? 0.3 : 1
            }
        }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
            onClick: onPrevious,
            className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
            disabled: submitting,
            style: {
                backgroundColor: "#0a223c",
                color: "white",
                border: "none",
                minWidth: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            className: "cursor-pointer"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M11 1.41406L4 8.20845",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M11 14.9975L4 8.20312",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
            onClick: handleSubmit,
            className: "border-radius-normal ok-button px-14px py-6px",
            isLoading: submitting,
            disabled: submitting,
            "data-text": buttonText
        }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "line-break-instruction d-sm-576-none d-lg-576-block"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "instruction-text text-abroad-blue"
        }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "phone-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "phone-input-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "custom-phone-input",
        style: {
            width: "100%",
            position: "relative"
        }
    }, (showCountrySelect || isClosing || isDesktopClosing || isDesktopOpening) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        ref: dropdownRef,
        className: `custom-country-dropdown show d-lg-576-block d-sm-576-none ${isClosing || isDesktopClosing ? "dropdown-closing" : isDesktopOpening ? "dropdown-opening" : "show"}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `search-section ${isScrolled ? "scrolled" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        placeholder: "Search countries",
        value: searchTerm,
        onChange: handleSearchChange,
        className: "search-input",
        autoFocus: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-list text-center",
        onScroll: handleScroll
    }, filteredCountries.length > 0 ? filteredCountries.map((country, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: country.code,
            onClick: ()=>handleCountryChange(country),
            className: `country-item ${(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) === country.code ? "selected" : ""}`
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "country-info"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
            countryCode: country.code.toUpperCase(),
            svg: true,
            className: "country-flag",
            style: {
                width: "1em",
                height: "1em",
                borderRadius: "30%"
            },
            "aria-label": country.code.toUpperCase()
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-name"
        }, highlightText(country.name, searchTerm))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-dial-code"
        }, "+", country.dialCode));
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
            opacity: showCountrySelect ? 0.3 : 1
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-flag-button d-flex align-items-center pe-1",
        onClick: handleCountryClick
    }, selectedCountry ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
        countryCode: ((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) || "us").toUpperCase(),
        svg: true,
        className: "me-2",
        style: {
            width: "1.25em",
            height: "1.25em",
            borderRadius: "30%"
        },
        "aria-label": ((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) || "us").toUpperCase()
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 48 48"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("polyline", {
        points: "12,20 24,30 36,20",
        fill: "none",
        stroke: "rgb(10, 34, 60)",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        style: {
            fontSize: "14px",
            color: "#666"
        }
    }, "Select country")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "tel",
        value: phoneNumber,
        onChange: handlePhoneChange,
        placeholder: "Enter phone number",
        disabled: submitting,
        className: "phone-number-input",
        name: field.name,
        required: question.isRequired,
        autoFocus: true,
        onKeyDown: handleKeyPress
    })))), renderErrorContainer(), renderActionContainer()))), (showCountrySelect || isClosing) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-modal d-sm-576-block d-lg-576-none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-overlay",
        onClick: handleCloseMobileDropdown
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `mobile-dropdown-sheet ${isClosing ? "closing" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-header"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        className: "mobile-dropdown-back-btn",
        onClick: handleCloseMobileDropdown,
        type: "button"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10 12L6 8L10 4",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        value: searchTerm,
        placeholder: "Search countries",
        onChange: handleSearchChange,
        className: "mobile-search-input",
        autoFocus: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-content"
    }, filteredCountries.length > 0 ? filteredCountries.map((country, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: country.code,
            className: `dropdown-option rounded-1 ${(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) === country.code ? "selected" : ""}`,
            onClick: ()=>handleCountryChange(country)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "country-info"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
            countryCode: country.code.toUpperCase(),
            svg: true,
            className: "country-flag pe-2",
            style: {
                width: "1.25em",
                height: "1.25em",
                borderRadius: "30%"
            },
            "aria-label": country.code.toUpperCase()
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-name"
        }, highlightText(country.name, searchTerm))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-dial-code pe-2"
        }, "+", country.dialCode));
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-no-suggestions-found"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "mobile-error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-action-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleCloseMobileDropdown,
        className: "border-radius-normal mobile-ok-button px-14px py-6px",
        "data-text": "OK"
    }, "OK")))))));
};
var $6f551deb21170b2b$export$2e2bcd8739ae039 = $6f551deb21170b2b$var$PhoneQuestion;





const $c45f87f8e3d3d7e7$export$a51c8ad41f831069 = [
    {
        code: "us",
        name: "United States",
        dialCode: "1"
    },
    {
        code: "ru",
        name: "Russia",
        dialCode: "7"
    },
    {
        code: "eg",
        name: "Egypt",
        dialCode: "20"
    },
    {
        code: "za",
        name: "South Africa",
        dialCode: "27"
    },
    {
        code: "gr",
        name: "Greece",
        dialCode: "30"
    },
    {
        code: "nl",
        name: "Netherlands",
        dialCode: "31"
    },
    {
        code: "be",
        name: "Belgium",
        dialCode: "32"
    },
    {
        code: "fr",
        name: "France",
        dialCode: "33"
    },
    {
        code: "es",
        name: "Spain",
        dialCode: "34"
    },
    {
        code: "hu",
        name: "Hungary",
        dialCode: "36"
    },
    {
        code: "it",
        name: "Italy",
        dialCode: "39"
    },
    {
        code: "ro",
        name: "Romania",
        dialCode: "40"
    },
    {
        code: "ch",
        name: "Switzerland",
        dialCode: "41"
    },
    {
        code: "at",
        name: "Austria",
        dialCode: "43"
    },
    {
        code: "gb",
        name: "United Kingdom",
        dialCode: "44"
    },
    {
        code: "dk",
        name: "Denmark",
        dialCode: "45"
    },
    {
        code: "se",
        name: "Sweden",
        dialCode: "46"
    },
    {
        code: "no",
        name: "Norway",
        dialCode: "47"
    },
    {
        code: "pl",
        name: "Poland",
        dialCode: "48"
    },
    {
        code: "de",
        name: "Germany",
        dialCode: "49"
    },
    {
        code: "pe",
        name: "Peru",
        dialCode: "51"
    },
    {
        code: "mx",
        name: "Mexico",
        dialCode: "52"
    },
    {
        code: "cu",
        name: "Cuba",
        dialCode: "53"
    },
    {
        code: "ar",
        name: "Argentina",
        dialCode: "54"
    },
    {
        code: "br",
        name: "Brazil",
        dialCode: "55"
    },
    {
        code: "cl",
        name: "Chile",
        dialCode: "56"
    },
    {
        code: "co",
        name: "Colombia",
        dialCode: "57"
    },
    {
        code: "ve",
        name: "Venezuela",
        dialCode: "58"
    },
    {
        code: "my",
        name: "Malaysia",
        dialCode: "60"
    },
    {
        code: "au",
        name: "Australia",
        dialCode: "61"
    },
    {
        code: "id",
        name: "Indonesia",
        dialCode: "62"
    },
    {
        code: "ph",
        name: "Philippines",
        dialCode: "63"
    },
    {
        code: "nz",
        name: "New Zealand",
        dialCode: "64"
    },
    {
        code: "th",
        name: "Thailand",
        dialCode: "66"
    },
    {
        code: "jp",
        name: "Japan",
        dialCode: "81"
    },
    {
        code: "kr",
        name: "South Korea",
        dialCode: "82"
    },
    {
        code: "vn",
        name: "Vietnam",
        dialCode: "84"
    },
    {
        code: "bd",
        name: "Bangladesh",
        dialCode: "880"
    },
    {
        code: "in",
        name: "India",
        dialCode: "91"
    },
    {
        code: "pk",
        name: "Pakistan",
        dialCode: "92"
    },
    {
        code: "af",
        name: "Afghanistan",
        dialCode: "93"
    },
    {
        code: "lk",
        name: "Sri Lanka",
        dialCode: "94"
    },
    {
        code: "mm",
        name: "Myanmar",
        dialCode: "95"
    },
    {
        code: "ir",
        name: "Iran",
        dialCode: "98"
    },
    {
        code: "ss",
        name: "South Sudan",
        dialCode: "211"
    },
    {
        code: "so",
        name: "Somalia",
        dialCode: "252"
    },
    {
        code: "dz",
        name: "Algeria",
        dialCode: "213"
    },
    {
        code: "ad",
        name: "Andorra",
        dialCode: "376"
    },
    {
        code: "ao",
        name: "Angola",
        dialCode: "244"
    },
    {
        code: "ai",
        name: "Anguilla",
        dialCode: "1264"
    },
    {
        code: "ag",
        name: "Antigua and Barbuda",
        dialCode: "1268"
    },
    {
        code: "am",
        name: "Armenia",
        dialCode: "374"
    },
    {
        code: "aw",
        name: "Aruba",
        dialCode: "297"
    },
    {
        code: "az",
        name: "Azerbaijan",
        dialCode: "994"
    },
    {
        code: "bs",
        name: "Bahamas",
        dialCode: "1242"
    },
    {
        code: "bh",
        name: "Bahrain",
        dialCode: "973"
    },
    {
        code: "bb",
        name: "Barbados",
        dialCode: "1246"
    },
    {
        code: "by",
        name: "Belarus",
        dialCode: "375"
    },
    {
        code: "bz",
        name: "Belize",
        dialCode: "501"
    },
    {
        code: "bj",
        name: "Benin",
        dialCode: "229"
    },
    {
        code: "bt",
        name: "Bhutan",
        dialCode: "975"
    },
    {
        code: "bo",
        name: "Bolivia",
        dialCode: "591"
    },
    {
        code: "ba",
        name: "Bosnia and Herzegovina",
        dialCode: "387"
    },
    {
        code: "bw",
        name: "Botswana",
        dialCode: "267"
    },
    {
        code: "bn",
        name: "Brunei",
        dialCode: "673"
    },
    {
        code: "bg",
        name: "Bulgaria",
        dialCode: "359"
    },
    {
        code: "bf",
        name: "Burkina Faso",
        dialCode: "226"
    },
    {
        code: "bi",
        name: "Burundi",
        dialCode: "257"
    },
    {
        code: "kh",
        name: "Cambodia",
        dialCode: "855"
    },
    {
        code: "cm",
        name: "Cameroon",
        dialCode: "237"
    },
    {
        code: "ca",
        name: "Canada",
        dialCode: "1"
    },
    {
        code: "cv",
        name: "Cape Verde",
        dialCode: "238"
    },
    {
        code: "cf",
        name: "Central African Republic",
        dialCode: "236"
    },
    {
        code: "td",
        name: "Chad",
        dialCode: "235"
    },
    {
        code: "cn",
        name: "China",
        dialCode: "86"
    },
    {
        code: "km",
        name: "Comoros",
        dialCode: "269"
    },
    {
        code: "cg",
        name: "Congo",
        dialCode: "242"
    },
    {
        code: "cd",
        name: "Democratic Republic of the Congo",
        dialCode: "243"
    },
    {
        code: "cr",
        name: "Costa Rica",
        dialCode: "506"
    },
    {
        code: "ci",
        name: "C\xf4te d'Ivoire",
        dialCode: "225"
    },
    {
        code: "hr",
        name: "Croatia",
        dialCode: "385"
    },
    {
        code: "cy",
        name: "Cyprus",
        dialCode: "357"
    },
    {
        code: "cz",
        name: "Czech Republic",
        dialCode: "420"
    },
    {
        code: "dj",
        name: "Djibouti",
        dialCode: "253"
    },
    {
        code: "dm",
        name: "Dominica",
        dialCode: "1767"
    },
    {
        code: "do",
        name: "Dominican Republic",
        dialCode: "1809"
    },
    {
        code: "ec",
        name: "Ecuador",
        dialCode: "593"
    },
    {
        code: "sv",
        name: "El Salvador",
        dialCode: "503"
    },
    {
        code: "gq",
        name: "Equatorial Guinea",
        dialCode: "240"
    },
    {
        code: "er",
        name: "Eritrea",
        dialCode: "291"
    },
    {
        code: "ee",
        name: "Estonia",
        dialCode: "372"
    },
    {
        code: "et",
        name: "Ethiopia",
        dialCode: "251"
    },
    {
        code: "fj",
        name: "Fiji",
        dialCode: "679"
    },
    {
        code: "fi",
        name: "Finland",
        dialCode: "358"
    },
    {
        code: "ga",
        name: "Gabon",
        dialCode: "241"
    },
    {
        code: "gm",
        name: "Gambia",
        dialCode: "220"
    },
    {
        code: "ge",
        name: "Georgia",
        dialCode: "995"
    },
    {
        code: "gh",
        name: "Ghana",
        dialCode: "233"
    },
    {
        code: "gd",
        name: "Grenada",
        dialCode: "1473"
    },
    {
        code: "gt",
        name: "Guatemala",
        dialCode: "502"
    },
    {
        code: "gn",
        name: "Guinea",
        dialCode: "224"
    },
    {
        code: "gw",
        name: "Guinea-Bissau",
        dialCode: "245"
    },
    {
        code: "gy",
        name: "Guyana",
        dialCode: "592"
    },
    {
        code: "ht",
        name: "Haiti",
        dialCode: "509"
    },
    {
        code: "hn",
        name: "Honduras",
        dialCode: "504"
    },
    {
        code: "is",
        name: "Iceland",
        dialCode: "354"
    },
    {
        code: "iq",
        name: "Iraq",
        dialCode: "964"
    },
    {
        code: "ie",
        name: "Ireland",
        dialCode: "353"
    },
    {
        code: "il",
        name: "Israel",
        dialCode: "972"
    },
    {
        code: "jm",
        name: "Jamaica",
        dialCode: "1876"
    },
    {
        code: "jo",
        name: "Jordan",
        dialCode: "962"
    },
    {
        code: "kz",
        name: "Kazakhstan",
        dialCode: "7"
    },
    {
        code: "ke",
        name: "Kenya",
        dialCode: "254"
    },
    {
        code: "ki",
        name: "Kiribati",
        dialCode: "686"
    },
    {
        code: "kp",
        name: "North Korea",
        dialCode: "850"
    },
    {
        code: "kw",
        name: "Kuwait",
        dialCode: "965"
    },
    {
        code: "kg",
        name: "Kyrgyzstan",
        dialCode: "996"
    },
    {
        code: "la",
        name: "Laos",
        dialCode: "856"
    },
    {
        code: "lv",
        name: "Latvia",
        dialCode: "371"
    },
    {
        code: "lb",
        name: "Lebanon",
        dialCode: "961"
    },
    {
        code: "ls",
        name: "Lesotho",
        dialCode: "266"
    },
    {
        code: "lr",
        name: "Liberia",
        dialCode: "231"
    },
    {
        code: "ly",
        name: "Libya",
        dialCode: "218"
    },
    {
        code: "li",
        name: "Liechtenstein",
        dialCode: "423"
    },
    {
        code: "lt",
        name: "Lithuania",
        dialCode: "370"
    },
    {
        code: "lu",
        name: "Luxembourg",
        dialCode: "352"
    },
    {
        code: "mk",
        name: "North Macedonia",
        dialCode: "389"
    },
    {
        code: "mg",
        name: "Madagascar",
        dialCode: "261"
    },
    {
        code: "mw",
        name: "Malawi",
        dialCode: "265"
    },
    {
        code: "mv",
        name: "Maldives",
        dialCode: "960"
    },
    {
        code: "ml",
        name: "Mali",
        dialCode: "223"
    },
    {
        code: "mt",
        name: "Malta",
        dialCode: "356"
    },
    {
        code: "mh",
        name: "Marshall Islands",
        dialCode: "692"
    },
    {
        code: "mr",
        name: "Mauritania",
        dialCode: "222"
    },
    {
        code: "mu",
        name: "Mauritius",
        dialCode: "230"
    },
    {
        code: "fm",
        name: "Micronesia",
        dialCode: "691"
    },
    {
        code: "md",
        name: "Moldova",
        dialCode: "373"
    },
    {
        code: "mc",
        name: "Monaco",
        dialCode: "377"
    },
    {
        code: "mn",
        name: "Mongolia",
        dialCode: "976"
    },
    {
        code: "me",
        name: "Montenegro",
        dialCode: "382"
    },
    {
        code: "ma",
        name: "Morocco",
        dialCode: "212"
    },
    {
        code: "mz",
        name: "Mozambique",
        dialCode: "258"
    },
    {
        code: "na",
        name: "Namibia",
        dialCode: "264"
    },
    {
        code: "nr",
        name: "Nauru",
        dialCode: "674"
    },
    {
        code: "np",
        name: "Nepal",
        dialCode: "971"
    },
    {
        code: "ni",
        name: "Nicaragua",
        dialCode: "505"
    },
    {
        code: "ne",
        name: "Niger",
        dialCode: "227"
    },
    {
        code: "ng",
        name: "Nigeria",
        dialCode: "234"
    },
    {
        code: "om",
        name: "Oman",
        dialCode: "968"
    },
    {
        code: "pw",
        name: "Palau",
        dialCode: "680"
    },
    {
        code: "pa",
        name: "Panama",
        dialCode: "507"
    },
    {
        code: "pg",
        name: "Papua New Guinea",
        dialCode: "675"
    },
    {
        code: "py",
        name: "Paraguay",
        dialCode: "595"
    },
    {
        code: "pt",
        name: "Portugal",
        dialCode: "351"
    },
    {
        code: "qa",
        name: "Qatar",
        dialCode: "974"
    },
    {
        code: "rw",
        name: "Rwanda",
        dialCode: "250"
    },
    {
        code: "kn",
        name: "Saint Kitts and Nevis",
        dialCode: "1869"
    },
    {
        code: "lc",
        name: "Saint Lucia",
        dialCode: "1758"
    },
    {
        code: "vc",
        name: "Saint Vincent and the Grenadines",
        dialCode: "1784"
    },
    {
        code: "ws",
        name: "Samoa",
        dialCode: "685"
    },
    {
        code: "sm",
        name: "San Marino",
        dialCode: "378"
    },
    {
        code: "st",
        name: "S\xe3o Tom\xe9 and Pr\xedncipe",
        dialCode: "239"
    },
    {
        code: "sa",
        name: "Saudi Arabia",
        dialCode: "966"
    },
    {
        code: "sn",
        name: "Senegal",
        dialCode: "221"
    },
    {
        code: "rs",
        name: "Serbia",
        dialCode: "381"
    },
    {
        code: "sc",
        name: "Seychelles",
        dialCode: "248"
    },
    {
        code: "sl",
        name: "Sierra Leone",
        dialCode: "232"
    },
    {
        code: "sg",
        name: "Singapore",
        dialCode: "65"
    },
    {
        code: "sk",
        name: "Slovakia",
        dialCode: "421"
    },
    {
        code: "si",
        name: "Slovenia",
        dialCode: "421"
    },
    {
        code: "sb",
        name: "Solomon Islands",
        dialCode: "677"
    },
    {
        code: "sd",
        name: "Sudan",
        dialCode: "249"
    },
    {
        code: "sr",
        name: "Suriname",
        dialCode: "597"
    },
    {
        code: "sz",
        name: "Eswatini",
        dialCode: "268"
    },
    {
        code: "sy",
        name: "Syria",
        dialCode: "963"
    },
    {
        code: "tw",
        name: "Taiwan",
        dialCode: "886"
    },
    {
        code: "tj",
        name: "Tajikistan",
        dialCode: "992"
    },
    {
        code: "tz",
        name: "Tanzania",
        dialCode: "255"
    },
    {
        code: "tl",
        name: "Timor-Leste",
        dialCode: "670"
    },
    {
        code: "tg",
        name: "Togo",
        dialCode: "228"
    },
    {
        code: "to",
        name: "Tonga",
        dialCode: "676"
    },
    {
        code: "tt",
        name: "Trinidad and Tobago",
        dialCode: "1868"
    },
    {
        code: "tn",
        name: "Tunisia",
        dialCode: "216"
    },
    {
        code: "tr",
        name: "Turkey",
        dialCode: "90"
    },
    {
        code: "tm",
        name: "Turkmenistan",
        dialCode: "993"
    },
    {
        code: "tv",
        name: "Tuvalu",
        dialCode: "688"
    },
    {
        code: "ug",
        name: "Uganda",
        dialCode: "256"
    },
    {
        code: "ua",
        name: "Ukraine",
        dialCode: "380"
    },
    {
        code: "ae",
        name: "United Arab Emirates",
        dialCode: "971"
    },
    {
        code: "uy",
        name: "Uruguay",
        dialCode: "598"
    },
    {
        code: "uz",
        name: "Uzbekistan",
        dialCode: "998"
    },
    {
        code: "vu",
        name: "Vanuatu",
        dialCode: "678"
    },
    {
        code: "va",
        name: "Vatican City",
        dialCode: "379"
    },
    {
        code: "ye",
        name: "Yemen",
        dialCode: "967"
    },
    {
        code: "zm",
        name: "Zambia",
        dialCode: "260"
    },
    {
        code: "zw",
        name: "Zimbabwe",
        dialCode: "263"
    }
];



const $5ca94075649ab824$var$CountryQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    const [selectedCountry, setSelectedCountry] = (0, $feLGi$react.useState)(null);
    const [showCountrySelect, setShowCountrySelect] = (0, $feLGi$react.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $feLGi$react.useState)("");
    const [isScrolled, setIsScrolled] = (0, $feLGi$react.useState)(false);
    const [isClosing, setIsClosing] = (0, $feLGi$react.useState)(false);
    const [isDesktopClosing, setIsDesktopClosing] = (0, $feLGi$react.useState)(false);
    const [isDesktopOpening, setIsDesktopOpening] = (0, $feLGi$react.useState)(false);
    const dropdownRef = (0, $feLGi$react.useRef)(null);
    // Sort countries alphabetically
    const sortedCountries = (0, $feLGi$react.useMemo)(()=>{
        return (0, $c45f87f8e3d3d7e7$export$a51c8ad41f831069).sort((a, b)=>a.name.localeCompare(b.name));
    }, []);
    // Filter countries based on search term
    const filteredCountries = (0, $feLGi$react.useMemo)(()=>{
        if (!searchTerm) return sortedCountries;
        const searchLower = searchTerm.toLowerCase();
        return sortedCountries.filter((country)=>country.name.toLowerCase().includes(searchLower) || country.dialCode.includes(searchTerm) || country.code.toLowerCase().includes(searchLower)).sort((a, b)=>{
            // Prioritize exact matches and matches at the beginning
            const aNameLower = a.name.toLowerCase();
            const bNameLower = b.name.toLowerCase();
            // Exact match gets highest priority
            if (aNameLower === searchLower) return -1;
            if (bNameLower === searchLower) return 1;
            // Starts with gets second priority
            if (aNameLower.startsWith(searchLower)) return -1;
            if (bNameLower.startsWith(searchLower)) return 1;
            // Then sort by position of match (earlier = higher priority)
            const aIndex = aNameLower.indexOf(searchLower);
            const bIndex = bNameLower.indexOf(searchLower);
            if (aIndex !== bIndex) return aIndex - bIndex;
            // Finally sort alphabetically
            return aNameLower.localeCompare(bNameLower);
        });
    }, [
        sortedCountries,
        searchTerm
    ]);
    // Helper function to highlight matched text
    const highlightText = (text, searchTerm)=>{
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
        const parts = text.split(regex);
        return parts.map((part, index)=>regex.test(part) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", {
                key: index
            }, part) : part);
    };
    // Handle scroll event for search section shadow
    const handleScroll = (e)=>{
        const scrollTop = e.target.scrollTop;
        setIsScrolled(scrollTop > 0);
    };
    // Handle closing the mobile dropdown with animation
    const handleCloseMobileDropdown = ()=>{
        setIsClosing(true);
        // Wait for animation to complete before actually closing
        setTimeout(()=>{
            setShowCountrySelect(false);
            setIsClosing(false);
            setSearchTerm("");
        }, 300) // Match the animation duration
        ;
    };
    // Handle opening the desktop dropdown with animation
    const handleOpenDesktopDropdown = ()=>{
        setShowCountrySelect(true);
        setIsDesktopOpening(true);
        setSearchTerm("");
        // After a brief moment, remove the opening class to trigger the show animation
        setTimeout(()=>{
            setIsDesktopOpening(false);
        }, 10) // Small delay to ensure the opening state is applied first
        ;
    };
    // Handle closing the desktop dropdown with animation
    const handleCloseDesktopDropdown = ()=>{
        setIsDesktopClosing(true);
        // Wait for animation to complete before actually closing
        setTimeout(()=>{
            setShowCountrySelect(false);
            setIsDesktopClosing(false);
            setSearchTerm("");
        }, 300) // Match the animation duration
        ;
    };
    // Extract country from saved value
    const extractCountryFromValue = (savedValue)=>{
        if (!savedValue || typeof savedValue !== "string") return null;
        // Handle format: +{dialCode} {countryName}
        const match = savedValue.match(/^\+(\d+)\s+(.+)$/);
        if (match) {
            const dialCode = match[1];
            const countryName = match[2];
            // Find country by dial code and name
            const country = (0, $c45f87f8e3d3d7e7$export$a51c8ad41f831069).find((c)=>c.dialCode === dialCode && c.name === countryName);
            return country || null;
        }
        return null;
    };
    // Initialize selected country from saved value
    (0, $feLGi$react.useEffect)(()=>{
        if (sortedCountries.length > 0) {
            const sourceValue = value || field.value;
            const extractedCountry = extractCountryFromValue(sourceValue);
            if (extractedCountry) setSelectedCountry(extractedCountry);
            else {
                // Default to US if no saved value
                const defaultCountry = sortedCountries.find((c)=>c.code === "us") || sortedCountries[0];
                setSelectedCountry(defaultCountry);
            }
        }
    }, [
        value,
        field.value,
        sortedCountries
    ]);
    // Handle click outside to close dropdown
    (0, $feLGi$react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) handleCloseDesktopDropdown();
        };
        if (showCountrySelect) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showCountrySelect
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!selectedCountry) {
            if (question.isRequired) {
                setShowError(true);
                return;
            }
        }
        const fullValue = selectedCountry ? `+${selectedCountry.dialCode} ${selectedCountry.name}` : "";
        onSubmit({
            [question._id]: fullValue
        });
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            if (!selectedCountry) {
                if (question.isRequired) {
                    setShowError(true);
                    return;
                }
            }
            const fullValue = selectedCountry ? `+${selectedCountry.dialCode} ${selectedCountry.name}` : "";
            onSubmit({
                [question._id]: fullValue
            });
        }
    };
    const handleCountryChange = (selectedOption)=>{
        setSelectedCountry(selectedOption);
        setSearchTerm("") // Clear search term when country is selected
        ;
        // Use the animated close function instead of directly closing
        handleCloseMobileDropdown();
        // Store the full format in formik field for submission
        const fullValue = `+${selectedOption.dialCode} ${selectedOption.name}`;
        field.onChange({
            target: {
                name: field.name,
                value: fullValue
            }
        });
        // Clear error if country is selected
        if (showError) setShowError(false);
    };
    const handleCountryClick = ()=>{
        if (!submitting) {
            if (showCountrySelect) // If dropdown is open, close it with animation
            handleCloseDesktopDropdown();
            else // If dropdown is closed, open it with animation
            handleOpenDesktopDropdown();
        }
    };
    const handleSearchChange = (e)=>{
        const value = e.target.value;
        setSearchTerm(value);
        // Open dropdown when user starts typing
        if (value && !showCountrySelect) handleOpenDesktopDropdown();
    };
    const getErrorMessage = ()=>{
        if (!showError) return null;
        if (question.isRequired && !selectedCountry) return "This field is required";
        return null;
    };
    const errorMessage = getErrorMessage();
    const renderErrorContainer = ()=>{
        if (!errorMessage) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "error-container mt-16px",
            style: {
                opacity: showCountrySelect ? 0.3 : 1
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "error-message d-flex align-items-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "error-icon"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, errorMessage)));
    };
    const renderActionContainer = ()=>{
        if (errorMessage) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "action-container mt-16px",
            style: {
                opacity: showCountrySelect ? 0.3 : 1
            }
        }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
            onClick: onPrevious,
            className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
            disabled: submitting,
            style: {
                backgroundColor: "#0a223c",
                color: "white",
                border: "none",
                minWidth: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            className: "cursor-pointer"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M11 1.41406L4 8.20845",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M11 14.9975L4 8.20312",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
            onClick: handleSubmit,
            className: "border-radius-normal ok-button px-14px py-6px",
            isLoading: submitting,
            disabled: submitting,
            "data-text": buttonText
        }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "line-break-instruction d-sm-576-none d-lg-576-block"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "instruction-text text-abroad-blue"
        }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")));
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-input-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "custom-country-input",
        style: {
            width: "100%",
            position: "relative"
        }
    }, (showCountrySelect || isClosing || isDesktopClosing || isDesktopOpening) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        ref: dropdownRef,
        className: `custom-country-dropdown show d-lg-576-block d-sm-576-none ${isClosing || isDesktopClosing ? "dropdown-closing" : isDesktopOpening ? "dropdown-opening" : "show"}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `search-section ${isScrolled ? "scrolled" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        placeholder: "Search countries",
        value: searchTerm,
        onChange: handleSearchChange,
        className: "search-input",
        autoFocus: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-list text-center",
        onScroll: handleScroll
    }, filteredCountries.length > 0 ? filteredCountries.map((country, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: country.code,
            onClick: ()=>handleCountryChange(country),
            className: `country-item ${(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) === country.code ? "selected" : ""}`
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "country-info"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
            countryCode: country.code.toUpperCase(),
            svg: true,
            className: "country-flag",
            style: {
                width: "1em",
                height: "1em",
                borderRadius: "30%"
            },
            "aria-label": country.code.toUpperCase()
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-name"
        }, highlightText(country.name, searchTerm))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-dial-code"
        }, "+", country.dialCode));
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
            opacity: showCountrySelect ? 0.3 : 1
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "country-flag-button d-flex align-items-center pe-1",
        onClick: handleCountryClick
    }, selectedCountry ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
        countryCode: selectedCountry.code.toUpperCase(),
        svg: true,
        className: "me-2",
        style: {
            width: "1.25em",
            height: "1.25em",
            borderRadius: "30%"
        },
        "aria-label": selectedCountry.code.toUpperCase()
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 48 48"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("polyline", {
        points: "12,20 24,30 36,20",
        fill: "none",
        stroke: "rgb(10, 34, 60)",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        style: {
            fontSize: "14px",
            color: "#666"
        }
    }, "Select country")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        value: searchTerm || (selectedCountry ? selectedCountry.name : ""),
        placeholder: "Select a country",
        disabled: submitting,
        className: "country-name-input",
        name: field.name,
        required: question.isRequired,
        autoFocus: true,
        onKeyDown: handleKeyPress,
        onChange: handleSearchChange,
        onClick: handleCountryClick
    })))), renderErrorContainer(), renderActionContainer()))), (showCountrySelect || isClosing) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-modal d-sm-576-block d-lg-576-none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-overlay",
        onClick: handleCloseMobileDropdown
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `mobile-dropdown-sheet ${isClosing ? "closing" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-header"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        className: "mobile-dropdown-back-btn",
        onClick: handleCloseMobileDropdown,
        type: "button"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10 12L6 8L10 4",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        value: searchTerm,
        placeholder: "Search countries",
        onChange: handleSearchChange,
        className: "mobile-search-input",
        autoFocus: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-content"
    }, filteredCountries.length > 0 ? filteredCountries.map((country, index)=>{
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: country.code,
            className: `dropdown-option rounded-1 ${(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code) === country.code ? "selected" : ""}`,
            onClick: ()=>handleCountryChange(country)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "country-info"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactcountryflag))), {
            countryCode: country.code.toUpperCase(),
            svg: true,
            className: "country-flag pe-2",
            style: {
                width: "1.25em",
                height: "1.25em",
                borderRadius: "30%"
            },
            "aria-label": country.code.toUpperCase()
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-name"
        }, highlightText(country.name, searchTerm))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "country-dial-code pe-2"
        }, "+", country.dialCode));
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-no-suggestions-found"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "mobile-error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-action-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleCloseMobileDropdown,
        className: "border-radius-normal mobile-ok-button px-14px py-6px",
        "data-text": "OK"
    }, "OK")))))));
};
var $5ca94075649ab824$export$2e2bcd8739ae039 = $5ca94075649ab824$var$CountryQuestion;





const $9eaf19f830421f6f$var$SingleSelectionQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    const [isOpen, setIsOpen] = (0, $feLGi$react.useState)(false);
    const [isClosing, setIsClosing] = (0, $feLGi$react.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $feLGi$react.useState)("");
    const [isSearching, setIsSearching] = (0, $feLGi$react.useState)(false);
    const dropdownRef = (0, $feLGi$react.useRef)(null);
    const mobileModalRef = (0, $feLGi$react.useRef)(null);
    // Use value prop if available, otherwise fall back to field.value
    const [selectedOption, setSelectedOption] = (0, $feLGi$react.useState)(value || field.value || "");
    // Sync from saved form data when navigating back to this question
    (0, $feLGi$react.useEffect)(()=>{
        if (value !== undefined && value !== null && value !== "") {
            setSelectedOption(value);
            setSearchTerm("");
            setIsSearching(false);
        }
    }, [
        value,
        question._id
    ]);
    // Handle closing the mobile dropdown with animation
    const handleCloseMobileDropdown = ()=>{
        setIsClosing(true);
        // Wait for animation to complete before actually closing
        setTimeout(()=>{
            setIsOpen(false);
            setIsClosing(false);
            setSearchTerm("");
            setIsSearching(false);
        }, 300) // Match the animation duration
        ;
    };
    // Handle clicking outside the dropdown (include mobile sheet so option taps register)
    const handleClickOutside = (event)=>{
        var _dropdownRef_current, _mobileModalRef_current;
        const isInsideDropdown = (_dropdownRef_current = dropdownRef.current) === null || _dropdownRef_current === void 0 ? void 0 : _dropdownRef_current.contains(event.target);
        const isInsideMobileModal = (_mobileModalRef_current = mobileModalRef.current) === null || _mobileModalRef_current === void 0 ? void 0 : _mobileModalRef_current.contains(event.target);
        if (!isInsideDropdown && !isInsideMobileModal) {
            if (isOpen) {
                setIsOpen(false);
                setSearchTerm("");
                setIsSearching(false);
            }
        }
    };
    // Add click outside listener
    (0, $feLGi$react.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    // Filter options based on search term
    const getFilteredOptions = ()=>{
        if (!searchTerm.trim()) {
            // If no search term and there's a selected option, show only that option
            if (selectedOption) return [
                selectedOption
            ];
            return question.options;
        }
        return question.options.filter((option)=>{
            // Handle both string options and object options
            const optionText = typeof option === "string" ? option : option.option || option.text || "";
            return optionText.toLowerCase().includes(searchTerm.toLowerCase());
        });
    };
    // Highlight matching text in option
    const highlightText = (text, searchTerm)=>{
        if (!searchTerm.trim()) return text;
        const regex = new RegExp(`(${searchTerm})`, "gi");
        const parts = text.split(regex);
        return parts.map((part, index)=>regex.test(part) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", {
                key: index,
                style: {
                    color: "#0A223C"
                }
            }, part) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
                key: index,
                style: {
                    color: "rgba(10, 34, 60, 0.7)"
                }
            }, part));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (question.isRequired && !selectedOption) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: selectedOption
        });
    };
    const handleOptionSelect = (option)=>{
        setSelectedOption(option);
        setSearchTerm("");
        setIsSearching(false);
        field.onChange({
            target: {
                name: field.name,
                value: option
            }
        });
        // Use the animated close function instead of directly closing
        handleCloseMobileDropdown();
        // Clear error when user selects an option
        if (showError) setShowError(false);
    };
    const handleClearSelection = (e)=>{
        e.stopPropagation() // Prevent dropdown from opening
        ;
        setSelectedOption("");
        setSearchTerm("");
        setIsSearching(false);
        field.onChange({
            target: {
                name: field.name,
                value: ""
            }
        });
        setIsOpen(false) // Close dropdown immediately
        ;
        // Clear error when user clears selection
        if (showError) setShowError(false);
    };
    const handleInputChange = (e)=>{
        const value = e.target.value;
        setSearchTerm(value);
        setIsSearching(true);
        // Don't close the mobile dropdown when typing in search field
        // Only handle desktop dropdown behavior
        if (!isOpen && value.trim()) setIsOpen(true);
        else if (!isOpen && !value.trim()) {
            // If input is cleared and dropdown is not open, clear the selected option
            setSelectedOption("");
            field.onChange({
                target: {
                    name: field.name,
                    value: ""
                }
            });
            setIsSearching(false);
        }
    };
    const getOptionText = (option)=>{
        if (typeof option === "string") return option;
        return (option === null || option === void 0 ? void 0 : option.option) || (option === null || option === void 0 ? void 0 : option.text) || "";
    };
    const handleInputKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            const filteredOptions = getFilteredOptions();
            if (filteredOptions.length >= 1) // Pass option text (not the full option object) so the input never shows [object Object]
            handleOptionSelect(getOptionText(filteredOptions[0]));
        } else if (e.key === "Escape") {
            setIsOpen(false);
            setSearchTerm("");
            setIsSearching(false);
        } else if (e.key === "Tab") // Only close dropdown if it's open
        {
            if (isOpen) {
                e.preventDefault();
                setIsOpen(false);
                setSearchTerm("");
                setIsSearching(false);
            }
        }
    };
    // Add keyboard event listener when component mounts
    (0, $feLGi$react.useEffect)(()=>{
        const handleGlobalKeyDown = (e)=>{
            if (e.key === "Enter" && !isOpen) {
                e.preventDefault();
                if (question.isRequired && !selectedOption) {
                    setShowError(true);
                    return;
                }
                // Only call onSubmit if validation passes
                onSubmit({
                    [question._id]: selectedOption
                });
            }
        };
        document.addEventListener("keydown", handleGlobalKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleGlobalKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedOption,
        showError,
        isOpen
    ]) // Dependencies for the effect
    ;
    const filteredOptions = getFilteredOptions();
    const displayValue = isSearching ? searchTerm : selectedOption;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "single-selection-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), " ", question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "dropdown-container pt-32px",
        ref: dropdownRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `dropdown-input ${isOpen ? "open" : ""} ${showError ? "error" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        value: displayValue,
        placeholder: "Type or select an option",
        onChange: handleInputChange,
        onFocus: ()=>setIsOpen(true),
        onKeyDown: handleInputKeyDown,
        className: "dropdown-field w-100"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: `dropdown-arrow ${isOpen ? "open" : ""}`,
        onClick: selectedOption && !isSearching ? handleClearSelection : ()=>setIsOpen(!isOpen),
        tabIndex: 0
    }, selectedOption && !isSearching ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            cursor: "pointer"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M12 4L4 12M4 4L12 12",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "13",
        height: "6",
        viewBox: "0 0 13 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            cursor: "pointer"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.60449 1.00313L6.90132 5.20313",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M12.1943 1.00313L6.89746 5.20312",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "input-underline"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `dropdown-options d-lg-576-block ${isOpen ? "open" : ""}`
    }, isOpen && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, filteredOptions.length > 0 ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, filteredOptions.map((option, index)=>{
        // Extract option text from object or use string directly
        const optionText = typeof option === "string" ? option : option.option || option.text || "";
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: index,
            className: `dropdown-option ${selectedOption === optionText ? "selected" : ""}`,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: ()=>handleOptionSelect(optionText)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "option-text"
        }, highlightText(optionText, searchTerm)), selectedOption === optionText && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "selected-checkmark"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M13.5 4.5L6 12L2.5 8.5",
            stroke: "#0A223C",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }))));
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "dropdown-options-divider"
    })) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "no-suggestions-found"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: ()=>{
            setIsOpen(false);
            setSearchTerm("");
            setIsSearching(false);
        },
        className: "border-radius-normal ok-button px-14px py-6px",
        "data-text": "OK"
    }, "OK")))))), showError ? question.isRequired && !selectedOption && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // d='M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z'></path>
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 1 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Please make a selection"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText,
        tabIndex: 0
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))), (isOpen || isClosing) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-modal d-sm-576-block d-lg-576-none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-overlay",
        onClick: handleCloseMobileDropdown
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        ref: mobileModalRef,
        className: `mobile-dropdown-sheet ${isClosing ? "closing" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-header"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        className: "mobile-dropdown-back-btn",
        onClick: handleCloseMobileDropdown,
        type: "button"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10 12L6 8L10 4",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        type: "text",
        value: searchTerm,
        placeholder: "Select an option",
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        className: "mobile-search-input",
        autoFocus: true
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-dropdown-content"
    }, filteredOptions.length > 0 ? filteredOptions.map((option, index)=>{
        // Extract option text from object or use string directly
        const optionText = typeof option === "string" ? option : option.option || option.text || "";
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: index,
            className: `dropdown-option rounded-1 ${selectedOption === optionText ? "selected" : ""}`,
            onClick: ()=>handleOptionSelect(optionText)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "option-text"
        }, highlightText(optionText, searchTerm)), selectedOption === optionText && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "selected-checkmark pe-2"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M13.5 4.5L6 12L2.5 8.5",
            stroke: "#0A223C",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }))));
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-no-suggestions"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "mobile-error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "No suggestions found"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mobile-action-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleCloseMobileDropdown,
        className: "border-radius-normal mobile-ok-button px-14px py-6px",
        "data-text": "OK"
    }, "OK")))))));
};
var $9eaf19f830421f6f$export$2e2bcd8739ae039 = $9eaf19f830421f6f$var$SingleSelectionQuestion;





const $14f98365f58ca6ab$var$MultipleSelectionQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    // Use value prop if available, otherwise fall back to field.value
    const [selectedOptions, setSelectedOptions] = (0, $feLGi$react.useState)(()=>{
        // Helper function to filter valid options for current question
        const filterValidOptions = (options)=>{
            if (!Array.isArray(options)) return [];
            return options.filter((option)=>{
                // Handle both string options and object options
                const optionText = typeof option === "string" ? option : option.option || option.text || "";
                return question.options.some((qOption)=>{
                    const qOptionText = typeof qOption === "string" ? qOption : qOption.option || qOption.text || "";
                    return qOptionText === optionText;
                });
            });
        };
        if (value && Array.isArray(value)) return filterValidOptions(value);
        else if (value && typeof value === "string") return filterValidOptions([
            value
        ]);
        else if (field.value && Array.isArray(field.value)) return filterValidOptions(field.value);
        else if (field.value && typeof field.value === "string") return filterValidOptions([
            field.value
        ]);
        return [];
    });
    // Update selectedOptions when value prop changes (for prefilling)
    (0, $feLGi$react.useEffect)(()=>{
        // Helper function to filter valid options for current question
        const filterValidOptions = (options)=>{
            if (!Array.isArray(options)) return [];
            return options.filter((option)=>{
                // Handle both string options and object options
                const optionText = typeof option === "string" ? option : option.option || option.text || "";
                return question.options.some((qOption)=>{
                    const qOptionText = typeof qOption === "string" ? qOption : qOption.option || qOption.text || "";
                    return qOptionText === optionText;
                });
            });
        };
        if (value && Array.isArray(value)) setSelectedOptions(filterValidOptions(value));
        else if (value && typeof value === "string") setSelectedOptions(filterValidOptions([
            value
        ]));
    }, [
        value,
        question.options
    ]);
    // Handle keyboard events
    (0, $feLGi$react.useEffect)(()=>{
        const handleKeyPress = (event)=>{
            const key = event.key.toUpperCase();
            // Handle option selection with A, B, C, etc.
            if (key >= "A" && key <= "Z") {
                const optionIndex = key.charCodeAt(0) - 65 // Convert A=0, B=1, C=2, etc.
                ;
                if (optionIndex < question.options.length) {
                    const option = question.options[optionIndex];
                    // Extract option text from object or use string directly
                    const optionText = typeof option === "string" ? option : option.option || option.text || "";
                    handleOptionSelect(optionText);
                }
            }
            // Handle Enter key to submit
            if (key === "ENTER") {
                if (question.isRequired && selectedOptions.length === 0) {
                    setShowError(true);
                    return;
                }
                // Only call onSubmit if validation passes
                onSubmit({
                    [question._id]: selectedOptions
                });
            }
        };
        // Add event listener
        document.addEventListener("keydown", handleKeyPress);
        // Cleanup event listener
        return ()=>{
            document.removeEventListener("keydown", handleKeyPress);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedOptions,
        question.options
    ]) // Dependencies for the effect
    ;
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (question.isRequired && selectedOptions.length === 0) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: selectedOptions
        });
    };
    // -----------single selection option------------
    // const handleOptionSelect = (option) => {
    //   let newSelectedOptions
    //   if (selectedOptions.includes(option)) {
    //     // Unselect if already selected
    //     newSelectedOptions = []
    //   } else {
    //     // Select only this option
    //     newSelectedOptions = [option]
    //   }
    //   setSelectedOptions(newSelectedOptions)
    //   field.onChange({ target: { name: field.name, value: newSelectedOptions } })
    //   if (showError && newSelectedOptions.length > 0) {
    //     setShowError(false)
    //   }
    // }
    // ---------------- multiple selection option ------------------------
    const handleOptionSelect = (option)=>{
        let newSelectedOptions;
        if (selectedOptions.includes(option)) // Remove option if already selected
        newSelectedOptions = selectedOptions.filter((opt)=>opt !== option);
        else // Add option if not selected
        newSelectedOptions = [
            ...selectedOptions,
            option
        ];
        setSelectedOptions(newSelectedOptions);
        field.onChange({
            target: {
                name: field.name,
                value: newSelectedOptions
            }
        });
        // Clear error when user selects an option
        if (showError && newSelectedOptions.length > 0) setShowError(false);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "multiple-selection-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "options-container pt-32px"
    }, question.options.map((option, index)=>{
        // Extract option text from object or use string directly
        const optionText = typeof option === "string" ? option : option.option || option.text || "";
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
            key: index,
            type: "button",
            className: `option-button mb-2 ${selectedOptions.includes(optionText) ? "selected" : ""}`,
            onClick: ()=>handleOptionSelect(optionText)
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "option-content d-flex align-items-center justify-content-between"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex align-items-center"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "option-letter-box"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "option-letter px-2 py-1"
        }, String.fromCharCode(65 + index))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "option-text"
        }, optionText)), selectedOptions.includes(optionText) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "selected-checkmark"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M13.5 4.5L6 12L2.5 8.5",
            stroke: "#0A223C",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })))));
    })), showError ? question.isRequired && selectedOptions.length === 0 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Oops! Please make a selection"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $14f98365f58ca6ab$export$2e2bcd8739ae039 = $14f98365f58ca6ab$var$MultipleSelectionQuestion;





const $00145b16fdd9671e$var$DateQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    // Add refs for input fields
    const monthRef = (0, $feLGi$react.useRef)(null);
    const dayRef = (0, $feLGi$react.useRef)(null);
    const yearRef = (0, $feLGi$react.useRef)(null);
    // Parse date value for prefilling
    const parseDateValue = (dateString)=>{
        // Value may be a leftover non-string answer after an admin changes
        // the question type (e.g. scale number / multi-select array in localStorage)
        if (!dateString || typeof dateString !== "string") return {
            month: "",
            day: "",
            year: ""
        };
        // Handle MM/DD/YYYY format
        const parts = dateString.split("/");
        if (parts.length === 3) return {
            month: parts[0] || "",
            day: parts[1] || "",
            year: parts[2] || ""
        };
        // Handle YYYY-MM-DD format
        if (dateString.includes("-")) {
            const isoParts = dateString.split("-");
            if (isoParts.length === 3) return {
                month: isoParts[1] || "",
                day: isoParts[2] || "",
                year: isoParts[0] || ""
            };
        }
        return {
            month: "",
            day: "",
            year: ""
        };
    };
    const [dateParts, setDateParts] = (0, $feLGi$react.useState)(()=>parseDateValue(value));
    const [activeField, setActiveField] = (0, $feLGi$react.useState)("month");
    const [validationErrors, setValidationErrors] = (0, $feLGi$react.useState)({});
    // Update dateParts when value prop changes (for prefilling)
    (0, $feLGi$react.useEffect)(()=>{
        setDateParts(parseDateValue(value));
    }, [
        value,
        question._id
    ]);
    // Date validation functions
    const validateMonth = (month)=>{
        if (!month) return "";
        const monthNum = parseInt(month, 10);
        if (monthNum < 1 || monthNum > 12) return "Month must be between 01 and 12";
        return "";
    };
    const validateDay = (day, month, year)=>{
        if (!day) return "";
        const dayNum = parseInt(day, 10);
        if (dayNum < 1 || dayNum > 31) return "Day must be between 01 and 31";
        // Check for valid day based on month and year
        if (month && year) {
            const monthNum = parseInt(month, 10);
            const yearNum = parseInt(year, 10);
            // Get days in month
            const daysInMonth = new Date(yearNum, monthNum, 0).getDate();
            if (dayNum > daysInMonth) return `Day must be between 01 and ${daysInMonth} for this month`;
        }
        return "";
    };
    const validateYear = (year)=>{
        if (!year) return "";
        // Only validate if year has 4 digits (complete)
        if (year.length !== 4) return "Please enter a 4-digit year";
        return "";
    };
    const validateDate = (month, day, year)=>{
        const errors = {};
        if (month) // Only validate month if it has 2 digits (complete)
        {
            if (month.length === 2) errors.month = validateMonth(month);
        }
        if (day) // Only validate day if it has 2 digits (complete)
        {
            if (day.length === 2) errors.day = validateDay(day, month, year);
        }
        if (year) {
            // Only validate year if it has 4 digits (complete)
            if (year.length === 4) errors.year = validateYear(year);
            else if (year.length > 0 && year.length < 4) errors.year = "Please enter a 4-digit year";
        }
        return errors;
    };
    const validateFieldOnBlur = (fieldName, value)=>{
        const errors = {
            ...validationErrors
        };
        let formattedValue = value;
        if (fieldName === "month" && value) {
            if (value.length === 1) {
                // Auto-format single digit with leading zero
                formattedValue = value.padStart(2, "0");
                const newDateParts = {
                    ...dateParts,
                    month: formattedValue
                };
                setDateParts(newDateParts);
                // Update Formik field value
                const dateString = `${formattedValue}/${newDateParts.day}/${newDateParts.year}`;
                field.onChange({
                    target: {
                        name: field.name,
                        value: dateString
                    }
                });
                // Validate the formatted value
                errors.month = validateMonth(formattedValue);
            } else if (value.length === 2) errors.month = validateMonth(value);
        }
        if (fieldName === "day" && value) {
            if (value.length === 1) {
                // Auto-format single digit with leading zero
                formattedValue = value.padStart(2, "0");
                const newDateParts = {
                    ...dateParts,
                    day: formattedValue
                };
                setDateParts(newDateParts);
                // Update Formik field value
                const dateString = `${newDateParts.month}/${formattedValue}/${newDateParts.year}`;
                field.onChange({
                    target: {
                        name: field.name,
                        value: dateString
                    }
                });
                // Validate the formatted value
                errors.day = validateDay(formattedValue, dateParts.month, dateParts.year);
            } else if (value.length === 2) errors.day = validateDay(value, dateParts.month, dateParts.year);
        }
        if (fieldName === "year" && value) {
            if (value.length === 4) errors.year = validateYear(value);
            else if (value.length > 0 && value.length < 4) errors.year = "Please enter a 4-digit year";
        }
        setValidationErrors(errors);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // Validate all fields
        const errors = validateDate(dateParts.month, dateParts.day, dateParts.year);
        setValidationErrors(errors);
        // Check if there are any validation errors
        const hasErrors = Object.values(errors).some((error)=>error !== "");
        if (hasErrors) {
            setShowError(true);
            return;
        }
        // For required questions, check if all date parts are filled
        if (question.isRequired) {
            if (!dateParts.month || !dateParts.day || !dateParts.year) {
                setShowError(true);
                return;
            }
        }
        // For non-required questions, allow empty dates or complete dates
        // If any date part is filled, all must be filled and valid
        if (dateParts.month || dateParts.day || dateParts.year) {
            if (!dateParts.month || !dateParts.day || !dateParts.year) {
                setShowError(true);
                return;
            }
        }
        // Call onSubmit with the date value (empty string for non-required empty dates)
        const dateString = dateParts.month && dateParts.day && dateParts.year ? `${dateParts.month}/${dateParts.day}/${dateParts.year}` : "";
        onSubmit({
            [question._id]: dateString
        });
    };
    const handleDateChange = (fieldName, value)=>{
        const newDateParts = {
            ...dateParts,
            [fieldName]: value
        };
        setDateParts(newDateParts);
        // Update Formik field value
        const dateString = `${newDateParts.month}/${newDateParts.day}/${newDateParts.year}`;
        field.onChange({
            target: {
                name: field.name,
                value: dateString
            }
        });
        // Clear error when user starts typing
        if (showError && value && value.trim() !== "") setShowError(false);
        // Only validate month and day on change, not year
        const errors = {
            ...validationErrors
        };
        if (fieldName === "month") {
            if (value.length === 2) errors.month = validateMonth(value);
            else errors.month = "";
        }
        if (fieldName === "day") {
            if (value.length === 2) errors.day = validateDay(value, newDateParts.month, newDateParts.year);
            else errors.day = "";
        }
        // Do not validate year on change
        // errors.year = ''
        setValidationErrors(errors);
        // Auto-advance to next field with formatting
        if (fieldName === "month" && value.length === 2) {
            // Format month with leading zero if needed
            const formattedMonth = value.padStart(2, "0");
            const formattedDateParts = {
                ...newDateParts,
                month: formattedMonth
            };
            setDateParts(formattedDateParts);
            // Update Formik field value with formatted date
            const formattedDateString = `${formattedMonth}/${formattedDateParts.day}/${formattedDateParts.year}`;
            field.onChange({
                target: {
                    name: field.name,
                    value: formattedDateString
                }
            });
            setActiveField("day");
            // Focus the day input without scrolling the page (avoids question text jumping left)
            setTimeout(()=>{
                if (dayRef.current) dayRef.current.focus({
                    preventScroll: true
                });
            }, 0);
        } else if (fieldName === "day" && value.length === 2) {
            // Format day with leading zero if needed
            const formattedDay = value.padStart(2, "0");
            const formattedDateParts = {
                ...newDateParts,
                day: formattedDay
            };
            setDateParts(formattedDateParts);
            // Update Formik field value with formatted date
            const formattedDateString = `${formattedDateParts.month}/${formattedDay}/${formattedDateParts.year}`;
            field.onChange({
                target: {
                    name: field.name,
                    value: formattedDateString
                }
            });
            setActiveField("year");
            // Focus the year input without scrolling the page
            setTimeout(()=>{
                if (yearRef.current) yearRef.current.focus({
                    preventScroll: true
                });
            }, 0);
        }
    };
    const focusFieldAtEnd = (ref, fieldName)=>{
        setActiveField(fieldName);
        const input = ref.current;
        if (!input) return;
        input.focus({
            preventScroll: true
        });
        const len = input.value ? input.value.length : 0;
        requestAnimationFrame(()=>{
            try {
                input.setSelectionRange(len, len);
            } catch (e) {
            // ignore unsupported selection ranges
            }
        });
    };
    // Backspace on an empty field (or caret at start) returns to the previous field
    const handleDateKeyDown = (fieldName, e)=>{
        if (e.key === "Enter") {
            handleKeyPress(e);
            return;
        }
        if (e.key !== "Backspace") return;
        const input = e.target;
        const value = dateParts[fieldName] || "";
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;
        const caretAtStart = selectionStart === 0 && selectionEnd === 0;
        const hasSelection = selectionStart !== selectionEnd;
        // Let the browser delete normally when there is content after the caret
        // or a selected range to clear
        if (hasSelection) return;
        if (value.length > 0 && !caretAtStart) return;
        if (fieldName === "day") {
            e.preventDefault();
            focusFieldAtEnd(monthRef, "month");
        } else if (fieldName === "year") {
            e.preventDefault();
            focusFieldAtEnd(dayRef, "day");
        }
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            // Validate all fields
            const errors = validateDate(dateParts.month, dateParts.day, dateParts.year);
            setValidationErrors(errors);
            // Check if there are any validation errors
            const hasErrors = Object.values(errors).some((error)=>error !== "");
            if (hasErrors) {
                setShowError(true);
                return;
            }
            // For required questions, check if all date parts are filled
            if (question.isRequired) {
                if (!dateParts.month || !dateParts.day || !dateParts.year) {
                    setShowError(true);
                    return;
                }
            }
            // For non-required questions, allow empty dates or complete dates
            // If any date part is filled, all must be filled and valid
            if (dateParts.month || dateParts.day || dateParts.year) {
                if (!dateParts.month || !dateParts.day || !dateParts.year) {
                    setShowError(true);
                    return;
                }
            }
            // Call onSubmit with the date value (empty string for non-required empty dates)
            const dateString = dateParts.month && dateParts.day && dateParts.year ? `${dateParts.month}/${dateParts.day}/${dateParts.year}` : "";
            onSubmit({
                [question._id]: dateString
            });
        }
    };
    // Add global keyboard event listener when component mounts
    (0, $feLGi$react.useEffect)(()=>{
        const handleGlobalKeyDown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                // Validate all fields
                const errors = validateDate(dateParts.month, dateParts.day, dateParts.year);
                setValidationErrors(errors);
                // Check if there are any validation errors
                const hasErrors = Object.values(errors).some((error)=>error !== "");
                if (hasErrors) {
                    setShowError(true);
                    return;
                }
                // For required questions, check if all date parts are filled
                if (question.isRequired) {
                    if (!dateParts.month || !dateParts.day || !dateParts.year) {
                        setShowError(true);
                        return;
                    }
                }
                // For non-required questions, allow empty dates or complete dates
                // If any date part is filled, all must be filled and valid
                if (dateParts.month || dateParts.day || dateParts.year) {
                    if (!dateParts.month || !dateParts.day || !dateParts.year) {
                        setShowError(true);
                        return;
                    }
                }
                // Call onSubmit with the date value (empty string for non-required empty dates)
                const dateString = dateParts.month && dateParts.day && dateParts.year ? `${dateParts.month}/${dateParts.day}/${dateParts.year}` : "";
                onSubmit({
                    [question._id]: dateString
                });
            }
        };
        document.addEventListener("keydown", handleGlobalKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleGlobalKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dateParts,
        showError,
        validationErrors
    ]) // Dependencies for the effect
    ;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "date-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "date-input-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "date-field-group"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "date-label"
    }, "Month"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        ref: monthRef,
        type: "text",
        inputMode: "numeric",
        className: `date-input ${activeField === "month" ? "active" : ""} ${validationErrors.month ? "error" : ""}`,
        value: dateParts.month,
        onChange: (e)=>handleDateChange("month", e.target.value.replace(/\D/g, "").slice(0, 2)),
        onFocus: ()=>setActiveField("month"),
        onKeyDown: (e)=>handleDateKeyDown("month", e),
        onBlur: (e)=>validateFieldOnBlur("month", e.target.value),
        placeholder: "MM",
        maxLength: 2
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `input-underline ${validationErrors.month ? "error" : ""}`
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "date-separator"
    }, "/"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "date-field-group"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "date-label"
    }, "Day"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        ref: dayRef,
        type: "text",
        inputMode: "numeric",
        className: `date-input ${activeField === "day" ? "active" : ""} ${validationErrors.day ? "error" : ""}`,
        value: dateParts.day,
        onChange: (e)=>handleDateChange("day", e.target.value.replace(/\D/g, "").slice(0, 2)),
        onFocus: ()=>setActiveField("day"),
        onKeyDown: (e)=>handleDateKeyDown("day", e),
        onBlur: (e)=>validateFieldOnBlur("day", e.target.value),
        placeholder: "DD",
        maxLength: 2
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `input-underline ${validationErrors.day ? "error" : ""}`
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "date-separator"
    }, "/"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "date-field-group"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: "date-label"
    }, "Year"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        ref: yearRef,
        type: "text",
        inputMode: "numeric",
        className: `date-input ${activeField === "year" ? "active" : ""} ${validationErrors.year ? "error" : ""}`,
        value: dateParts.year,
        onChange: (e)=>handleDateChange("year", e.target.value.replace(/\D/g, "").slice(0, 4)),
        onFocus: ()=>setActiveField("year"),
        onKeyDown: (e)=>handleDateKeyDown("year", e),
        onBlur: (e)=>validateFieldOnBlur("year", e.target.value),
        placeholder: "YYYY",
        maxLength: 4
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `input-underline ${validationErrors.year ? "error" : ""}`
    }))), (validationErrors.month || validationErrors.day || validationErrors.year) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, validationErrors.month || validationErrors.day || validationErrors.year))), validationErrors.date && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, validationErrors.date))), showError ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, question.isRequired && (!dateParts.month || !dateParts.day || !dateParts.year) && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Please select a date")))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $00145b16fdd9671e$export$2e2bcd8739ae039 = $00145b16fdd9671e$var$DateQuestion;





const $63e74658476514e3$export$a238cb463698c900 = {
    "FIRST NAME": "FIRST NAME",
    "LAST NAME": "LAST NAME",
    Gender: "Gender",
    Age: "Age",
    "Country Of Residence": "Country Of Residence",
    EDUCATION: "EDUCATION",
    "FIRST PRIORITY": "FIRST PRIORITY",
    "SECOND PRIORITY": "SECOND PRIORITY",
    "THIRD PRIORITY": "THIRD PRIORITY",
    COMPANY: "COMPANY",
    EMAIL: "EMAIL",
    PASSWORD: "PASSWORD",
    "CONFIRM PASSWORD": "CONFIRM PASSWORD",
    "ROLE AT Organization": "ROLE AT Organization",
    "ORGANIZATION TYPE": "ORGANIZATION TYPE",
    "NUMBER OF PEOPLE": "NUMBER OF PEOPLE",
    "INVESTMENT STAGE": "INVESTMENT STAGE",
    "VIRTUAL WORKERS": "% OF VIRTUAL WORKERS",
    "CURRENT STATUS": "CURRENT STATUS",
    "PREFERRED LANGUAGE": "PREFERRED LANGUAGE",
    ETHNICITY: "ETHNICITY / RACE",
    "Current Password": "Current Password",
    Password: "Password",
    "Confirm password": "Confirm password",
    "Organization name": "Organization name",
    TEAM: "TEAM",
    "NEW PASSWORD": "NEW PASSWORD",
    "CONFIRM NEW PASSWORD": "CONFIRM NEW PASSWORD",
    Title: "Title",
    "Card Number": "Card Number",
    "Expiration Date": "Expiration Date",
    CVV: "CVV",
    SUBJECT: "SUBJECT",
    BODY: "MESSAGE",
    BillerName: "Biller Name",
    FullName: "Full Name",
    AddressLine1: "Address Line 1",
    AddressLine2: "Address Line 2",
    Country: "Country",
    PostalCode: "Postal Code",
    State: "State",
    City: "City",
    QuestState: "State / Province / Region",
    QuestPostalCode: "Postal Code / Zip Code"
};
const $63e74658476514e3$export$8dc2bebde6e1a635 = (field)=>{
    switch(field){
        case "Address":
            return "Address";
        case "Address2":
            return $63e74658476514e3$export$a238cb463698c900.AddressLine2;
        case "City":
            return "City/Town";
        case "State":
            return $63e74658476514e3$export$a238cb463698c900.QuestState;
        case "Zip":
            return $63e74658476514e3$export$a238cb463698c900.QuestPostalCode;
        case "Country":
            return $63e74658476514e3$export$a238cb463698c900.Country;
        default:
            return null;
    }
};


const $67509c8d1d238d43$var$ObjectQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    // Use value prop if available, otherwise fall back to field.value
    const [addressData, setAddressData] = (0, $feLGi$react.useState)(value || field.value || {});
    // Update addressData when value prop changes (for prefilling)
    (0, $feLGi$react.useEffect)(()=>{
        if (value && typeof value === "object") setAddressData(value);
    }, [
        value
    ]);
    const handleSubmit = async (e)=>{
        if (e) e.preventDefault();
        if (question.isRequired) {
            const hasEmptyFields = question.subQuestions.some((subQ)=>!addressData[subQ._id] || !addressData[subQ._id].trim());
            if (hasEmptyFields) {
                setShowError(true);
                return;
            }
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: addressData
        });
    };
    const handleFieldChange = (fieldId, value)=>{
        const newData = {
            ...addressData,
            [fieldId]: value
        };
        setAddressData(newData);
        field.onChange({
            target: {
                name: field.name,
                value: newData
            }
        });
        // Clear error when user starts typing
        if (showError && value && value.trim() !== "") setShowError(false);
    };
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (question.isRequired) {
                const hasEmptyFields = question.subQuestions.some((subQ)=>!addressData[subQ._id] || !addressData[subQ._id].trim());
                if (hasEmptyFields) {
                    setShowError(true);
                    return;
                }
            }
            // Only call onSubmit if validation passes
            onSubmit({
                [question._id]: addressData
            });
        }
    };
    // Add global keyboard event listener when component mounts
    (0, $feLGi$react.useEffect)(()=>{
        const handleGlobalKeyDown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                if (question.isRequired) {
                    const hasEmptyFields = question.subQuestions.some((subQ)=>!addressData[subQ._id] || !addressData[subQ._id].trim());
                    if (hasEmptyFields) {
                        setShowError(true);
                        return;
                    }
                }
                // Only call onSubmit if validation passes
                onSubmit({
                    [question._id]: addressData
                });
            }
        };
        document.addEventListener("keydown", handleGlobalKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleGlobalKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        addressData,
        showError
    ]) // Dependencies for the effect
    ;
    const getLabelForSubQuestion = (subQuestion)=>(0, $63e74658476514e3$export$8dc2bebde6e1a635)(subQuestion) || (0, $63e74658476514e3$export$a238cb463698c900)[subQuestion] || subQuestion;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "object-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "address-fields-container pt-32px"
    }, question.subQuestions.map((subQ)=>{
        const fieldLabel = getLabelForSubQuestion(subQ.subQuestion);
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: subQ._id,
            className: "address-field-group"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
            className: "address-label"
        }, fieldLabel), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
            type: "text",
            className: "address-input",
            value: addressData[subQ._id] || "",
            onChange: (e)=>handleFieldChange(subQ._id, e.target.value),
            onKeyPress: handleKeyPress,
            placeholder: `Enter ${fieldLabel.toLowerCase()}`
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "input-underline"
        }));
    })), showError ? question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Please fill in all required fields"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $67509c8d1d238d43$export$2e2bcd8739ae039 = $67509c8d1d238d43$var$ObjectQuestion;





const $3ab7053e5d709235$var$ScaleQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , submitting: submitting = false , onPrevious: onPrevious // Add onPrevious prop
  })=>{
    var _question_scaleOptions, _question_scaleOptions1, _question_scaleOptions2, _question_scaleOptions3;
    const [field] = (0, $feLGi$formik.useField)(question._id);
    const [scaleValue, setScaleValue] = (0, $feLGi$react.useState)("");
    // Initialize scaleValue when value prop changes or component mounts
    (0, $feLGi$react.useEffect)(()=>{
        if (value !== undefined && value !== null && value !== "") setScaleValue(value);
    }, [
        value
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (question.isRequired && !scaleValue) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: scaleValue
        });
    };
    const handleScaleChange = (newValue)=>{
        setScaleValue(newValue);
        field.onChange({
            target: {
                name: field.name,
                value: newValue
            }
        });
        setShowError(false);
    };
    // Generate dynamic scale options based on scaleOptions configuration
    const getScaleOptions = ()=>{
        if (question.scaleOptions && question.scaleOptions.maxScaleLimit) {
            const maxLimit = question.scaleOptions.maxScaleLimit;
            return Array.from({
                length: maxLimit
            }, (_, i)=>i + 1);
        }
        // Fallback for older questions without scaleOptions
        if (question.options && question.options.length > 0) return question.options;
        // Default fallback
        return [
            1,
            2,
            3,
            4,
            5,
            6
        ];
    };
    const dynamicScaleOptions = getScaleOptions();
    // Add keyboard event listener when component mounts
    (0, $feLGi$react.useEffect)(()=>{
        const handleGlobalKeyDown = (e)=>{
            // Handle Enter key for submission
            if (e.key === "Enter") {
                e.preventDefault();
                if (question.isRequired && !scaleValue) {
                    setShowError(true);
                    return;
                }
                // Only call onSubmit if validation passes
                onSubmit({
                    [question._id]: scaleValue
                });
            }
            // Handle number keys for scale selection
            const keyNumber = parseInt(e.key);
            if (!isNaN(keyNumber) && keyNumber >= 1 && keyNumber <= dynamicScaleOptions.length) {
                e.preventDefault();
                // Check if the number corresponds to a valid scale option
                if (dynamicScaleOptions.includes(keyNumber)) handleScaleChange(keyNumber);
            }
        };
        document.addEventListener("keydown", handleGlobalKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleGlobalKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scaleValue,
        showError,
        dynamicScaleOptions,
        handleSubmit,
        handleScaleChange
    ]) // Updated dependencies
    ;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "scale-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "question-title d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "scale-options-container pt-32px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "scale-legend-mobile d-md-none"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "legend-row"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "legend-item"
    }, "1", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shouldFlipIfRtl"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.046 1.546a.5.5 0 0 1 .708 0l2.1 2.1a.5.5 0 0 1 0 .707l-2.1 2.1a.5.5 0 1 1-.708-.707L4.293 4.5H.5a.5.5 0 1 1 0-1h3.793L3.046 2.253a.5.5 0 0 1 0-.707Z"
    })), " ", ((_question_scaleOptions = question.scaleOptions) === null || _question_scaleOptions === void 0 ? void 0 : _question_scaleOptions.lowSubtitle) || "Strongly disagree"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "legend-item"
    }, dynamicScaleOptions.length, " ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shouldFlipIfRtl"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.046 1.546a.5.5 0 0 1 .708 0l2.1 2.1a.5.5 0 0 1 0 .707l-2.1 2.1a.5.5 0 1 1-.708-.707L4.293 4.5H.5a.5.5 0 1 1 0-1h3.793L3.046 2.253a.5.5 0 0 1 0-.707Z"
    })), " ", ((_question_scaleOptions1 = question.scaleOptions) === null || _question_scaleOptions1 === void 0 ? void 0 : _question_scaleOptions1.highSubtitle) || "Strongly agree"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "scale-options"
    }, dynamicScaleOptions.map((option)=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            key: option,
            // type='button'
            className: `scale-option rounded-1 ${scaleValue === option ? "selected" : ""}`,
            onClick: ()=>handleScaleChange(option),
            onKeyPress: (e)=>{
                if (e.key === "Enter") handleScaleChange(option);
            }
        }, option))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "scale-labels d-none d-md-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "scale-label-left"
    }, ((_question_scaleOptions2 = question.scaleOptions) === null || _question_scaleOptions2 === void 0 ? void 0 : _question_scaleOptions2.lowSubtitle) || "Strongly disagree"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "scale-label-right"
    }, ((_question_scaleOptions3 = question.scaleOptions) === null || _question_scaleOptions3 === void 0 ? void 0 : _question_scaleOptions3.highSubtitle) || "Strongly agree"))), showError ? question.isRequired && !scaleValue && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Please select a value"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $3ab7053e5d709235$export$2e2bcd8739ae039 = $3ab7053e5d709235$var$ScaleQuestion;








const $9ff6748d08f8fa8b$var$PreviewFileTypeIcon = ({ fileName: fileName  })=>{
    const extension = (fileName || "").split(".").pop().toLowerCase();
    const isImage = [
        "jpg",
        "jpeg",
        "png"
    ].includes(extension);
    if (isImage) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "64",
        height: "64",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: "#0A223C"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("rect", {
        x: "3",
        y: "5",
        width: "18",
        height: "14",
        rx: "2",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("circle", {
        cx: "8.5",
        cy: "10",
        r: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M21 16L16 12L9 18H21V16Z",
        fill: "currentColor",
        opacity: "0.85"
    }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "64",
        height: "64",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: "#0A223C"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M14 2V8H20",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M16 13H8",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M16 17H8",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10 9H8",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
const $9ff6748d08f8fa8b$var$FilesQuestion = ({ question: question , questionIndex: questionIndex , value: value , onSubmit: onSubmit , showError: showError , setShowError: setShowError , buttonText: buttonText = "OK" , questId: questId , customFormId: customFormId , submitting: submitting = false , onPrevious: onPrevious , onUploadingStateChange: onUploadingStateChange , isPreviewMode: isPreviewMode = false , questsApi: questsApi  })=>{
    const [field] = (0, $feLGi$formik.useField)(question._id);
    const { user: user  } = (0, $ca001929343b7efa$export$2e2bcd8739ae039)();
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const Notification = (0, $102ddb9add0f5b8b$export$2e2bcd8739ae039)();
    // Use value prop if available, otherwise fall back to field.value
    const [uploadedFile, setUploadedFile] = (0, $feLGi$react.useState)(()=>{
        // Only load file if it's a valid value for this question
        // For file uploads, we expect either a string (file name) or null
        let fileValue = null;
        // Check if value prop is provided and valid
        if (value && typeof value === "string" && value.trim() !== "") fileValue = value;
        else if (field.value && typeof field.value === "string" && field.value.trim() !== "") fileValue = field.value;
        // Only create file object if we have a valid file value
        if (fileValue) return {
            name: fileValue,
            size: 0,
            type: "application/octet-stream",
            url: null,
            isFileNameOnly: true // Flag to indicate this is just a file name from localStorage
        };
        return null;
    });
    const [isUploading, setIsUploading] = (0, $feLGi$react.useState)(false);
    const [dragActive, setDragActive] = (0, $feLGi$react.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $feLGi$react.useState)(false);
    const fileInputRef = (0, $feLGi$react.useRef)(null);
    // Add state for fileUrl loading
    const [fileUrl, setFileUrl] = (0, $feLGi$react.useState)(null);
    const [isFileUrlLoading, setIsFileUrlLoading] = (0, $feLGi$react.useState)(false);
    const userId = user === null || user === void 0 ? void 0 : user.id;
    // Notify parent component when uploading state changes
    (0, $feLGi$react.useEffect)(()=>{
        if (onUploadingStateChange) onUploadingStateChange(isUploading || isDeleting);
    }, [
        isUploading,
        isDeleting,
        onUploadingStateChange
    ]);
    // Add keyboard event listener for Enter key
    (0, $feLGi$react.useEffect)(()=>{
        const handleGlobalKeyDown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                // Prevent navigation if uploading or deleting is in progress
                if (isUploading || isDeleting) return;
                if (question.isRequired && !uploadedFile) {
                    setShowError(true);
                    return;
                }
                // Only call onSubmit if validation passes
                onSubmit({
                    [question._id]: uploadedFile ? uploadedFile.name : null
                });
            }
        };
        document.addEventListener("keydown", handleGlobalKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleGlobalKeyDown);
        };
    }, [
        uploadedFile,
        isUploading,
        isDeleting,
        onSubmit,
        question._id,
        question.isRequired,
        setShowError
    ]);
    // Update uploadedFile when value prop changes (for prefilling)
    (0, $feLGi$react.useEffect)(()=>{
        // Only update if the value is a valid string and not empty
        if (value && typeof value === "string" && value.trim() !== "") setUploadedFile({
            name: value,
            size: 0,
            type: "application/octet-stream",
            url: null,
            isFileNameOnly: true
        });
        else if (!value || value === null || value === "") // Only clear the file if we don't have a current uploaded file with a URL
        // This prevents clearing files that were just uploaded by the user
        setUploadedFile((currentFile)=>{
            if (currentFile && currentFile.url) // Keep the current uploaded file if it has a URL (user uploaded)
            return currentFile;
            // Clear only if it's a file name only (from localStorage) or null
            return null;
        });
    }, [
        value,
        question._id,
        question.question
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        const fetchFileUrl = async ()=>{
            if (isPreviewMode) {
                setFileUrl((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.url) || null);
                return;
            }
            if (uploadedFile && uploadedFile.name && !uploadedFile.url && [
                "jpg",
                "jpeg",
                "png"
            ].includes(uploadedFile.name.split(".").pop().toLowerCase()) && questId && userId && (questsApi === null || questsApi === void 0 ? void 0 : questsApi.downloadTravelDocument)) {
                setIsFileUrlLoading(true);
                try {
                    const { data: data  } = await questsApi.downloadTravelDocument(questId, userId, uploadedFile.name);
                    if (data && data.url) setFileUrl(data.url);
                } catch (e) {
                    setFileUrl(null);
                } finally{
                    setIsFileUrlLoading(false);
                }
            } else setFileUrl(null);
        };
        fetchFileUrl();
    // Only run when uploadedFile changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uploadedFile,
        questId,
        userId
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (question.isRequired && !uploadedFile) {
            setShowError(true);
            return;
        }
        // Only call onSubmit if validation passes
        onSubmit({
            [question._id]: uploadedFile ? uploadedFile.name : null
        });
    };
    // Map question.connectedTo to documentType for API
    const getDocumentType = ()=>{
        switch(question.connectedTo){
            case "passport":
                return "passport";
            case "ticket":
                return "ticket";
            case "insurance":
                return "insurance";
            case "headshot":
                return "headshot";
            default:
                return null // Default fallback
                ;
        }
    };
    // Get file type from file extension
    const getFileType = (fileName)=>{
        const extension = fileName.substr(fileName.lastIndexOf(".") + 1).toUpperCase();
        switch(extension){
            case "PDF":
                return "PDF";
            case "JPG":
            case "JPEG":
                return "JPG";
            case "PNG":
                return "PNG";
            default:
                return "PDF" // Default fallback
                ;
        }
    };
    const handleFileUpload = async (file)=>{
        if (!file) return;
        if (!isPreviewMode && (!questId || !userId)) {
            Error.showError({
                message: "Missing quest or user information. Please try again."
            });
            return;
        }
        // Validate file type
        const supportedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png"
        ];
        if (!supportedTypes.includes(file.type)) {
            Notification.showNotification("Please upload only JPG, PNG, or PDF files");
            return;
        }
        // Validate file size (10MB limit)
        const maxSize = 10485760 // 10MB in bytes
        ;
        if (file.size > maxSize) {
            Error.showError({
                message: "File size must be less than 10MB"
            });
            return;
        }
        setIsUploading(true);
        try {
            if (isPreviewMode) {
                const fileData = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    url: URL.createObjectURL(file),
                    isPreviewOnly: true
                };
                setUploadedFile(fileData);
                field.onChange({
                    target: {
                        name: field.name,
                        value: file.name
                    }
                });
                if (showError) setShowError(false);
                return;
            }
            // Get file type and document type
            const fileType = getFileType(file.name);
            const documentType = getDocumentType();
            // Get signed URL
            const { data: signedUrlData  } = await questsApi.getTravelDocumentSignedURL(questId, fileType, documentType);
            if (signedUrlData && signedUrlData.url) {
                // Upload to signed URL
                await (0, ($parcel$interopDefault($feLGi$axios))).put(signedUrlData.url.url, file, {
                    headers: {
                        "Content-Type": signedUrlData.url.contentType
                    }
                });
                // Call API to finalize upload
                const { data: uploadApiResult  } = await questsApi.uploadTravelDocument(questId, userId, {
                    fileName: signedUrlData.fileName,
                    documentType: documentType
                });
                if (uploadApiResult) {
                    const fileData = {
                        name: signedUrlData.fileName,
                        size: file.size,
                        type: file.type,
                        url: URL.createObjectURL(file)
                    };
                    setUploadedFile(fileData);
                    // Store file name in Formik for localStorage
                    field.onChange({
                        target: {
                            name: field.name,
                            value: signedUrlData.fileName
                        }
                    });
                    // Clear error when user uploads a file
                    if (showError) setShowError(false);
                } else throw new Error("Upload API did not return expected data.");
            } else throw new Error("Could not get signed URL.");
        } catch (error) {
            Error.showError({
                message: "Failed to upload file. Please try again."
            });
        } finally{
            setIsUploading(false);
        }
    };
    const handleFileSelect = (e)=>{
        if (isUploading) return;
        const file = e.target.files[0];
        if (file) handleFileUpload(file);
    };
    const handleDrag = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (isUploading) return;
        if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
        else if (e.type === "dragleave") setDragActive(false);
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (isUploading) return;
        const file = e.dataTransfer.files[0];
        if (file) handleFileUpload(file);
    };
    const removeFile = async ()=>{
        if (!uploadedFile) {
            setUploadedFile(null);
            field.onChange({
                target: {
                    name: field.name,
                    value: null
                }
            });
            if (fileInputRef.current) fileInputRef.current.value = "";
            return;
        }
        setIsDeleting(true);
        try {
            if (!isPreviewMode && questId && uploadedFile.name && (questsApi === null || questsApi === void 0 ? void 0 : questsApi.deleteTravelDocument)) {
                const documentType = getDocumentType();
                await questsApi.deleteTravelDocument(questId, userId, uploadedFile.name, documentType);
            }
            // Clear the file from state and Formik
            setUploadedFile(null);
            field.onChange({
                target: {
                    name: field.name,
                    value: null
                }
            });
            if (fileInputRef.current) fileInputRef.current.value = "";
            // Remove file from localStorage form object
            if (!isPreviewMode && typeof window !== "undefined" && questId && customFormId && question && question._id) {
                const storageKey = `${customFormId}-${userId}`;
                try {
                    const savedData = localStorage.getItem(storageKey);
                    if (savedData) {
                        const parsedData = JSON.parse(savedData);
                        delete parsedData[question._id];
                        localStorage.setItem(storageKey, JSON.stringify(parsedData));
                    }
                } catch (e) {
                    Error.showError(e);
                }
            }
        } catch (error) {
            Error.showError(error);
            // Even if API fails, still clear local state
            setUploadedFile(null);
            field.onChange({
                target: {
                    name: field.name,
                    value: null
                }
            });
            if (fileInputRef.current) fileInputRef.current.value = "";
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "files-question"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mb-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "me-1 question-index form-index-color mt-1"
    }, questionIndex), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "pe-2 pe-md-12px right-arrow-icon mt-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M1.5 7L16.5 7M16.5 7L10.875 13M16.5 7L10.875 1",
        stroke: "#0A223C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-title"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("strong", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: question.question
        }
    }), question.isRequired && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "required-question"
    }, "*"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "mt-2"
    }, question.description && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-description",
        dangerouslySetInnerHTML: {
            __html: (question.description || "").replace(/<a\s+([^>]*?)>/gi, '<a $1 target="_blank" rel="noreferrer noopener" style="color: #bf9000;">')
        }
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "pt-32px"
    }, question.connectedTo === "passport" && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "passport-guidelines mb-4"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
        className: "border-radius-10 lazyload imgix-object-cover",
        imgixParams: {
            fit: "clip",
            auto: "format"
        },
        src: `${process.env.REACT_APP_IMG_SOURCE}/passport_placeholder.png`,
        width: "100%",
        height: "75%",
        alt: "image",
        attributeConfig: {
            src: "data-src",
            srcSet: "data-srcset",
            sizes: "data-sizes"
        },
        htmlAttributes: {
            src: `${process.env.REACT_APP_IMG_SOURCE}/passport_placeholder.png?fit=clip&auto=format&fill=blur&blur=300&px=16` // low quality image here
        }
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "upload-area"
    }, !uploadedFile ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `upload-zone ${dragActive ? "drag-active" : ""} ${isUploading ? "uploading" : ""}`,
        onDragEnter: handleDrag,
        onDragLeave: handleDrag,
        onDragOver: handleDrag,
        onDrop: handleDrop,
        onClick: ()=>{
            var _fileInputRef_current;
            return !isUploading && ((_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click());
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("input", {
        ref: fileInputRef,
        type: "file",
        accept: ".pdf,.jpg,.jpeg,.png",
        onChange: handleFileSelect,
        style: {
            display: "none"
        },
        disabled: isUploading
    }), isUploading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "spinner-border text-saffron-700",
        role: "status",
        style: {
            width: "48px",
            height: "48px"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "visually-hidden"
    }, "Loading...")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        style: {
            margin: 0,
            fontSize: "16px",
            fontWeight: "600",
            color: "#6C757D"
        }
    }, "Uploading..."))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "52",
        height: "42",
        viewBox: "0 0 52 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M10.5975 16.3387C5.09375 17.6475 1 22.5962 1 28.5C1 35.4037 6.59625 41 13.5 41C14.6838 41 15.83 40.835 16.9162 40.5275M41.0688 16.3387C46.5725 17.6475 50.665 22.5962 50.665 28.5C50.665 35.4037 45.0687 41 38.165 41C36.9812 41 35.835 40.835 34.75 40.5275M41 16C41 7.71625 34.2837 1 26 1C17.7163 1 11 7.71625 11 16M17.3313 25.8513L26 17.155L34.915 26M26 38.5V21.5775",
        stroke: "#6C757D",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        style: {
            margin: "16px 0 8px 0",
            fontSize: "16px",
            fontWeight: "600",
            color: "#6C757D",
            textAlign: "center"
        }
    }, "Choose a file or drag it here"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        style: {
            margin: 0,
            fontSize: "14px",
            color: "#6C757D",
            textAlign: "center"
        }
    }, "Size limit: 10MB"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: {
            width: "100%",
            minHeight: "200px",
            backgroundColor: "rgba(10, 34, 60, 0.1);",
            border: "1px dashed rgba(10, 34, 60, 0.8)",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: {
            backgroundColor: "#E9ECEF",
            borderRadius: "8px",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            minWidth: "200px",
            position: "relative"
        }
    }, (()=>{
        const ext = uploadedFile.name.split(".").pop().toLowerCase();
        if (isPreviewMode) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($9ff6748d08f8fa8b$var$PreviewFileTypeIcon, {
            fileName: uploadedFile.name
        });
        if ([
            "jpg",
            "jpeg",
            "png"
        ].includes(ext)) return isFileUrlLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "spinner-border text-saffron-700",
            role: "status",
            style: {
                width: 40,
                height: 40
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "visually-hidden"
        }, "Loading...")) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("img", {
            src: uploadedFile.url || fileUrl,
            alt: uploadedFile.name,
            style: {
                width: "200px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #DEE2E6"
            }
        });
        else if (ext === "pdf") return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "64",
            height: "64",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                color: "#0A223C"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M14 2V8H20",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M16 13H8",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M16 17H8",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
            d: "M10 9H8",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
        else return null;
    })(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            maxWidth: "100%"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        style: {
            fontSize: "14px",
            color: "#495057",
            fontWeight: "500",
            maxWidth: "250px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }
    }, (()=>{
        const fileName = uploadedFile.name;
        const ext = fileName.split(".").pop();
        const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf("."));
        // Increased character limit from 15 to 25 before truncating
        if (nameWithoutExt.length > 25) {
            const start = nameWithoutExt.substring(0, 15) // Increased from 8 to 15
            ;
            const end = nameWithoutExt.substring(nameWithoutExt.length - 6 // Increased from 4 to 6
            );
            return `${start}...${end}.${ext}`;
        }
        return fileName;
    })()), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            removeFile();
        },
        disabled: isDeleting,
        style: {
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#6C757D",
            transition: "all 0.2s ease"
        },
        onMouseEnter: (e)=>{
            e.target.style.backgroundColor = "#F8F9FA";
            e.target.style.color = "#DC3545";
        },
        onMouseLeave: (e)=>{
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "#6C757D";
        }
    }, isDeleting ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "spinner-border spinner-border-sm",
        role: "status",
        style: {
            width: "12px",
            height: "12px"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "visually-hidden"
    }, "Deleting...")) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M9 3L3 9M3 3L9 9",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })))))))), showError ? question.isRequired && !uploadedFile && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-container mt-16px"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "error-message d-flex align-items-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "error-icon"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.785 6.604a.25.25 0 0 1 .43 0l6.243 10.515a.25.25 0 0 1-.215.378H5.757a.25.25 0 0 1-.215-.378l6.243-10.515Zm1.72-.766a1.75 1.75 0 0 0-3.01 0L4.252 16.353c-.693 1.167.148 2.644 1.505 2.644h12.486c1.357 0 2.198-1.477 1.505-2.643L13.505 5.838Zm-.755 4.966a.75.75 0 1 0-1.5 0V13a.75.75 0 0 0 1.5 0v-2.196ZM12 14.666a.828.828 0 1 0 0 1.655.828.828 0 0 0 0-1.655Z"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "Please upload a file"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "action-container mt-16px"
    }, questionIndex > 1 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        onClick: onPrevious,
        className: "back-button d-sm-576-flex d-lg-576-none border-radius-normal px-14px py-6px",
        disabled: submitting,
        style: {
            backgroundColor: "#0a223c",
            color: "white",
            border: "none",
            minWidth: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: "cursor-pointer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 1.41406L4 8.20845",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("path", {
        d: "M11 14.9975L4 8.20312",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round"
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        variant: isPreviewMode ? undefined : "saffron",
        onClick: handleSubmit,
        className: "border-radius-normal ok-button px-14px py-6px",
        isLoading: submitting,
        disabled: submitting || isUploading || isDeleting,
        "data-text": buttonText
    }, buttonText), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "line-break-instruction d-sm-576-none d-lg-576-block"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
        className: "instruction-text text-abroad-blue"
    }, "press ", /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("b", null, "Enter"), " ↵")))))));
};
var $9ff6748d08f8fa8b$export$2e2bcd8739ae039 = $9ff6748d08f8fa8b$var$FilesQuestion;




const $6b45442dba6a28ce$var$useResolutionService = ()=>{
    const [isLGScreen, setIsLGScreen] = (0, $feLGi$react.useState)(window.innerWidth >= 992);
    const [isSMScreen, setIsSMScreen] = (0, $feLGi$react.useState)(window.innerWidth >= 576 && window.innerWidth < 768);
    const [isMDScreen, setIsMDScreen] = (0, $feLGi$react.useState)(window.innerWidth >= 768 && window.innerWidth < 992);
    const [isXSScreen, setIsXSScreen] = (0, $feLGi$react.useState)(window.innerWidth < 576);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $feLGi$react.useEffect)(()=>{
        const windowSize = ()=>{
            if (window.innerWidth >= 992) {
                setIsLGScreen(true);
                setIsSMScreen(false);
                setIsMDScreen(false);
                setIsXSScreen(false);
            } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
                setIsLGScreen(false);
                setIsSMScreen(true);
                setIsMDScreen(false);
                setIsXSScreen(false);
            } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
                setIsLGScreen(false);
                setIsSMScreen(false);
                setIsMDScreen(true);
                setIsXSScreen(false);
            } else {
                setIsXSScreen(true);
                setIsLGScreen(false);
                setIsSMScreen(false);
                setIsMDScreen(false);
            }
        };
        windowSize();
        window.addEventListener("resize", windowSize);
        return ()=>window.removeEventListener("resize", windowSize);
    }, []);
    return {
        isLGScreen: isLGScreen,
        isSMScreen: isSMScreen,
        isMDScreen: isMDScreen,
        isXSScreen: isXSScreen
    };
};
var $6b45442dba6a28ce$export$2e2bcd8739ae039 = $6b45442dba6a28ce$var$useResolutionService;


// Display size is CSS-driven; these params only affect Imgix URL generation.
const $a1f984fe84e53642$var$QUESTION_IMAGE_IMGIX_PARAMS = {
    fit: "fill",
    w: 800,
    h: 800,
    q: 95,
    fill: "blur"
};
const $a1f984fe84e53642$var$isEmptyAnswer = (answer)=>{
    if (answer === undefined || answer === null || answer === "") return true;
    if (Array.isArray(answer) && answer.length === 0) return true;
    if (typeof answer === "object" && answer !== null && !Array.isArray(answer)) return Object.values(answer).every((v)=>!v || typeof v === "string" && v.trim() === "");
    return false;
};
const $a1f984fe84e53642$var$hasSavedAnswer = (answer)=>!$a1f984fe84e53642$var$isEmptyAnswer(answer);
// Debounced save while user types so optional answers persist before navigation
const $a1f984fe84e53642$var$FormikValuesPersistence = ({ questionId: questionId , value: value , savedValue: savedValue , onSaveAnswer: onSaveAnswer  })=>{
    (0, $feLGi$react.useEffect)(()=>{
        if (!onSaveAnswer || value === undefined) return;
        if ($a1f984fe84e53642$var$isEmptyAnswer(value) && $a1f984fe84e53642$var$hasSavedAnswer(savedValue)) return;
        const timer = setTimeout(()=>{
            onSaveAnswer(value);
        }, 300);
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        questionId,
        value,
        savedValue
    ]);
    return null;
};
const $a1f984fe84e53642$var$QuestionRenderer = ({ question: question , questionIndex: questionIndex , totalQuestions: totalQuestions , value: value , onSubmit: onSubmit , onSaveAnswer: onSaveAnswer , onNext: onNext , onPrevious: onPrevious , isLastQuestion: isLastQuestion , submitting: submitting , onFinalSubmit: onFinalSubmit , formData: formData , questId: questId , customFormId: customFormId , allQuestions: allQuestions , hasMoreQuestionsAfterCurrent: hasMoreQuestionsAfterCurrent , prefetchQuestionImages: prefetchQuestionImages = [] , isPreviewMode: isPreviewMode = false , questsApi: questsApi  })=>{
    const { isLGScreen: isLGScreen , isXSScreen: isXSScreen  } = (0, $6b45442dba6a28ce$export$2e2bcd8739ae039)();
    const [showError, setShowError] = (0, $feLGi$react.useState)(false);
    const [animationDirection, setAnimationDirection] = (0, $feLGi$react.useState)(null);
    const questionContentRef = (0, $feLGi$react.useRef)(null);
    const formikValuesRef = (0, $feLGi$react.useRef)({});
    const [isUploading, setIsUploading] = (0, $feLGi$react.useState)(false) // Add state for uploading/deleting
    ;
    const hasQuestionImage = Boolean(question.questionImageName);
    // XS / SM / MD: always stack (image top). LG+: side-by-side.
    const isStackedLayout = !isLGScreen;
    const imageSize = isLGScreen ? 800 : isXSScreen ? 400 : 600;
    // Persist current answer (required or optional) so back/next navigation does not lose it
    const persistCurrentAnswer = (currentFormValues)=>{
        var _formikValuesRef_current;
        if (!onSaveAnswer) return;
        const currentValue = currentFormValues && Object.prototype.hasOwnProperty.call(currentFormValues, question._id) ? currentFormValues[question._id] : (_formikValuesRef_current = formikValuesRef.current) === null || _formikValuesRef_current === void 0 ? void 0 : _formikValuesRef_current[question._id];
        if (currentValue === undefined) return;
        // Stale empty Formik state must not wipe a previously saved optional answer
        const savedValue = formData === null || formData === void 0 ? void 0 : formData[question._id];
        if ($a1f984fe84e53642$var$isEmptyAnswer(currentValue) && $a1f984fe84e53642$var$hasSavedAnswer(savedValue)) return;
        onSaveAnswer(currentValue);
    };
    // Add this useEffect:
    (0, $feLGi$react.useEffect)(()=>{
        setShowError(false);
    }, [
        question._id,
        questionIndex
    ]);
    // Reset uploading state when question changes
    (0, $feLGi$react.useEffect)(()=>{
        setIsUploading(false);
    }, [
        question._id
    ]);
    // Callback to handle uploading state changes from FilesQuestion
    const handleUploadingStateChange = (uploading)=>{
        setIsUploading(uploading);
    };
    const getValidationSchema = ()=>{
        const baseSchema = {};
        if (question.isRequired) switch(question.answerType){
            case "text":
                baseSchema[question._id] = $feLGi$yup.string().required("This field is required");
                break;
            case "phone":
                baseSchema[question._id] = $feLGi$yup.string().required("This field is required").test("phone-format", "Hmm... that phone number doesn't look right", function(value) {
                    if (!value) return false;
                    const digitsOnly = value.replace(/\D/g, "");
                    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
                });
                break;
            case "email":
                baseSchema[question._id] = $feLGi$yup.string().required("This field is required").email("Please enter a valid email address (e.g., user@example.com)");
                break;
            case "singleSelectionDropdown":
            case "multipleSelectionDropdown":
                baseSchema[question._id] = $feLGi$yup.string().required("Please make a selection");
                break;
            case "date":
                baseSchema[question._id] = $feLGi$yup.date().required("Please select a date");
                break;
            case "object":
                {
                    const objectSchema = {};
                    question.subQuestions.forEach((subQ)=>{
                        objectSchema[subQ._id] = $feLGi$yup.string().required("This field is required");
                    });
                    baseSchema[question._id] = $feLGi$yup.object().shape(objectSchema);
                    break;
                }
            case "scale":
                var _question_scaleOptions, _question_scaleOptions1;
                baseSchema[question._id] = $feLGi$yup.number().required("Please select a value").min(1, "Please select a valid scale value").max(((_question_scaleOptions = question.scaleOptions) === null || _question_scaleOptions === void 0 ? void 0 : _question_scaleOptions.maxScaleLimit) || 6, `Please select a value between 1 and ${((_question_scaleOptions1 = question.scaleOptions) === null || _question_scaleOptions1 === void 0 ? void 0 : _question_scaleOptions1.maxScaleLimit) || 6}`);
                break;
            case "files":
                baseSchema[question._id] = $feLGi$yup.mixed().required("Please upload a file");
                break;
            default:
                baseSchema[question._id] = $feLGi$yup.string().required("This field is required");
        }
        else // Add validation for non-required fields
        // eslint-disable-next-line default-case
        switch(question.answerType){
            case "email":
                baseSchema[question._id] = $feLGi$yup.string().email("Please enter a valid email address (e.g., user@example.com)");
                break;
            case "phone":
                baseSchema[question._id] = $feLGi$yup.string().test("phone-format", "Hmm... that phone number doesn't look right", function(value) {
                    if (!value || value.trim() === "") return true // Allow empty for non-required
                    ;
                    const digitsOnly = value.replace(/\D/g, "");
                    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
                });
                break;
        }
        return $feLGi$yup.object().shape(baseSchema);
    };
    const getInitialValues = ()=>{
        const initialValues = {};
        if (question.answerType === "object") {
            const objectValue = value || {};
            question.subQuestions.forEach((subQ)=>{
                objectValue[subQ._id] = objectValue[subQ._id] || "";
            });
            initialValues[question._id] = objectValue;
        } else initialValues[question._id] = value || "";
        return initialValues;
    };
    const handleNextClick = (currentFormValues)=>{
        // Check if current question is valid before proceeding
        const currentValue = currentFormValues ? currentFormValues[question._id] : value;
        if (question.isRequired && !isCurrentQuestionValid(currentValue)) {
            setShowError(true);
            return;
        }
        // Always persist before navigating so optional answers are not lost
        persistCurrentAnswer(currentFormValues);
        const resolvedValue = currentFormValues && Object.prototype.hasOwnProperty.call(currentFormValues, question._id) ? currentFormValues[question._id] : currentValue;
        if (!$a1f984fe84e53642$var$isEmptyAnswer(resolvedValue)) onSubmit(resolvedValue);
        else onNext();
    };
    const handlePreviousWithSave = (currentFormValues)=>{
        persistCurrentAnswer(currentFormValues);
        onPrevious();
    };
    const isCurrentQuestionValid = (currentValue)=>{
        if (!question.isRequired) {
            // For non-required fields, still validate format if value exists
            if (question.answerType === "email" && currentValue && currentValue.trim() !== "") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(currentValue.trim());
            }
            if (question.answerType === "phone" && currentValue && currentValue.trim() !== "") {
                // Phone validation for non-required fields
                const digitsOnly = currentValue.replace(/\D/g, "");
                return digitsOnly.length >= 7 && digitsOnly.length <= 15;
            }
            if (question.answerType === "country" && currentValue && currentValue.trim() !== "") {
                // Country validation for non-required fields - check if it matches the expected format
                const countryMatch = currentValue.match(/^\+(\d+)\s+(.+)$/);
                return countryMatch && countryMatch[1] && countryMatch[2];
            }
            return true;
        }
        if (question.answerType === "object") {
            // For object type, check if all sub-questions have values
            const objectValue = currentValue || {};
            return question.subQuestions.every((subQ)=>{
                const subValue = objectValue[subQ._id];
                return subValue && subValue.trim && subValue.trim() !== "";
            });
        } else if (question.answerType === "multipleSelectionDropdown") // For multiple selection, check if at least one option is selected
        return Array.isArray(currentValue) && currentValue.length > 0;
        else if (question.answerType === "email") {
            // For email, check if value exists and is valid email format
            if (!currentValue || currentValue.toString().trim() === "") return false;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(currentValue.toString().trim());
        } else if (question.answerType === "phone") {
            // For phone, check if value exists and is valid phone format
            if (!currentValue || currentValue.toString().trim() === "") return false;
            const phoneString = currentValue.toString().trim();
            const digitsOnly = phoneString.replace(/\D/g, "");
            // Basic phone validation: 7-15 digits
            if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;
            // Additional validation for common country formats
            if (phoneString.includes("+1")) {
                // US/Canada format
                const usDigits = digitsOnly.replace(/^1/, "") // Remove country code
                ;
                return usDigits.length === 10;
            }
            return true;
        } else if (question.answerType === "country") {
            // For country, check if value exists and is valid country format
            if (!currentValue || currentValue.toString().trim() === "") return false;
            const countryString = currentValue.toString().trim();
            // Check if it matches the expected format: +{dialCode} {countryName}
            const countryMatch = countryString.match(/^\+(\d+)\s+(.+)$/);
            return countryMatch && countryMatch[1] && countryMatch[2];
        } else if (question.answerType === "date") {
            // For date, check if all three parts (month, day, year) are filled
            if (!currentValue || currentValue.toString().trim() === "") return false;
            // Parse the date string to check if all parts are present
            const dateString = currentValue.toString().trim();
            const parts = dateString.split("/");
            if (parts.length !== 3) return false;
            const [month, day, year] = parts;
            return month && day && year && month.trim() !== "" && day.trim() !== "" && year.trim() !== "";
        } else // For other types, check if the value exists and is not empty
        return currentValue && currentValue.toString && currentValue.toString().trim() !== "";
    };
    // Animation handler
    const handleAnimatedNavigation = (direction, currentFormValues)=>{
        // Prevent navigation if uploading or deleting is in progress
        if (isUploading) return;
        // For next direction, validate before starting animation
        if (direction === "next") {
            const currentValue = currentFormValues ? currentFormValues[question._id] : value;
            if (question.isRequired && !isCurrentQuestionValid(currentValue)) {
                setShowError(true);
                return; // Don't start animation if validation fails
            }
        }
        setAnimationDirection(direction);
        // Wait for animation to finish before navigating
        if (questionContentRef.current) {
            const handleAnimationEnd = ()=>{
                setAnimationDirection(null);
                if (direction === "next") handleNextClick(currentFormValues);
                else if (direction === "prev") handlePreviousWithSave(currentFormValues);
                questionContentRef.current.removeEventListener("animationend", handleAnimationEnd);
            };
            questionContentRef.current.addEventListener("animationend", handleAnimationEnd);
        }
    };
    // Mouse wheel navigation handler
    const handleWheelNavigation = (0, $feLGi$react.useCallback)((e, currentFormValues)=>{
        // Prevent default scroll behavior
        e.preventDefault();
        // Prevent navigation if uploading or deleting is in progress
        if (isUploading) return;
        // Prevent navigation if animation is already in progress
        if (animationDirection) return;
        const delta = e.deltaY;
        const threshold = 50 // Minimum scroll amount to trigger navigation
        ;
        if (Math.abs(delta) < threshold) return;
        if (delta > 0) {
            // Scrolling down - go to next question
            const currentValue = currentFormValues ? currentFormValues[question._id] : value;
            if (question.isRequired && !isCurrentQuestionValid(currentValue)) {
                setShowError(true);
                return;
            }
            handleAnimatedNavigation("next", currentFormValues);
        } else // Scrolling up - go to previous question
        if (questionIndex > 1) handleAnimatedNavigation("prev", currentFormValues);
    }, [
        questionIndex,
        isUploading,
        animationDirection,
        value,
        question._id
    ]);
    // Add wheel event listener
    (0, $feLGi$react.useEffect)(()=>{
        const handleWheel = (e)=>{
            // Only handle wheel events when not in a form input
            const target = e.target;
            const isInput = target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.contentEditable === "true";
            if (isInput) return; // Don't interfere with input scrolling
            // Check if the target is within a dropdown or scrollable container
            const isInDropdown = target.closest(".custom-country-dropdown") || target.closest(".mobile-dropdown-sheet") || target.closest(".country-list") || target.closest(".mobile-dropdown-content") || target.closest(".search-section") || target.closest(".search-input");
            if (isInDropdown) return; // Don't interfere with dropdown scrolling
            // Check if the target is within scrollable content areas (for long questions like FilesQuestion)
            const isInScrollableContent = target.closest(".files-question") || target.closest(".passport-guidelines") || target.closest(".upload-area") || target.closest(".upload-zone") || target.closest(".question-content") || target.closest(".typeform-question");
            if (isInScrollableContent) return; // Don't interfere with content scrolling
            // Use live Formik values so typed optional answers are not lost on wheel nav
            const currentValues = formikValuesRef.current || {
                [question._id]: value
            };
            handleWheelNavigation(e, currentValues);
        };
        // Add event listener to the container
        const container = document.querySelector(".enroll-typeform-container");
        if (container) container.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>{
            if (container) container.removeEventListener("wheel", handleWheel);
        };
    }, [
        questionIndex,
        isUploading,
        animationDirection,
        value,
        question._id
    ]) // Dependencies for the effect
    ;
    // New function to handle Enter key submissions with animation
    const handleAnimatedSubmit = (values)=>{
        // Prevent submission if uploading or deleting is in progress
        if (isUploading) return;
        // Check if the question is required and has a value
        const currentValue = values[question._id];
        let isValid = true;
        if (question.isRequired) {
            if (question.answerType === "object") {
                // For object type, check if all sub-questions have values
                const objectValue = currentValue || {};
                isValid = question.subQuestions.every((subQ)=>{
                    const subValue = objectValue[subQ._id];
                    return subValue && subValue.trim && subValue.trim() !== "";
                });
            } else if (question.answerType === "multipleSelectionDropdown") // For multiple selection, check if at least one option is selected
            isValid = Array.isArray(currentValue) && currentValue.length > 0;
            else if (question.answerType === "email") {
                // For email, check if value exists and is valid email format
                if (!currentValue || currentValue.toString().trim() === "") isValid = false;
                else {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    isValid = emailRegex.test(currentValue.toString().trim());
                }
            } else if (question.answerType === "phone") {
                // For phone, check if value exists and is valid phone format
                if (!currentValue || currentValue.toString().trim() === "") isValid = false;
                else {
                    const phoneString = currentValue.toString().trim();
                    const digitsOnly = phoneString.replace(/\D/g, "");
                    // Basic phone validation: 7-15 digits
                    if (digitsOnly.length < 7 || digitsOnly.length > 15) isValid = false;
                    else // Additional validation for common country formats
                    if (phoneString.includes("+1")) {
                        // US/Canada format
                        const usDigits = digitsOnly.replace(/^1/, "") // Remove country code
                        ;
                        isValid = usDigits.length === 10;
                    } else isValid = true;
                }
            } else if (question.answerType === "country") {
                // For country, check if value exists and is valid country format
                if (!currentValue || currentValue.toString().trim() === "") isValid = false;
                else {
                    const countryString = currentValue.toString().trim();
                    // Check if it matches the expected format: +{dialCode} {countryName}
                    const countryMatch = countryString.match(/^\+(\d+)\s+(.+)$/);
                    isValid = countryMatch && countryMatch[1] && countryMatch[2];
                }
            } else // For other types, check if the value exists and is not empty
            isValid = currentValue && currentValue.toString && currentValue.toString().trim() !== "";
        } else {
            // For non-required fields, still validate format if value exists
            if (question.answerType === "email" && currentValue && currentValue.trim() !== "") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                isValid = emailRegex.test(currentValue.trim());
            } else if (question.answerType === "phone" && currentValue && currentValue.trim() !== "") {
                const phoneString = currentValue.toString().trim();
                const digitsOnly = phoneString.replace(/\D/g, "");
                isValid = digitsOnly.length >= 7 && digitsOnly.length <= 15;
            } else if (question.answerType === "country" && currentValue && currentValue.trim() !== "") {
                // Country validation for non-required fields - check if it matches the expected format
                const countryMatch = currentValue.match(/^\+(\d+)\s+(.+)$/);
                isValid = countryMatch && countryMatch[1] && countryMatch[2];
            } else isValid = true;
        }
        if (!isValid) {
            setShowError(true);
            return;
        }
        const hasMoreQuestions = hasMoreQuestionsAfterCurrent(question._id, {
            ...formData,
            [question._id]: currentValue
        });
        const proceedAfterSubmit = ()=>{
            if (!hasMoreQuestions) {
                const updatedFormData = {
                    ...formData,
                    [question._id]: currentValue
                };
                onSubmit(currentValue);
                onFinalSubmit(updatedFormData);
            } else onSubmit(values[question._id]);
        };
        // Last question: submit immediately without exit animation
        if (!hasMoreQuestions) {
            proceedAfterSubmit();
            return;
        }
        // If valid, start animation and then proceed to next question
        setAnimationDirection("next");
        if (questionContentRef.current) {
            const handleAnimationEnd = ()=>{
                setAnimationDirection(null);
                proceedAfterSubmit();
                questionContentRef.current.removeEventListener("animationend", handleAnimationEnd);
            };
            questionContentRef.current.addEventListener("animationend", handleAnimationEnd);
        }
    };
    const renderQuestionContent = (currentValues)=>{
        // Get the current value from Formik values, fallback to prop value
        const currentValue = currentValues ? currentValues[question._id] : value;
        // Create a dynamic getButtonText function that uses the current value
        const getDynamicButtonText = ()=>{
            // Use the helper function to determine if there are more questions after the current one
            const hasMoreQuestions = hasMoreQuestionsAfterCurrent(question._id, {
                ...formData,
                [question._id]: currentValue
            });
            // If there are more questions to show, show "OK", otherwise show "Submit"
            return hasMoreQuestions ? "OK" : "Submit";
        };
        const commonProps = {
            question: question,
            questionIndex: questionIndex,
            value: currentValue || "",
            onSubmit: handleAnimatedSubmit,
            showError: showError,
            setShowError: setShowError,
            buttonText: getDynamicButtonText(),
            submitting: submitting,
            // Save current answer before going back so optional answers persist
            onPrevious: ()=>handlePreviousWithSave(currentValues),
            allQuestions: allQuestions // Pass allQuestions for dependent logic
        };
        switch(question.answerType){
            case "text":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $741477a3bb5af4c8$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "email":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $0a2eb85e94a9408d$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "phone":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $6f551deb21170b2b$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "country":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $5ca94075649ab824$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "singleSelectionDropdown":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $9eaf19f830421f6f$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "multipleSelectionDropdown":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $14f98365f58ca6ab$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "date":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $00145b16fdd9671e$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "object":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $67509c8d1d238d43$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "scale":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $3ab7053e5d709235$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
            case "files":
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $9ff6748d08f8fa8b$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps,
                    questId: questId,
                    customFormId: customFormId,
                    onUploadingStateChange: handleUploadingStateChange,
                    isPreviewMode: isPreviewMode,
                    questsApi: questsApi
                });
            default:
                return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $741477a3bb5af4c8$export$2e2bcd8739ae039), {
                    key: question._id,
                    ...commonProps
                });
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `full-screen-question ${hasQuestionImage && isLGScreen && question.position === "right" ? "image-right" : ""} ${hasQuestionImage ? "has-question-image" : ""} ${isStackedLayout ? "layout-stacked" : "layout-split"}`
    }, prefetchQuestionImages.length > 0 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-image-prefetch",
        "aria-hidden": true
    }, prefetchQuestionImages.map(({ _id: _id , questionImageName: questionImageName  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
            key: `prefetch-${_id}`,
            src: `${process.env.REACT_APP_IMG_SOURCE}/forms/images/${questionImageName}`,
            imgixParams: $a1f984fe84e53642$var$QUESTION_IMAGE_IMGIX_PARAMS,
            width: imageSize,
            height: imageSize,
            alt: "",
            className: "question-image question-image-prefetch-tile"
        }))), hasQuestionImage && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "question-image-container"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$reactimgix))), {
        key: question._id,
        src: `${process.env.REACT_APP_IMG_SOURCE}/forms/images/${question.questionImageName}`,
        imgixParams: $a1f984fe84e53642$var$QUESTION_IMAGE_IMGIX_PARAMS,
        width: imageSize,
        height: imageSize,
        htmlAttributes: {
            crossOrigin: "anonymous",
            "data-enroll-question-image": "true"
        },
        alt: question.question,
        className: "question-image"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `question-content m-0 ${isLGScreen ? "mx-lg-auto" : ""} ${hasQuestionImage && isLGScreen ? "question-content-mw-50" : ""}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$formik.Formik), {
        initialValues: getInitialValues(),
        validationSchema: getValidationSchema(),
        onSubmit: handleAnimatedSubmit,
        enableReinitialize: true
    }, ({ values: values , errors: errors , touched: touched , handleChange: handleChange , handleBlur: handleBlur , setFieldValue: setFieldValue  })=>{
        formikValuesRef.current = values;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($a1f984fe84e53642$var$FormikValuesPersistence, {
            questionId: question._id,
            value: values[question._id],
            savedValue: formData === null || formData === void 0 ? void 0 : formData[question._id],
            onSaveAnswer: onSaveAnswer
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$formik.Form), {
            className: "w-100"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: `question-form-content ${animationDirection === "next" ? "fade-up" : animationDirection === "prev" ? "fade-down" : ""}`,
            ref: questionContentRef
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "typeform-question"
        }, renderQuestionContent(values))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "navigation-arrows d-sm-576-none d-lg-576-flex align-items-center justify-content-center rounded-1"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Button), {
            variant: "none",
            onClick: ()=>handleAnimatedNavigation("prev", values),
            disabled: questionIndex === 1 || isUploading,
            className: "bg-none border-none box-shadow-none p-0 outline-none"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "30",
            height: "30",
            viewBox: "0 0 48 48"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("polyline", {
            points: "12,28 24,18 36,28",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            style: {
                width: 2,
                height: 32,
                background: "#2C4157",
                opacity: 0.5
            }
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Button), {
            variant: "none",
            onClick: ()=>handleAnimatedNavigation("next", values),
            disabled: questionIndex === totalQuestions || isUploading,
            className: "bg-none border-none box-shadow-none p-0 outline-none"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("svg", {
            width: "30",
            height: "30",
            viewBox: "0 0 48 48"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("polyline", {
            points: "12,20 24,30 36,20",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }))))));
    })));
};
var $a1f984fe84e53642$export$2e2bcd8739ae039 = $a1f984fe84e53642$var$QuestionRenderer;











const $0f486ef2fcf0337b$var$normalizeOption = (option)=>{
    if (typeof option === "string") return {
        _id: option,
        id: option,
        option: option
    };
    return {
        _id: (option === null || option === void 0 ? void 0 : option._id) || (option === null || option === void 0 ? void 0 : option.id) || (option === null || option === void 0 ? void 0 : option.option) || (option === null || option === void 0 ? void 0 : option.text) || "",
        id: (option === null || option === void 0 ? void 0 : option._id) || (option === null || option === void 0 ? void 0 : option.id) || (option === null || option === void 0 ? void 0 : option.option) || (option === null || option === void 0 ? void 0 : option.text) || "",
        option: (option === null || option === void 0 ? void 0 : option.option) || (option === null || option === void 0 ? void 0 : option.text) || ""
    };
};
const $0f486ef2fcf0337b$var$normalizeSubQuestion = (subQuestion)=>{
    return {
        _id: (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion._id) || (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.id) || (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.subQuestion) || "",
        subQuestion: (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.subQuestion) || ""
    };
};
const $0f486ef2fcf0337b$var$normalizeQuestion = (question)=>{
    return {
        _id: (question === null || question === void 0 ? void 0 : question._id) || (question === null || question === void 0 ? void 0 : question.id) || "",
        question: (question === null || question === void 0 ? void 0 : question.question) || (question === null || question === void 0 ? void 0 : question.text) || "",
        description: (question === null || question === void 0 ? void 0 : question.description) || "",
        answerType: (question === null || question === void 0 ? void 0 : question.answerType) || "text",
        questionType: (question === null || question === void 0 ? void 0 : question.questionType) || "direct",
        dependentQuestionId: (question === null || question === void 0 ? void 0 : question.dependentQuestionId) || "",
        condition: Array.isArray(question === null || question === void 0 ? void 0 : question.condition) ? question.condition : [],
        isRequired: Boolean(question === null || question === void 0 ? void 0 : question.isRequired),
        questionImageName: (question === null || question === void 0 ? void 0 : question.questionImageName) || (question === null || question === void 0 ? void 0 : question.imageFileName) || "",
        position: (question === null || question === void 0 ? void 0 : question.position) || "left",
        connectedTo: (question === null || question === void 0 ? void 0 : question.connectedTo) || "",
        isDeleted: Boolean(question === null || question === void 0 ? void 0 : question.isDeleted),
        options: ((question === null || question === void 0 ? void 0 : question.options) || (question === null || question === void 0 ? void 0 : question.originalOptions) || []).map($0f486ef2fcf0337b$var$normalizeOption),
        subQuestions: ((question === null || question === void 0 ? void 0 : question.subQuestions) || []).map($0f486ef2fcf0337b$var$normalizeSubQuestion),
        scaleOptions: (question === null || question === void 0 ? void 0 : question.scaleOptions) || {}
    };
};
const $0f486ef2fcf0337b$var$shouldShowDependentQuestion = (question, allQuestions, answers)=>{
    if (question.questionType !== "dependent") return true;
    const parentQuestion = allQuestions.find((candidate)=>candidate._id === question.dependentQuestionId);
    if (!parentQuestion) return false;
    const parentAnswer = answers[parentQuestion._id];
    const conditions = question.condition || [];
    if (!parentAnswer || conditions.length === 0) return false;
    if (parentQuestion.answerType === "multipleSelectionDropdown") {
        const selectedValues = Array.isArray(parentAnswer) ? parentAnswer : [
            parentAnswer
        ];
        return selectedValues.some((selectedValue)=>{
            const matchingOption = parentQuestion.options.find((option)=>option.option === selectedValue);
            const optionId = (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption._id) || (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.id) || (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.option);
            return conditions.includes(optionId);
        });
    }
    const selectedValue = Array.isArray(parentAnswer) ? parentAnswer[0] : parentAnswer;
    const matchingOption = parentQuestion.options.find((option)=>option.option === selectedValue);
    const optionId = (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption._id) || (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.id) || (matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.option);
    return conditions.includes(optionId);
};
const $0f486ef2fcf0337b$var$EnrollmentFormPreviewModal = ({ show: show , onHide: onHide , questId: questId , questions: questions = [] , isLoading: isLoading = false  })=>{
    const { isSMScreen: isSMScreen , isMDScreen: isMDScreen , isLGScreen: isLGScreen  } = (0, $6b45442dba6a28ce$export$2e2bcd8739ae039)();
    const formDataRef = (0, $feLGi$react.useRef)({});
    const [formData, setFormData] = (0, $feLGi$react.useState)({});
    const [currentQuestion, setCurrentQuestion] = (0, $feLGi$react.useState)(0);
    const [showThankYou, setShowThankYou] = (0, $feLGi$react.useState)(false);
    formDataRef.current = formData;
    const normalizedQuestions = (0, $feLGi$react.useMemo)(()=>questions.map($0f486ef2fcf0337b$var$normalizeQuestion).filter((question)=>question._id && !question.isDeleted), [
        questions
    ]);
    const getFilteredQuestions = (allQuestions, currentFormData)=>allQuestions.filter((question)=>$0f486ef2fcf0337b$var$shouldShowDependentQuestion(question, allQuestions, currentFormData));
    const hasMoreQuestionsAfterCurrent = (currentQuestionId, currentFormData)=>{
        const currentQuestionIndex = normalizedQuestions.findIndex((question)=>question._id === currentQuestionId);
        if (currentQuestionIndex === -1) return false;
        return normalizedQuestions.slice(currentQuestionIndex + 1).some((question)=>$0f486ef2fcf0337b$var$shouldShowDependentQuestion(question, normalizedQuestions, currentFormData));
    };
    (0, $feLGi$react.useEffect)(()=>{
        if (!show) return;
        formDataRef.current = {};
        setFormData({});
        setCurrentQuestion(0);
        setShowThankYou(false);
    }, [
        normalizedQuestions,
        show
    ]);
    const filteredQuestions = (0, $feLGi$react.useMemo)(()=>getFilteredQuestions(normalizedQuestions, formData), [
        formData,
        normalizedQuestions
    ]);
    const currentQ = normalizedQuestions[currentQuestion];
    const currentQuestionInFiltered = filteredQuestions.find((question)=>{
        return question._id === (currentQ === null || currentQ === void 0 ? void 0 : currentQ._id);
    });
    (0, $feLGi$react.useEffect)(()=>{
        if (currentQuestionInFiltered || filteredQuestions.length === 0) return;
        const firstFilteredQuestion = filteredQuestions[0];
        const firstQuestionIndex = normalizedQuestions.findIndex((question)=>question._id === firstFilteredQuestion._id);
        if (firstQuestionIndex >= 0) setCurrentQuestion(firstQuestionIndex);
    }, [
        currentQuestionInFiltered,
        filteredQuestions,
        normalizedQuestions
    ]);
    const handleClose = ()=>{
        formDataRef.current = {};
        setFormData({});
        setCurrentQuestion(0);
        setShowThankYou(false);
        onHide();
    };
    const handleSaveAnswer = (questionId, answer)=>{
        const nextFormData = {
            ...formDataRef.current,
            [questionId]: answer
        };
        formDataRef.current = nextFormData;
        setFormData(nextFormData);
    };
    const handleQuestionSubmit = (questionId, answer)=>{
        const nextFormData = {
            ...formDataRef.current,
            [questionId]: answer
        };
        formDataRef.current = nextFormData;
        setFormData(nextFormData);
        const nextFilteredQuestions = getFilteredQuestions(normalizedQuestions, nextFormData);
        const currentQuestionIndex = nextFilteredQuestions.findIndex((question)=>question._id === questionId);
        if (currentQuestionIndex < nextFilteredQuestions.length - 1) {
            const nextFilteredQuestion = nextFilteredQuestions[currentQuestionIndex + 1];
            const nextQuestionIndex = normalizedQuestions.findIndex((question)=>question._id === nextFilteredQuestion._id);
            setCurrentQuestion(nextQuestionIndex);
        }
    };
    const handleNext = ()=>{
        const nextFilteredQuestions = getFilteredQuestions(normalizedQuestions, formData);
        const currentQuestionIndex = nextFilteredQuestions.findIndex((question)=>{
            return question._id === (currentQ === null || currentQ === void 0 ? void 0 : currentQ._id);
        });
        if (currentQuestionIndex < nextFilteredQuestions.length - 1) {
            const nextFilteredQuestion = nextFilteredQuestions[currentQuestionIndex + 1];
            const nextQuestionIndex = normalizedQuestions.findIndex((question)=>question._id === nextFilteredQuestion._id);
            setCurrentQuestion(nextQuestionIndex);
        }
    };
    const handlePrevious = ()=>{
        const nextFilteredQuestions = getFilteredQuestions(normalizedQuestions, formData);
        const currentQuestionIndex = nextFilteredQuestions.findIndex((question)=>{
            return question._id === (currentQ === null || currentQ === void 0 ? void 0 : currentQ._id);
        });
        if (currentQuestionIndex > 0) {
            const prevFilteredQuestion = nextFilteredQuestions[currentQuestionIndex - 1];
            const prevQuestionIndex = normalizedQuestions.findIndex((question)=>question._id === prevFilteredQuestion._id);
            setCurrentQuestion(prevQuestionIndex);
        }
    };
    const handleFinalSubmit = ()=>{
        setShowThankYou(true);
    };
    const hasQuestionImage = Boolean(currentQ === null || currentQ === void 0 ? void 0 : currentQ.questionImageName);
    const isXLScreen = typeof window !== "undefined" ? window.innerWidth >= 1200 : false;
    const questionImageBreakpointClass = hasQuestionImage ? isXLScreen ? "question-image-breakpoint-xl" : isLGScreen ? "question-image-breakpoint-lg" : isMDScreen ? "question-image-breakpoint-md" : isSMScreen ? "question-image-breakpoint-sm" : "question-image-breakpoint-xs" : "";
    const currentQuestionValue = formDataRef.current[currentQ === null || currentQ === void 0 ? void 0 : currentQ._id] !== undefined ? formDataRef.current[currentQ._id] : formData[currentQ === null || currentQ === void 0 ? void 0 : currentQ._id];
    const hasMoreQuestions = currentQ ? hasMoreQuestionsAfterCurrent(currentQ._id, formData) : false;
    const currentFilteredIndex = filteredQuestions.findIndex((question)=>{
        return question._id === (currentQ === null || currentQ === void 0 ? void 0 : currentQ._id);
    });
    const prefetchQuestionImages = currentFilteredIndex < 0 ? [] : filteredQuestions.slice(currentFilteredIndex + 1, currentFilteredIndex + 5).filter((question)=>question.questionImageName).map((question)=>({
            _id: question._id,
            questionImageName: question.questionImageName
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal), {
        show: show,
        fullscreen: true,
        onHide: handleClose,
        className: "enrollment-preview-overlay",
        dialogClassName: "enrollment-preview-modal"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Modal).Body, {
        className: "p-0"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("button", {
        type: "button",
        className: "enrollment-preview-close",
        onClick: handleClose,
        "aria-label": "Close preview"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $000a07b0d337ce91$export$2e2bcd8739ae039), {
        color: "#0A223C",
        discardMargin: true
    })), isLoading ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "enroll-typeform-loading"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a41d748d78d3a02e$export$2e2bcd8739ae039), {
        animation: "border"
    })) : !filteredQuestions.length ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "enroll-typeform-empty"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "mb-0"
    }, "No questions available for preview.")) : showThankYou ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "enroll-typeform-empty enrollment-preview-thank-you"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
        className: "confirmation-title mb-3"
    }, "Thank you"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "confirmation-subtitle mb-4"
    }, "Preview only. No enrollment form response was submitted."), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex flex-wrap justify-content-center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        type: "button",
        variant: "gray",
        size: "sm",
        className: "mr-2 mb-2",
        onClick: ()=>{
            setShowThankYou(false);
            setCurrentQuestion(0);
        }
    }, "Back To Form"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
        type: "button",
        variant: "saffron",
        size: "sm",
        className: "mb-2 text-white",
        onClick: handleClose
    }, "Close Preview"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: `enroll-typeform-container${hasQuestionImage ? " has-question-image" : ""} ${questionImageBreakpointClass}`
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "enroll-typeform-content"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $a1f984fe84e53642$export$2e2bcd8739ae039), {
        question: currentQ,
        questionIndex: filteredQuestions.findIndex((question)=>question._id === currentQ._id) + 1,
        totalQuestions: filteredQuestions.length,
        value: currentQuestionValue,
        onSubmit: (answer)=>handleQuestionSubmit(currentQ._id, answer),
        onSaveAnswer: (answer)=>handleSaveAnswer(currentQ._id, answer),
        onNext: handleNext,
        onPrevious: handlePrevious,
        isLastQuestion: !hasMoreQuestions,
        submitting: false,
        onFinalSubmit: handleFinalSubmit,
        formData: formData,
        questId: questId,
        customFormId: "enrollment-preview",
        allQuestions: normalizedQuestions,
        hasMoreQuestionsAfterCurrent: hasMoreQuestionsAfterCurrent,
        prefetchQuestionImages: prefetchQuestionImages,
        isPreviewMode: true
    })))));
};
var $0f486ef2fcf0337b$export$2e2bcd8739ae039 = $0f486ef2fcf0337b$var$EnrollmentFormPreviewModal;

















const $77f25c8eec95e4e8$var$ABROAD_BLUE = "#0A223C";
const $77f25c8eec95e4e8$var$TEXT_COLOR = "#010101";
const $77f25c8eec95e4e8$var$BORDER_COLOR = "#010101";
const $77f25c8eec95e4e8$var$RENDER_WIDTH = 800;
const $77f25c8eec95e4e8$var$PDF_WIDTH_MM = 210;
const $77f25c8eec95e4e8$var$PDF_HEIGHT_MM = 297;
const $77f25c8eec95e4e8$var$PAGE_HEIGHT_PX = $77f25c8eec95e4e8$var$RENDER_WIDTH * $77f25c8eec95e4e8$var$PDF_HEIGHT_MM / $77f25c8eec95e4e8$var$PDF_WIDTH_MM;
const $77f25c8eec95e4e8$var$PAGE_PADDING_X = 32;
const $77f25c8eec95e4e8$var$PAGE_PADDING_BOTTOM = 36;
const $77f25c8eec95e4e8$var$COLUMN_GAP = 24;
const $77f25c8eec95e4e8$var$RIGHT_COLUMN_BALANCE_THRESHOLD = 60;
const $77f25c8eec95e4e8$var$PAGE_TITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:44px;line-height:56px;letter-spacing:-1.76px;";
const $77f25c8eec95e4e8$var$SECTION_TITLE_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:600;font-size:16px;line-height:26px;letter-spacing:-0.32px;";
const $77f25c8eec95e4e8$var$BODY_TEXT_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:600;font-size:13px;line-height:20px;letter-spacing:0;";
const $77f25c8eec95e4e8$var$DOCUMENT_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect width="40" height="40" rx="20" fill="${$77f25c8eec95e4e8$var$ABROAD_BLUE}" />
    <path d="M16.9013 15.6805C16.7104 15.6805 16.5272 15.7563 16.3922 15.8914C16.2572 16.0264 16.1813 16.2095 16.1813 16.4005C16.1813 16.5914 16.2572 16.7746 16.3922 16.9096C16.5272 17.0446 16.7104 17.1205 16.9013 17.1205H24.1013C24.2923 17.1205 24.4754 17.0446 24.6104 16.9096C24.7455 16.7746 24.8213 16.5914 24.8213 16.4005C24.8213 16.2095 24.7455 16.0264 24.6104 15.8914C24.4754 15.7563 24.2923 15.6805 24.1013 15.6805H16.9013ZM16.1813 20.7205C16.1813 20.5295 16.2572 20.3464 16.3922 20.2114C16.5272 20.0763 16.7104 20.0005 16.9013 20.0005H24.1013C24.2923 20.0005 24.4754 20.0763 24.6104 20.2114C24.7455 20.3464 24.8213 20.5295 24.8213 20.7205C24.8213 20.9114 24.7455 21.0946 24.6104 21.2296C24.4754 21.3646 24.2923 21.4405 24.1013 21.4405H16.9013C16.7104 21.4405 16.5272 21.3646 16.3922 21.2296C16.2572 21.0946 16.1813 20.9114 16.1813 20.7205ZM16.9013 24.3205C16.7104 24.3205 16.5272 24.3963 16.3922 24.5314C16.2572 24.6664 16.1813 24.8495 16.1813 25.0405C16.1813 25.2314 16.2572 25.4146 16.3922 25.5496C16.5272 25.6846 16.7104 25.7605 16.9013 25.7605H19.7813C19.9723 25.7605 20.1554 25.6846 20.2904 25.5496C20.4255 25.4146 20.5013 25.2314 20.5013 25.0405C20.5013 24.8495 20.4255 24.6664 20.2904 24.5314C20.1554 24.3963 19.9723 24.3205 19.7813 24.3205H16.9013ZM15.4613 8.48047C15.2704 8.48047 15.0872 8.55633 14.9522 8.69135C14.8172 8.82638 14.7413 9.00951 14.7413 9.20047V9.92047H14.0213C13.4485 9.92047 12.8991 10.148 12.494 10.5531C12.0889 10.9582 11.8613 11.5076 11.8613 12.0805V29.3605C11.8613 29.9333 12.0889 30.4827 12.494 30.8878C12.8991 31.2929 13.4485 31.5205 14.0213 31.5205H22.6613C22.7559 31.5206 22.8497 31.5022 22.9371 31.4661C23.0246 31.43 23.1041 31.377 23.1711 31.3102L28.9311 25.5502C28.9979 25.4832 29.0509 25.4037 29.0869 25.3163C29.123 25.2288 29.1415 25.1351 29.1413 25.0405V12.0805C29.1413 11.5076 28.9138 10.9582 28.5087 10.5531C28.1036 10.148 27.5542 9.92047 26.9813 9.92047H26.2613V9.20047C26.2613 9.00951 26.1855 8.82638 26.0504 8.69135C25.9154 8.55633 25.7323 8.48047 25.5413 8.48047C25.3504 8.48047 25.1672 8.55633 25.0322 8.69135C24.8972 8.82638 24.8213 9.00951 24.8213 9.20047V9.92047H21.2213V9.20047C21.2213 9.00951 21.1455 8.82638 21.0104 8.69135C20.8754 8.55633 20.6923 8.48047 20.5013 8.48047C20.3104 8.48047 20.1272 8.55633 19.9922 8.69135C19.8572 8.82638 19.7813 9.00951 19.7813 9.20047V9.92047H16.1813V9.20047C16.1813 9.00951 16.1055 8.82638 15.9704 8.69135C15.8354 8.55633 15.6523 8.48047 15.4613 8.48047ZM26.9813 11.3605C27.1723 11.3605 27.3554 11.4363 27.4904 11.5714C27.6255 11.7064 27.7013 11.8895 27.7013 12.0805V24.3205H24.1013C23.5285 24.3205 22.9791 24.548 22.574 24.9531C22.1689 25.3582 21.9413 25.9076 21.9413 26.4805V30.0805H14.0213C13.8304 30.0805 13.6472 30.0046 13.5122 29.8696C13.3772 29.7346 13.3013 29.5514 13.3013 29.3605V12.0805C13.3013 11.8895 13.3772 11.7064 13.5122 11.5714C13.6472 11.4363 13.8304 11.3605 14.0213 11.3605H26.9813ZM26.6832 25.7605L23.3813 29.0624V26.4805C23.3813 26.2895 23.4572 26.1064 23.5922 25.9714C23.7272 25.8363 23.9104 25.7605 24.1013 25.7605H26.6832Z" fill="white"/>
  </svg>
`;
const $77f25c8eec95e4e8$var$getAbroadLogoUrl = ()=>{
    const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return `${window.location.origin}${publicUrl}/assets/images/signupHeaderIcon.svg`;
};
const $77f25c8eec95e4e8$var$getCheckboxSvg = ()=>{
    return `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="4.5" fill="white" stroke="${$77f25c8eec95e4e8$var$TEXT_COLOR}" />
    </svg>
  `;
};
const $77f25c8eec95e4e8$var$escapeHtml = (value = "")=>String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
const $77f25c8eec95e4e8$var$getSafeFileName = (title)=>{
    const cleaned = String(title).replace(/[<>:"/\\|?*]+/g, "").replace(/\s+/g, " ").trim();
    return cleaned;
};
const $77f25c8eec95e4e8$var$waitForImages = (element)=>{
    const images = Array.from(element.querySelectorAll("img"));
    if (images.length === 0) return Promise.resolve();
    return Promise.all(images.map((img)=>new Promise((resolve)=>{
            if (img.complete && img.naturalWidth > 0) {
                resolve();
                return;
            }
            img.onload = ()=>resolve();
            img.onerror = ()=>resolve();
        })));
};
const $77f25c8eec95e4e8$var$buildSectionMarkup = ({ title: title , items: items = [] , notes: notes = ""  })=>{
    const itemsHtml = items.map((item, idx)=>{
        const marginBottom = idx === items.length - 1 ? "0" : "14px";
        return `
        <li style="display:flex;align-items:flex-start;margin:0 0 ${marginBottom} 0;list-style:none;">
          <span style="flex-shrink:0;margin-right:12px;line-height:0;">
            ${$77f25c8eec95e4e8$var$getCheckboxSvg()}
          </span>
          <span style="${$77f25c8eec95e4e8$var$BODY_TEXT_STYLE}color:${$77f25c8eec95e4e8$var$TEXT_COLOR};">
            ${$77f25c8eec95e4e8$var$escapeHtml((item === null || item === void 0 ? void 0 : item.item) || "")}
          </span>
        </li>
      `;
    }).join("");
    const notesHtml = notes ? `
      <div style="margin-top:12px;opacity:0.5;${$77f25c8eec95e4e8$var$BODY_TEXT_STYLE}color:${$77f25c8eec95e4e8$var$TEXT_COLOR};">
        ${notes}
      </div>
    ` : "";
    return `
    <div style="margin-bottom:20px;">
      <div style="display:flex;align-items:center;margin-bottom:12px;">
        <div style="flex-shrink:0;line-height:0;">${$77f25c8eec95e4e8$var$DOCUMENT_ICON_SVG}</div>
        <h2 style="margin:0 0 0 8px;${$77f25c8eec95e4e8$var$SECTION_TITLE_STYLE}text-transform:uppercase;color:${$77f25c8eec95e4e8$var$ABROAD_BLUE};">
          ${$77f25c8eec95e4e8$var$escapeHtml(title || "")}
        </h2>
      </div>
      <div style="border:1px solid ${$77f25c8eec95e4e8$var$BORDER_COLOR};border-radius:10px;padding:16px;">
        <ul style="margin:0;padding:0;list-style:none;">
          ${itemsHtml}
        </ul>
        ${notesHtml}
      </div>
    </div>
  `;
};
const $77f25c8eec95e4e8$var$renderSectionHtml = (section)=>{
    return $77f25c8eec95e4e8$var$buildSectionMarkup({
        title: section === null || section === void 0 ? void 0 : section.title,
        items: (section === null || section === void 0 ? void 0 : section.items) || [],
        notes: (section === null || section === void 0 ? void 0 : section.notes) || ""
    });
};
const $77f25c8eec95e4e8$var$getDescriptionHtml = (description)=>{
    if (!description) return "";
    return `
    <div style="margin:0 0 20px 0;${$77f25c8eec95e4e8$var$BODY_TEXT_STYLE}color:${$77f25c8eec95e4e8$var$TEXT_COLOR};">
      ${description}
    </div>
  `;
};
const $77f25c8eec95e4e8$var$createPageMarkup = ({ questTitle: questTitle , descriptionHtml: descriptionHtml , showHeader: showHeader = true , leftColumnHtml: leftColumnHtml = "" , rightColumnHtml: rightColumnHtml = ""  })=>`
  <div
    class="travel-checklist-pdf-page"
    style="
      width:${$77f25c8eec95e4e8$var$RENDER_WIDTH}px;
      height:${$77f25c8eec95e4e8$var$PAGE_HEIGHT_PX}px;
      background:#ffffff;
      color:${$77f25c8eec95e4e8$var$TEXT_COLOR};
      box-sizing:border-box;
      overflow:hidden;
      display:flex;
      flex-direction:column;
    ">
    ${showHeader ? `
    <div style="padding:32px ${$77f25c8eec95e4e8$var$PAGE_PADDING_X}px 8px ${$77f25c8eec95e4e8$var$PAGE_PADDING_X}px;text-align:center;background:#ffffff;">
      <img
        src="${$77f25c8eec95e4e8$var$getAbroadLogoUrl()}"
        alt="Abroad"
        width="120"
        height="80"
        style="display:block;margin:0 auto 16px auto;width:120px;height:auto;"
        crossorigin="anonymous"
      />
      <div style="font-family:'Cormorant Garamond',Georgia,serif;font-size:28px;font-weight:600;line-height:1.3;color:${$77f25c8eec95e4e8$var$TEXT_COLOR};word-break:break-word;">
        ${$77f25c8eec95e4e8$var$escapeHtml(questTitle)}
      </div>
    </div>
    ` : ""}
    <div style="padding:${showHeader ? "24px" : "32px"} ${$77f25c8eec95e4e8$var$PAGE_PADDING_X}px ${$77f25c8eec95e4e8$var$PAGE_PADDING_BOTTOM}px ${$77f25c8eec95e4e8$var$PAGE_PADDING_X}px;display:flex;flex-direction:column;flex:1;min-height:0;">
      ${showHeader ? `
      <h1 style="margin:0 0 16px 0;${$77f25c8eec95e4e8$var$PAGE_TITLE_STYLE}color:${$77f25c8eec95e4e8$var$TEXT_COLOR};">
        Travel checklist
      </h1>
      ${descriptionHtml}
      ` : ""}
      <div
        class="travel-checklist-pdf-columns"
        style="
          display:flex;
          align-items:flex-start;
          gap:${$77f25c8eec95e4e8$var$COLUMN_GAP}px;
          flex:1;
          min-height:0;
        ">
        <div
          class="travel-checklist-pdf-column"
          style="flex:1;min-width:0;">
          ${leftColumnHtml}
        </div>
        <div
          class="travel-checklist-pdf-column"
          style="flex:1;min-width:0;">
          ${rightColumnHtml}
        </div>
      </div>
    </div>
  </div>
`;
const $77f25c8eec95e4e8$var$createMeasurementRoot = ()=>{
    const root = document.createElement("div");
    root.setAttribute("aria-hidden", "true");
    root.style.cssText = `
    position: fixed;
    left: -10000px;
    top: 0;
    width: ${$77f25c8eec95e4e8$var$RENDER_WIDTH}px;
    background: #ffffff;
    z-index: -1;
    pointer-events: none;
  `;
    document.body.appendChild(root);
    return root;
};
const $77f25c8eec95e4e8$var$measurePageLayout = async ({ root: root , questTitle: questTitle , descriptionHtml: descriptionHtml , showHeader: showHeader = true  })=>{
    root.innerHTML = $77f25c8eec95e4e8$var$createPageMarkup({
        questTitle: questTitle,
        descriptionHtml: showHeader ? descriptionHtml : "",
        showHeader: showHeader
    });
    await $77f25c8eec95e4e8$var$waitForImages(root);
    const pageElement = root.querySelector(".travel-checklist-pdf-page");
    const columnsElement = root.querySelector(".travel-checklist-pdf-columns");
    const columnElement = root.querySelector(".travel-checklist-pdf-column");
    return {
        pageHeight: pageElement.getBoundingClientRect().height,
        columnHeight: columnsElement.getBoundingClientRect().height,
        columnWidth: columnElement.getBoundingClientRect().width
    };
};
const $77f25c8eec95e4e8$var$measureHtmlHeight = (root, columnWidth, html)=>{
    const measureContainer = document.createElement("div");
    measureContainer.style.cssText = `
    width: ${columnWidth}px;
    box-sizing: border-box;
  `;
    measureContainer.innerHTML = html;
    root.appendChild(measureContainer);
    const height = measureContainer.getBoundingClientRect().height;
    root.removeChild(measureContainer);
    return height;
};
const $77f25c8eec95e4e8$var$splitSectionIntoFragments = ({ section: section , columnWidth: columnWidth , columnHeight: columnHeight , root: root  })=>{
    const fullHtml = $77f25c8eec95e4e8$var$renderSectionHtml(section);
    const fullHeight = $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, fullHtml);
    if (fullHeight <= columnHeight) return [
        {
            html: fullHtml,
            height: fullHeight
        }
    ];
    const items = (section === null || section === void 0 ? void 0 : section.items) || [];
    const notes = (section === null || section === void 0 ? void 0 : section.notes) || "";
    const fragments = [];
    let currentItems = [];
    items.forEach((item)=>{
        const nextItems = [
            ...currentItems,
            item
        ];
        const nextHtml = $77f25c8eec95e4e8$var$buildSectionMarkup({
            title: section === null || section === void 0 ? void 0 : section.title,
            items: nextItems,
            notes: ""
        });
        const nextHeight = $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, nextHtml);
        if (nextHeight <= columnHeight || currentItems.length === 0) {
            currentItems = nextItems;
            return;
        }
        const currentHtml = $77f25c8eec95e4e8$var$buildSectionMarkup({
            title: section === null || section === void 0 ? void 0 : section.title,
            items: currentItems,
            notes: ""
        });
        fragments.push({
            html: currentHtml,
            height: $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, currentHtml)
        });
        currentItems = [
            item
        ];
    });
    if (currentItems.length > 0 || notes) {
        const finalHtml = $77f25c8eec95e4e8$var$buildSectionMarkup({
            title: section === null || section === void 0 ? void 0 : section.title,
            items: currentItems,
            notes: notes
        });
        const finalHeight = $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, finalHtml);
        if (finalHeight <= columnHeight || currentItems.length === 0) fragments.push({
            html: finalHtml,
            height: finalHeight
        });
        else {
            const currentHtml = $77f25c8eec95e4e8$var$buildSectionMarkup({
                title: section === null || section === void 0 ? void 0 : section.title,
                items: currentItems,
                notes: ""
            });
            fragments.push({
                html: currentHtml,
                height: $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, currentHtml)
            });
            const notesHtml = $77f25c8eec95e4e8$var$buildSectionMarkup({
                title: section === null || section === void 0 ? void 0 : section.title,
                items: [],
                notes: notes
            });
            fragments.push({
                html: notesHtml,
                height: $77f25c8eec95e4e8$var$measureHtmlHeight(root, columnWidth, notesHtml)
            });
        }
    }
    return fragments.length ? fragments : [
        {
            html: fullHtml,
            height: fullHeight
        }
    ];
};
const $77f25c8eec95e4e8$var$paginateSections = ({ sections: sections , columnWidth: columnWidth , firstPageColumnHeight: firstPageColumnHeight , nextPageColumnHeight: nextPageColumnHeight , root: root  })=>{
    const pages = [];
    let currentPageColumnHeight = firstPageColumnHeight;
    let currentPage = {
        left: [],
        right: [],
        leftHeight: 0,
        rightHeight: 0
    };
    const finalizePage = ()=>{
        if (!currentPage.left.length && !currentPage.right.length) return;
        pages.push({
            showHeader: pages.length === 0,
            leftHtml: currentPage.left.map((fragment)=>fragment.html).join(""),
            rightHtml: currentPage.right.map((fragment)=>fragment.html).join("")
        });
        currentPage = {
            left: [],
            right: [],
            leftHeight: 0,
            rightHeight: 0
        };
        currentPageColumnHeight = nextPageColumnHeight;
    };
    const placeInColumn = (fragment, column)=>{
        if (column === "left") {
            currentPage.left.push(fragment);
            currentPage.leftHeight += fragment.height;
        } else {
            currentPage.right.push(fragment);
            currentPage.rightHeight += fragment.height;
        }
    };
    sections.forEach((section)=>{
        const fragments = $77f25c8eec95e4e8$var$splitSectionIntoFragments({
            section: section,
            columnWidth: columnWidth,
            columnHeight: nextPageColumnHeight,
            root: root
        });
        fragments.forEach((fragment)=>{
            const canFitLeft = currentPage.leftHeight + fragment.height <= currentPageColumnHeight;
            const canFitRight = currentPage.rightHeight + fragment.height <= currentPageColumnHeight;
            if (canFitLeft && canFitRight) {
                const leftProjectedDiff = Math.abs(currentPage.leftHeight + fragment.height - currentPage.rightHeight);
                const rightProjectedDiff = Math.abs(currentPage.leftHeight - (currentPage.rightHeight + fragment.height));
                if (rightProjectedDiff + $77f25c8eec95e4e8$var$RIGHT_COLUMN_BALANCE_THRESHOLD < leftProjectedDiff) {
                    placeInColumn(fragment, "right");
                    return;
                }
                placeInColumn(fragment, "left");
                return;
            }
            if (canFitRight) {
                placeInColumn(fragment, "right");
                return;
            }
            if (canFitLeft) {
                placeInColumn(fragment, "left");
                return;
            }
            finalizePage();
            placeInColumn(fragment, "left");
        });
    });
    finalizePage();
    return pages;
};
const $77f25c8eec95e4e8$var$createPdf = async (pageElements)=>{
    // eslint-disable-next-line new-cap
    const pdf = new (0, $feLGi$jspdf.jsPDF)({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
    });
    for(let index = 0; index < pageElements.length; index += 1){
        if (index > 0) pdf.addPage();
        const canvas = await (0, ($parcel$interopDefault($feLGi$html2canvas)))(pageElements[index], {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: false,
            width: $77f25c8eec95e4e8$var$RENDER_WIDTH,
            height: $77f25c8eec95e4e8$var$PAGE_HEIGHT_PX,
            windowWidth: $77f25c8eec95e4e8$var$RENDER_WIDTH,
            windowHeight: $77f25c8eec95e4e8$var$PAGE_HEIGHT_PX
        });
        const imgData = canvas.toDataURL("image/png", 1.0);
        pdf.addImage(imgData, "PNG", 0, 0, $77f25c8eec95e4e8$var$PDF_WIDTH_MM, $77f25c8eec95e4e8$var$PDF_HEIGHT_MM, undefined, "FAST");
    }
    return pdf;
};
const $77f25c8eec95e4e8$export$b1e495304ea49a69 = async ({ questTitle: questTitle , checklistData: checklistData , checklistProgress: checklistProgress = {}  })=>{
    if (!checklistData) throw new Error("Checklist data is required");
    const container = $77f25c8eec95e4e8$var$createMeasurementRoot();
    try {
        const descriptionHtml = $77f25c8eec95e4e8$var$getDescriptionHtml(checklistData === null || checklistData === void 0 ? void 0 : checklistData.description);
        const firstPageLayout = await $77f25c8eec95e4e8$var$measurePageLayout({
            root: container,
            questTitle: questTitle,
            descriptionHtml: descriptionHtml
        });
        const nextPageLayout = await $77f25c8eec95e4e8$var$measurePageLayout({
            root: container,
            questTitle: questTitle,
            descriptionHtml: descriptionHtml,
            showHeader: false
        });
        const pages = $77f25c8eec95e4e8$var$paginateSections({
            sections: (checklistData === null || checklistData === void 0 ? void 0 : checklistData.sections) || [],
            checklistProgress: checklistProgress,
            columnWidth: firstPageLayout.columnWidth,
            firstPageColumnHeight: firstPageLayout.columnHeight,
            nextPageColumnHeight: nextPageLayout.columnHeight,
            root: container
        });
        const html = pages.map((page)=>$77f25c8eec95e4e8$var$createPageMarkup({
                questTitle: questTitle,
                descriptionHtml: descriptionHtml,
                showHeader: page.showHeader,
                leftColumnHtml: page.leftHtml,
                rightColumnHtml: page.rightHtml
            })).join("");
        container.innerHTML = html;
        await $77f25c8eec95e4e8$var$waitForImages(container);
        return html;
    } finally{
        if (container.parentNode) container.parentNode.removeChild(container);
    }
};
const $77f25c8eec95e4e8$export$24fda5aee259610b = async ({ questTitle: questTitle , checklistData: checklistData , checklistProgress: checklistProgress = {}  })=>{
    const html = await $77f25c8eec95e4e8$export$b1e495304ea49a69({
        questTitle: questTitle,
        checklistData: checklistData,
        checklistProgress: checklistProgress
    });
    const container = $77f25c8eec95e4e8$var$createMeasurementRoot();
    try {
        container.innerHTML = html;
        await $77f25c8eec95e4e8$var$waitForImages(container);
        const pageElements = Array.from(container.querySelectorAll(".travel-checklist-pdf-page"));
        const pdf = await $77f25c8eec95e4e8$var$createPdf(pageElements);
        pdf.save(`${$77f25c8eec95e4e8$var$getSafeFileName(questTitle)}_Travel Checklist.pdf`);
    } finally{
        if (container.parentNode) container.parentNode.removeChild(container);
    }
};
var $77f25c8eec95e4e8$export$2e2bcd8739ae039 = $77f25c8eec95e4e8$export$24fda5aee259610b;






const $7b38bc0be6891ec0$var$TEXT_COLOR = "#010101";
const $7b38bc0be6891ec0$var$BORDER_COLOR = "#D9D9D9";
const $7b38bc0be6891ec0$var$ACCENT_COLOR = "#BF9000";
const $7b38bc0be6891ec0$var$RENDER_WIDTH = 800;
const $7b38bc0be6891ec0$var$PDF_WIDTH_MM = 210;
const $7b38bc0be6891ec0$var$PDF_HEIGHT_MM = 297;
const $7b38bc0be6891ec0$var$PAGE_HEIGHT_PX = $7b38bc0be6891ec0$var$RENDER_WIDTH * $7b38bc0be6891ec0$var$PDF_HEIGHT_MM / $7b38bc0be6891ec0$var$PDF_WIDTH_MM;
const $7b38bc0be6891ec0$var$PAGE_PADDING_X = 32;
const $7b38bc0be6891ec0$var$PAGE_PADDING_BOTTOM = 36;
const $7b38bc0be6891ec0$var$TITLE_STYLE = "font-family:'Cormorant Garamond',Georgia,serif;font-weight:500;font-size:44px;line-height:56px;letter-spacing:-1.76px;";
const $7b38bc0be6891ec0$var$BODY_TEXT_STYLE = "font-family:'Open Sans',Arial,sans-serif;font-weight:600;font-size:13px;line-height:20px;letter-spacing:0;";
const $7b38bc0be6891ec0$var$LABEL_STYLE = "font-family:'Montserrat',Arial,sans-serif;font-weight:600;font-size:10px;line-height:normal;letter-spacing:2px;text-transform:uppercase;";
const $7b38bc0be6891ec0$var$getAbroadLogoUrl = ()=>{
    const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    return `${window.location.origin}${publicUrl}/assets/images/signupHeaderIcon.svg`;
};
const $7b38bc0be6891ec0$var$getQuestImageUrl = (imageFileName)=>{
    if (!imageFileName) return `${process.env.REACT_APP_IMG_SOURCE}/quest-placeholder.png?ar=4:1&fit=crop&crop=format&auto=format`;
    return `${process.env.REACT_APP_IMG_SOURCE}/quest/${imageFileName}?ar=4:1&fit=crop&crop=faces&auto=format`;
};
const $7b38bc0be6891ec0$var$getSafeFileName = (title)=>String(title || "").replace(/[<>:"/\\|?*]+/g, "").replace(/\s+/g, " ").trim();
const $7b38bc0be6891ec0$var$getHeaderQuestTitle = (title)=>String(title || "").trim();
const $7b38bc0be6891ec0$var$getPdfFileName = (questTitle)=>{
    const safeQuestTitle = $7b38bc0be6891ec0$var$getSafeFileName(questTitle);
    return `${safeQuestTitle}_Itinerary.pdf`;
};
const $7b38bc0be6891ec0$var$waitForImages = (element)=>{
    const images = Array.from(element.querySelectorAll("img"));
    if (images.length === 0) return Promise.resolve();
    return Promise.all(images.map((img)=>new Promise((resolve)=>{
            if (img.complete && img.naturalWidth > 0) {
                resolve();
                return;
            }
            img.onload = ()=>resolve();
            img.onerror = ()=>resolve();
        })));
};
const $7b38bc0be6891ec0$var$escapeHtml = (value = "")=>String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
const $7b38bc0be6891ec0$var$getTimeLabel = (event, index, total)=>{
    const fromTime = (0, $50f91df4720112ee$export$cf5705bae9972c44)(event.fromTime, "HH:mm");
    if (event.toTime) return `${fromTime} - ${(0, $50f91df4720112ee$export$cf5705bae9972c44)(event.toTime, "HH:mm")}`;
    if (index === total - 1) return `${fromTime} onwards`;
    return fromTime;
};
const $7b38bc0be6891ec0$var$renderItineraryRowsHtml = (rows = [])=>rows.map((event, index)=>`
        <div
          style="
            display:flex;
            gap:20px;
            padding:16px 0;
            border-bottom:${index === rows.length - 1 ? "none" : `1px solid ${$7b38bc0be6891ec0$var$BORDER_COLOR}`};
          ">
          <div style="width:160px;flex-shrink:0;${$7b38bc0be6891ec0$var$BODY_TEXT_STYLE}color:${$7b38bc0be6891ec0$var$TEXT_COLOR};">
            ${$7b38bc0be6891ec0$var$escapeHtml($7b38bc0be6891ec0$var$getTimeLabel(event, index, rows.length))}
          </div>
          <div style="flex:1;${$7b38bc0be6891ec0$var$BODY_TEXT_STYLE}color:${$7b38bc0be6891ec0$var$TEXT_COLOR};">
            ${$7b38bc0be6891ec0$var$escapeHtml(event.itinerary || "")}
          </div>
        </div>
      `).join("");
const $7b38bc0be6891ec0$var$buildDaySectionMarkup = ({ day: day , index: index , itineraries: itineraries  })=>`
  <div style="margin-bottom:28px;">
    <img
      src="${$7b38bc0be6891ec0$var$getQuestImageUrl(day.imageFileName)}"
      alt="Itinerary"
      style="display:block;width:100%;height:184px;object-fit:cover;border-radius:10px;margin-bottom:12px;"
      crossorigin="anonymous"
    />
    <div style="${$7b38bc0be6891ec0$var$LABEL_STYLE}color:${$7b38bc0be6891ec0$var$ACCENT_COLOR};margin-bottom:6px;">
      ${$7b38bc0be6891ec0$var$escapeHtml((0, $50f91df4720112ee$export$307103d2a6db5e8d)(day.date))}
    </div>
    <div style="${$7b38bc0be6891ec0$var$TITLE_STYLE}color:${$7b38bc0be6891ec0$var$TEXT_COLOR};margin-bottom:8px;">
      <span style="text-transform:capitalize;">Day ${$7b38bc0be6891ec0$var$escapeHtml((0, $feLGi$numbertowords.toWords)(index + 1))}</span>
      -
      ${$7b38bc0be6891ec0$var$escapeHtml(day.subTitle || "")}
    </div>
    <div style="border-top:1px solid ${$7b38bc0be6891ec0$var$BORDER_COLOR};">
      ${$7b38bc0be6891ec0$var$renderItineraryRowsHtml(itineraries)}
    </div>
  </div>
`;
const $7b38bc0be6891ec0$var$createPageMarkup = ({ questTitle: questTitle , showHeader: showHeader = true , bodyHtml: bodyHtml = ""  })=>`
  <div
    class="quest-itinerary-pdf-page"
    style="
      width:${$7b38bc0be6891ec0$var$RENDER_WIDTH}px;
      height:${$7b38bc0be6891ec0$var$PAGE_HEIGHT_PX}px;
      background:#ffffff;
      color:${$7b38bc0be6891ec0$var$TEXT_COLOR};
      box-sizing:border-box;
      overflow:hidden;
      display:flex;
      flex-direction:column;
    ">
    ${showHeader ? `
    <div style="padding:32px ${$7b38bc0be6891ec0$var$PAGE_PADDING_X}px 8px ${$7b38bc0be6891ec0$var$PAGE_PADDING_X}px;text-align:center;background:#ffffff;">
      <img
        src="${$7b38bc0be6891ec0$var$getAbroadLogoUrl()}"
        alt="Abroad"
        width="120"
        height="80"
        style="display:block;margin:0 auto 16px auto;width:120px;height:auto;"
        crossorigin="anonymous"
      />
      ${$7b38bc0be6891ec0$var$getHeaderQuestTitle(questTitle) ? `
      <div style="font-family:'Cormorant Garamond',Georgia,serif;font-size:28px;font-weight:600;line-height:1.3;color:${$7b38bc0be6891ec0$var$TEXT_COLOR};word-break:break-word;">
        ${$7b38bc0be6891ec0$var$escapeHtml($7b38bc0be6891ec0$var$getHeaderQuestTitle(questTitle))}
      </div>
      ` : ""}
    </div>
    ` : ""}
    <div style="padding:${showHeader ? "24px" : "32px"} ${$7b38bc0be6891ec0$var$PAGE_PADDING_X}px ${$7b38bc0be6891ec0$var$PAGE_PADDING_BOTTOM}px ${$7b38bc0be6891ec0$var$PAGE_PADDING_X}px;display:flex;flex-direction:column;flex:1;min-height:0;">
      ${showHeader ? `
      <h1 style="margin:0 0 16px 0;${$7b38bc0be6891ec0$var$TITLE_STYLE}color:${$7b38bc0be6891ec0$var$TEXT_COLOR};">
        Itinerary
      </h1>
      ` : ""}
      <div class="quest-itinerary-pdf-content" style="flex:1;min-height:0;">
        ${bodyHtml}
      </div>
    </div>
  </div>
`;
const $7b38bc0be6891ec0$var$createMeasurementRoot = ()=>{
    const root = document.createElement("div");
    root.setAttribute("aria-hidden", "true");
    root.style.cssText = `
    position: fixed;
    left: -10000px;
    top: 0;
    width: ${$7b38bc0be6891ec0$var$RENDER_WIDTH}px;
    background: #ffffff;
    z-index: -1;
    pointer-events: none;
  `;
    document.body.appendChild(root);
    return root;
};
const $7b38bc0be6891ec0$var$measurePageContentHeight = async ({ root: root , questTitle: questTitle , showHeader: showHeader  })=>{
    root.innerHTML = $7b38bc0be6891ec0$var$createPageMarkup({
        questTitle: questTitle,
        showHeader: showHeader,
        bodyHtml: ""
    });
    await $7b38bc0be6891ec0$var$waitForImages(root);
    return root.querySelector(".quest-itinerary-pdf-content").getBoundingClientRect().height;
};
const $7b38bc0be6891ec0$var$measureHtmlHeight = (root, html)=>{
    const measureContainer = document.createElement("div");
    measureContainer.style.cssText = `
    width: ${$7b38bc0be6891ec0$var$RENDER_WIDTH - $7b38bc0be6891ec0$var$PAGE_PADDING_X * 2}px;
    box-sizing: border-box;
  `;
    measureContainer.innerHTML = html;
    root.appendChild(measureContainer);
    const height = measureContainer.getBoundingClientRect().height;
    root.removeChild(measureContainer);
    return height;
};
const $7b38bc0be6891ec0$var$splitDayIntoFragments = ({ day: day , index: index , pageContentHeight: pageContentHeight , root: root  })=>{
    const fullHtml = $7b38bc0be6891ec0$var$buildDaySectionMarkup({
        day: day,
        index: index,
        itineraries: day.itineraries || []
    });
    const fullHeight = $7b38bc0be6891ec0$var$measureHtmlHeight(root, fullHtml);
    if (fullHeight <= pageContentHeight) return [
        {
            html: fullHtml,
            height: fullHeight
        }
    ];
    const fragments = [];
    let currentRows = [];
    (day.itineraries || []).forEach((event)=>{
        const nextRows = [
            ...currentRows,
            event
        ];
        const nextHtml = $7b38bc0be6891ec0$var$buildDaySectionMarkup({
            day: day,
            index: index,
            itineraries: nextRows
        });
        const nextHeight = $7b38bc0be6891ec0$var$measureHtmlHeight(root, nextHtml);
        if (nextHeight <= pageContentHeight || currentRows.length === 0) {
            currentRows = nextRows;
            return;
        }
        const currentHtml = $7b38bc0be6891ec0$var$buildDaySectionMarkup({
            day: day,
            index: index,
            itineraries: currentRows
        });
        fragments.push({
            html: currentHtml,
            height: $7b38bc0be6891ec0$var$measureHtmlHeight(root, currentHtml)
        });
        currentRows = [
            event
        ];
    });
    if (currentRows.length > 0) {
        const finalHtml = $7b38bc0be6891ec0$var$buildDaySectionMarkup({
            day: day,
            index: index,
            itineraries: currentRows
        });
        fragments.push({
            html: finalHtml,
            height: $7b38bc0be6891ec0$var$measureHtmlHeight(root, finalHtml)
        });
    }
    return fragments.length ? fragments : [
        {
            html: fullHtml,
            height: fullHeight
        }
    ];
};
const $7b38bc0be6891ec0$var$paginateDays = ({ days: days , firstPageContentHeight: firstPageContentHeight , nextPageContentHeight: nextPageContentHeight , root: root  })=>{
    const pages = [];
    let currentHeightLimit = firstPageContentHeight;
    let currentPageFragments = [];
    let currentHeight = 0;
    const finalizePage = ()=>{
        if (!currentPageFragments.length) return;
        pages.push({
            showHeader: pages.length === 0,
            bodyHtml: currentPageFragments.map((fragment)=>fragment.html).join("")
        });
        currentPageFragments = [];
        currentHeight = 0;
        currentHeightLimit = nextPageContentHeight;
    };
    days.forEach((day, index)=>{
        const fragments = $7b38bc0be6891ec0$var$splitDayIntoFragments({
            day: day,
            index: index,
            pageContentHeight: nextPageContentHeight,
            root: root
        });
        fragments.forEach((fragment)=>{
            if (currentHeight + fragment.height <= currentHeightLimit) {
                currentPageFragments.push(fragment);
                currentHeight += fragment.height;
                return;
            }
            finalizePage();
            currentPageFragments.push(fragment);
            currentHeight += fragment.height;
        });
    });
    finalizePage();
    return pages;
};
const $7b38bc0be6891ec0$var$createPdf = async (pageElements)=>{
    // eslint-disable-next-line new-cap
    const pdf = new (0, $feLGi$jspdf.jsPDF)({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true
    });
    for(let index = 0; index < pageElements.length; index += 1){
        if (index > 0) pdf.addPage();
        const canvas = await (0, ($parcel$interopDefault($feLGi$html2canvas)))(pageElements[index], {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: false,
            width: $7b38bc0be6891ec0$var$RENDER_WIDTH,
            height: $7b38bc0be6891ec0$var$PAGE_HEIGHT_PX,
            windowWidth: $7b38bc0be6891ec0$var$RENDER_WIDTH,
            windowHeight: $7b38bc0be6891ec0$var$PAGE_HEIGHT_PX
        });
        const imgData = canvas.toDataURL("image/png", 1.0);
        pdf.addImage(imgData, "PNG", 0, 0, $7b38bc0be6891ec0$var$PDF_WIDTH_MM, $7b38bc0be6891ec0$var$PDF_HEIGHT_MM, undefined, "FAST");
    }
    return pdf;
};
const $7b38bc0be6891ec0$export$b76e62620358c591 = async ({ questTitle: questTitle , days: days = []  })=>{
    const container = $7b38bc0be6891ec0$var$createMeasurementRoot();
    try {
        const firstPageContentHeight = await $7b38bc0be6891ec0$var$measurePageContentHeight({
            root: container,
            questTitle: questTitle,
            showHeader: true
        });
        const nextPageContentHeight = await $7b38bc0be6891ec0$var$measurePageContentHeight({
            root: container,
            questTitle: questTitle,
            showHeader: false
        });
        const pages = $7b38bc0be6891ec0$var$paginateDays({
            days: days,
            firstPageContentHeight: firstPageContentHeight,
            nextPageContentHeight: nextPageContentHeight,
            root: container
        });
        const html = pages.map((page)=>$7b38bc0be6891ec0$var$createPageMarkup({
                questTitle: questTitle,
                showHeader: page.showHeader,
                bodyHtml: page.bodyHtml
            })).join("");
        container.innerHTML = html;
        await $7b38bc0be6891ec0$var$waitForImages(container);
        return html;
    } finally{
        if (container.parentNode) container.parentNode.removeChild(container);
    }
};
const $7b38bc0be6891ec0$export$a7f322dc2750e2ee = async ({ questTitle: questTitle , days: days = []  })=>{
    const html = await $7b38bc0be6891ec0$export$b76e62620358c591({
        questTitle: questTitle,
        days: days
    });
    const container = $7b38bc0be6891ec0$var$createMeasurementRoot();
    try {
        container.innerHTML = html;
        await $7b38bc0be6891ec0$var$waitForImages(container);
        const pageElements = Array.from(container.querySelectorAll(".quest-itinerary-pdf-page"));
        const pdf = await $7b38bc0be6891ec0$var$createPdf(pageElements);
        pdf.save($7b38bc0be6891ec0$var$getPdfFileName(questTitle));
    } finally{
        if (container.parentNode) container.parentNode.removeChild(container);
    }
};
var $7b38bc0be6891ec0$export$2e2bcd8739ae039 = $7b38bc0be6891ec0$export$a7f322dc2750e2ee;


/**
 * Estimate how much vertical space a checklist section takes so columns
 * can be balanced by content size instead of section count alone.
 */ const $b6f2fdec6c694a56$var$getSectionWeight = (section)=>{
    var _section_items;
    const itemCount = (section === null || section === void 0 ? void 0 : (_section_items = section.items) === null || _section_items === void 0 ? void 0 : _section_items.length) || 0;
    const notesWeight = (section === null || section === void 0 ? void 0 : section.notes) ? 1 : 0;
    // Header / card chrome is roughly equal to a couple of list rows.
    const sectionChromeWeight = 2;
    return sectionChromeWeight + itemCount + notesWeight;
};
const $b6f2fdec6c694a56$export$d12d06391209fdd8 = (sections = [])=>{
    if (!sections.length) return {
        firstHalf: [],
        secondHalf: []
    };
    if (sections.length === 1) return {
        firstHalf: sections,
        secondHalf: []
    };
    const weights = sections.map($b6f2fdec6c694a56$var$getSectionWeight);
    const totalWeight = weights.reduce((sum, weight)=>sum + weight, 0);
    let bestIndex = Math.ceil(sections.length / 2);
    let bestDiff = Infinity;
    let foundLeftPreferred = false;
    let leftWeight = 0;
    for(let i = 1; i < sections.length; i += 1){
        leftWeight += weights[i - 1];
        const rightWeight = totalWeight - leftWeight;
        const leftIsPreferred = leftWeight >= rightWeight;
        const diff = leftIsPreferred ? leftWeight - rightWeight : Math.abs(leftWeight - rightWeight);
        if (leftIsPreferred) {
            if (!foundLeftPreferred || diff < bestDiff) {
                foundLeftPreferred = true;
                bestDiff = diff;
                bestIndex = i;
            }
        } else if (!foundLeftPreferred && diff < bestDiff) {
            bestDiff = diff;
            bestIndex = i;
        }
    }
    return {
        firstHalf: sections.slice(0, bestIndex),
        secondHalf: sections.slice(bestIndex)
    };
};
var $b6f2fdec6c694a56$export$2e2bcd8739ae039 = $b6f2fdec6c694a56$export$d12d06391209fdd8;





const $6fd600a01db077f7$var$getFname = (person)=>{
    const name = person === null || person === void 0 ? void 0 : person.fname;
    return name && String(name).trim() ? String(name).trim() : "-";
};
const $6fd600a01db077f7$var$formatPlanRowLabel = ({ clientName: clientName , coachName: coachName , isGrowth: isGrowth  })=>{
    const client = clientName || "-";
    const coach = coachName || "-";
    const kind = isGrowth ? "Growth plan" : "Coaching plan";
    return `${kind} : ${coach} & ${client}`;
};
const $6fd600a01db077f7$var$SubscriptionTable = ({ isRenderOnAdminSide: isRenderOnAdminSide = false , isTogglePayment: isTogglePayment , showHighlightedPart: showHighlightedPart , API: API , userId: userId , clientName: clientNameProp  })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [subscriptionPayments, setSubscriptionPayments] = (0, $feLGi$react.useState)([]);
    const location = (0, $feLGi$reactrouterdom.useLocation)();
    const history = (0, $feLGi$reactrouterdom.useHistory)();
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    (0, $feLGi$react.useEffect)(()=>{
        const getUserSubscriptionPayment = async ()=>{
            setIsLoading(true);
            try {
                const { data: data  } = await API.payment.getUserSubscriptionPayment(userId);
                if (data) {
                    setSubscriptionPayments(data);
                    setIsLoading(false);
                }
            } catch (e) {
                setIsLoading(false);
                Error.showError(e);
            }
        };
        getUserSubscriptionPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTogglePayment
    ]);
    const renderPageTitle = ()=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
            className: "s3 subscription-title"
        }, isRenderOnAdminSide ? "Subscription" : "My Subscription");
    };
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, renderPageTitle(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTable), {
        row: 2,
        col: 6
    }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, renderPageTitle(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Coach Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Type"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%"
    }, "Upcoming Payment & Date"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "25%",
        className: "text-right text-end"
    }, "Action"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, (subscriptionPayments === null || subscriptionPayments === void 0 ? void 0 : subscriptionPayments.length) > 0 ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, subscriptionPayments === null || subscriptionPayments === void 0 ? void 0 : subscriptionPayments.map((subscription, index)=>{
        var _subscription_sow;
        const noBillingReq = (subscription === null || subscription === void 0 ? void 0 : subscription.isPaymentRequired) === false;
        const showActionBtns = (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[0] && ((subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeDate) || (subscription === null || subscription === void 0 ? void 0 : subscription.nextPaymentDate)) && !noBillingReq && !(subscription === null || subscription === void 0 ? void 0 : subscription.terminatedOn) && !subscription.isTemp && [
            (0, $b5f12f83c4275d44$export$40bae20db5989375)[1].value
        ].includes(subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus);
        var _subscription_isGrowth;
        const subscriptionPlanLabel = $6fd600a01db077f7$var$formatPlanRowLabel({
            clientName: $6fd600a01db077f7$var$getFname(subscription === null || subscription === void 0 ? void 0 : subscription.clientId) !== "-" ? $6fd600a01db077f7$var$getFname(subscription === null || subscription === void 0 ? void 0 : subscription.clientId) : clientNameProp,
            coachName: $6fd600a01db077f7$var$getFname(subscription === null || subscription === void 0 ? void 0 : subscription.coachId),
            isGrowth: (_subscription_isGrowth = subscription === null || subscription === void 0 ? void 0 : subscription.isGrowth) !== null && _subscription_isGrowth !== void 0 ? _subscription_isGrowth : subscription === null || subscription === void 0 ? void 0 : (_subscription_sow = subscription.sow) === null || _subscription_sow === void 0 ? void 0 : _subscription_sow.isGrowth
        });
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
            key: index,
            id: subscription === null || subscription === void 0 ? void 0 : subscription._id,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))({
                "highlight-row": `#${subscription === null || subscription === void 0 ? void 0 : subscription._id}` === (location === null || location === void 0 ? void 0 : location.hash) && showHighlightedPart
            })
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "25%"
        }, isRenderOnAdminSide ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: `/coach/clients/${userId}/plans/${subscription === null || subscription === void 0 ? void 0 : subscription._id}`
        }, subscriptionPlanLabel) : subscriptionPlanLabel), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "25%",
            className: "text-capitalize"
        }, [
            (0, $b5f12f83c4275d44$export$a18da5e670f0b062).WAITING_FOR_PAYMENT
        ].includes(subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "New") : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "25%"
        }, [
            (0, $b5f12f83c4275d44$export$a18da5e670f0b062).WAITING_FOR_PAYMENT
        ].includes(subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[0] ? (subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) >= 0 && (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount) && `$${(subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) + (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount)}` : (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[1] && `$${subscription === null || subscription === void 0 ? void 0 : subscription.onetimeAmount}`) : [
            (0, $b5f12f83c4275d44$export$a18da5e670f0b062).PAYMENT_FAILED
        ].includes(subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[0] && (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount) && (subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) >= 0 ? (subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeDate) ? (0, $50f91df4720112ee$export$3ae94a2503e890a1)(subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeDate) === (0, $50f91df4720112ee$export$3ae94a2503e890a1)(subscription === null || subscription === void 0 ? void 0 : subscription.planStartDate) ? `$${(subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) + (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount)}` : `$${subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeAmount} - ${(0, $50f91df4720112ee$export$3ae94a2503e890a1)(subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeDate)}` : (subscription === null || subscription === void 0 ? void 0 : subscription.totalDurationOfContract) > 1 ? `$${subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount}` : `$${(subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) + (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount)}` : (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[1] && `$${subscription === null || subscription === void 0 ? void 0 : subscription.onetimeAmount}`) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, noBillingReq || (subscription === null || subscription === void 0 ? void 0 : subscription.terminatedOn) ? "N/A" : (subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeAmount) ? `$${subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeAmount} - ${(0, $50f91df4720112ee$export$3ae94a2503e890a1)(subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeDate)}` : "-")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "25%",
            className: "text-end pe-0"
        }, [
            (0, $b5f12f83c4275d44$export$a18da5e670f0b062).WAITING_FOR_PAYMENT,
            (0, $b5f12f83c4275d44$export$a18da5e670f0b062).PAYMENT_FAILED
        ].includes(subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, isRenderOnAdminSide ? "-" : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[0] && ((subscription === null || subscription === void 0 ? void 0 : subscription.upfrontFee) + (subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionAmount) === 0 || (subscription === null || subscription === void 0 ? void 0 : subscription.nextChargeAmount) === 0) || (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[1] && (subscription === null || subscription === void 0 ? void 0 : subscription.onetimeAmount) === 0 ? "-" // Do not show Pay or Retry if the total payment is $0
         : ((subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[0] || (subscription === null || subscription === void 0 ? void 0 : subscription.paymentCycle) === Object.values((0, $b5f12f83c4275d44$export$cf6c01cadfc8fe18))[1]) && (subscription === null || subscription === void 0 ? void 0 : subscription.sowStatus) === (0, $b5f12f83c4275d44$export$a18da5e670f0b062).PAYMENT_FAILED ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: `/plans-payments/coaching-plan/${subscription === null || subscription === void 0 ? void 0 : subscription._id}?isRetryingPayment=true`
        }, "Retry") : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $ba6b6ef9345ffc3c$export$2e2bcd8739ae039), {
            variant: "saffron",
            size: "md",
            onClick: ()=>{
                history.push((subscription === null || subscription === void 0 ? void 0 : subscription.isTemp) ? `/plans-payments/coaching-plan/coaching-plan-${subscription === null || subscription === void 0 ? void 0 : subscription.amount}?coaching=coaching-plan-${subscription === null || subscription === void 0 ? void 0 : subscription.amount}` : `/plans-payments/coaching-plan/${subscription === null || subscription === void 0 ? void 0 : subscription._id}`);
            },
            className: "text-uppercase border-radius-normal text-white hover:text-white"
        }, "Pay"))) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, showActionBtns ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex flex-column"
        }, !isRenderOnAdminSide && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactrouterdom.Link), {
            to: `/plans-payments/coaching-plan/${subscription === null || subscription === void 0 ? void 0 : subscription._id}/card/${subscription === null || subscription === void 0 ? void 0 : subscription.paymentMethodId}/change-card`
        }, "Change card")), isRenderOnAdminSide && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", null, "-")) : "-")));
    })) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
        colSpan: 6,
        className: "text-center"
    }, !isRenderOnAdminSide ? "You don't have any subscriptions" : "The user has no subscription."))))));
};
var $6fd600a01db077f7$export$2e2bcd8739ae039 = $6fd600a01db077f7$var$SubscriptionTable;










const $a3c868540a2e7f9d$var$placement = "top";
const $a3c868540a2e7f9d$var$getFname = (person)=>{
    const name = person === null || person === void 0 ? void 0 : person.fname;
    return name && String(name).trim() ? String(name).trim() : "-";
};
const $a3c868540a2e7f9d$var$formatPlanRowLabel = ({ clientName: clientName , coachName: coachName , isGrowth: isGrowth  })=>{
    const client = clientName || "-";
    const coach = coachName || "-";
    const kind = isGrowth ? "Growth plan" : "Coaching plan";
    return `${kind} : ${coach} & ${client}`;
};
const $a3c868540a2e7f9d$var$getQuestId = (payment)=>{
    var _payment_quest;
    const questId = (payment === null || payment === void 0 ? void 0 : (_payment_quest = payment.quest) === null || _payment_quest === void 0 ? void 0 : _payment_quest._id) || (payment === null || payment === void 0 ? void 0 : payment.questId);
    return questId ? String(questId) : null;
};
const $a3c868540a2e7f9d$var$getPaymentIdFromHash = (hash)=>{
    const rawHash = (hash || "").replace(/^#/, "").trim();
    if (!rawHash.startsWith("paymentId=")) return null;
    return rawHash.slice(10).trim() || null;
};
const $a3c868540a2e7f9d$var$PaymentHistoryTable = ({ setShowHighlightedPart: setShowHighlightedPart , API: API , userId: userId , clientName: clientNameProp , isTogglePayment: isTogglePayment = false , isDiscardInfoIcon: isDiscardInfoIcon = false , isRenderInAdmin: isRenderInAdmin = false  })=>{
    const [isLoading, setIsLoading] = (0, $feLGi$react.useState)(true);
    const [userPayments, setUserPayments] = (0, $feLGi$react.useState)([]);
    const [showPaymentHighlight, setShowPaymentHighlight] = (0, $feLGi$react.useState)(false);
    const Error = (0, $abbf3dedc3048db2$export$2e2bcd8739ae039)();
    const { url: url  } = (0, $feLGi$reactrouterdom.useRouteMatch)();
    const location = (0, $feLGi$reactrouterdom.useLocation)();
    const paymentIdFromHash = $a3c868540a2e7f9d$var$getPaymentIdFromHash(location === null || location === void 0 ? void 0 : location.hash);
    let timeInterval = null;
    (0, $feLGi$react.useEffect)(()=>{
        return ()=>{
            clearInterval(timeInterval);
        };
    }, [
        timeInterval
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        const getUserPayments = async ()=>{
            setIsLoading(true);
            try {
                const { data: data  } = await API.payment.getUserPayments(userId);
                if (data) {
                    setUserPayments(Array.isArray(data) ? data : []);
                    setIsLoading(false);
                }
            } catch (e) {
                setIsLoading(false);
                Error.showError(e);
            }
        };
        getUserPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTogglePayment
    ]);
    (0, $feLGi$react.useEffect)(()=>{
        if (!paymentIdFromHash || isLoading || !(userPayments === null || userPayments === void 0 ? void 0 : userPayments.length)) return;
        const matchedPayment = userPayments.find((payment)=>{
            return String(payment === null || payment === void 0 ? void 0 : payment._id) === String(paymentIdFromHash);
        });
        if (!matchedPayment) return;
        setShowPaymentHighlight(true);
        const el = document.getElementById(`payment-${paymentIdFromHash}`);
        if (el === null || el === void 0 ? void 0 : el.scrollIntoView) el.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        const highlightTimeout = setTimeout(()=>{
            setShowPaymentHighlight(false);
        }, 3000);
        return ()=>clearTimeout(highlightTimeout);
    }, [
        paymentIdFromHash,
        isLoading,
        userPayments
    ]);
    const renderPageTitle = ()=>{
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("h3", {
            className: "s3 payment-history-title"
        }, "Payment History");
    };
    const renderInfoIcon = (reason)=>{
        if (isDiscardInfoIcon) return null;
        return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.OverlayTrigger), {
            key: $a3c868540a2e7f9d$var$placement,
            placement: $a3c868540a2e7f9d$var$placement,
            overlay: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Tooltip), {
                style: {
                    "--bs-tooltip-max-width": "22rem",
                    maxWidth: "22rem"
                },
                id: `tooltip-${$a3c868540a2e7f9d$var$placement}`,
                className: "font-open-sans font-16 font-semibold leading-7 text-center payment-failed-info"
            }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
                style: {
                    width: "100%",
                    maxWidth: "100%",
                    // minWidth: '15rem',
                    whiteSpace: "normal",
                    wordWrap: "break-word"
                }
            }, reason))
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "d-flex align-items-center justify-content-center ml-2 ms-2"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $8d04a2f4ff06a04c$export$2e2bcd8739ae039), {
            className: "cursor-pointer"
        }))));
    };
    const renderAction = (payment)=>{
        var _payment_stripeCharges, _payment_stripeCharges1;
        if ((payment === null || payment === void 0 ? void 0 : payment.paid) && (payment === null || payment === void 0 ? void 0 : (_payment_stripeCharges = payment.stripeCharges) === null || _payment_stripeCharges === void 0 ? void 0 : _payment_stripeCharges.invoiceUrl)) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            target: "_blank",
            href: payment === null || payment === void 0 ? void 0 : (_payment_stripeCharges1 = payment.stripeCharges) === null || _payment_stripeCharges1 === void 0 ? void 0 : _payment_stripeCharges1.invoiceUrl,
            rel: "noreferrer"
        }, "Print Invoice");
        const questId = $a3c868540a2e7f9d$var$getQuestId(payment);
        const canRetryQuestPayment = !(payment === null || payment === void 0 ? void 0 : payment.paid) && !!questId && (payment === null || payment === void 0 ? void 0 : payment.canRetry) === true && !isRenderInAdmin;
        if (canRetryQuestPayment) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            href: `/your-experiences/${questId}/payments`
        }, "Retry");
        return "-";
    };
    if (isLoading) return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, renderPageTitle(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactshimmereffects.ShimmerTable), {
        row: 2,
        col: 4
    }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("section", null, (userPayments === null || userPayments === void 0 ? void 0 : userPayments.length) > 0 && /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, renderPageTitle(), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Table), {
        hover: true,
        responsive: true,
        className: "custom-table"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("thead", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "30%"
    }, "Coaching Plan Name"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%"
    }, "Type Of Payment"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%"
    }, "Amount"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "12%"
    }, "Status"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "13%"
    }, "Date"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("th", {
        width: "15%",
        className: "text-right text-end"
    }, "Action"))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("tbody", null, userPayments === null || userPayments === void 0 ? void 0 : userPayments.map((payment, index)=>{
        var _payment_sow, _payment_quest, _payment_sow1, _payment_sow2, _payment_sow3, _payment_sow4, _payment_stripeCharges, _payment_stripeCharges1;
        /*#__PURE__*/ return (0, ($parcel$interopDefault($feLGi$react))).createElement("tr", {
            key: (payment === null || payment === void 0 ? void 0 : payment._id) || index,
            id: (payment === null || payment === void 0 ? void 0 : payment._id) ? `payment-${payment._id}` : undefined,
            className: (0, ($parcel$interopDefault($feLGi$classnames)))({
                "highlight-row": paymentIdFromHash && String(payment === null || payment === void 0 ? void 0 : payment._id) === String(paymentIdFromHash) && showPaymentHighlight
            })
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "30%"
        }, (payment === null || payment === void 0 ? void 0 : payment.plan) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "text-capitalize"
        }, payment === null || payment === void 0 ? void 0 : payment.plan) : /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("a", {
            rel: "noopener",
            href: (payment === null || payment === void 0 ? void 0 : payment.quest) ? isRenderInAdmin ? `/admin/experiences/${$a3c868540a2e7f9d$var$getQuestId(payment)}` : `/your-experiences?questId=${$a3c868540a2e7f9d$var$getQuestId(payment)}` : `${url}#${(payment === null || payment === void 0 ? void 0 : (_payment_sow = payment.sow) === null || _payment_sow === void 0 ? void 0 : _payment_sow._id) || (payment === null || payment === void 0 ? void 0 : payment.sowId)}`,
            onClick: ()=>{
                setShowHighlightedPart(true);
                timeInterval = setInterval(()=>{
                    setShowHighlightedPart(false);
                    clearInterval(timeInterval);
                }, 3000);
            },
            className: "text-wrap"
        }, (payment === null || payment === void 0 ? void 0 : payment.quest) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("span", {
            className: "text-capitalize"
        }, payment === null || payment === void 0 ? void 0 : (_payment_quest = payment.quest) === null || _payment_quest === void 0 ? void 0 : _payment_quest.title) : $a3c868540a2e7f9d$var$formatPlanRowLabel({
            clientName: $a3c868540a2e7f9d$var$getFname(payment === null || payment === void 0 ? void 0 : (_payment_sow1 = payment.sow) === null || _payment_sow1 === void 0 ? void 0 : _payment_sow1.clientId) !== "-" ? $a3c868540a2e7f9d$var$getFname(payment === null || payment === void 0 ? void 0 : (_payment_sow2 = payment.sow) === null || _payment_sow2 === void 0 ? void 0 : _payment_sow2.clientId) : clientNameProp,
            coachName: $a3c868540a2e7f9d$var$getFname(payment === null || payment === void 0 ? void 0 : (_payment_sow3 = payment.sow) === null || _payment_sow3 === void 0 ? void 0 : _payment_sow3.coachId),
            isGrowth: payment === null || payment === void 0 ? void 0 : (_payment_sow4 = payment.sow) === null || _payment_sow4 === void 0 ? void 0 : _payment_sow4.isGrowth
        }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "15%"
        }, (payment === null || payment === void 0 ? void 0 : payment.plan) ? "Platform" : (payment === null || payment === void 0 ? void 0 : payment.questId) ? "Experience" : "Coaching"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "15%"
        }, (payment === null || payment === void 0 ? void 0 : payment.amount) || (payment === null || payment === void 0 ? void 0 : payment.amount) === 0 ? `$${payment === null || payment === void 0 ? void 0 : payment.amount}` : ""), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "12%"
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
            className: "d-flex"
        }, (payment === null || payment === void 0 ? void 0 : payment.paid) ? "Paid" : (payment === null || payment === void 0 ? void 0 : (_payment_stripeCharges = payment.stripeCharges) === null || _payment_stripeCharges === void 0 ? void 0 : _payment_stripeCharges.message) ? /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, "Failed", " ", renderInfoIcon(payment === null || payment === void 0 ? void 0 : (_payment_stripeCharges1 = payment.stripeCharges) === null || _payment_stripeCharges1 === void 0 ? void 0 : _payment_stripeCharges1.message)) // send reason text
         : "Failed")), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "13%"
        }, (0, $50f91df4720112ee$export$3ae94a2503e890a1)(payment === null || payment === void 0 ? void 0 : payment.createAt)), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("td", {
            width: "15%",
            className: "text-right text-end pe-0 pl-0"
        }, renderAction(payment)));
    })))));
};
var $a3c868540a2e7f9d$export$2e2bcd8739ae039 = $a3c868540a2e7f9d$var$PaymentHistoryTable;







const $6cb41c74f36dfb61$var$stripePromise = (0, $feLGi$stripestripejs.loadStripe)(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const $6cb41c74f36dfb61$var$AddCreditCard = ({ baseStyle: baseStyle , labelClasses: labelClasses , isComeFromPaymentDetailsForm: isComeFromPaymentDetailsForm = false  })=>{
    const styleObj = {
        // hidePostalCode: true, // only use in 'card' element
        style: {
            base: baseStyle,
            invalid: {
                borderColor: "#B22222",
                color: "#000"
            }
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, ($parcel$interopDefault($feLGi$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100 "
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100", labelClasses)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "card-labels"
    }, "CARD NUMBER*"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$stripereactstripejs.CardNumberElement), {
        stripe: $6cb41c74f36dfb61$var$stripePromise,
        className: `field form-control-md ${!isComeFromPaymentDetailsForm && "user-payment-custom"}`,
        options: {
            ...styleObj,
            placeholder: "0000 0000 0000 0000",
            showIcon: true
        }
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Row), {
        className: "d-flex justify-content-between"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-6"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100", labelClasses)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "card-labels"
    }, "EXPIRATION DATE*"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$stripereactstripejs.CardExpiryElement), {
        stripe: $6cb41c74f36dfb61$var$stripePromise,
        className: `field form-control-md ${!isComeFromPaymentDetailsForm && "user-payment-custom"}`,
        options: styleObj
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$reactbootstrap.Col), {
        className: "col-5"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("div", {
        className: "d-flex w-100"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("label", {
        className: (0, ($parcel$interopDefault($feLGi$classnames)))("w-100", labelClasses)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("p", {
        className: "card-labels"
    }, "CVV*"), /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement((0, $feLGi$stripereactstripejs.CardCvcElement), {
        stripe: $6cb41c74f36dfb61$var$stripePromise,
        className: `field form-control-md ${!isComeFromPaymentDetailsForm && "user-payment-custom"}`,
        options: {
            ...styleObj,
            placeholder: "000"
        }
    })))))));
};
var $6cb41c74f36dfb61$export$2e2bcd8739ae039 = $6cb41c74f36dfb61$var$AddCreditCard;




$parcel$exportWildcard($2cc048a7b2c045c0$exports, $9e1a431b1deb4138$exports);
$parcel$exportWildcard($2cc048a7b2c045c0$exports, $8c246ff365b80da1$exports);













const $a78d72d5d16583e5$var$LoadableImgix = (0, ($parcel$interopDefault($feLGi$loadablecomponent)))(()=>{
    // eslint-disable-next-line no-unused-expressions
    $feLGi$lazysizes;
    // eslint-disable-next-line no-unused-expressions
    $feLGi$lazysizespluginsparentfitlsparentfit;
    // eslint-disable-next-line no-unused-expressions
    $feLGi$lazysizespluginsattrchangelsattrchange;
    return $feLGi$reactimgix;
});
const $a78d72d5d16583e5$var$Imgix = /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).memo(({ children: children , ...rest })=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement($a78d72d5d16583e5$var$LoadableImgix, {
        fallback: /*#__PURE__*/ (0, ($parcel$interopDefault($feLGi$react))).createElement("img", {
            className: "lazyload w-100 h-lg-100 img-cover",
            src: `${rest.src}?${!(0, $62ffb3622b928f7d$export$91ee5070df9c3469) ? "" : "crop=top&fit=crop&ar=2.21:1&"}fill=blur&blur=300&px=16&auto=format`,
            alt: "page-banner"
        }),
        ...rest
    }, children);
});
var $a78d72d5d16583e5$export$2e2bcd8739ae039 = $a78d72d5d16583e5$var$Imgix;


const $d64b76c7d7ee0683$export$55abd4691b317664 = (0, $feLGi$history.createBrowserHistory)();
$parcel$exportWildcard(module.exports, $2cc048a7b2c045c0$exports);


//# sourceMappingURL=index.js.map
